/* eslint-disable prettier */
/* eslint-disable max-len */
/**
 * KO resource file
 */

import {
    ArcTimeLineValidationTypes,
    ArcTimelineGroups,
    Entity,
    GAComponentDocumentStatus,
    GALinkStatus,
    GARoleTypeId,
    TaskListTypes,
    actionTypes,
    activityType,
    assignmentTypes,
    bulkAssignment,
    bulkAssignmentConstants,
    clientRequestNoteTab,
    confidentialityTypes,
    filters,
    financialStatementType,
    gaRecommendationType,
    gaScopes,
    groupSummaryTabs,
    independenceActionIds,
    instructionStatus,
    instructionType,
    ipFilterType,
    ipInputType,
    linkType,
    milestoneBuildTaskIds,
    notesFilter,
    reviewNoteRoutes,
    rnhFilterTypeQuery,
    rnhQuickFilter,
    snapshotComparisonIds,
    syncStatus,
    todoListTimeframeOptions,
    trialBalanceType,
    uiViews,
    receiveInstructionSwitcherIds
} from "../util/uiconstants";

export const labels = {

    //Review notes tile 2

    reviewNoteTileGraphHeader: "만료일별 처리 전 리뷰노트",
    reviewNoteTileGraphHeaderAssignedToMe: "처리 전 내 담당 리뷰노트, 만료일별",
    reviewNoteTileGraphHeaderAuthoredByMe: 'Authored open notes, by due date',
    reviewNoteYAxisLabel: "리뷰노트",
    overDueCatFirst: ">90 지연",
    overDueCatSecond: "31-90 지연",
    overDueCatThird: "10-30 지연",
    overDueCatFourth: "<10 지연",
    catFifth: '<10',
    catSixth: '10-30',
    catSeventh: '31-90',
    catEighth: '>90',
    noNotesAvailable: "사용 가능한 노트 없음",


    //ReviewNoteTiles
    totalOpen: "총 처리 전 수",
    totalCleared: "총 처리됨 수",
    changeDueDate: "만료일 변경",
    reviewNoteHashValue: '#',

    //Rejected PSPs
    rejectedPSPsTitle: 'Rejected PSPs',
    noRejectedPSPs: 'No rejected PSPs',
    updateRejectedPSPs: 'Update rejected PSPs',


    //CRA Build Step 2 Labels
    inherentRiskTypeId: "고유위험 평가",
    controlRiskTypeId: "통제위험 평가",
    viewUnRelatedWCGWs: "연결되지 않은 WCGW 보기",
    unrelatedWCGWsInstruction: "아래 열거된 WCGW은 어떤 경영진주장에도 연결되지 않았습니다. 경영진주장을 하나 이상 연결하거나 삭제해야 합니다. 이러한 WCGW을 ‘WCGW을 경영진주장에 연결’ 모달에서 쉽게 찾으려면, SCOT 드롭다운에서 \'연결되지 않은 WCGW'\을 선택하십시오. WCGW이 더 이상 관련되지 않거나 편집이 필요한 경우, 원래 페이지에서 \'WCGW 및 통제 식별'\을 클릭하여 변경하십시오.",
    relatedWCGWsInstruction: "WCGW을 선택한 경영진주장에 연결하십시오. SCOT을 선택하여 특정 SCOT에서 WCGW을 연결하거나 전체 SCOT에서 옵션을 선택하십시오. 경영진주장에 연결해야 하는 WCGW 목록을 보려면, \연결되지 않은 WCGW'\을 선택하십시오.",
    allScots: "모든 SCOT",
    allWCGWs: "모든 WCGW",
    unRelatedWCGWs: "연결되지 않은 WCGW",
    //CRA Build Step 4 Header Label
    craValue: "CRA",
    incompleteCraValue: "미완료 CRA",
    // Panel Headers
    taskCategories: "Task 네비게이션",
    taskCategoryExecution: "실행",
    taskList: "Task 목록",
    taskDetails: "Task 세부정보",
    fullScreen: "전체 화면",
    exitFullScreen: "전체 화면 종료",
    defaultDropdown: "드롭다운 메뉴",
    status: "상태",
    language: "언어",
    channel: "채널",
    header: "머리글",
    headerName: "머리글 이름",
    sectionCustomLabelLabel: "사용자지정 레이블",
    sectionNamePlaceHolder: "섹션 제목 입력",
    showRelatedObjectLabel: "연결된 Object 표시",
    errorBanner: "{0}개 오류",
    customize: "수정",
    customized: "수정됨",
    custom: "사용자지정",
    description: "설명",
    seeDescription: "설명 보기",
    section: "섹션",
    entities: "기업",
    edit: "편집",
    delete: "삭제",
    collapse: "축소",
    collapseAll: "모두 축소",
    expand: "확장",
    expandAll: "모두 확장",
    incompleteResponse: "미완료 응답",
    unresolvedComments: "미해결 Comment",
    saving: "저장 중…",
    tasks: "task",
    requests: "요청사항",

    //BodyType Placeholder
    numericValuePlaceholder: "수치 입력",

    //Modal
    addButton: "버튼 추가",
    evidence: "증거",
    temporary: "임시",
    temporaryFiles: "임시 파일",
    priorPeriod: "전기",
    externaldocuments: "외부 문서",
    eydocuments: "EY 문서",
    clientRequestClientAnalytics: "분석 이름",
    groupdocuments: "그룹 문서",
    name: "이름",
    reason: "사유",
    browse: "찾아보기",
    uploadFile: "파일 업로드",
    uploadDocument: "문서 업로드",
    duplicateDocumentHeader: "이 engagement에 이름이 동일한 문서가 (증거나 임시파일로서) 이미 하나 이상 존재합니다.",
    duplicateDocumentInstruction: "덮어쓰기'를 선택하여 문서를 업로드하고 기존 파일을 교체하거나 '폐기'를 선택하여 취소합니다. 기존 파일이 증거에 있다면 문서는 증거로 업로드됩니다. 기존 파일이 임시파일에 있다면 문서는 임시파일로 업로드됩니다.",
    overwriteLabel: "덮어쓰기",
    discardLabel: "폐기",
    discardChangesLabel: "변경사항 폐기",
    note: "노트",
    notes: "노트",
    signOffs: "Sign-off",
    related: "연결됨",
    attributes: "정보",
    approveChanges: "변경사항 승인",
    nodocumentsAdded: "사용 가능한 문서가 없습니다",
    noEntitiesAvailable: "사용 가능한 기업 없음",
    noDocumentsUpload: "업로드 중인 문서가 없습니다",
    noSections: "사용 가능한 섹션이 없습니다",
    noRequestMessage: "이 engagement에 요청사항이나 외부 Task가 없습니다",
    noResultFound: "결과를 찾을 수 없습니다",
    noRequestsFound: "요청사항을 찾을 수 없습니다",
    noTimePhasesFound: "사용 가능한 시기 없음",
    noEntitiesFound: "결과 없음",
    relatedEntities: "연결된 기업",
    noClickableRelatedEntities: "이 task에 연결된 기업을 편집할 수 없습니다",
    taskByEntityLabel: "기업별 task",
    relEntityLabel: "기업",
    singleEntity: "{0} 기업",
    multipleEntity: "{0} 기업",
    engagementDeliveryLabel: "Engagemen별 task",
    onlyShowRelEntities: "연결된 기업만 표시",
    engDeliveryDescription: "이 task는 이 engagment 내 모든 기업에 연결되어 있습니다",
    relEntitiesDescription: "Task에 연결된 기업 보기. OSP 및 OST task에 연결된 기업만 편집할 수 있습니다.",
    relEntitiesPSTorPSPDesc: "Task에 연결된 기업 보기. PST 및 PSP task에 연결된 기업은 편집할 수 없습니다.",
    warningRelMsg: "Task는 하나 이상의 기업에 연결되어야 합니다. 해당 task를 engagement 차원으로 만들려면 기업별 task 토글을 변경하십시오.",
    reldetailDescription: "기본적으로 OSP 및 OST task는 engagement 차원에서 모든 기업에 연결되어 있습니다. 기업별 task를 활성화하여 task를 하나 이상의 기업에 연결할 수 있습니다.",
    results: "결과",
    searchPlaceholder: "검색",
    searchDocPlaceholder: "문서 검색",
    searchCanvasForms: "Canvas 양식 검색",
    searchControlForms: "SCOT 검색",
    canvasFormListDescription: "관련 Canvas 양식 보고서를 보려면 아래 목록에서 Canvas 양식을 선택하십시오",
    controlFormListDescription: "관련 통제 양식을 보려면 SCOT을 선택하십시오",
    object: "Object",
    relateCollaboration: "공동작업 연결",
    reviewNote: "리뷰노트",
    reviewNoteSingle: "리뷰노트",
    documentReviewNotes: "문서 노트",
    noEvidenceFilesAssociated: "이 task에 연결된 증거 파일이 없습니다",
    taskReviewNoteWithParenthesess: "Task 노트",
    taskNotes: "Task 노트",
    documentsNotes: "문서 노트",
    addNewDocumentNote: "문서 노트 추가",
    selectDocument: "문서 선택",
    taskReviewNotes: "Task 노트",
    showCleared: "처리된 항목 표시",
    Replied: "회신됨:",
    showClosed: "닫힌 항목 표시",
    allNotes: "모든 노트",
    myNotes: "내 노트",
    noTasksAvailable: "사용 가능한 task가 없습니다",
    noWCGWAvailableForTask: "사용 가능한 ROMM 없음",
    noSubstantiveTasksAvailable: "연결된 실증 task가 없습니다",
    noNotesAssociatedWithDocument: "이 문서에 연결된 노트가 없습니다",
    noNotesAssociatedWithTak: "이 task에 연결된 노트가 없습니다",
    otherEngagementNotes: "다른 engagement 노트",
    to: "to",
    deleteReviewNote: "삭제",
    missingToUserError: "필수",
    missingReviewNoteTextError: "리뷰노트 텍스트는 필수입니다",
    invalidReviewNoteTextError: "입력된 텍스트가 한도를 초과합니다",
    dueDateRequiredTextError: "만료일은 필수입니다",
    saveNoteTextError: "계속하려면 저장하거나 취소하십시오",
    engagementName: "Engagement 이름:",
    assignmentsCountLabel: "배정",
    AssignmentsDays: "일",
    closedOnTime: "적시 닫힘",
    daysToPrepare: "작성 기간",
    daysToReview: "검토 기간",
    totalAssignments: "총 <br>배정",
    currentlyAssigned: "현재 <br>담당",
    UpcomingAssignments: "임박",
    authoredByMe: "내가 작성",
    commentsLabel: "리뷰노트",
    clearedOnTime: "적시 처리됨",
    daysToClear: "처리 기간",
    daysToClose: "마감 기간",
    totalLabel: "총 노트",

    criticalAndHighRn: "Critical 및 high 노트",
    criticalAndHighComments: "Critical 및 high 노트",
    lowAndMediumComments: "Medium 및 low 노트",
    metricsInstructionalText: "아래에서 배정 및 노트에 대한 성과 지표를 보십시오. <br> 팀 멤버의 지표를 보려면 그를 선택하고, 전반적인 요약을 보려면 <b>Engagement 보기</b>를 선택하십시오.",
    metricsNewInstructionalText: "팀 멤버의 리뷰노트와 배정을 보려면 팀 멤버를 선택하고, 전반적인 요약을 보려면 <b>Engagement 보기</b>를 선택하십시오",
    switchToViewPlaceholder: "표시할 데이터가 없습니다.<br>다른 팀 멤버를 선택하거나 <b>Engagement 보기</b>로 바꾸십시오.",
    tasksClosedOnTime: "적시에 닫힌 task",
    daysDetailReview: "세부 검토 일수",
    daysGeneralReview: "일반 검토 일수",
    totalDaysReview: "총 검토 일수",
    metricsInstructionalTextconfiguration: "아래에서 배정 및 노트에 대한 전반적인 성과 지표 요약을 보십시오",

    //document download
    docSizeMB: "MB",
    docSizeKB: "KB",
    labelForExpiredPackage: "패키지가 만료됐습니다.",
    headerForDocumentDownload: "다운로드할 파일 이름을 클릭하십시오",
    labelForNoFiles: "선택한 범주에 파일이 없습니다",
    labelForProcessing: "파일을 처리 중입니다",

    //create dropdown texts
    create: "생성",
    addRequestText: "요청",
    addExternalTaskText: "외부 task",
    addFindingText: "발견사항",
    show: "표시:",
    riskTypeHeader: "위험 유형",
    wcgwHeader: "WCGW",
    hasNotes: "처리 전 노트",
    hasNote: "open note",
    noNotes: "(처리 전 노트 0)",
    addTemporaryFiles: "임시 파일 추가",
    addPriorPeriodEvidence: "전기 추가",
    addExternalDocuments: "외부 문서 추가",
    //Nav
    navHeaderTasks: "Task",
    quickFilterAllCompletedTasks: "완료한 모든 task",
    quickFilterMyCompletedAssignmnets: "완료한 내 배정",
    quickFilterMyUpcomingAssignments: "임박한 내 배정",
    navHeaderTaskCategory: "Task 범주",
    navFilterBy: "필터 옵션",
    navHeaderDocuments: "문서",
    navHeaderCollaboration: "공동작업",
    navHeaderAssignments: "배정",
    navHeaderAutomation: "자동화",
    navHeaderMore: "자세히",
    navDashboard: "대시보드",
    navReviewnotes: "리뷰노트",
    navHeaderManageteam: "팀 관리",
    navHeaderMangeteamNew: "팀 관리 - 신규",
    mangeteam: "팀 관리",
    postArchive: "Post archive",
    addmember: "멤버 추가",
    addnewmember: "신규 멤버 추가",
    addPriorPeriodMembers: "비활동 멤버 추가",
    addPriorPeriodUsers: "비활동 멤버 추가",
    createPackage: "패키지 생성",
    engagementrole: "Engagement 역할",
    noPendingPriorPeriodUsers: "초대할 비활동 멤버 없음",
    sendPriorPeriodUserInvitesWithCount: "({0}) 초대 보내기",
    sendPriorPeriodUserInvitesWithoutCount: "초대 보내기",
    priorPeriodMembersModalHeaderMessage: "Engagement에 추가하려는 비활동 멤버를 선택하십시오. 멤버들은 재활성화될 때 engagement에서 이전에 가지고 있던 권한을 받게 됩니다.",
    priorPeriodIndependenceModalHeaderMessage: "귀하의 engagement에 추가하려는 비활동 독립성 전용 멤버를 선택하십시오",
    disabledPriorPeriodMembersButtonToolTip: "이전 멤버를 추가할 권한이 없습니다. 이 작업을 하려면 적합한 권한이 있는 engagement 팀 멤버와 얘기하십시오.",
    disabledNewMembersButtonToolTip: "신규 멤버를 추가할 권한이 없습니다. 이 작업을 하려면 적합한 권한이 있는 engagement 팀 멤버와 얘기하십시오.",
    disabledNewMembersButtonToolTipThirdpartyuser: "신규 제3자 멤버를 추가할 권한이 없습니다. 이 작업을 하려면 적합한 권한이 있는 engagement 팀 멤버와 얘기하십시오.",
    rbacNoRightsForContentUpdateToolTip: "내용 업데이트를 수행할 권한이 없습니다. 내용 업데이트를 개시할 권한을 받으려면 engagement 관리자에게 문의하십시오.",
    deactivateInternalUsersWithCount: "{0} 멤버 선택됨",
    canvasFormSelectionMessageSingular: "{0} Canvas 양식 선택됨",
    canvasFormSelectionMessagePlural: "{0} Canvas 양식 선택됨",
    pspAccountSelectionMessageSingular: "{0} Account 선택됨",
    pspAccountSelectionMessagePlural: "{0} Account 선택됨",
    manageTeamGroupLabel: "그룹",
    manageTeamGroupsLabel: "그룹",
    allAccessGroups: "모든 접근 그룹",
    reactivate: "재활성화",
    deactivate: "비활성화",
    unselect: "모두 선택 해제",
    deactivateInternalModalTitle: "내부 멤버 비활성화",
    deactivateInternalModalMessage: "다음 팀 멤버를 비활성화하시겠습니까?",
    deactivateInternalUsersSuccessMessage: "{0} 멤버가 비활성화됐습니다",
    deactivateExternalModalTitle: "외부 멤버 비활성화",
    deactivateExternalModalMessage: "다음 팀 멤버를 {0}에서 비활성화하시겠습니까? 배정된 항목은 각 접근 그룹에 재배정됩니다.",
    deactivateExternalSuccessMessage: "멤버가 비활성화됐습니다",
    internalMember: "내부 멤버",
    addinternalmember: "내부 멤버 추가",
    addThirdPartymember: "제3자 멤버 추가",
    missingResponsiblePerson: "책임자 누락",
    sentRequests: "전송됨",
    receivedRequests: "수신됨",
    syncProfileNotAllowed: "프로필 동기화가 허용되지 않습니다",
    allSyncProfileNotAllowedMessage: "프로필 동기화가 허용되지 않습니다. 이 프로필에 양식을 사용할 수 없습니다.",
    allCanvasFormsContentUpdateMessage: "공유된 EY Canvas FIT enablement 활동에 내용을 전달할 수 없습니다. 내용 업데이트를 계속하려면 해당 활동에서 링크를 해제하십시오.",
    someFormContentUpdateMessage: "내용이 없어서 일부 양식을 engagement 프로필에 동기화할 수 없습니다",
    linkedFormContentUpdateMessage: "공유된 EY Canvas FIT enablement 활동에 내용을 전달할 수 없습니다. 내용을 업데이트 하려면 해당 활동에서 링크를 해제하십시오.",
    leaveUsFeedback: "피드백을 남겨 주십시오",

    notApplicableLabel: "N/A",
    addThirdPartyMemberDescription: "이 기능은 제3자 검토자에게 이 Canvas engagement 접근 권한을 부여하는 데만 사용해야 합니다. 심리실에서 적합한 승인과 허가를 받아야 합니다.",
    hasOverallResponsibilityDescription: "감사 또는 engagement의 지시, 감독, 수행과 상황에 적합한 보고서 및/또는 interoffice conclusion을 전반적으로 책임지는 감사팀 또는 engagment팀 멤버",
    partnerInChargeHeader: "Partner in charge / Executive in charge",
    picFlag: "PIC",
    CannotUpdatePicInArchivedEngagement: "제한된 필드에 대한 편집을 처리할 수 없습니다. 새로 고침하여 다시 시도하십시오.",

    noGroupFound: "이 Engagement에 접근 그룹이 생성되지 않았습니다 \'접근 그룹 추가\'를 선택하여 신규 외부 팀 멤버 접근 그룹을 생성하십시오.",
    addGroup: "그룹 추가",
    deleteGroup: "접근 그룹 삭제",
    deleteGroupMessage: "{0} 접근 그룹을 삭제하시겠습니까?",
    addAccessGroup: "접근 그룹 추가",
    accessGroupCreated: "신규 접근 그룹 {0}이(가) 생성됐습니다",
    accessGroupUpdated: "접근 그룹 {0}에 대한 변경사항이 저장됐습니다",
    editAccessGroup: "접근 그룹 편집",
    sharedGroupwarning: "이는 공유 접근 그룹이며 이에 대한 변경사항은 모든 관련 engagement에 반영됩니다",
    groups: "그룹",
    addExternalMembers: "모든 외부 멤버",
    members: "멤버",
    externalMember: "외부 멤버",
    member: "멤버",
    role: "역할",
    actions: "작업",
    internalUserEdit: "편집",
    internalUserDeactivate: "비활성화",
    usersFilter: "필터",
    externalUserEdit: "편집",
    externalUserDeactivate: "비활성화",
    externalUserGroupLabel: "그룹",
    externalNoUserInGroup: "이 접근 그룹에 멤버가 추가되지 않았습니다",
    externalNoUserInAllGroup: "이 engagement에 멤버가 추가되지 않았습니다",
    alias: "별칭",
    independence: "독립성",
    navManagegroup: "그룹 관리",
    navCRAsummary: "CRA 요약",
    navAuditplan: "감사 계획",
    navWorkplan: "작업 계획",
    navSEM: "실증절차평가표",
    nav440GL: "보고서일 후 변경사항",
    navFindings: "발견사항",
    navCanvasformupdates: "Canvas 양식 업데이트",
    navPSPContentUpdates: "PSP 내용 업데이트",
    navCopyhubNew: "복사 허브 - 신규",
    navCopyhub: "복사 허브",
    navArchiveChecklist: "Archive 체크리스트",
    navExporthub: "내보내기 허브",
    navReporting: "보고",
    navAccountSummary: "계정 요약",
    navScotSummary: "SCOT 요약",
    navItSummary: "IT 요약",
    navGroupInstructionSummary: "그룹 지침",
    navGroupInvolvement: "그룹 관여",
    navHelixProjects: "EY Helix 연결",
    navContentUpdates: "내용 업데이트",
    contentUpdateErrorMsg: "변경사항을 저장할 권한이 없습니다. 변경하려면 권한이 있는 다른 팀 멤버에게 문의하십시오.",
    contentUpdateTitleTip: "내용 업데이트를 수행할 권한이 없습니다. 내용 업데이트를 개시할 권한을 받으려면 engagement 관리자에게 문의하십시오.",
    noPreviousUpdates: "이전 업데이트 없음",
    noContentUpdateResults: "결과를 찾을 수 없습니다",
    noPSPAccountsToUpdate: "업데이트할 계정 없음",
    rbcaUnavailableMsg: "지금은 EY Canvas에서 변경사항을 저장할 수 없습니다. 다시 시도하고 문제가 지속되면 헬프 데스크에 문의하십시오.",
    showErrInProgressMsg: "29007 - 다음 업데이트가 진행되는 동안에는 내용 업데이트를 시작할 수 없습니다. 현재 내용 업데이트가 완료될 때까지 기다리거나 페이지를 새로 고침하여 다시 시도하십시오.",
    navHelp: "일반 도움말",
    validationNavHelp: "유효성 검증 도움말",
    searchUserText: "사용자 검색",
    superModelTitle: "Engagement object",
    superModelText: "수퍼 모달",
    independenceOnlyMembers: "독립성 전용 멤버",
    noIndependenceOnlyPriorPeriodUsers: "초대할 비활동 독립성 전용 멤버 없음",

    //Copyright
    copyRight: "Copyright © <year> all rights reserved",

    //Copyhub List labels
    moreRecipient: "기타",
    copyHubPackageName: "패키지 이름",
    copyHubSentBy: "전송한 사람",
    copyHubSentTo: "전송 대상",
    copyHubReceivedBy: "수신한 사람",
    copyHubDate: "날짜",
    copyHubRemainingTime: "잔여 시간",
    copyHubAvailableFor: "사용 가능",
    copyHubStatus: "상태",
    noCopyHubSentPackages: "복사 패키지가 아직 생성되지 않았습니다. 신규 데이터 패키지를 생성하려면 패키지 생성을 선택하십시오.",
    noCopyHubReceivedPackages: "이 engagement에 사용 가능한 복사 패키지가 없습니다",
    remainingTimeTooltip: "항목은 archive 시 또는 생성 3일 후에 영구히 제거됩니다.",
    copyHubDeleteText: "삭제",
    appendDays: "일",
    generalInformation: "일반 정보",
    copyDocuments: "문서",
    copyFiles: "파일",
    scots: "SCOT",
    accounts: "계정",
    copyHubImport: "불러오기",
    copyHubPackageType: "패키지 유형:",
    copyHubCreatedModal: "생성:",
    copyHubRemainingTimeModal: "잔여 시간:",
    copyHubAvailableForModal: "사용 가능:",
    copyHubInstructionModal: "지침:",
    copyHubCategories: "범주",
    copyHubPendingDeletion: "삭제 보류 중",
    copyHubVersionMismatchCat: "패키지 버전 불일치로 범주를 표시할 수 없습니다",
    copyHubVersionMismatchPersonInfo: "패키지 버전 불일치로 발신자와 수신자 정보를 표시할 수 없습니다",
    copyHubViewLegacyPacakgeDetails: "자세한 정보를 사용할 수 없는 레거시 복사 패키지 입니다",
    associateTasks: "Task 연결",
    backToForms: "양식으로 돌아가기",
    noTaskSelected: "Task를 하나 이상 선택해야 합니다",
    taskLabel: "Task :",
    taskMessage: "Task를 이러한 불러오기 양식과 연결해야 합니다",
    importSuccessMessage: "불러오기 요청이 대기 중입니다",
    taskSelectedText: "task 선택됨",
    insufficientPermissionsToImport: "복사 패키지를 불러올 권한이 없습니다. Engagement 관리자에게 문의하여 복사 패키지 불러오기 권한을 요청하십시오.",
    cannotImportExpiredPackage: "만료된 복사 패키지를 불러올 수 없습니다",
    cannotImportWhileInProgress: "이미 진행 중인 복사 패키지를 불러올 수 없습니다",
    deletePackageHeader: "패키지 삭제",
    copyPackageDeleted: "패기지가 삭제됐습니다",
    copyPackageDeleteConfirmation: "이 패키지를 삭제하시겠습니까?",
    insufficientPermissionsToDelete: "복사 패키지를 삭제할 권한이 없습니다. Engagement 관리자에게 문의하여 복사 패키지 삭제 권한을 요청하십시오.",
    insufficientPermissions: "권한 미비",
    GuidedWorkflowsPackageDisplayText: "불러오기를 선택하면 복사본에서 이 engagement로 일치하는 가이드 업무흐름이 업데이트됩니다. 일치하지 않는 가이드 업무흐름은 불러오지 않습니다.",
    copyRequestStatusInQueue: "대기 중",
    GuidedWorkflowImportError: "Multi-entity engagement에서는 가이드 업무흐름 가져오기를 사용할 수 없습니다",

    //TopHeaderLayout.js
    topHeaderLayoutMilestoneText: "Mile Stone 재무정보를 원천회계기록과 대사하거나 조정합니다. 중간재무정보가 원천회계기록과 일치하거나 조정된다는 증거를 입수합니다.",
    //TaskLayoutHeader
    taskLayoutHeaderSearchPlaceholder: "Task 검색",
    taskLayoutHeaderAssignments: "배정",
    taskLayoutHeaderAddTask: "신규 task",
    wcgwSearchPlaceholder: "WCGW 검색",
    //TaskListHeader
    taskTypeHeader: "유형",
    taskNameHeader: "이름",
    taskDueDateHeader: "만료일",
    reviewNoteChangeDueDate: "만료일 변경",
    taskListHeaderSortByDueDate: "만료일",
    taskListHeaderSortByTaskName: "Task 이름",
    sortBy: "정렬 순서:",
    ascending: "오름차순",
    descending: "내림차순",
    taskListHeaderSortByKnowledge: "감사 계획",
    taskListHeaderDeleteWarning: "선택한 task를 삭제하시겠습니까",
    taskListHeaderSortText: "정렬",
    taskListHeaderSortOrderText: "정렬 순서",
    taskListHeaderTimePhaseText: "시기 설정",
    taskListHeaderBookMarkText: "북마크",
    taskListHeaderFavoriteText: "즐겨찾기",
    taskListHeaderEditText: "Task 제목 편집",
    moreMenu: "기타",
    taskListHeaderMoveTaskText: "Task 그룹 변경",
    taskGroupIconHoverText: "Task 그룹 변경",
    taskGroupLabel: "그룹 변경",
    task: "Task",
    toc: "TOC",
    tenNotes: "10 노트",
    source: "원천",
    nature: "성격",
    assertion: "경영진주장",
    relatedAccounts: "연결된 계정",
    testOfDetail: "세부 테스트",
    testOfControl: "통제테스트",
    substantiveAnalyticalProcedure: "실증적 분석절차",
    tod: "TOD",
    sap: "SAP",
    int: "INT",
    ext: "EXT",
    notSel: "선택되지 않음",
    internal: "내부",
    external: "외부",
    notSelected: "선택되지 않음",
    documentCannotOpen: "이 문서는 Task 세부정보에서 열 수 없습니다. 이 문서를 열려면 문서 목록으로 가십시오.",
    //TaskPanelLayout
    emptyTaskDetailsMessage: "세부정보를 보려면 task를 선택하십시오",
    multiTaskSelectedMessage: "한꺼번에 제어하려면, control 키를 이용하여 여러 task를 선택하십시오. \n 개별 task에서 작업하려면, task 목록에서 해당 task를 선택하십시오.",
    emptyAndMultiSelectedMessage: "한꺼번에 제어하려면, 체크박스를 이용하여 task를 하나 이상 선택하십시오. 여러 task를 한 번에 선택하려면 Shift 키를 이용하십시오. 개별 task에서 작업하려면 목록에서 해당 task를 선택하십시오.",
    //Evidence
    evidenceDragAndDrop: "끌어서 놓기 또는",
    //Timephases
    noResultTimePhase: "결과를 찾을 수 없습니다",
    //handoff
    handoff: "Hand-off",
    handoffConfirmButtonText: "Hand-off",
    handoffModalTitle: "Hand-off task",
    handoffTitle: "다음 팀 멤버에게 hand-off",
    handoffTextLine2: "증거 파일에 sign-off하려면, 아래 옵션에서 선택하십시오",
    return: "반송",
    returnDisabledMessage: "(1) 귀하가 작성자로 배정되어 있거나, (2) task가 '리뷰 중' 또는 '완료' 상태이거나 (3) 배정된 작성자가 없기 때문에 이 task를 반송할 수 없습니다",
    handOffTitleTip: "리뷰를 위해 Hand-off",
    //Mark Complete
    markCompleteTitleTip: "완료 표시",
    markCompleteTitle: "Task 완료 표시",
    markCompleteText: "아래 지정한 대로, 이 task에 연결된 증거에 sign-off가 적용됩니다. 이 task는 완료 표시됩니다.",
    markCompleteTextLine1: "이 task를 다음 팀 멤버에게 hand-off합니다",
    markCompleteTextLine2: "증거 파일에 sign-off하려면, 아래 옵션에서 선택하십시오. 귀하에게 이 task가 배정됐고 이를 마쳤다면, <b>예</b>를 선택하여 닫으십시오. 이 task에 PIC 또는 EQR sign-off가 필요하다면 아래 옵션에서 선택하십시오.",
    markCompleteConfirm: "완료 표시",
    signOffAs: "모두 Sign-off:",
    additionalSignOff: "추가 필수 sign-off",
    additionalTaskStatus: "내 배정 닫기",
    markCompleteModalHeaderTextPart1: "이 task가 완료 표시됩니다",
    markCompleteModalHeaderTextPart2: "증거 파일에 sign-off하려면, 아래 옵션에서 선택하십시오. 귀하에게 이 task가 배정됐고 이를 마쳤다면, <b>예</b>를 선택하여 닫으십시오. 이 task에 PIC 또는 EQR sign-off가 필요하다면 아래 옵션에서 선택하십시오.",
    ep: "PIC",
    eqr: "EQR",
    closeMyAssignment: "내 배정 닫기",
    tempMarkCompleteMessage: "Task에 완료 표시할 수 없습니다. 페이지를 새로 고침하여 다시 시도하십시오. 문제가 지속되면 헬프 데스크에 문의하십시오.",
    tempMarkCompleteEnable: "완료 표시-활성화",
    tempMarkCompleteDisable: "완료 표시-비활성화",
    //TaskDetails
    seeTask: "Task 보기",
    NoTasksFound: "Task를 찾을 수 없습니다",
    taskDetailsAddRelate: "추가/연결",
    taskDetailsDocument: "문서",
    taskDetailsAutomationRequest: "자동화 요청",
    taskDetailsExternalTask: "외부 task",
    taskDetailsFinding: "발견사항",
    taskDetailsRequest: "요청",
    taskDetailsNotes: "노트",
    taskDetailsRelatedTask: "연결된 Task",
    epeqr: "PIC/EQR",
    epeqrsignoffheader: "Sign-off 필요",
    addTaskGroupLabel: "Task 그룹 추가",
    itgcTaskDescription: "의존대상기간 동안의 운영 효과성에 대한 충분하고 적합한 감사증거를 입수하기 위해 설계된 ITGC 테스트를 수행합니다",
    //create assignment
    createassignmentheaderLine1: "선택한 팀 멤버에게 이 task가 배정되지 않았습니다",
    createassignmentheaderLine2: "여기에서 배정을 생성하십시오. 다른 팀 멤버에게 동일한 유형의 미완료 배정이 이미 있다면,",
    createassignmentheaderLine3: "다음을 선택하여",
    createassignmentheaderLine4: "이 배정을 대체합니다.",
    overwriteIncompleAssignments: "미완료 배정 덮어쓰기",
    //Create Assignment
    createassignmentheader1: "선택한 팀 멤버에게 이 task가 배정되지 않았습니다",
    createassignmentheader2: "여기에서 배정을 생성하십시오",
    //Guidance
    atlasLink: "Atlas 링크",
    automationLink: "스마트 자동화 링크",
    otherLink: "기타 링크",
    helixLink: "Helix 링크",
    relatedAutomations: "연결된 자동화",
    noSuggestedAutomationLabel: "이 task에 권장된 자동화가 없습니다",
    noSuggestedItemLabel: "이 task에 권장된 항목이 없습니다",
    noAutomationRequestLabel: "이 task는 어느 자동화에도 연결되어 있지 않습니다. 시작하려면, 신규 자동화를 생성하거나 기존 자동화를 연결하십시오.",
    relateAutomation: "연결",
    relateAutomationModelHeader: "스마트 자동화 연결",
    automationSolution: "솔루션",
    automationName: "자동화 이름",
    relateAutomationTextLine1: "스마트 자동화를 이 task에 연결합니다",
    relateAutomationTextLine2: "연결되고 나면, task 세부정보에서 자동화를 볼 수 있고 클릭하여 열 수 있습니다",
    noSamrtAutomationForEngagement: "Engagement에 스마트 자동화가 생성되지 않았습니다",
    searchAutomationLabel: "자동화 검색",

    //RelatedItemHeader
    relatedItemsHeader: "연결된 항목",
    relateButtonText: "연결",
    createButtonText: "생성",
    relatedItemREQ: "요청",
    relatedItemET: "외부 task",
    relatedItemATM: "자동화",
    relatedItemRelatedTask: "연결된 task",
    relateObjectsToTaskTitle: "Object를 이 task에 연결합니다",
    relateObjectsToTaskSubTitle: "하나 이상의 object를 이 task에 연결합니다. 이 object는 task 세부정보의 연결된 항목 섹션에 나타납니다.",
    relateObjectOptionsHeaderPSPOSP: "계정, 경영진주장 및 limited risk 계정",
    relateObjectOptionsHeaderITWalkthrough: "IT 프로세스",
    relateObjectOptionsHeaderITControl: "IT 통제 (ITGC 및 ITSP)",
    // SDM Nextwave services
    scheduledServicesText: "연결된 서비스",
    suggestedServicesText: "권장 서비스",
    suggestedServicesDefaultMessage: "이 task에 권장되는 NextWave 서비스가 있습니다.",
    suggestedServicesDefaultMessage1: '+',
    suggestedServicesDefaultMessage2: "아이콘을 선택하여 시작하십시오.",
    suggestedServicesPlaceholderMessage: "이 task에 권장 서비스가 없습니다",
    nextWaveServiceOfferingLabel: "서비스",
    nextWaveServiceStatusLabel: "상태",
    nextWaveServiceStartDateLabel: "시작",
    nextWaveServiceDueDateLabel: "만료",
    nextWaveServiceRequestCreate: "요청 생성",
    nextWaveServiceRequests: "중앙집중식 서비스 요청사항",
    nextWaveServiceGatewayRequests: "서비스 게이트웨이 요청사항",
    onlyShowSelectedTask: "선택한 task만 표시",
    sdmRestrictAddTaskLabel: "다음 단계로 진행하려면 계속을 클릭하십시오. 서비스 제공이 수락되고 GDS 프로세스 기반 팀 관리자가 완료할 작업을 논의하기 위해 연락한 후에, task를 선택할 수 있습니다.",
    //Links
    linksText: "링크",
    //Forms
    formsText: "양식",
    /*Accounts*/
    associatedTasks: "WCGW 항목과 연결된 Task",
    noAssertionsChecked: "연결된 WCGW을 보려면 경영진주장을 선택하십시오",
    noAccountsCreated: "생성된 계정이 없습니다",
    noDesignationSelected: "선택된 지정 없음",
    noRelatedAccounts: "연결된 계정 없음",
    manageAccount: "계정 및 공시 관리",
    /*Risks*/
    risk: "위험",
    risks: "위험",
    wcgw: "WCGW",
    riskWcgw: "위험:WCGW",
    wcgwTasks: "WCGW: Task",
    riskWcgwLabel: "위험을 WCGW에 연결",
    wcgwTasksLabel: "WCGW을 Task와 연결",
    noRiskTypes: "위험 유형을 찾을 수 없습니다",
    saveRisk: "저장",
    noRisksFound: "위험을 찾을 수 없습니다",
    haveBeenIdentified: "이(가) 식별됐습니다",
    noAssertionFound: "이 engagement에 적용 가능한 관련 경영진주장 없음",
    noAssertionApplicable: "이 engagement에 해당 경영진주장이 연결되지 않았습니다",
    noWCGWFound: "이 위험에 연결된 WCGW이 없습니다. 연결 편집을 클릭하여 하나 이상의 WCGW을 연결합니다.",
    noRelatedWCGWs: "연결된 WCGW이 없습니다",
    noRelatedControls: "연결된 통제 없음",
    noRelatedRisks: "연결된 IT 위험 없음",
    noRelatedITGCs: "연결된 ITGC 없음",
    iTriskVal: "IT 위험",
    iTrisksVal: "IT 위험",
    iTGCVal: "ITGC",
    iTGCsVal: "ITGC",
    iTSPVal: "ITSP",
    iTSPsVal: "ITSP",
    iTGCname: "ITGC 이름",
    iTSPname: "ITSP 이름",
    noWCGWAvailable: "선택된 경영진주장에 사용 가능한 ROMM이 없습니다",
    relevantWcgwCountHint: "계정 이름 옆에 표시된 수는 총 WCGW 개수 대비 의존하지 않는 통제위험이 있는 경영진주장이나 위험이 높은 추정치 관련 경영진주장과 관련되어 실증절차에 연결된 WCGW 개수로 해석해야 합니다",
    noAccountsFound: "기록을 찾을 수 없습니다",
    selectAssertionToRelateWCGW: "위험을 WCGW과 연결하려면 경영진주장을 선택하십시오",
    significantAccounts: "유의적인 계정",
    riskName: "위험:",
    accountName: "계정:",
    noScotsFound: "연결된 SCOT이 없습니다",
    relatedwcgw: "연결된 WCGW",
    relatedRisks: "연결된 위험",
    noRelatedAssertionsLabel: "계정에 선택된 경영진주장 없음",
    boltIconTitle: "연결된 위험",
    instructions: "지침",
    expandRisk: "1. 위험을 확장합니다",
    selectAssertion: "2. 경영진주장을 선택합니다",
    identifyRelatedWCGW: "3. 위험에 관련된 WCGW을 식별합니다",
    clickAccount: "1. 계정을 클릭합니다",
    selectWCGW: "2. WCGW을 선택합니다",
    identifyRelatedTask: "3. WCGW에 대응하는 task를 식별합니다",
    information: "정보",
    requiredAssertions: "필수 경영진주장",
    wcgwWithoutTasks: "Task 없는 WCGW",
    found: "발견됨",
    editAssociations: "연결 편집",
    riskWCGW: "위험:WCGW 관계",
    wcgwTask: "WCGW:Task 관계",
    requireTaskToBeRelated: "연결할 task가 필요합니다",
    expandCollapse: "확장/축소하려면 여기를 클릭하십시오",
    requiredAssertionsInfo: "의존하지 않는 통제위험이 있는 경영진주장과 위험이 높은 추정치 관련 경영진주장만 표시",
    wCGWwithoutTasksInfo: "의존하지 않는 통제위험이 있는 경영진주장과 위험이 높은 추정치 관련 경영진주장에 관련되며, 이에 대응하는 실증 task가 연결되지 않은 WCGW만 표시",
    noBuildStepsAvailable: "표시할 수 있는 작성 단계가 없습니다",
    accountRiskAssessmentSummary: "계정 및 공시",
    manageRisk: "위험 관리",
    addResponsivePSPOSP: "대응 PSP/OSP 추가",
    assertionlbl: "경영진주장",
    addResponsiveControl: "대응 통제 추가",
    addResponsiveTOC: "대응 TOC 추가",
    showOnlyRelatedItems: "연결된 항목만 표시",
    relatedControlCounter: "{0} 통제",
    relatedControlsCounter: "{0} 통제",
    noControlsAvailableForRelateItem: "사용 가능한 통제 없음",
    relateControlName: "통제",
    relateContolsAPIErrorMessage: "통제를 경영진주장에 연결할 수 없습니다. 페이지를 새로 고침하여 다시 시도하십시오. 문제가 지속되면, 헬프 데스크에 문의하십시오.",
    relateTasksAPIErrorMessage: "Task를 경영진주장에 연결할 수 없습니다. 페이지를 새로 고침하여 다시 시도하십시오. 문제가 지속되면, 헬프 데스크에 문의하십시오.",
    toggleFilterWarningMessage: "실증절차가 없는 계정 및 공시만 표시",
    toggleFilterWarningMessageForRisk: "대응 실증절차 또는 통제/TOC가 없는 위험만 표시",
    warningIconHoverText: "대응 실증절차 또는 통제/TOC가 없는 위험",
    filterYes: "예",
    filterNo: "아니오",

    /*OrphanedControls*/
    orphanedControls: 'View unrelated controls',
    unRelatedOrphanControls: 'Unrelated controls',
    noOrphanedControlsDataLabel: "No unrelated controls available",
    noOrphanedControlsResultLabel: "No unrelated controls available",
    noControlSelected: 'At least one control must be selected for deletion.',
    controlsDeleteConformation: 'Are you sure that you want to delete the selected controls?',
    controlDeleteConformation: 'Are you sure that you want to delete the selected control?',
    deleteControlModalHeader: 'Confirm deletion of selected control',
    deleteControlsModalHeader: 'Confirm deletion of selected controls',

    /*SEM*/
    select: "선택",
    selectAnAccountFromTheDropDown: "1. 드롭다운에서 계정을 선택합니다",
    applyAsertionsFilters: "2. 경영진주장 필터를 적용합니다",
    reviewTheTasksThatRespondToTheRisks: "3. 위험에 대응하는 task를 검토합니다",
    riskOfMaterialMisstatement: "중요왜곡표시위험",
    expandScot: "1. SCOT을 확장합니다",
    selectWCGWToDisplayTheResponsiveTask: "2. 중요왜곡표시위험을 선택하여 대응하는 task를 표시합니다",
    tasksWithNoRelatedWCGW: "중요왜곡표시위험이 연결되지 않은 task",
    selected: "선택됨",
    clearSelections: "모두 선택 해제",
    romm: "ROMM",
    selectAccount: "계정",
    selectHeader: "머리글 선택",
    riskOfMaterialMisstatementsWithoutRelatedTask: "Task가 연결되지 않은 중요왜곡표시위험",
    selectOneOrMoreTasksToSeeTheRelatedROMM: "연결된 ROMM을 보려면 하나 이상의 task를 선택하십시오",
    invalidRelatedEntity: "연결된 계정을 찾을 수 없습니다. 페이지를 새로 고침하여 다시 시도하십시오. 문제가 지속되면 헬프 데스크에 문의하십시오.",
    scrollUp: "위로 스크롤",
    scrollDown: "아래로 스크롤",
    duplicate: "복제",
    showIndex: "Index 표시",
    noContentAvailable: "사용 가능한 내용이 없습니다",
    navigateTo: "다음으로 이동",
    /*validations */
    semValidation: "SEM 유효성 검증",
    riskWCGWValidation: "위험 WCGW 유효성 검증",
    showValidation: "유효성 검증",
    wcgwWithNoRelatedTask: "실증 task가 연결되지 않은 WCGW",
    riskWithNoRelatedWCGW: "WCGW이 연결되지 않은 위험",
    noValidationIdentified: "식별된 유효성 검증이 없습니다",
    onlyShowScotWithNoControlNoWCGW: "WCGW 또는 통제가 연결되지 않은 SCOT만 표시",
    /*CRA Badge*/
    ir: "IR",
    cr: "CR",
    cra: "CRA",
    selectToEdit: "편집 선택",
    both: "둘 다",
    prefix: "Prefix",
    suffix: "Suffix",
    optional: "(선택 사항)",
    title: "제목",
    charLimitExceeded: "문자 한도를 초과했습니다",
    requiredField: "필수 필드",
    Lastmodifiedby: "최근 수정한 사람",
    fileSize: "| {1} KB",
    fileSizeInKB: "{1} KB",
    fileSizeHeader: "파일 크기",
    daysAgo: "일 전",
    weekAgo: "주 전",
    weeksAgo: "주 전",
    monthAgo: "개월 전",
    monthsAgo: "개월 전",
    yearAgo: "년 전",
    yearsAgo: "년 전",
    currentlyBeingModifiedBy: "현재 수정 중인 사람",
    beingEditedInCoeditModeError: 'Being edited in multi-user edit',
    beingEditedInCoeditMode: 'Being edited in multi-user edit. Edit started by {0} ',
    beingEditedInCoeditModeOn: 'on {0}.',
    coEditModeAutomaticallyEnds: 'Multi-user editing. {0} days until multi-user editing automatically ends.',
    coEditModeIsEnding: "Multi-user 편집이 종료됩니다",
    coEditMode: "Multi-user 편집 중",
    checkInInProgressMessage: "체크인 진행 중. 문서가 체크인되는 데 20분까지 소요될 수 있습니다. 업데이트하려면 새로 고침하십시오.",
    checkOutInProgressMessage: "체크아웃 진행 중. 문서가 체크아웃되는 데 20분까지 소요될 수 있습니다. 업데이트하려면 새로 고침하십시오.",
    daasErrorMessage: "지금은 작업을 완료할 수 없습니다. 페이지를 새로 고침하여 다시 시도하십시오. 문제가 지속되면, 헬프 데스크에 문의하십시오.",
    coEditModeIsStarting: "Multi-user 편집이 시작됩니다",
    daasOpenDocumentWarning: 'Multi-user editing may have been ended by another user. Refresh the page and try again.',
    daasStartCollaborationModeWarning: 'Collaboration mode may have been started by another user. Refresh the page and try again.',
    documentCurrentlyBeingModifiedTitle: 'Document currently being modified',
    documentCurrentlyBeingModifiedHeader: 'This document is currently being modified by {0}. This user opened the document',
    documentCurrentlyBeingModifiedBody: 'Starting multi-user edit mode could cause conflicts, so we recommend discussing with {0} before proceeding. Select {1} to start the multi-user edit mode or {2} to return without starting multi-user edit mode.',
    documentEndMultiUserEditingTitle: 'Confirm you want to end multi-user editing',
    documentEndMultiUserEditingHeader: 'Warning: Other users may be actively editing this document.  This can be checked by opening the document and seeing if other users are currently in the file. Please confirm that all changes are complete before ending multi-user mode. File changes in multi-user mode may take up to 1 minute to be processed. Therefore, please wait at least 1 minute after exiting the file before ending multi-user mode.',
    documentEndMultiUserEditingBody: 'Select {0} to end the multi-user edit mode or {1} to return without ending multi-user edit mode.',
    startMultiuserEditing: 'Start',
    continue: "계속",
    openReadOnly: "읽기 전용으로 열기",
    takeControlFromTeam: "현재 팀멤버에게서 통제권 받기",
    itapplication: "IT Application",
    aggregateITevaluation: "Aggregate IT evaluation:",
    control: "통제",
    itgcitsp: "ITGC/ITSP",
    limitedRisk: "Limited Risk 계정",
    so: "SO",
    itApp: "IT App",
    itAppType: "IT App",
    deleteTaskModalHeader: "선택한 task 삭제 확인",
    deleteTasksModalHeader: "선택한 task 삭제 확인",
    deleteTaskModalMessage: "선택한 task를 삭제하시겠습니까?",
    deleteTaskModalMessage1: "다른 task와 연결되지 않은 관련 증거는 임시 파일로 이동됩니다. 다른 증거와 연결되지 않은 발견사항과 응답 task는 삭제됩니다.",
    deleteTasksModalMessage: "선택한 task를 삭제하시겠습니까?",
    someTasksCannotBeDeleted: "일부 task를 삭제할 수 없습니다",
    onlySomeTasksCanBeDeleted: "선택한 task 중 일부만 삭제할 수 있습니다",
    tasksThatCanBeDeleted: "계속을 선택하면 engagement에서 <b>아래 열거된 task가 제거됩니다</b>. Engagement에 있는 다른 task와 연결되지 않은 증거는 임시 파일로 이동됩니다. 다른 증거와 연결되지 않은 발견사항과 응답 task도 삭제됩니다.",
    tasksThatCannnotBeDeleted: "Engagement에서 <b>아래 열거된 task를 제거할 수 없습니다</b>. 그러나 필요한 경우, 감사 계획에서 거절할 수 있습니다.",
    accountHeader: "계정",
    noAccountsIdentified: "계정이 식별되지 않았습니다",
    noRisksIdentified: "위험이 식별되지 않았습니다",
    noAssertionsIdentified: "경영진주장이 식별되지 않았습니다",
    noWcgwsIdentified: "WCGW이 식별되지 않았습니다",
    // Tasks/TaskDetails/Evidence
    addEvidence: "증거 추가",
    relateEvidence: "증거 연결",
    relateTemporary: "임시 파일 연결",
    relatePriorPeriod: "전기 증거 연결",
    relateExtDoc: "외부 문서 연결",
    relateFile: "파일 연결",
    relateAnalytics: "분석 연결",
    quickAddButton: "빠른 추가",
    createPaperProfile: "Paper Profile 생성",
    paperProfileInformationMessage: "작성 및 검토 sign-off를 비롯한 모든 조서는 전자 형태로 작성합니다. 경영진이나 제3자가 종이 형태로 제공하고 전자사본(예, 기업과 제3자 간에 서명된 계약서 사본)이 없는 문서인 경우에만 조서에 종이 문서화가 허용됩니다.",
    paperProfileName: "Paper Profile 이름",
    paperProfileAdd: "추가",
    paperProfileError: "유효한 paper profile 이름을 입력하십시오",
    otherEngagementsInWorkspace: "이 workspace 내 다른 engagement",
    relateDescription: "이 engagement 또는 이 workspace에 있는 다른 engagement에서 문서를 연결하십시오",
    onlyShowRelatedDocuments: "연결된 문서만 표시",
    relateDescriptionTemp: "이 engagement에서 문서 연결",
    added: "추가됨",
    documentLocation: "문서 위치",
    documentIneligibleForSharingMessage: "기밀 문서는 공유할 수 없습니다",
    confidentialityNotAppropiateForSharing: "귀하에게 이 문서를 전송하는 데 적합한 기밀 수준이 없습니다",
    documentIsCheckedOut: "문서가 공동편집 모드이므로 공유될 수 없습니다. 문서를 공유하려면 공동편집 모드를 종료하십시오.",
    addCanvasFormNew: "신규 canvas 양식 추가",
    documentCount: "{0} 문서",
    documentsCount: "{0} 문서",
    fitDocumentCannotbeSelected: "FIT 문서는 engagement 간에 공유할 수 없습니다",
    // Task/TaskDetail/Description
    noDescriptionAvailable: "사용 가능한 설명 없음",
    knowledge: "Knowledge",
    knowledgeDescription: "Knowledge 설명",
    descriptionInstructions: "지침의 설명",
    fromInstructions: "지침에서",
    customizeDescription: "수정된 설명",
    custimizeTaskDescription: "Task 설명 수정",
    editTaskDescription: "Task 설명 편집",
    saveLabel: "저장",
    okLabel: "확인",
    cancelLabel: "취소",
    leaveCommentLabel: "Comment를 남기십시오",
    addLabel: "추가",
    closeLabel: "닫기",
    editText: "편집",
    enterReply: "회신 입력",
    reply: "회신",
    deleteTagDesc: "태그 삭제는 실행 취소할 수 없습니다. 계속하시겠습니까?",
    requiredText: "텍스트는 필수입니다",
    descriptionEmptyError: "설명은 필수입니다",
    descriptionMaxLengthError: "설명 길이가 최대 허용 길이를 초과합니다",
    assignmentDueDate: "배정 만료일",
    navigateToGuidedWorkflow: "EY Canvas FIT enablement로 이동",
    openInTasksPage: "Task에서 열기",
    copyTaskLink: "Task 링크 복사",
    copyReviewNoteLink: "리뷰노트 링크 복사",
    urlCopiedLabel: "링크가 복사됐습니다",
    //Related Tasks
    showOnlyRelatedTask: "연결된 항목만 표시",
    noTaskAvailable: "사용 가능한 task 없음",

    // Client Request / Client Request Detail /  Client Request Drawer
    openInCollaborationPage: "공동작업에서 열기",
    copyRequestLink: "요청 링크 복사",
    requestType2MessageTitleDrawer: "이 요청에 추가 기능이 있습니다",
    requestType2MessageSubtitleDrawer1: 'Please',
    requestType2MessageSubtitleDrawer2: "여기를 클릭하여",
    requestType2MessageSubtitleDrawer3: "이동하십시오",

    // SeeMore component
    showMore: "더 표시",
    showLess: "덜 표시",
    showMoreEllipsis: "더 표시…",
    showLessEllipsis: "덜 표시…",

    // Request Description
    saveAndCloseButtonLabel: "저장 및 닫기",
    saveButtonLabel: "저장",
    cancelButtonLabel: "닫기",

    // Request Description Modal labels
    discardChangesModalText: "변경사항 폐기",
    inlineSaveUnsavedChanges: "저장되지 않은 변경사항이 있습니다. 계속하시겠습니까?",

    // RelateWCGWModal labels
    wcgwName: "WCGW 이름",
    wcgwByScot: "SCOT별 WCGW",
    unrelatedSCOTsHeader: "연결되지 않은 SCOT",
    unrelatedSCOTPlaceholder: "연결되지 않은 SCOT 없음",
    noWcgwPlaceholder: "WCGW이 생성되지 않았습니다",
    showOnlyUnrelatedWCGW: "연결되지 않은 항목만 표시",

    // CharCount component.
    of: "of",
    characters: "characters",
    fromUserLabel: "From",
    toUserLabel: "To",
    handoffto: "Hand-off 대상",
    priorityLabel: "우선순위",
    addNoteLabel: "추가",
    replyNoteLabel: "회신",
    characterCountLabel: "of 4000 characters",
    taskNotePlacehodler: "Task 노트 입력",
    documentNotePlacehodler: "문서 노트 입력",
    taskNoteStatusBy: "by:",
    addNewReviewNoteButtonText: "신규 노트",
    fromKnowledge: "From Knowledge",
    /*day labels*/
    mon: "월",
    tues: "화",
    wed: "수",
    thurs: "목",
    fri: "금",
    sat: "토",
    sun: "일",
    /*month labels*/
    jan: "1월",
    feb: "2월",
    march: "3월",
    april: "4월",
    may: "5월",
    june: "6월",
    july: "7월",
    august: "8월",
    sept: "9월",
    oct: "10월",
    nov: "11월",
    dec: "12월",
    /*Rename*/
    documentDropdown: "문서 드롭다운",
    fileNameRequired: "파일 이름은 필수입니다",
	invalidCharacters: '파일 이름에 다음을 포함할 수 없습니다: */:<>\\?|\"',
    existingFileName: "파일 이름이 고유하지 않습니다. 이 메시지를 제거하려면 페이지를 새로 고침하거나 파일 이름을 변경하십시오.",
    unknowError: "예상치 못한 오류가 발생했습니다. 페이지를 새로 고침하여 이 메이시를 제거하십시오.",
    maxLengthExceeded: "문서 이름은 115자를 초과할 수 없습니다",
    documentNameSyncErrorMessage: "문서 이름을 Canvas Client Portal에 동기화할 수 없습니다. 페이지를 새로 고침하여 다시 시도하십시오.",
    /*Delete*/
    deleteFileTitle: "문서 삭제",
    deleteFileCloseBtnTitle: "취소",
    deleteFileConfirmBtnTitle: "삭제",
    deleteFileCloseTitle: "닫기",
    deleteFileModalMessage: "선택한 문서를 삭제하시겠습니까?",
    none: "없음",
    /*Unlink*/
    unlinkFileTitle: "공유된 증거 링크 해제",
    unlinkSource: "원천",
    unlinkTarget: "대상",
    unlinkFileCloseBtnTitle: "취소",
    unlinkFileConfirmBtnTitle: "확인",
    unlinkFileCloseTitle: "닫기",
    unlinkFileModalMessage: "이 공유된 증거 파일을 링크 해제하시겠습니까?",
    /*Relate Tasks*/
    relateTasksTitle: "Task 연결",
    relateTaskSearchPlaceholder: "Enter 키를 눌러 검색합니다",
    relateTaskInstructionalText: "문서가 연결되어야 하는 task를 추가하거나 제거합니다. 문서가 증거인 경우, 마지막 task에서 이를 제거하면 임시 파일로 이동합니다.",
    relatedTaskInstructionalText: "문서가 이 engagement 내 다음 task와 연결되어 있습니다. task로 이동하려면 task 이름을 클릭하십시오.",
    relateTaskName: "Task 이름",
    relateTaskType: "유형",
    relatedTaskCounter: "{0} task",
    relatedTasksCounter: "{0} tasks",
    /*Relate Entities*/
    relateEntitiesTitle: "기업 연결",
    relateEntitiesSearchPlaceholder: "Enter키를 눌러 이름별로 검색하십시오",
    relateEntitiesName: "기업 이름",
    relateEntitiesIndex: "기업 표준 Index",
    relatedEntitiesCounter: "{0} 기업",
    relatedEntityCounter: "{0} 기업",
    onlyShowRelatedEntities: "연결된 기업만 표시",
    unableToRemoveSystemAssociatedRelatedEntity: "문서와 기업 간 시스템 연결을 제거할 수 없습니다",
    /* Finalize document */
    document: "문서",
    finalize: "마무리",
    finalizeDocument: "문서 마무리",
    finalizeDocumentTitle: "이 문서가 마무리됐다는 것을 primary team에 알리시겠습니까?",
    finalizeDocumentSubtitle: "문서를 마무리하면 primary team에게 추가 버전을 보내지 않을 것이라고 알리게 되고 문서 상태가 <b>최종 버전 전송됨</b>으로 변경됩니다. 마무리한 문서를 변경하게 되면, primary team에 신규 버전을 보낼 수 있습니다.",
    /* Remove From Task */
    removeEvidenceModalTitle: "Task에서 제거",
    remove: "제거",
    removeFromTaskModalContent: "선택한 문서를 이 task에서 제거하시겠습니까? 이 문서는 이 engagement 내 다른 task에 연결되어 있지 않으므로 임시 파일로 이동됩니다.",
    sharedEvidenceRemoveFromTaskModalContent: "선택한 문서를 이 task에서 제거하시겠습니까? 이 문서는 공유되어 있으며 이 engagement 내 다른 task에 연결되어 있지 않습니다. 이를 제거하면 engagement에서 더 이상 사용할 수 없습니다.",
    /*AddDocumentToTasksModal*/
    modalCheckboxHeading: "하나 이상의 task에 대한 증거 추가",
    modalRadioHeading: "하나 이상의 task에 문서 연결",
    confirm: "확인",
    proceed: "계속",
    modalCheckboxMessage: "이 문서를 추가할 관련 task를 선택합니다",
    selectedDocument: "선택된 문서",
    modalRadioMessage: "이 문서는 이미 증거나 임시 파일에 추가됐습니다",
    modalRadioMessage1: "이 문서를 다시 추가하면 본제본이 생성됩니다. 이 문서의 기존 복사본에 연결할지 신규 복사본을 생성할지 선택하십시오.",
    option: "옵션",
    option1Message: "이 task와 기존 문서를 연결합니다",
    option2Message: "이 문서의 신규 복사본을 생성합니다",
    addToEvidenceSelectAll: "모두 선택",
    currentTask: "현재 task:",
    createNewCopy: "신규 복사본 생성",
	fileNameMaxLenError: (maxFileLen) => ` 파일 이름은 ${maxFileLen}자로 제한됩니다.`,
    /* Confidentiality */
    confidentiality: "기밀",
    confidentialityType: "기밀 (선택사항)",
    confidentialityTitle: "문서 기밀성",
    confidentialityPlaceholder: "기밀 선택",
    confidentialityText: "이 문서를 여는 데 필요한 접근 수준을 설정합니다. 접근 수준은 팀 관리 페이지에서 Engafgement 관리자가 설정합니다. 이 문서에 이미 기밀성이 설정된 경우, 문서를 열 수 있는 사람만 문서를 변경할 수 있습니다.",
    confidentialityNotOpenable: "Engagement 권한이 충분하지 않아 문서를 열 수 없습니다. 접근 수준은 Engagement 관리자가 팀 관리에서 설정합니다.",
    confidentialityTargetNotOpenable: "기밀 문서는 원천 engagement에서만 열 수 있습니다",
    /*Sign-off requirements*/
    signOffRequirements: "Sign-off 요건",
    signoffRequirementsModalTitle: "Sign-off 요건",
    signoffRequirementsModalDescription1: "아래에서 이 문서의 executive sign-off 요건을 조정하십시오",
    signoffRequirementsModalDescription2: "EY Canvas에서 필요로 하는 일부 sign-off 요건은 조정할 수 없습니다",
    signoffRequirementsModalSaveLabel: "저장",
    signoffRequirementsModalCancelLabel: "취소",
    signoffRequirementsModalCloseLabel: "닫기",
    signoffRequirementsModalPICLabel: "PIC",
    signoffRequirementsModalEQRLabel: "EQR",
    /*SEM summary*/
    nextAccount: '>',
    prevAccount: "<",
    reviewedBy: "검토자",
    displaytoc: "TOC 표시",
    viewBy: "보기",
    substantiveEvaluation: "실증절차평가표",
    reviewed: "리뷰됨",
    estimate: "추정치",
    /*440GL*/
    FourFortyTitle: "보고서일 ({0}) 후 수정된 증거",
    LeftContainerTitle440GL: "변경 사유",
    approvals: "승인",
    approveChangesColumnTitle: "변경사항 승인",
    approveChangesButton: "변경사항 승인",
    deleteApproval: "승인 제거",
    unauthorizedAction: "작업은 engagement executive만 수행할 수 있습니다",
    reasonColumnTitle: "사유",
    approvedBy: "승인한 사람:",
    approvedByPeople: "사람",
    noChangeReasonCommentAvailable: "문서 톱니바퀴 옵션에서 사유 편집을 클릭하여 변경 사유를 입력하십시오",
    changeReasonModalTitle: "변경 사유 편집",
    changeReasonModalText: "보고서일 후 문서를 변경한 사유를 선택하십시오. 관리적 변경이 여러 번 이루어진 경우, 아래 드롭다운에서 가장 유의한 변경을 선택하십시오. 관리적 변경과 비관리적 변경이 모두 이루어진 경우, 아래에서 비관리적 변경을 선택하십시오.",
    changeReasonUploadModalTitle: "문서 업로드 사유",
    changeReasonUploadModalText: "보고서일 후 문서를 변경한 사유를 선택하십시오. 관리적 변경이 여러 번 이루어진 경우, 아래 드롭다운에서 가장 유의한 변경을 선택하십시오. 관리적 변경과 비관리적 변경이 모두 이루어진 경우, 아래에서 비관리적 변경을 선택하십시오.",
    changeReasonModalComboPlaceholder: "선택",
    changeReasonModalAnnotationText: "발생한 상황과 정보를 추가한 사유; 새롭게 또는 추가로 수행한 감사절차, 입수한 감사증거와 도출한 결론; 그리고 감사보고서에 미치는 영향을 문서화합니다",
    changeReasonUploadModalAnnotationText: "발생한 상황과 정보를 추가한 사유; 새롭게 또는 추가로 수행한 감사절차, 입수한 감사증거와 도출한 결론; 그리고 감사보고서에 미치는 영향을 문서화합니다",
    changeReasonModalAnnotationPlaceHolder: "변경 사유 입력",
    changeReasonModalChangeReasonRequired: "저장할 사유 변경",
    noDocumentsModifiedAfterReportDate: "보고서일 후 수정된 문서 없음",
    noReasonSelected: "선택한 변경사항 사유가 없습니다",
    fileSizeColumn: "파일 크기",
    changePercent: "% 변동",
    toolTipChangePercent: "파일 크기 변동은 보고서일 현재 파일 크기와 현재 파일 크기로 계산됩니다",
    /*Account Conclusion*/
    AccountConclusion: "계정 결론",
    AccountDetails: "세부정보",
    Conclusions: "결론",
    accountDetailsTab: "세부정보",
    conclusionsTab: "결론",
    accountConclusionNoContentText: "이 양식을 위한 내용이 제공되지 않았습니다. 글로벌 내비게이션 기타 메뉴에서 Canvas 양식 업데이트로 이동하여 내용을 수동 업데이트하십시오.",
    validations: "유효성 검증",
    /*RelatedFindings*/
    deficiency: "{0} 연결된 미비점",
    misstatement: "{0} 연결된 왜곡표시",
    relatedDeficiency: "{0} 연결된 미비점",
    relatedMisstatement: "{0} 연결된 왜곡표시",
    deficiencies: "미비점",
    misstatements: "왜곡표시",
    pagingShowtext: "표시",
    documentOpenModelLabel: "현재 수정 중인 문서",
    openedLabelText: "열림",
    modelDocumentOpenedText: "이 문서를 현재 수정 중인 사람",
    modelUserOpenedTheDocumentText: "이 사용자가 문서를 열었습니다",
    modelOpenedDocumentConflictText: "문서를 열면 충돌을 초래할 수 있기 때문에 읽기 전용으로 여는 것을 권장합니다. 이 문서의 편집자가 되고 싶다면,",
    clickHereEnabledText: "여기를 클릭하십시오.",
    reviewNotesTemporeryFilesTitle: "임시 파일 리뷰노트",
    addNewReviewNoteTitle: "Task 노트",
    /*Assignments*/
    assignedTo: "담당자",
    createAssignment: "배정 생성",
    createAssignments: "배정 생성",
    editAssignments: "배정 편집",
    deleteAssignments: "배정 삭제",
    removeAssignments: "배정 제거",
    noTimephaseSelected: "선택되지 않음",
    unassigned: "배정되지 않음",
    unassignedCapitalized: "배정되지 않음",
    dueDateBlank: "만료",
    reviewerAssignment: "검토자 배정",
    manageAssignments: "Task 배정 관리",
    manageTaskAssignments: "배정 생성",
    selectedTasks: "선택된 task",
    someTasksCannotBeMoved: "일부 task를 이동시킬 수 없습니다",
    onlySomeTaskCanMoveToOtherGroup: "선택한 task 중 일부만 다른 task 그룹으로 이동시킬 수 있습니다",
    taskThatCanBeMovedToOtherGroup: "계속을 선택하면 선택된 task 그룹으로 <b>아래 열거된 task가 이동됩니다</b>.",
    tasksThatCannotBeMovedToOtherGroup: "다른 task 그룹으로 <b>아래 열거된 task를 이동시킬 수 없습니다</b>",
    taskGroupSectionNotFound: "결과를 찾을 수 없습니다",
    placeholderForSearch: "검색",
    taskFilter: "필터",
    noResultsAvavilable: "결과를 찾을 수 없습니다",
    noTasksAvavilable: "사용 가능한 task 없음",
    clearAll: "모두 처리",
    engagementPhase: "감사 단계",
    noOptionAvailable: "사용 가능한 옵션이 없습니다",
    noTimePhase: "배정된 시기 없음",
    roles: "역할",
    users: "팀 멤버",
    rommAssociatedWNotRelyAssertion: "ROMM은 계정에 추정이 있는 경우 의존하지 않는 통제위험이 있는 경영진주장이나 높은 고유위험이 있는 경영진주장에 연결됩니다",
    hasRiskAssociated: "연결된 위험",
    canvas: "Canvas",
    workingoffline: "오프라인 작업",
    syncinprogress: "동기화 진행 중",
    prepareoffline: "오프라인 데이터 준비",
    connectionavilable: "연결 가능",
    createAnAssignment: "Create an assignment",
    createAssignmentEnd: "for this task to get started.",
    // Manage Assignments
    step01: "단계 01",
    step02: "단계 02",
    step03: "단계 03",
    step04: "단계 04",
    step05: "단계 05",
    manageAssigmentsStep1: "작업 선택.",
    manageAssigmentsStep2: "Task 배정 편집",
    editAssignment: "배정 편집",
    deleteAssignment: "배정 삭제",
    manageAssigmentsStep3: "배정 완료",
    taskAssigmentStatusHeader: "배정 상태",
    taskAssigmentStatusTileHeader: "Task 및 배정 상태",
    taskAssignmentName: "배정",
    dueDateAssigment: "만료",
    editDueDate: "선택사항: 종료일까지 남은 날짜 편집",
    teamMemberAssigmentLabel: "팀 멤버",
    currentAssigmentLabel: "현재",
    handOffToAssigmentLabel: "Hand-off 대상:",
    priorToEndDateLabel: "prior to end date",
    noTimePhaseAssigmentLabel: "배정된 시기 없음",
    closedByAssigmentLabel: "닫은 사람",
    onAssingmentLabel: "on",
    preparerAssigmentOpenTitleTip: "Task 배정을 닫으려면 이 task를 hand-off하십시오",
    reviewerAssigmentOpenTitleTip: "Task 배정 닫힘 표시",
    reviewerAssigmentClosedTitleTip: "Task 배정 처리 전 표시",
    AssigmentLabel: "Task 배정을 닫으려면 이 task를 hand-off하십시오",
    noEvidenceReviewerAssigmentTitleTip: "Task 배정에 닫힘 표시하려면 증거를 추가하십시오",
    noTaskEvidencesHandoffModal: "이 task에 연결된 증거 파일이 없습니다",
    back: "뒤로",
    savecontinue: "저장 & 계속",
    finish: "마침",
    save: "저장",
    emptyManageAssignmentStep: "...",
    selectAssignmentActionToContinue: "계속하려면 작업을 선택하십시오",
    createNewTaskAssingment: "신규 task 배정 생성",
    deleteTaskAssingment: "Task 배정 삭제",
    createTaskAssingment: "Task 배정 생성",
    editExistingTaskAssingment: "기존 task 배정 편집",
    editTaskAssingment: "Task 배정 편집",
    removeExistingTaskAssingment: "기존 task 배정 제거",
    warningPopUpPreparerAssignmentTitle: "기존 작성자 배정 덮어쓰기",
    warningPopUpPreparerAssignmentText: "이 task에 작성자 배정이 이미 있습니다. 이 배정에 덮어쓰겠습니까?",
    warningPopUpPreparerAssignmentConfirm: "확인",
    warningPopUpPreparerAssignmentCancel: "취소",
    selectTaskAssingment: "Task 배정 선택",
    viewHistoryAndConflicts: "기록 보기",
    noHistoryAvailable: "사용 가능한 기록이 없습니다",
    teamMember: "팀 멤버",
    dateEdited: "최근 수정",
    viewHistoryHeader: "이 문서 버전 기록이 아래에 표시됩니다",
    viewHistorySubHeader: "팀 멤버 이름을 클릭하여 이 문서의 이전 버전을 읽기 전용 모드로 엽니다. 이 이전 버전에서 변경한 사항은 EY Canvas에 저장되지 않습니다.",
    docConflictedMessage: "이 문서와 관련된 충돌이 있습니다. 해결하려면 문서 목록의 충돌 탭으로 가십시오.",
    removeTaskAssingment: "Task 배정 제거",
    addAssignmentInstructionalText: "여기에 신규 task 배정 이름(예: 세부 검토자, 일반 검토자)을 입력하십시오",
    addNewAssingmentName: "신규 배정 이름 추가",
    addTaskAssignmentName: "Task 배정 이름 추가",
    assignmentName: "배정 이름",
    selectedTask: "선택된 task",
    createTaskAssignmentHeading: "여기에 신규 배정을 생성합니다",
    createTaskAssignmentHeading1: "아래에 배정 세부정보를 입력하고 <b>저장 및 닫기</b>를 선택하여 마칩니다. 다른 배정을 생성하려면, <b>저장 및 추가</b>를 선택하십시오.",
    saveDelete: "저장 & 삭제",
    createTaskAssignmentFinishLabel: "저장 & 닫기",
    createTaskAssignment: "저장 & 추가",
    editTaskAssignment: "저장 & 추가 관리",
    createTaskAssignmentSaveAndContinueLabel: "저장 & 추가 관리",
    daysPriorToEndDate: "종료일까지 남은 날짜",
    daysdue: "만료 전 기간",
    daysPriorToEndDateOptional: "종료일까지 남은 날짜 (선택사항)",
    timephase: "시기",
    timephasesLabel: "시기",
    manageTimePhase: "시기 관리",
    removeTaskAssingmentSingleTaskHeading: "삭제하려는 배정을 선택하십시오",
    removeTaskAssingmentSingleTaskHeading2: "마치려면 '저장 & 닫기'를 클릭하고 다른 task 배정을 관리하려면 '저장 & 추가 관리'를 클릭하십시오",
    removeTaskAssingmentMultipleTaskHeading: "선택한 task에 배정과 팀 멤버 조합이 있다면 배정이 삭제됩니다. 선택 후 <b>저장 & 닫기</b>를 클릭하여 마칩니다. 다른 배정을 삭제하려면 <b>저장 & 삭제</b>를 선택하십시오.",
    editTaskAssingnmentStep2Heading: "편집하려는 task 배정을 선택하십시오",
    selectedAssignment: "선택된 배정:",
    editTaskAssingmentBulkHeading: "편집하려는 배정을 선택합니다",
    editTaskAssingmentBulkSubHeading1: "선택한 task에 배정과 팀 멤버 조합이 있다면 task가 재배정됩니다. 귀하는 <b>종료일까지 남은 날짜</b>를 편집할 수 있습니다. 이 값을 편집하면, 재배정된 task가 모두 업데이트됩니다. 편집 후 <b>저장 & 닫기</b>를 선택하여 마칩니다. 다른 배정을 편집하려면 <b>저장 & 추가 관리</b>를 선택하십시오.",
    noResultInCategory: "이 task 범주에서 결과를 찾을 수 없습니다",
    searchTaskList: "Task 목록 검색",
    searchCanvasFormList: "검색",
    clearHoverText: "처리",
    filtersWarningMessage: "필터 한도를 초과했습니다. 한 번에 25개 필터만 적용할 수 있습니다.",
    reviewNotesWarningMessage: "데이터 검색에 오류가 발생했습니다. 다시 시도하고 문제가 지속되면 헬프 데스크에 문의하십시오.",
    editTaskAssingmentSept3Header: "선택한 배정 편집",
    editTaskAssingmentSept3Header2: "마치려면 '저장 & 닫기'를 클릭하고 다른 task 배정을 관리하려면 '저장 & 추가 관리'를 클릭하십시오",
    editTaskAssignmentHeaderPart1: "아래에서 배정 세부정보를 편집하고 <b>변경사항 저장</b>을 선택하십시오",
    calculatedDate: "계산된 날짜",
    saveAndAddbtn: "저장 및 더 추가",

    //Calendar Toggle Labels
    daysPriorToEndDateRequired: "종료일까지 남은 날짜 (필수)",
    dueDateRequired: "만료일 (필수)",
    selectDate: "날짜 선택",
    calculateDate: "날짜 계산",

    /* Bulk TimePhase*/
    taskText: "Task",
    timephasesetsuccess: "{0} 시기를 설정했습니다",
    timephasessetsuccess: "{0} 시기를 설정했습니다",
    addTimephaseLabel: "시기 추가",
    infoSetTimePhase: "<h3>시기 설정</h3><p>선택한 항목에 시기를 설정하려면 특정 시기로 끌어서 놓으십시오.</p>",
    infoEditTimePhase: "<h3>시기 편집</h3><p>시기 속성을 편집하려면 오버플로우 메뉴(점 세 개)를 클릭하고 편집을 선택하십시오.</p>",
    infoAddTimePhase: "<h3>시기 추가</h3><p>시기를 생성하려면 시기 추가를 클릭하십시오.</p>",
    infoDeleteTimePhase: "<h3>시기 삭제</h3><p>시기를 삭제하려면 오버플로우 메뉴(점 세 개)를 클릭하고 삭제를 선택하십시오.</p>",
    deletedTimePhaseFilterWarningMessage: "다른 사용자가 시기를 삭제했습니다",

    //Set assignment dates modal labels
    setAssignmentTitle: "배정 만료일 설정",
    setAssignmentDesc: "배정 만료일을 정의하지 않았습니다. 계속하려면 아래 배정의 만료일을 선택하십시오.",
    setAssignmentDesc2: "하나 이상의 task에서 시기 날짜가 귀하가 선택한 {0}의 만료일보다 이릅니다. 계속하려면 task 만료일 또는 시기 만료일을 조정하십시오.",
    timePhaseNameLabel: "시기",
    timephaseEndDate: "시기 종료일",
	tasksLabel: "Task 수",
    assignmentDateLabel: "배정",
    noAssignedTimePhase: "배정된 시기 없음",
    endDate: "종료일",
    calendarDateError: "만료일은 시기 종료일보다 이전이어야 합니다",

    /* Events*/
    addEventLabel: "사건 추가",
    sharedWithClient: "공유됨",
    noEventsMessage: "사건이 식별되지 않았습니다",
    naLabel: "N/A",
    deleteEventModalTitle: "사건 삭제",
    deleteEventDescription: "이 사건을 삭제하시겠습니까?",
    showEventeName: "사건",
    eventDateLabel: "날짜",
    eventDatesLabel: "날짜",
    showEventStartDate: "시작일",
    showEventEndDate: "종료일",
    deleteEventSuccessMessage: "사건이 삭제됐습니다",
    eventTypeLabel: "사건 유형",
    singleDayEventLabel: "하루",
    multiDayEventLabel: "며칠",
    dateRangeEventLabel: "날짜 범위",
    eventSharedWithClientLabel: "고객과 공유됨",
    editEventLabel: "사건 편집",
    eventUpdateSuccessMessage: "사건이 업데이트됐습니다",
    noTimephasesMessage: "시기가 식별되지 않았습니다",

    /* Review Notes */
    showAll: "모두",
    reviewNotesLabel: "리뷰노트",
    athoredByMeLabel: "내가 작성",
    assignedToMe: "내 담당",
    assignedToOpen: "담당자 (처리 전)",
    authoredByCleared: "작성자 (처리됨)",
    totalOpenReviewLabel: "총 처리 전 리뷰노트",
    totalClearedReviewLabel: "총 처리된 리뷰노트",
    agingLabel: "연령",
    openLabel: "처리 전",
    clearedLabel: "처리됨",
    noUsersFoundLabel: "결과를 찾을 수 없습니다",
    chartDataLabel: "사용 가능한 데이터 없음",
    noClientDataAvailable: "사용 가능한 데이터 없음",
    DaysLessThan10: "<10일",
    Days11To30: "<30일",
    Days31To60: "<60일",
    Days61To90: "<90일",
    DaysMoreThan90: ">90일",
    noReviewNotesFound: "리뷰노트를 찾을 수 없습니다",

    formMaxLength: "텍스트는 {number}자를 초과할 수 없습니다",
    voiceNote: "음성 노트",
    microphoneBlockedMessage: "음성 노트를 사용하려면 마이크에 접근할 수 있도록 브라우저를 허용하십시오. 이미 허용됐다면, 새로 고침하여 다시 시도하십시오",
    microphoneBlockedOnVideoMessage: "화면 기록에 음성을 사용하려면 브라우저에 마이크 접근 권한을 허용하십시오. 이미 허용했다면, 새로 고침하여 다시 시도하십시오.",
    notInMainWindowVoice: "드로어 안에서 음성 기록은 허용되지 않습니다. 작업을 수행하려면 문서를 새 탭에서 여십시오",
    notInMainWindowScreen: "드로어 안에서 화면 기록은 허용되지 않습니다. 작업을 수행하려면 문서를 새 탭에서 여십시오",
    screenRecord: "화면 기록",
    playbackReview: "재생 검토",
    recording: "기록 중",

    /* Sign Offs */
    preparerHoverText: "작성자로 Sign-off",
    reviewerHoverText: "검토자로 Sign-off",
    preparerTitle: "작성자 Sign-off",
    reviewerTitle: "검토자 Sign-off",
    preparerLetter: "P",
    reviewerLetter: "R",
    deleteHoverText: "Sign-off 제거",
    signoffsrequired: "Sign-off 필요",
    signoffsOptional: "PIC/EQR 선택사항",
    eqrLabel: "EQR",
    partnerInChargeLabel: "PIC",

    landingPage: "랜딩 페이지",
    dashboardPage: "대시보드",
    tasksPage: "Task",
    documentsPage: "문서",
    collaborationPage: "공동작업",
    automationPage: "자동화",
    newContentUpdate: "내용 업데이트",
    contentUpdatesHistory: "기록",
    history: "기록",
    contentUpdateType: "내용 업데이트 유형",
    iniciatedBy: "개시한 사람",
    date: "날짜",
    clickForOptions: "옵션을 더 보려면 클릭하십시오",
    offline: "오프라인",
    eyServiceGateway: 'EY Service Gateway',
    eyAutomation: 'EY Automation',
    eyserviceGatewayAutomation: 'EY Service Gateway & Automation',

    // ContentUpdates
    contentUpdate: "내용 업데이트",
    canvasFormUpdates: "Canvas 양식 업데이트",
    syncFormProfile: "양식 프로필 동기화",
    documentName: "문서 이름",
    analyticName: "분석 이름",
    formType: "양식 유형",
    dateOfContent: "내용 날짜",
    formStatus: "상태",
    formsWarningMessage: "업데이트하려면 EY Canvas 양식을 하나 이상 선택해야 합니다",
    formsUpdateSuccessMessage: "EY Canvas 양식 업데이트 제출됨",
    filterTypeOfFormLabel: "양식 유형",
    filterSourceOfFormLabel: "양식 원천",
    documentSelectionRequired: "덮어쓸 문서를 선택하십시오",
    overwriteForm: "양식 덮어쓰기",
    overwriteFormInstructionalText: "현재 Canvas 양식에서 응답을 덮어쓸 양식을 선택하십시오. 현재 양식은 임시 파일로 옮겨집니다.",
    confirmOverwrite: "덮어쓰기 확인",
    confirmOverwriteAreYouSure: "\'{0}\' 양식 내용을 \'{1}\' 양식으로 복사하시겠습니까?",
    confirmOverwriteDesc: "응답은 \'{1}\' 양식으로 덮어써지지만, 연결된 증거와 object는 그렇지 않습니다. 해당 증거와 object는 덮어쓰기 완료 후 \'{1}\' 양식에 다시 연결해야 합니다. \'{0}\' 양식은 기존 프로필/GAM 단계를 유지하므로 프로필이 \'{1}\' 양식과 다른 경우, 복사된 내용을 검토하고 정리하십시오.",
    confirmOverwriteDoNotClose: "덮어쓰기 프로세스가 진행되는 동안에는 브라우저를 닫거나 이동하지 마십시오. 덮어쓰기 프로세스가 완료되면, \'{0}\' 양식은 임시파일로 이동됩니다. 이 작업은 실행 취소할 수 없습니다.",
    sourceDocument: "원천 문서",
    targetDocument: "대상 문서",
    profileLayers: "GAM 단계",
    pspAccountWarningMessage: "업데이트하려면 계정을 하나 이상 선택해야 합니다",
    pspAccountUpdateSuccessMessage: "PSP 내용 업데이트가 제출됐습니다",
    pspAccountconfirmUpdateMessage: "이 계정을 업데이트하면 내용에 유의한 영향을 미칠 수 있습니다. 시작되고 나면, 완료될 때까지 추가 내용 업데이트를 수행할 수 없습니다.",
    est: "추정 있음",
    bookmarkTaskModalHeader: "선택한 task를 다운로드할 수 없습니다",
    bookmarkTaskModalMessage: "선택한 task는 오프라인 작업을 위해 다운로드할 수 없습니다",
    noGuidanceAvailable: "사용 가능한 Guidance가 없습니다",
    next: "다음",
    previous: "이전",
    guidanceLink: "링크",
    addToEvidenceLabel: "증거에 추가",
    otherEngagements: "다른 engagement",
    navigationView: "네비게이션 보기",
    listView: "목록 보기",
    detailsView: "세부정보 보기",
    closeguidance: "Guidance 닫기",
    reviewNotesModalClose: "닫기",
    gamGuidanceLinkLabel: "GAM Guidance",
    inProgess: "진행 중",
    upcomingReview: "리뷰 임박",
    teamSummaryEmptyTaskDetailsMesage1: "팀 멤버별 작성자 및 검토자 배정 상태를 보려면, 팀 요약을 사용하십시오. Engagement에서 모든 배정을 관리하려면,",
    teamSummaryEmptyTaskDetailsMesage2: "배정 관리를 선택하십시오.",
    teamSummaryEmptyTaskDetailsMesage3: "한꺼번에 제어하려면, 체크박스를 이용하여 task를 하나 이상 선택하십시오. 여러 task를 한 번에 선택하려면 Shift 키를 이용하십시오. 개별 task에서 작업하려면 목록에서 해당 task를 선택하십시오.",
    taskSummaryPoint1: "'작성'을 선택하여 팀 멤버별 작성자 배정 목록을 봅니다",
    taskSummaryPoint2: "'검토'를 선택하여 팀 멤버별 검토자 배정 목록을 봅니다",
    taskSummaryPoint3: "배정은 배정 상태(시작 전, 진행 중 및 마침)별로 정렬됩니다",
    noLinksfound: "이 task에 사용 가능한 링크가 없습니다",
    noFormsfound: "이 task에 사용 가능한 양식이 없습니다",
    workofflinemsg: "선택한 task의 최신 버전을 다운로드하여 오프라인에서 계속 편집할 수 있습니다. 나중에 재접속하여 변경사항을 동기화할 수 있습니다.",
    workonlinemsg: "온라인으로 돌아가면 변경사항이 자동으로 동기화됩니다. 재접속하기 전에 인터넷에 연결되어 있는지 확인하십시오.",
    workoffline: "오프라인에서 작업",
    workonline: "온라인에서 작업",
    duplicateFileNames: "파일 이름 복제",
    training: "교육",
    duplicateFileNameValidationMessage: "이 engagement에 추가하려는 파일 이름이 기존 파일과 동일합니다. 계속하려면 파일 이름을 변경하십시오.",
	documentHelperConnectionIssue: 'EY Canvas Document Helper에 문제가 발견됐습니다. 문제 해결 지침을 보려면 <a style="color: #467cbe" href="https://eyt.service-now.com/kb_view.do?sysparm_article=KB0486774" target="_blank">here</a>을(를) 클릭하십시오.',
    incompleteCra: "미완료 CRA",
    noteItemCreated: "생성됨:",
    NetworkErrorMessage: "응용프로그램 네트워크에 오류가 발생했습니다. 페이지를 새로 고침하고 나중에 다시 시도하십시오. 오류가 지속되면 헬프 데스크에 문의하십시오.",
    saveClose: "저장 및 닫기",
    contentupdatePSPs: "내용 업데이트 - PSP",
    /* PAANS */
    paansIsNotReachable: "지금은 EY 정책 작성, 승인 및 알림 서비스를 사용할 수 없습니다. 따라서 관련 정책이 모두 완료됐는지 확인할 수 없습니다. 관련 정책을 검토하지 않았다면, 페이지를 새로 고침하여 다시 시도하십시오. 문제가 지속되면 헬프 데스크에 문의하십시오.",

    /* Add New Task */
    standardtask: "표준 task - OST",
    substantivetask: "실증 task - OSP",
    walkthroughtask: "Walkthrough task – WT",
    controltask: "통제 task - TOC",
    addnewTask: "신규 task 추가",
    taskType: "Task 유형",
    taskTypeError: "Task 유형을 선택하십시오",
    selectTaskTypeHeader: "계속하려면 task 유형을 선택하십시오",
    selectTaskType: "Task 유형 선택",
    enterTaskDetails: "Task 세부정보 입력",
    assignTask: "Task 배정",
    taskGroup: "Task 그룹",
    finishLabel: "저장 & 닫기",
    addTaskContinueLabel: "저장 및 배정",
    AssignTaskStepSaveandContinueLabel: "저장 & 추가",
    addTaskDetailsHeader: "계속하려면 task 세부정보를 입력하십시오",
    addTaskAssignmentHeader: "선택사항: 이 task에 배정 생성",
    addTaskDetailsSubHeader: "이 task를 지금 배정하려면 <b>저장 및 배정</b>을 클릭하고 이 task를 나중에 배정하려면 <b>저장 및 닫기</b>를 클릭하십시오",
    addTaskAssignmentSubHeader: "아래에 배정 세부정보를 입력하고 저장 & 닫기를 선택하여 마칩니다. 다른 배정을 생성하려면 저장 & 추가를 선택하십시오.",
    addTaskAssignmentSubHeader1: "아래에 배정 세부정보를 입력하고 <b>저장 & 닫기</b>를 선택하여 마칩니다. 다른 배정을 생성하려면 <b>저장 & 추가</b>를 선택하십시오.",
    addTaskGroup: "여기에 신규 task 그룹을 추가하십시오. 추가한 후에는 신규 task를 생성할 때 이 task 그룹을 선택할 수 있고 기존 OST task를 이 task 그룹으로 이동할 수 있습니다.",
    relateObjectHeaderAccount: "유의적인 계정 또는 공시에 대해 경영진주장을 하나 이상 선택하거나 limited risk 계정을 선택하십시오",
    relateObjectSubHeaderAccount: "Task는 하나의 계정 또는 공시에만 연결할 수 있습니다",
    relateObjectHeader: "계속하려면 하나 이상의 object를 연결하십시오",
    limitedRiskAccount: "Limited Risk 계정",
    onlyShowAddedObject: "추가된 object만 표시",
    relateObjectRequiredError: "계속하려면 하나 이상의 object를 선택해야 합니다",
    invalidSelectionWarning: "Task는 하나의 계정 또는 공시에만 연결할 수 있습니다. 다른 계정 또는 공시에 대한 경영진주장이나 다른 limited risk 계정에 task를 연결하려면 선택된 경영진주장 또는 limited risk 계정을 제거하십시오.",
    invalidSelctionCRA: "단일 object 유형 선택",
    relateObjectOptionsHeaderAccountTask: "경영진주장 및 Limited Risk 계정",
    relateObjectOptionsHeaderITWalkthroughTask: "IT/SO 프로세스",
    relateObjectOptionsHeaderITControlTask: "IT 일반통제",
    relateObjectOptionsHeaderITSubstantiveTask: "IT 실증절차",
    relateObjectOptionsHeaderSCOTControlTask: "통제",
    relateObjectOptionsHeaderSCOTWalkthroughTask: "SCOT",
    StrategyTypeControls: "통제",
    StrategyTypeSubstantive: "실증",

    //Manage quick filters labels
    manageQuickFilterHeader: "기본으로 저장됐거나 권장된 필터를 선택하십시오",
    manageQuickFilterText: "기본을 선택하면 task 목록으로 이동할 때 이 필터가 적용됩니다",
    noDefaultFilter: "기본 필터 없음",
    suggestedFiltersHeading: "권장 필터",
    savedFiltersHeading: "저장 필터",
    manageQuickFilters: "빠른 필터 관리",
    manageLabel: "관리",


    /* RNH Labels */
    emptyNoteDetailsMessage: "세부정보를 보려면 노트를 선택하십시오. 한꺼번에 제어하려면, control 키나 shift 키를 이용하여 여러 리뷰노트를 선택하십시오. 개별 노트에서 작업하려면 목록에서 해당 노트를 선택하십시오.",
    emptyRepliesMessage: "아직 회신이 없습니다",
    emptyRepliesMessageAlt: "회신 없음",
    reviewNotes: "리뷰노트",
    reviewNotesStatus: "리뷰노트 상태",
    reviewNotesStatusAssignedToMe: "내 담당 리뷰노트 상태",
    reviewNotesStatusAuthoredByMe: "내가 작성한 리뷰노트 상태",
    comments: "리뷰노트",
    showHideNotes: "노트 표시/숨기기",
    fileType: "파일 유형",
    noteType: "유형",
    statusId: "상태",
    rnhPriority: "우선순위",
    rnhDueDate: "만료:",
    rnhModifiedDate: "수정됨",
    textAreaPlaceholder: "노트 입력",
    requiredFieldErrorMessage: "필수 필드입니다",
    meLabel: "Me",
    editIconHoverText: "편집",
    deleteIconHoverText: "삭제",
    deleteIconModalTitle: "노트 삭제",
    deleteIconCommentModalTitle: "노트 삭제",
    deleteReplyIconModalTitle: "회신 삭제",
    deleteIconModalConfirmMessage: "이 노트에 대한 회신을 삭제하시겠습니까?",
    deleteIconModalConfirmMessageParent: "선택한 노트를 삭제하시겠습니까?",
    deleteIconModalCommentConfirmMessage: "이 회신을 삭제하시겠습니까?",
    deleteIconModalCommentConfirmMessageParent: "이 노트를 삭제하시겠습니까? 이 노트에 대한 회신도 모두 삭제됩니다.",
    deleteIconModalAcceptText: "삭제",
    replyInputPlaceholder: "이 노트에 회신",
    changeStatus: "상태 변경",
    emptyReplyErrorMsg: "계속하려면 텍스트 또는 음성 노트를 추가하십시오",
    lengthReplyErrorMsg: "회신은 4,000자를 초과할 수 없습니다",
    closeTitle: "닫기",
    closedBy: "닫은 사람",
    ClearedBy: "처리한 사람",
    ReopenedBy: "다시 연 사람",
    commentTitle: "노트",
    noteDueDateLabel: "만료",
    reopen: "다시 열기",
    noNotesAssociatedWithDocumentLabel: "아래에 입력하여 노트를 남기십시오. 노트를 특정 사용자에게 배정하고 우선순위와 만료일을 지정하십시오.",
    noNotesFound: "노트를 찾을 수 없습니다",

    /* Add new review note RNH */
    addNewNoteButtonTitle: "신규 노트",
    addNewNoteModalTitle: "신규 노트 추가",
    addNewNoteModalClose: "닫기",
    backButtonLabel: "뒤로",
    cancelButtonLabel: "취소",
    addNewNoteStep1Title: "노트 유형 선택",
    addNewNoteStep2Title: "문서 또는 task 선택",
    addNewNoteStep3Title: "노트 세부정보 입력",
    editNoteModalTitle: "노트 편집",
    editReplyModelTitle: "회신 편집",
    voiceNoteButtonLabel: "음성 노트",
    stopRecordingButtonLabel: "정지",
    enterText: "텍스트 입력",

    /* RNH Review note hub Step 1 */
    step1Title: "계속하려면 노트 유형을 선택하십시오",
    step1Subtitle: "문서와 task 노트만 여기에 추가할 수 있습니다. Canvas 양식 comment는 각 Canvas 양식 안에 추가해야 합니다.",
    step1NoTypeSelectedError: "계속하려면 노트 유형을 선택하십시오",

    /* RNH Review note hub Step 2 */
    step2DocumentTitle: "노트를 추가하려는 문서를 선택하십시오",
    step2TaskTitle: "노트를 추가하려는 task를 선택하십시오",
    step2SearchTitle: "검색",
    step2SearchClearTitleTip: "처리",
    step2ErrorMessageTop: "계속하려면 항목을 선택하십시오",
    step2ErrorMessageBottom: "계속하려면 위에서 식별한 필수 필드를 완료하십시오",
    step2EmptySearch: "결과를 찾을 수 없습니다",

    /* RNH Review note hub Step 3 */
    step3InstructionalText: "선택한 문서나 task에 대해 노트 세부정보를 입력하십시오",
    step3InstructionalSubTitle: "마치려면 <b>저장 & 닫기</b>'를 클릭하고 선택한 문서나 task에 다른 노트를 추가하려면 <b>저장 & 더 추가</b>를 클릭하십시오",
    step3SelectedDocument: "선택된 문서:",
    step3SelectedTask: "선택된 task:",
    step3SaveAndContinue: "저장 & 더 추가",
    step3SaveAndClose: "저장 & 닫기",

    /* RNH List Layout Labels*/
    searchReviewNotes: "노트 검색",
    searchReviewNotesResultsNotFound: "이 노트 범주에서 결과를 찾을 수 없습니다",
    searchReviewNotesNotAvailable: "사용 가능한 노트 없음",
    notesRepliesNotFound: "선택한 노트에 대한 회신을 찾을 수 없습니다",

    selectValueToContinue: "계속하려면 값을 선택하십시오",
    required: "필수",
    invalidEngagementId: "Engagement ID가 유효하지 않습니다. 페이지를 새로 고침하여 다시 시도하십시오. 오류가 지속되면 헬프 데스크에 문의하십시오.",
    accessDenied: "접근 거부됨",
    annotationDeletedError: "선택한 노트가 삭제됐습니다. 페이지를 새로 고침하여 다시 시도하십시오.",

    /* RNH Filters */
    rnhClearAll: "모두 처리",
    rnhShowMore: "자세히",
    rnhFilter: "필터",
    hideFiltersLabel: "숨기기",
    noDocumentChangeTypes: "결과를 찾을 수 없습니다",
    selectatasktype: "Task 유형 선택",
    importfromknowledge: "Knowledge에서 불러오기",
    assigntaskoptional: "Task 배정 (선택사항)",
    relateanobject: "Object 연결",
    account: "계정",
    userOrRole: "사용자 또는 역할",
    userSummary: "사용자 요약",
    other: "기타",
    userNotFound: "사용자를 찾을 수 없습니다",
    dueOnOrBefore: "이전 만료",
    dueOnOrAfter: "이후 만료",

    /*Dashboard - Milestone tile*/
    milestonesLabel: "Milestone",
    scopeAndStrategy: "범위 및 전략",
    scopeAndStrategyTabLabel: "범위 및 전략",
    executionTabLabel: "실행",
    conclusionTabLabel: "결론",
    viewAllTabLabel: "모두 보기",
    noTaskAssociatedToMilestoneMsg: "이 감사 단계에서 milestone에 배정된 task가 없습니다",
    overdueLabel: "지연",
    upcomingLabel: "만료일 임박",
    quickLinkText: "빠른 링크",
    inreviewLabel: "리뷰 중",
    CompleteLabel: "완료",
    completeLabel: "완료",
    startLabel: "시작",
    endLabel: "종료",
    auditPhaseSummary: "감사 단계 요약",
    milestoneView: "Milestone 보기",
    timePhaseView: "시기 보기",
    localLandingPageHeader: "이 페이지는 이 데이터 센터에서 사용 가능한 EY Canvas Engagement만 표시합니다",
    localLandingPage: "로컬 랜딩 페이지",
    noEngagementsAvailable: "이 데이터 센터에서 사용 가능한 engagement 없음",
    engagements: "Engagement",
    /* Document List */
    docListRelatedTasks: "연결된 Task",
    temporaryFilesTab: "임시 파일",
    priorPeriodEvidenceTab: "전기 증거",
    conflictsTab: "충돌",
    recentlyDeletedTab: "최근 삭제내역",
    docListSelectedDocument: "{0} 문서 선택됨",
    docListSelectedDocuments: "{0} 문서 선택됨",
    shared: "공유됨",
    shareStatusOwned: "이 engagement에서 보유함",
    shareStatusShared: "이 engagement에 공유됨",
    unlinkInprogress: "링크 해제 진행 중",
    unlinkError: "링크 해제 오류",
    documentList: "문서",
    restoreModalTitle: "임시 파일로 복원",
    restoreModalText: "복원하여 이 문서를 임시 파일로 반송합니다",
    permanentlyDeleteModalTitle: "영구 삭제",
    permanentlyDeleteModalText: "문서를 영구 삭제하면 문서가 EY Canvas에서 제거되고 실행 취소할 수 없습니다. 계속하려면 영구 삭제를 클릭하십시오.",
    misstatementsInstructionalText: "문서가 이 engagement 내 다음 왜곡표시와 연결되어 있습니다. 왜곡표시로 이동하려면 왜곡표시를 클릭하십시오.",
    deficienciesInstructionalText: "문서가 이 engagement 내 다음 미비점과 연결되어 있습니다. 미비점으로 이동하려면 미비점을 클릭하십시오.",
    referenceId: "ID",
    findingDescription: "설명",
    deficienciesModalTitle: "연결된 미비점",
    misstatementsModalTitle: "연결된 왜곡표시",
    startsWith: "다음으로 시작",
    contains: "포함",
    documentsWherePICEQRSignOffIsRequired: "PIC/EQR sign-off가 필수인 문서",
    otherDocuments: "기타 문서",
    documentsWherePICSignOffIsRequired: "PIC sign-off가 필요한 문서",
    documentSignoffRequiredLabel: "Sign-off 필요:",
    timePhaseFilterLabel: "시기",
    drillDownTimePhaseFilterLabel: "시기별 보기",
    auditPhasesLabel: "감사 단계",
    openedLabel: "열림",

    clientApprovals: "외부 Sign-off",
    noTeamsAvailable: "팀이 아직 생성되지 않았습니다. 시작하려면 팀을 생성하고 링크 요청을 보내십시오.",
    noDocumentRecieved: "수신된 문서 없음",
    team: "팀",
    pendingEvidence: "보류 중인 증거",
    noTimePhasePlaceHolder: "시기 없음",

    regionComponentEvidence: "지역 및 부문 증거",
    preparersignoffs: "작성자 Sign-off",
    reviewersignoffs: "검토자 Sign-off",
    receivedon: "수신일:",
    nosignoffsyet: "아직 sign-off 없음",
    noRegionComponentEvidence: "문서가 아직 수신되지 않았습니다. 문서를 아직 전송하지 않은 지역과 부문 목록을 보려면, <b>문서 보류 중</b>을 선택하십시오.",
    noComponentEvidence: "문서가 아직 수신되지 않았습니다",
    assignToRegionOrComponent: "지역 또는 부문에 배정",
    assignRegionComponentModalText: "이 문서를 배정할 지역이나 부문을 선택하십시오",
    documentAssignedToPGT: "이 문서는 다른 region 또는 부문에 이미 배정됐습니다. 따라서 배정할 수 없습니다.",
    assignedToRegionComponent: "배정된 region 또는 부문:",
    noRegionComponentsAvailable: "사용 가능한 지역이나 부문이 없습니다",
    documentUnassignedFromComponent: "{0}이(가) {1}에서 배정취소됐습니다",
    documentUnassigned: "{0}이(가) 배정취소됐습니다",
    documentReturnedToComponent: "{0}이(가) {1}(으)로 반송됐습니다",
    documentReturned: "{0}이(가) 반송됐습니다",
    regionComponentName: "지역 또는 부문 이름",
    relatedReviewNoteCount: "다른 engagement에서 열린 노트 1개",
    relatedReviewNotesCount: "다른 engagement에서 열린 노트 {0}개",

    deleteVersion: "버전 삭제",
    deleteVersionMessage: "계속하려면 버전을 선택하십시오",
    deleteVersionDisabledMessage: "기록 버전은 engagement 관리자가 문서의 원천 engagement에서만 삭제할 수 있습니다",
    deleteVersionTitle: "문서 버전 삭제",
    deleteVersionPlaceholder: "이 기록 버전을 삭제하시겠습니까? 이 작업은 실행 취소할 수 없습니다.",

    childDocumentsCountLabel: "기존 본사본",
    childDocumentsModalTitle: "기존 본사본",
    childDocumentsModalDescription: "아래 문서는 원본 문서에서 생성됐습니다",
    childDocumentsModalColumnDocumentName: "문서 이름",
    childDocumentsModalColumnDocumentType: "문서 유형",
    childDocumentsModalColumnRelatedTasks: "연결된 Task",
    childDocumentsModalColumnSignoffs: "Sign-off",

    bulkAddToEvidenceDescription1: "증거로 표시된 문서의 신규 복사본을 생성하거나 사용 가능한 경우 기존 복사본을 선택하십시오",
	bulkAddToEvidenceDescription2: '기본적으로, 새로 생성된 문서는 이전 문서가 연결되었던 모든 task와 Canvas 양식에 추가됩니다. 신규 문서가 연결될 task와 Canvas 양식을 수동으로 선택하려면 "고급 옵션 "을 사용합니다. 신규 문서 이름의 특정 부분(예, 연도)을 교체하려면 찾기와 바꾸기 기능을 사용합니다; 이 기능은 여러 번 사용할 수 있습니다.',
    bulkAddToEvidenceDescription3: "기존 문서를 선택한 경우, 현재 task에만 추가됩니다. 기존 문서를 하나만 사용 가능한 경우, 미리 선택됩니다; 그렇지 않은 경우, 추가할 기존 복사본을 선택하십시오.",
    bulkAddToEvidenceAdvancedOn: "고급 옵션",
    bulkAddToEvidenceAdvancedOff: "Off",
    bulkAddToEvidenceFindText: "찾기 텍스트",
    bulkAddToEvidenceFindTextRequired: "유효한 찾기 텍스트를 입력하십시오",
    bulkAddToEvidenceReplaceWith: "바꿀 대상",
    bulkAddToEvidenceReplaceSuccess: "{0}을(를) {1}(으)로 바꾸기",
    bulkAddToEvidenceUseExisting: "기존 문서 사용",
    bulkAddToEvidenceCreateNew: "신규 생성",
    bulkAddToEvidenceDocumentName: "문서 이름",
    bulkAddToEvidenceExistingDocument: "기존 문서",
    bulkAddToEvidenceSelectANewOrExistingCopy: "신규 또는 기존 복사본 선택",
    bulkAddToEvidenceAssociateToTasks: "Task에 연결",
    bulkAddToEvidenceAssociateToCanvasForms: "Canvas 양식에 연결",
    bulkAddToEvidenceOtherRelatedTasks: "기타 관련 task",
    bulkAddToEvidenceAssociateToTasksPlaceholder: "신규 생성 문서만 task에 연결할 수 있습니다. 기존 문서는 현재 task에 자동 연결됩니다.",
    bulkAddToEvidenceSelectedTask: "{0} 연결된 task",
    bulkAddToEvidenceSelectedTasks: "{0} 연결된 task",
    bulkAddToEvidenceSelectedTasksPlaceholder: "사용 가능한 관련 task 없음",
    bulkAddToEvidenceAssociateToCanvasFormsPlaceholder: "신규 생성 문서만 Canvas 양식에 연결할 수 있습니다.",
    bulkAddToEvidenceRelatedCanvasForms: "연결된 Canvas 양식",
    bulkAddToEvidenceSelectedForm: "{0} 연결된 Canvas 양식",
    bulkAddToEvidenceSelectedForms: "{0} 연결된 Canvas 양식",
    bulkAddToEvidenceSelectedFormsPlaceholder: "연결된 Canvas 양식 없음",
    picRequiredValidation: "PIC sign-off 필요 문서가 PIC task에 연결되어 있지 않습니다",
    eqrRequiredValidation: "EQR sign-off 필요 문서가 EQR task에 연결되어 있지 않습니다",
    picEqrRequiredValidation: "PIC/EQR sign-off 필요 문서가 PIC/EQR task에 연결되어 있지 않습니다",

    viewSwitcherDefault: "기본 보기",
    viewSwitcherEntity: "기업 보기",
    viewSwitcherAllEntities: "모든 기업",
    viewByEntities: "기업별 보기",

    /* bulk delete modal */
    bulkDeleteFilesModalMessage: "선택한 문서를 삭제하시겠습니까?",
    bulkDeleteFIlesModalMessageSub: "삭제할 수 없는 문서는 아래 표시되고 삭제되지 않습니다",
    bulkDeleteModalLabel: "문서 삭제",
    bulkDeleteSuccessMessage: "문서가 삭제됐습니다",
    bulkDeleteValidDocumentsHeader: "다음 문서가 삭제됩니다",
    bulkDeleteInvalidDocumentsHeader: "아래 열거된 문서는 삭제할 수 없습니다",

    /* Bulk sign-off requirements modal */
    bulkSignOffRequirementsModalMessage: "아래에서 선택한 문서의 executive sign-off 요건을 조정하십시오. EY Canvas에서 필수로 요구되는 일부 sign-off 요건은 조정할 수 없습니다.",
    bulkSignOffRequirementsResultMessage: "{0} 문서의 sign-off 요건이 업데이트됐습니다",


    bulkOpenCountWarning: "선택한 문서 수가 최대 허용치를 초과했습니다. 처음 {0}만 열립니다.",

    /* Pending evidence modal */
    pendingEvidenceInstructionalText: "아래 열거된 팀은 그룹 문서를 아직 보내지 않았습니다",
    pendingEvidenceDueDate: "만료일",
    searchRegionComponentLabel: "지역 및 부문 검색",

    /* Review Notes Count */
    noReviewNotesAssignedOrAuthored: "선택한 팀 멤버에 대한 노트가 없습니다",
    noUserSelected: "세부정보를 보려면 사용자를 선택하십시오. EY Canvas에서 노트를 역할에 배정할 수 없습니다.",
    reviewNotesText: "리뷰노트",
    assigned: "배정됨",
    authored: "작성됨",
    overdue: "지연",
    comingDue: "만료 도래",
    cleared: "처리됨",
    open: "Open",
    closed: "닫힘",
    noTaskAssignedToUser: "선택한 팀 멤버 또는 역할에 배정된 task가 없습니다",
    preparer: "작성자",
    reviewer: "검토자",
    assignments: "배정",
    notStarted: "시작 전",
    inProgress: "진행 중",
    done: "마침",
    forUpcomingReview: "임박",
    noTaskOrNotesAssigned: "선택한 팀 멤버 또는 역할에는 task나 노트가 없습니다",
    fromTo: "From / to",

    /* Collaboration grid */
    overdueCollaboration: "지연",
    comingDueCollaboration: "만료 도래",

    /*Document Conflict*/
    documentConflict: "문서 충돌",
    documentConflictModalConfirm: "이 버전 유지",
    documentConflictModalClose: "취소",
    documentConflictInstruction: "충돌을 해결하려면, 유지해야 하는 문서 버전을 선택하십시오",
    documentConflictMessage: "팀 멤버 이름을 클릭하여 이 문서의 이전 버전을 읽기 전용 모드로 엽니다. 이전 버전에서 변경한 사항은 EY Canvas에 저장되지 않습니다.",
    lastmodifiedDate: "최근 수정일",
    modifiedBy: "수정한 사람",
    documentConflictErrorMessage: "계속하려면 버전을 선택하십시오",
    currentVersion: "현재 버전",
    documentConflictError: "문서 충돌 오류 메시지",
    documentConflictHeader: "이 문서에 충돌이 있습니다",
    viewHistory: "기록 보기",
    confirmButtonToolTip: "그룹 문서 충돌을 해결할 권한이 있어야 합니다. 이 작업을 하려면 engagement 관리자에게 문의하여 권한을 요청하십시오.",
    documentHistoryHeader: "이 문서의 버전 기록은 아래 표시됩니다",
    documentHistoryMessage: "팀 멤버 이름을 클릭하여 이 문서의 이전 버전을 읽기 전용 모드로 엽니다. 이전 버전에서 변경한 사항은 EY Canvas에 저장되지 않습니다.",

	documentHistoryInstruction: '이전 버전이 현재 버전이어야 한다면 해당 버전을 선택하고 "버전 업데이트 "를 클릭하십시오',
	documentHistoryAdminInstruction: '버전이 필요하지 않다면, 해당 버전을 선택하고 "버전 삭제 "를 클릭하십시오',

    documentHistoryModalConfirm: "버전 업데이트",
    documentHistoryModalClose: "닫기",
    documentHistoryErrorMessage: "문서에 충돌이 있습니다. 계속하기 전에 이를 해결하십시오.",

    /* Dashboard  - Collaboration Tile*/
    clientCollboration: "고객 공동작업",
    nextwaveServices: "중앙집중식 서비스",
    receivedStatusLabel: "수신됨",
    acceptedStatusLabel: "수락됨",
    outstandingStatusLabel: "처리 전",
    collaborationNonUsageMessage1: "EY Canvas에서 공동작업을 이용하여 외부 팀멤버에게 요청사항과 외부 task를 직접 전송합니다. 공동작업을 활성화하려면 먼저 고객을 EY Canvas Client Portal에 등록합니다. 그 다음, 접근 그룹을 설정합니다. 그러고 나서 요청사항을 생성하거나 외부 task를 배정합니다.",
    collaborationNonUsageMessage2: "시작 매뉴얼을 볼 수 있습니다",
    collaborationNonUsageMessageHyperlinkText: "여기를 클릭하면",
    collaborationNonSentMessage1: "{0}로 이동하고",
    collaborationNonSentMessage2: "초안을 전송하여 시작합니다",
    collaborationNonSentMessageHyperlinkText: "공동작업",
    noBodies: "본문 없음",
    editResponse: "응답 편집",
    unsentDrafts: "미전송 초안",
    unsentDraft: "미전송 초안",
    noUnsentDrafts: "미전송 초안 없음",
    requestsSent: "요청사항 전송됨",
    nextWavetotalTasks: "총 TASK",
    comingDueTimeframe: "기간",
    otherTimeframeDataAvailableMessage: "데이터를 보려면 다른 기간을 선택하십시오",

    /* Dashboard Engagement Metrics */
    engagementMetricsTileHeader: "Engagement 지표",
    overdueColumnHeader: "지연",
    comingDueColumnHeader: "만료 도래",
    whatsNewColumnHeader: "신규",
    placeholderMessageNoContentInSpecifiedTimeframe: "데이터를 보려면 다른 기간을 선택하십시오",
    placeholderMessageNoEngagementMetrics: "Engagement에 사용 가능한 지표가 없습니다",
    performanceMetrics: "성과 지표",
    reviewNotesAndAssignments: "리뷰노트 및 배정",
    /*Dashboard Engagement overview*/
    engagementOverview: "Engagement 개요",
    engagementOverviewInstructionalText: "아래에서 감사 단계별 engagement 진행상황을 검토하십시오",

    /*Dashboard Milestone tile*/
    milestoneprogressTileHeader: "Milestone",
    milestoneprogressSubHeader: "Milestone별 task 완료 상태를 보려면 아래에서 감사 단계를 선택하십시오. 시기별 task 완료 상태를 보려면, <b>시기별 보기</b>를 선택하십시오. 각 milestone 또는 시기별로 자세한 진행상태를 보려면, <b>세부정보 보기</b>를 선택하십시오.",
    tasksStatus: "Task 상태",
    preparerAssignments: "작성자 배정",
    reviewerAssignments: "검토자 배정",
    openComments: "처리 전 노트",
    /* Dashboard Profile Page */
    groupAudit: "그룹 감사",
    groupStatus: "그룹 상태",
    viewInstructions: "지침 보기",
    instructionsInstructionalText: "Primary team에서 수신한 지침은 아래에 표시됩니다. 지침을 보려면 링크를 선택하십시오.",
    noInstructionsAccepted: "지침이 아직 수락되지 않았습니다",

    /* Dashboard SDM Summary */
    nextWaveservices: "중앙집중식 서비스",
    totalTasksLabel: "총 task",
    tasksUsingNextWaveservices: "task 중앙집중식 서비스 사용 중",
    tasksSuggestedForNextwaveUse: "task 중앙집중식 서비스 권장됨",
    outOf: "out of",
    tasksUsing: "tasks using",
    suggestedFor: "suggested for",
    nextwaveUse: "중앙집중식 서비스",
    draftRequests: "초안 요청사항",
    draftRequest: "초안 요청",
    createRequests: "요청사항 생성",
    noRequestCreated: "생성된 요청사항이 없습니다. 시작하려면 요청을 생성하고 전송하십시오.",

    /* RNH Bulk Controls */
    rnhBulkAssignPriorityTitle: "우선순위 변경",
    rnhBulkAssignPriorityTooltip: "우선순위",
    rnhBulkDueDateTooltip: "만료일",
    rnhBulkAssignPriorityModalHeader: "선택한 노트를 편집할 수 없습니다",
    rnhBulkAssignPriorityModalContent: "처리 전 상태인 노트만 우선순위를 변경할 수 있습니다. 우선순위를 변경하려면 처리됐거나 닫힌 상태인 노트를 다시 여십시오.",
    rnhBulkAssignDueDateModalContent: "처리 전 상태인 노트만 만료일을 변경할 수 있습니다. 만료일을 변경하려면 처리됐거나 닫힌 상태인 노트를 다시 여십시오.",
    rnhBulkAssignUserTooltip: "재배정",
    rnhBulkAssignUserSearch: "검색",
    rnhBulkAssignUserTitle: "선택한 리뷰노트를 편집할 수 없습니다",
    rnhBulkAssignUserText: "처리 전 상태인 리뷰노트만 재배정할 수 있습니다. 재배정하려면 처리됨 또는 닫힘 상태인 리뷰노트를 다시 여십시오.",
    rnhBulkAssignStatusTooltip: "상태",
    rnhBulkAssignUserNoFound: "결과를 찾을 수 없습니다",
    rnhBulkDueDatePlaceholder: "날짜 고르기",
    rnhBulkDeleteTextCorrect: "선택한 노트를 삭제하시겠습니까? 노트가 삭제되면 더 이상 접근할 수 없습니다.",
    rnhBulkDeleteTextIncorrect: "닫힘 상태인 노트만 삭제할 수 있습니다. 삭제하려면 처리 전이나 처리됨 상태인 노트를 닫으십시오.",
    rhnBulkDeleteTitleCorrect: "선택한 노트 삭제",
    rhnBulkDeleteTitleIncorrect: "선택한 노트를 삭제할 수 없습니다",
    rnhBulkDeleteTextIncorrectComment: "닫힘 상태인 리뷰노트만 삭제할 수 있습니다. 삭제하려면 처리 전 또는 처리됨 상태인 리뷰노트를 닫으십시오.",
    rhnBulkDeleteDescriptionAuthorComment: "귀하가 작성한 노트만 삭제할 수 있습니다",
    rnhBulkDeleteEngagementComment: "선택한 리뷰노트를 삭제하시겠습니까? 리뷰노트가 삭제되면 더 이상 접근할 수 없습니다.",
    rhnBulkDeleteTitleCorrectEngagementComment: "선택한 노트 삭제",
    rhnBulkDeleteTitleCommentCloseStatus: "선택한 노트를 삭제할 수 없습니다",


    fourFortyFilters: "필터",
    fourFortySearch: "검색",

    /* Add External Member Start*/
    addExternalModalTitle: "외부 멤버 추가",
    accessGroupSelection: "접근 그룹 선택",
    noRecordinGroups: "결과를 찾을 수 없습니다",
    permission: "허가",
    permissionProjectManagement: "프로젝트 관리",
    permissionProjectManagementDesc: "EY Canvas Client Portal에서 고객 요청사항과 외부 task 상태를 보는 기능. 이 외부 멤버는 고객 요청사항과 외부 task 세부정보에 접근할 수 없습니다.",
    permissionInfoTooltip: "모든 허가 목록",
    groupInfoTooltip: "그룹 목록",
    groupRequired: "그룹을 선택하십시오",
    firstnameRequired: "이름 필요",
    lastnameRequired: "성 필요",
    initialsRequired: "이니셜 필요",
    roleRequired: "Engagement 역할 필요",
    confidentialityRequired: "기밀 수준 필요",
    groupLabel: "접근 그룹",
    firstnameLabel: "이름",
    lastnameLabel: "성",
    initialsLabel: "이니셜",
    userinfo: "사용자 정보",
    userinfoDescription: "초대하려는 팀 멤버의 이름, 성 또는 이메일 주소를 입력하고 Enter 키를 누르십시오",
    inviteAndClose: "초대 & 닫기",
    inviteAndAddOther: "초대 & 다른 멤버 추가",
    addAndClose: "초대 & 닫기",
    addAndAddOther: "초대 & 다른 멤버 추가",
    externalUserCreatedSuccessMessage: "추가 성공",
    accessGroupSelectionMessage: "접근 그룹을 통해 외부 팀에서 EY Canvas Client Portal로 전송된 요청사항을 볼 수 있는 사람을 관리할 수 있습니다. EY Canvas Client Portal에 접근할 접근 그룹과 사용자 목록을 고객과 협의하십시오. 어떤 요청이 그룹에 속한 외부 사용자에게 배정되면, 이는 해당 그룹의 모든 멤버에게 보입니다.",
    accessGroupSectionMessage1: "외부 팀 멤버는 EY Canvas에 추가되기 전에 My EY Admin Portal을 통해 등록되어야 합니다.",
    accessGroupSectionMessage2: "를 클릭하여 My EY Admin Portal에 접속하고 시작하십시오.",
    accessGroupMessageHyperlinkText: "여기",
    accessGroupUserMessage1: "온보딩 사용자에 대해 더 많은 정보를 보려면",
    accessGroupUserMessage2: "를 클릭하여 EY Atlas에 접속하십시오.",
    noRecordForExternalMember1: "이메일 주소를 찾을 수 없습니다",
    noRecordForExternalMember2: "외부 팀 멤버가 My EY를 통해 등록했는지 확인합니다",

    /* Add External Member End*/

    /* Edit External Member Start*/

    editExternalModalTitle: "외부 멤버 편집",
    editExternalaccessGroupSelection: "접근 그룹 선택",
    editExternalGroupInfoTooltip: "그룹 목록",
    editExternalGroupLabel: "접근 그룹",
    editExternalGroupRequired: "그룹을 선택하십시오",
    editExternalNoRecordinGroups: "결과를 찾을 수 없습니다",
    editExternalUserinfo: "사용자 정보",
    editExternalUserinfoDescription: "이름, 성 또는 이니셜 편집",
    editExternalEmailLabel: "이메일",
    editExternalFirstnameLabel: "이름",
    editExternalLastnameLabel: "성",
    editExternalInitialsLabel: "이니셜",
    editExternalSaveLabel: "저장",
    editExternalUsersSuccessMessage: "{0} {1}에 대한 변경사항이 저장됐습니다",
    editExternalUsersCloseLabel: "닫기",

    /* Edit External Member End*/



    /*access group*/
    groupName: "그룹 이름",
    groupNameHelp: "접근 그룹을 생성하려면 이름은 필수입니다",
    groupNameHelpOnEdit: "이름은 필수입니다",
    groupNameReq: "그룹 이름 필요",
    groupNameInvalidCharacter: "유효하지 않은 문자",
    grpDomainManage: "도메인 관리",
    grpDomainHelp: "도메인은 이 접근 그룹에 추가할 수 있는 사용자를 제한합니다. 접근 그룹을 생성하려면 하나 이상의 도메인은 필수입니다. 도메인은 @ 기호 뒤 문자입니다. 와일드카드 *를 사용하십시오(예, *.ey.com).",
    btnAddNewDomain: "신규 도메인 추가",
    btnAddExistingDomain: "기존 도메인 추가",
    domainValidation01: "하나 이상의 유효한 도메인은 필수입니다",
    domainValidation02: "도메인 선택",
    domainValidation03: "중복 입력",
    domainValidation04: "유효하지 않은 도메인 이름",
    domainValidation05: "도메인 이름 필요",
    domainName: "도메인 이름",
    emailDomain: "이메일 도메인",
    groupDeletionErrorPendingReqMsg: "접근 그룹을 삭제하는 동안 오류가 발생했습니다. 이 그룹 또는 이 그룹의 멤버에게 배정된 요청사항/외부 Task가 없는지 확인하고 다시 시도하십시오.",
    groupDeletionSuccessMsg: "{0}이(가) 삭제됐습니다. 활성 멤버 모두 비활성화됐습니다.",

    /* uncommon values for internal mem */
    editInternalMember: "내부 멤버 편집",
    editThirdPartyMember: "제3자 멤버 편집",
    listOfAllPerm: "모든 허가 목록",
    internalPermiInviteExt: "내부 멤버 초대",
    internalPermiInviteInt: "외부 멤버 초대",
    internalPermiAssignPer: "허가 배정",
    internalPermiDeleteEng: "Engagement 삭제",
    internalPermiArchEng: "Engagement Archive",
    internalPermiUpdateContet: "내용 업데이트",

    internalPermiInviteExtToolTp: "내부 팀 멤버를 engagement에 초대하는 기능",
    internalPermiInviteIntToolTp: "외부 팀 멤버를 engagement에 초대하는 기능",
    internalPermiAssignPerToolTp: "이 허가를 engagement의 내부와 외부 팀 멤버에게 배정하는 기능",
    internalPermiDeleteEngToolTp: "Engagement를 삭제하는 기능",
    internalPermiArchEngToolTp: "Engagement를 archive하는 기능",
    internalPermiUpdateContetToolTp: "프로필을 편집하고 내용 업데이트를 수락하는 기능",
    internalMemberInviteSuccessMessage: "{0} {1}에게 초대를 전송했습니다.",
    internalMemberPostArchivalAdditionSuccessMessage: "{0} {1}을(를) 추가했습니다",
    invitePriorPeriodUsersSuccessMessage: "비활동 멤버에게 초대를 전송했습니다",
    editInternalUsersSuccessMessage: "{0} {1}에 대한 변경사항이 저장됐습니다",
    rbacErrorEditUser: "지금은 변경사항을 저장할 수 없습니다. 다시 시도하고 문제가 지속되면, 헬프 데스크에 문의하십시오.",
    universalQueueErrorEditUser: "지금은 EY Canvas 랜딩페이지에 접속할 수 없으며 편집이 필요합니다. 다시 시도하고 문제가 지속되면 헬프 데스크에 문의하십시오.",
    removeExternalUsersSuccessMessage: "{0} {1}이(가) 제거됐습니다",
    reActivateExternalUsersSuccessMessage: "{0} {1}이(가) 다음 접근 그룹에서 재활성화됐습니다: {2}",

    /*user search component*/
    seachInputRequired: "검색 입력 필요",
    nameOrEmail: "이름 또는 이메일",
    emailForExternal: "이메일",
    noRecord: "결과를 찾을 수 없습니다",
    userSearchPlaceholder: "결과를 보려면 이름이나 이메일을 입력하고 Enter 키를 누르십시오",
    userSearchPlaceholderForExternal: "이메일을 입력하고 Enter 키를 눌러 결과를 보십시오",
    clearAllValues: "모든 값 처리",
    inValidEmail: "유효한 이메일을 입력하십시오",

    maxLengthForEditResponse: "Rich text 서식 태그를 포함한 최대 문자 수는 30,000입니다. 불필요한 서식을 제거하고 다시 시도하십시오.",
    clickEditResponseToContinue: "계속하려면 응답 편집을 클릭하십시오",
    bodyDescriptionFromKnowledge: "Knowledge의 본문 설명",
    execution: "실행",
    cannotpasteimages: "이미지를 붙여 넣을 수 없습니다",
    pastingImagesNotAllowed: "이미지 붙여넣기는 허용되지 않습니다. 이미지가 필요한 경우, 증거로 업로드하고 참조 표시하십시오.",
    saveResponse: "저장되지 않은 변경사항이 있습니다. 계속하시겠습니까",
    conclusion: "결론",
    referenceDocsPlaceHolder: "자주 접근하는 파일을 여기에 추가하여 빠르게 엽니다",
    referenceDocsTeamPlaceHolder: "팀 참조 문서가 이 engagement에 추가되지 않았습니다. 시작하려면 '문서 추가'를 클릭하십시오.",
    referenceDocsMyPlaceHolder: "참조 문서를 추가하지 않았습니다. 시작하려면 '문서 추가'를 클릭하십시오.",
    teamDocuments: "팀 고정",
    myDocuments: "내 고정",
    teamDocumentsModalTitle: "팀 문서",
    myDocumentsModalTitle: "내 문서",
    referenceDocuments: "팀 고정",

    /* PinnedDocument  */
    PinnedDocument: "고정된 문서",
    PinnedDocumentSubTite: "아래에서 자신의 목록이나 팀 목록에 항목을 고정하여 자주 접근하는 문서 목록을 생성하십시오. 목록을 수정하려면, <b>문서 추가</b>를 선택하십시오.",
    PinnedDocPaceholder: "고정한 문서가 없습니다. <br>여기에 문서를 고정하려면 <b>문서 추가</b>를 선택하십시오.",
    PinnedTeamDocPlaceholder: "팀이 고정한 문서가 없습니다. <br>여기에 문서를 고정하려면 <b>문서 추가</b>를 선택하십시오.",
    PinnedDocAddDocHeaderText: "고정된 문서 목록을 사용자지정하려면 증거와 임시 파일을 선택하십시오",
    onlyShowPinnedDocuments: "고정된 문서만 표시",
    pinned: "고정됨",
    /* Arc Timeline */
    arcTitle: "Archive 체크리스트",
    arcCompleted: "완료됨",
    arcSubmit: "Archive 제출",
    arcDescription: "이 engagement를 archive하려면 체크리스트에 있는 항목을 모두 완료해야 합니다",
    invalidEngagementCode: "유효하지 않은 Engagement 코드",
    invalidClientCode: "유효하지 않은 고객 코드",
    arcCheckBox: "Archive 재지정",
    arcUnlinkEvidenceButtonText: "모두 링크 해제",
    arcUnlinkEvidenceModalTitle: "모든 공유 증거 링크 해제",
    arcUnlinkEvidenceModalText: "이 workspace 내 다른 engagement에서 이 engagement로 공유된 증거를 모두 링크 해제하시겠습니까? 이 작업을 완료하면 실행 취소할 수 없습니다.",
    arcUnlinkEvidenceModalConfirmButton: "모두 링크 해제",
    arcUnlinkEvidenceModalCancelButton: "취소",
    arcUnlinkEvidenceButtonUnlinkInProgress: "링크 해제 진행 중",
    arcUnlinkEvidenceButtonUnlinkError: "링크 해제 오류",
    arcUnlinkGroupEngagementButtonText: "그룹에서 링크 해제",
    arcUnlinkGroupEngagementModalTitle: "그룹에서 이 Engagement 링크 해제",
    arcUnlinkGroupEngagementModalText: "이 workspace 내 다른 engagement에서 이 engagement를 링크 해제하시겠습니까? 이 작업을 완료하면, 실행 취소할 수 없습니다.",
    arcUnlinkGroupEngagementModalConfirmButton: "링크 해제",
    arcUnlinkGroupEngagementModalCancelButton: "취소",
    arcUnlinkGroupEngagementButtonUnlinkInProcess: "링크 해제 진행 중",
    arcModalTitle: "기존 ARC 기록",
    arcProceedWithArchive: "Archive 진행",
    arcModalBodyText: "복원된 engagement 파일을 archive하려고 합니다. 이 파일은 이미 Archive Records Center (ARC)에 이미 있습니다. 계속하시겠습니까?",
    noDataAvailabel: "지금 사용 가능한 데이터가 없습니다. 페이지를 새로 고침하여 다시 시도하십시오. 오류가 지속되면 헬프 데스크에 문의하십시오.",
    reportDateBeforeCurrentDate: "Engagement 보고서일은 오늘 이전이어야 합니다. 계속하려면 보고서일을 업데이트하십시오. 보고서일을 업데이트하려면 '주요 engagement 날짜 정확성 확인' 링크를 클릭하십시오.",

    /*Helix Projects*/
    linkedProjects: "링크된 프로젝트",
    suggestedAnalyzers: "권장 analyzer",
    linkSelected: "선택된 링크",
    noLinkedProjectsAvailable: "링크된 프로젝트가 없습니다",
    helixProjectTitle: "EY Helix 프로젝트",
    findProjects: "프로젝트 찾기",
    findProjectsModalTitle: "EY Helix 프로젝트 찾기",
    selectProjectsToLink: "아래 EY Helix 프로젝트 중 하나 이상을 선택하여 EY Canvas engagement와 링크를 생성합니다. 고객 코드로 수동 검색하여 다른 EY Helix 프로젝트를 찾을 수 있습니다.",
    newSearch: "신규 검색",
    noResultsFound: "결과를 찾을 수 없습니다",
    enterClientCode: "다시 검색하려면 고객 코드를 입력하십시오",
    enterClientCodeToDisplayAnalizers: "고객 코드를 입력하여 사용 가능한 analyzer 목록을 표시하십시오",
    defaultClientCodeIsInvalid: "기본 고객 코드 {0}은(는) 이 engagement에 유효하지 않습니다. 유효한 고객 코드를 입력하여 사용 가능한 analyzer 목록을 표시하십시오.",
    mirrorCodesNotAccepted: "미러 코드는 수락되지 않습니다",
    helixProjectSearch: "검색",
    helixProjectsSearchPlaceholderText: "검색하려면 고객 코드를 입력하십시오",
    helixWizardProjectsSearchPlaceholderText: "고객 코드별 analyzer 검색",
    selectOneOrMoreProjects: "목록에서 하나 이상의 Helix 프로젝트를 선택하여 링크하십시오",
    noPermissionLabel: "이 engagement를 archive하려면 Archive 권한이 있어야 합니다",
    linkProject: "프로젝트 링크",
    oneAnalyzerMustBeSelected: "Analyzer 중 하나를 선택해야 합니다",
    selectAnAnalyzer: "Analyzer 선택",
    selectOneAnalyzer: "아래에서 EY Canvas engagement와 링크를 생성할 EY Helix analyzer를 선택하십시오. 고객 코드를 수동으로 검색하여 EY Helix 프로젝트 및 관련 analyzer를 찾을 수 있습니다.",
    selectAnalyzerModalTitle: "Analyzer 선택",
    selectAnalyzerModalBodyText: "EY Canvas engagement와 연결할 EY Helix analyzer를 선택하십시오",
    selectAnalyzerModalSubmitButtonLabel: "프로젝트 링크",
    projectCanNotBeLikedTootip: "EY Canvas Engagement의 위치와 일치하지 않기 때문에 이 EY Helix 프로젝트를 사용할 수 없습니다",
    unlinkProjectConfirmationModalTitle: "경고 - 프로젝트 링크 해제",
    unlinkProjectConfirmationModalBodyText: "링크 해제할 EY Helix analyzer에 이 engagement와 연결된 고객 북마크가 있습니다. 이 analyzer를 링크 해제하면 그 북마크를 더 이상 사용할 수 없게 됩니다. 이 작업은 실행 취소할 수 없습니다. 계속하시겠습니까?",
    defineConnectionSettings: "연결 설정 정의",

    helixConnectionPageTitle: "EY Helix 연결",
    helixConnectionPageSubtitle: "연결된 EY Helix analyzer, 거기에 불러온 데이터, EY 계정에 매핑된 GL 계정의 백분율입니다. 매핑을 조정하려면 매핑된 백분율을 클릭하십시오. 연결과 불러온 데이터 간 매핑된 백분율이 다를 수 있습니다. 예를 들어, 불러온 날짜 이후 매핑이 일어난 경우입니다. 최신 매핑을 가져오려면 데이터를 다시 불러오십시오.",
    helixIntegrationPageNoConnectedAnalyzerLabel: "연결된 analyzer 없음",
    helixIntegrationPageTitle: "EY Helix 통합",
    helixIntegrationPageSubtitle: "EY Canvas engagement에 EY Helix analyzer를 하나 이상 연결하십시오",
    helixIntegrationPageNoHelixProjectLinkedLabel1: "연결된 analyzer 없음. 신규 analyzer를 연결하려면,",
    helixIntegrationPageNoHelixProjectLinkedLabel2: " 여기를 클릭하십시오.",
    helixIntegrationPageColumnConnectionName: "연결 이름",
    helixIntegrationPageColumnConnectionType: "연결 유형",
    helixIntegrationPageColumnAnalysisPeriod: "분석일",
    helixIntegrationPageColumnAnalyzerName: "EY Helix analyzer 이름",
    helixIntegrationPageColumnLastConnectedBy: "최근 연결한 사람",
    connectAnalyzer: "Analyzer 연결",
    dataImportModalTitle: "불러오기 확인",
    dataImportModalBodyLabel: "이 engagement에 ‘범위 및 전략’ 불러오기가 이미 있습니다. Engagement별로 하나의 ‘범위 및 전략’ 불러오기만 허용됩니다. 이 데이터를 불러오면 기존에 불러온 ‘범위 및 전략’이 대체됩니다. 계속하시겠습니까? 이 작업은 실행 취소할 수 없습니다.",
    dataImportModalBodyLabelMest: "이 기업에 ‘범위 및 전략’ 불러오기가 이미 있습니다. 기업별로 하나의 ‘범위 및 전략’ 불러오기만 허용됩니다. 이 데이터를 불러오면 기존에 불러온 ‘범위 및 전략’이 대체됩니다. 계속하시겠습니까? 이 작업은 실행 취소할 수 없습니다.",
    dataImportModalCancelButtonLabel: "취소",
    dataImportModalCloseButtonLabel: "닫기",
    dataImportModalConfirmButtonLabel: "불러오기",
    dataImportModalImportError: "연결된 EY Helix analyzer와 관련하여 오류가 발생했습니다. 데이터를 불러올 수 없습니다. 페이지를 새로 고침하여 다시 시도하십시오. 문제가 지속되면, 헬프 데스크에 문의하십시오.",

    //Entites to Business Mapping Modal
    entityMappingModalTitle: 'Entity mapping',
    entityMappingModalCancelLabel: 'Cancel',
    entityMappingModalSaveLabel: 'Save',
    entityMappingModalDescription: 'Manage the mapping between entities and business units for this connection. Each business unit can be mapped to a single entity only.',
    entityMappingModalBusinessUnitsPlaceholder: 'Business unit(s)',
    entityMappingModalAllBusinessUnitsLabel: 'All business units',
    entityMappingModalBusinessUnitSelectedCount: '{0} business unit',
    entityMappingModalBusinessUnitsSelectedCount: '{0} business units',
    entityMappingModalNoResultsFound: 'No results found',
    entityMappingModalNoEntitiesLabel1: 'No entities exists in the engagement.',
    entityMappingModalNoEntitiesLabel2: 'Create an entity to get started.',
    entityMappingModalBusinessUnitAlreadyMapped: 'A business unit can be related to only one entity. Unrelate from other entities to enable.',
    /*Entites to Business Table*/
    entityMappingTableEntityColumnLabel: 'Entity',
    entityMappingTableBusinessUnitsColumnLabel: 'Business unit(s)',

    helixProjectPageTitle: "EY Helix 프로젝트",
    helixProjectPageSubtitle: "이 EY Canvas engagement와 관련된 EY Helix 프로젝트를 링크하십시오. EY Helix 프로젝트가 둘 이상 링크되면, 하나를 primary 프로젝트로 선택하여 EY Canvas로 데이터를 통합하십시오. Primary 프로젝트만 EY Canvas로 통합될 수 있으므로, engagement 관련 당기 분개 활동이 모두 포함돼야 합니다.",
    helixProjectPageNoHelixProjectLinkedLabel1: "Engagement에 현재 링크된 EY Helix 프로젝트가 없습니다",
    helixProjectPageNoHelixProjectLinkedLabel2: "시작하려면 신규 EY Helix 프로젝트를 추가하십시오",
    helixProjectPageNoHelixProjectLinkedLabel3: ' to get started.',
    helixProjectPageNoHelixProjectLinkedLabel4: "Click",
    linkToHelixProject: "EY Helix에서 열기",
    addNewEYHelixProject: "신규 EY Helix 프로젝트 추가",
    eyHelixSetup: "EY Helix 데이터 통합",
    existingConnectionDetectedModalTitle: "기존 연결 발견됨",
    existingConnectionDetectedDescription: "선택한 analyzer는 이전에 이 EY Canvas engagement에 연결됐습니다. 신규 연결을 생성하거나 아래에서 기존 연결을 선택할 수 있습니다.",
    selectExistingConnection: "기존 연결 선택",
    selectCreateNewConnection: "신규 연결 생성",
    connectionNoRecords: "연결을 찾을 수 없습니다",
    selectOneOfTheOptionsToProceed: "계속하려면 옵션 중 하나를 선택하십시오",
    saveHelixProjectErrorMessage: "선택한 analyzer를 저장할 수 없습니다. 페이지를 새로 고침하여 다시 시도하십시오. 문제가 지속되면, 헬프 데스크에 문의하십시오.",
    noResultFoundForAnalyzerSelection: "검색하려는 analyzer가 유효한 상태이고 analyzer 접근 권한을 받았는지 확인하십시오. 추가 세부정보를 보려면 EY Helix 관리자에게 문의하십시오. 다시 검색하려면 고객 코드를 입력하십시오.",

    /*Helix Analyzer Details Drawer*/
    connectButtonLabel: "연결",
    reConnectButtonLabel: "재연결",
    demoteFromFinancialStatementsOptionLabel: "재무제표에서 격하",
    promoteToFinancialStatementsOptionLabel: "재무제표로 격상",
    deleteOptionLabel: "삭제",
    projectAndAnalyzerDetailsSectionTitle: "프로젝트 및 analyzer 세부정보",
    projectNameLabel: "프로젝트 이름",
    clientCodeLabel: "고객 코드",
    analyzerNameLabel: "Analyzer 이름",
    periodEndDateLabel: "종료일",
    analysisDateLabel: "분석일",
    lastConnectedByLabel: "최근 연결한 사람",
    connectionSettingsSectionTitle: "연결 설정",
    connectionTypesLabel: "연결 유형",
    currencyTypeLabel: "통화 유형",
    currencyLabel: "통화",
    currencyCodeLabel: "통화 코드",
    businessUnitsLabel: "사업부",
    entitiesLabel: "기업",
    analysisPeriodLabel: "분석일",
    comparativePeriod1Label: "비교일 1",
    comparativePeriod2Label: "비교일 2",
    manageAccountMappingSectionTitle: "계정 매핑 관리",
    manageAccountMappingButtonLabel: "계정 매핑 관리",
    mappedGLAccountsLabel: "매핑된 GL 계정 %:",
    updateSettingsButtonLabel: "업데이트 설정",
    deleteConnection: "연결 삭제",
    deleteConnectionQuestion: "선택한 연결을 삭제하시겠습니까? 이 연결과 관련하여 이전에 통합된 데이터가 모두 삭제됩니다. 이 작업은 실행 취소할 수 없습니다.",
    deleteConnectionWithAnalyticsQuestion: "선택한 연결을 삭제하시겠습니까? 이 연결과 관련하여 이전에 통합된 데이터가 모두 삭제됩니다. 또한, 선택한 연결에는 이 engagement에 연결된 고객 북마크가 있습니다. 연결을 삭제하면 그러한 북마크를 더 이상 사용할 수 없습니다. 이 작업은 실행 취소할 수 없습니다.",

    /*Helix Projects Table*/
    tableShowing: "결과 표시:",
    tableClientCode: "- 고객 코드:",
    tableEngagementCode: "Engagement 코드",
    tableEngagementCodeName: "Engagement 이름",
    tableProjectID: "프로젝트 ID",
    tableProjectName: "프로젝트 이름",
    tableAnalyzerName: "Analyzer 이름",
    tablePeriodEndDate: 'Period end date',
    tableEYHelixPeriodEndDate: "종료일",
    tableAnalysisDate: "분석일",
    tableEYHelixAnalysisDate: "분석일",
    tableAssignedPartner: "배정된 partner",
    tableProjectLinked: "프로젝트 링크됨",
    tableTooltipAnalizerIsDeleted: "Analyzer가 EY Helix에서 삭제됐습니다. 연결을 영구 삭제하려면 클릭하여 세부정보 드로어를 여십시오. 다른 analyzer를 연결해야 할지 고려하십시오.",
    tableTooltipAnalizerIsUnavailable: "EY Helix에서 analyzer를 사용할 수 없습니다. 추가 세부정보를 보려면 EY Helix 관리자에게 문의하십시오. 연결을 영구 삭제하려면 클릭하여 세부정보 드로어를 여십시오. 다른 analyzer를 연결해야 할지 고려하십시오.",
    tableTooltipNotValidUser: "귀하는 선택한 analyzer에 권한이 있는 팀 멤버가 아닙니다. 접근 권한을 얻으려면 EY Helix 프로젝트 관리자에게 문의하고 다시 시도십시오.",

    /*Helix Project Cards*/
    cardAnalyzerConnectionLabel: "연결",
    cardAnalyzerHelixLabel: "EY Helix analyzer",
    cardAnalyzerMappedGLAccountsLabel: "매핑된 GL 계정",
    cardAnalyzerEntityMappingLabel: 'Entity mapping',
    cardAnalyzerManageGLAccountsLink: "계정 매핑 관리",
    cardAnalyzerSectionScopeAndStrategy: "범위 및 전략",
    cardAnalyzerSectionFinancialStatements: "재무제표",
    cardAnalyzerSectionButtonLink: "여기",
    cardAnalyzerSectionButtonDisconnect: "Analyzer 연결 해제",
    cardAnalyzerSectionScopeAndStrategyNoBalance: "범위 및 전략 데이터는 중요성과 같은 범위 및 전략 활동에서 잔액을 표시하는 데 사용됩니다. 범위 및 전략 데이터를 불러오려면 {0}을(를) 클릭하십시오.",
    cardAnalyzerSectionFinancialStatementsNoBalance: "재무제표를 EY Canvas로 불러와 재무제표에서 EY Canvas 업무 수행 부분까지 드릴다운을 제공할 수 있습니다. 재무제표를 불러오려면 {0}을(를) 클릭하십시오.",
    cardAnalyzerSectionAnotherAnalyzerType: "EY Canvas, EY Helix, 및/또는 EY Smart Sampling 간 통합을 촉진하기 위해 이 analyzer가 연결됐습니다. 이 analyzer 연결을 해제하려면 {0}을(를) 클릭하십시오.",
    cardAnalyzerSectionButtonLinkDisableTooltip: "링크된 analyzer에 권한이 있는 팀 멤버가 아닙니다. 접근 권한을 얻으려면 EY Helix 프로젝트 관리자에게 문의하십시오.",
    cardAnalyzerSectionButtonLinkDisableTooltipPermission: "이 데이터를 불러오는 데 필요한 권한이 없습니다. 이 Canvase engagement에서 “EY Helix 데이터 불러오기” 권한이  있는지 확인한 후 다시 시도하십시오.",
    cardAnalyzerTrialBalanceAnalisysPeriod: "분석일",
    cardAnalyzerTrialBalanceComparativePeriod: "비교일",
    cardAnalyzerTrialBalanceSecondComparativePeriod: "이차 비교일",
    cardAnalyzerTrialBalanceLastImportDate: "최근 불러온 날짜",
    cardAnalyzerTrialBalanceCurrency: "통화",
    cardAnalyzerTrialBalanceBusinessUnits: "사업부",
    cardAnalyzerTrialBalanceMapedGLAccounts: "매핑된 GL 계정",
    cardAnalyzerTrialBalanceImportStatus: "불러오기 상태",
    cardAnalyzerTrialBalanceCurrencyTypeFunctional: "기능",
    cardAnalyzerTrialBalanceCurrencyTypeReporting: "보고",
    cardAnalyzerTrialBalanceImportData: "데이터 불러오기",
    cardAnalyzerTrialBalanceAdjustmentModule: "조정사항 모듈",
    cardAnalyzerTrialBalanceReImport: "다시 불러오기",
    cardAnalyzerTrialBalanceRemove: "제거",
    cardAnalyzerTrialBalanceImportStatusInProgress: "진행 중",
    cardAnalyzerTrialBalanceImportStatusImported: "불러옴",
    cardAnalyzerTrialBalanceImportStatusError: "오류",
    cardAnalyzerTrialBalanceImportStatusDisconnected: "연결 해제됨",
    cardAnalyzerTrialBalanceImportModalTitle: "데이터 불러오기",
    cardAnalyzerTrialBalanceImportModalDescription: "불러오기 속성을 선택하고 ‘불러오기’를 클릭하여 불러오십시오",
    cardAnalyzerTrialBalanceImportModalButton: "불러오기",
    cardAnalyzerTrialBalanceReImportModalTitle: "데이터 다시 불러오기",
    cardAnalyzerTrialBalanceReImportModalDescription: "불러오기 속성을 선택하고 ‘다시 불러오기’를 클릭하여 다시 불러오십시오",
    cardAnalyzerTrialBalanceReImportModalButton: "다시 불러오기",
    cardAnalyzerTrialBalanceImportInProgressTooltip: "불러오기 진행 중. 수 분이 소요될 수 있습니다.",
    cardAnalyzerTrialBalanceImportEntityTooltip: "다시 불러오기 도중에 기업을 변경할 수 없습니다. 다른 기업을 선택하려면 새로 불러오기를 생성하십시오.",
    cardAnalyzerTrialBalanceImportMestEntity: "이 선택은 이전 단계에서 이루어졌습니다. 편집하려면 해당 단계로 되돌아가야 합니다.",
    cardAnalyzerTrialBalanceMestBusinessUnit: "이 선택은 위 기업을 기반으로 합니다. 기업 대 사업부 연결을 편집하려면 원래 요약 페이지에서 ‘기업 매핑’에 접근하십시오.",
    cardAnalyzerTrialBalanceFirstSelectCurrencyTypeTooltip: "이 필드를 활성화하려면 ‘통화 유형’을 먼저 선택하십시오",
    cardAnalyzerTrialBalanceFirstSelectCurrencyTooltip: "이 필드를 활성화하려면 ‘통화’를 먼저 선택하십시오",

    /*Helis Linked Projects Cards*/
    analysisDate: "분석일:",
    unlinkProject: "프로젝트 링크 해제",
    editAnalyzer: "Analyzer 편집",
    deleteProject: "프로젝트 삭제",
    projectDeleted: "프로젝트가 삭제됐습니다",
    loadingProjectDataLinked: "EY Helix에서 데이터 로드 중",
    projectMarkPrimaryConfirmationHeader: "주 EY Helix 프로젝트 변경",
    projectMarkPrimaryConfirmationMsg: "주 EY Helix 프로젝트를 변경하시겠습니까?",
    projectPrimaryEYHexliProject: "주 EY Helix 프로젝트",
    helixProjectUnlink: "링크 해제",
    helixProjectDelete: "삭제",
    analyzersLabel: "Analyzer:",


    /*Helix Import List*/
    importHelixList: "EY Helix 불러오기 목록",
    importDocumentName: "문서 이름",
    importDocumentID: "문서 ID",
    importFileSize: "파일 크기 (KB)",
    importDownload: "다운로드",
    importNoRecords: "문서를 찾을 수 없습니다",
    importInvalidDocumentID: "문서 ID를 검색하려면 완전히 일치해야 합니다. 문서 ID 전체를 포함했는지 확인하십시오.",

    /*Helix Connect analyzer modal*/
    connectAnalyzerClientLabel: "고객:",
    addConnectionNameLabel: "연결 이름 추가",
    connectionNamePlaceholder: "연결 이름",
    connectionNameRequired: "필수",
    connectAnalyzerModalTitle: "Analyzer 연결",
    connectAnalyzerDescription: "이 EY Canvas engagement와 링크를 생성할 analyzer를 아래에서 선택하십시오. 고객 코드별로 검색하여 EY Helix 프로젝트 및 관련 analyzer를 찾으십시오.",
    analyzerLocationIncompatibleErrorMessage: "Analyzer의 데이터가 EY Canvas engagement 위치와 양립할 수 없는 위치에 저장되어 있기 때문에 analyzer를 연결할 수 없습니다",
    analyzerMaxConnectionReachedErrorMessage: "선택한 analyzer에 허용된 최대 연결 수에 도달했습니다. 계속하려면 다른 analyzer를 선택하십시오.",
    helixAnalyzerErrorMessage: "EY Helix analyzer 연결에 오류가 발생했습니다. 페이지를 새로 고침하여 다시 시도하십시오. 문제가 지속되면, 헬프 데스크에 문의하십시오.",
    helixAnalyzerGLAConnectionErrorMessage: "매핑된 계정 수를 가져오기 위해 EY Helix analyzer에 연결하는 동안 오류가 하나 이상 발생했습니다. 페이지를 새로 고침하여 다시 시도하십시오. 문제가 지속되면, 헬프 데스크에 문의하십시오.",
    helixReImportErrorMessage: "EY Helix에서 데이터를 불러오는 동안 오류가 발생하였습니다. 페이지를 새로 고침하여 다시 시도하십시오. 문제가 지속되면 헬프 데스크에 문의하십시오.",

    /*Helix Select Entity Modal*/
    selectEntityModalTitle: "기업 선택",
    noEntitiesMappedToBusiness: "기업이 사업부에 매핑되지 않았습니다",
    noEntitiesMappedToBusinessFirst: "시작하려면",
    noEntitiesMappedToBusinessLink: "여기",
    noEntitiesMappedToBusinessLinkText: "를 클릭하십시오",
    searchEntityPlaceholder: "기업 검색",
    entityListHeader: "기업",
    selectEntityErrorMessage: "계속하려면 기업을 선택하십시오",
    entityAlreadyConnectedToScopeAndStrategy: "이 기업에 ‘범위 및 전략’ 불러오기가 이미 있습니다. 기업별로 하나의 ‘범위 및 전략’ 불러오기만 허용됩니다. 이 선택을 활성화하려면 기존 불러오기를 제거하십시오.",
    selectEntityNoEntitiesFound: "결과를 찾을 수 없습니다",
    selectEntityModalDescription: "데이터를 불러오려는 기업을 선택하십시오",

    /*Manage Account Mapping*/
    manageAccountMapping: "계정 매핑 관리",
    manageAccountMappingErrorMessage: "EY Helix에 연결할 수 없습니다. 페이지를 새로 고침하여 다시 시도하십시오. 문제가 지속되면, 헬프 데스크에 문의하십시오.",
    helixViewerLoader: "Helix 뷰어 로드 중...",

    /*Helix Remove Import Modal*/
    removeImportModalTitle: "불러오기 제거",
    removeImportRemoveButtonLabel: "제거",
    removeImportDescription: "다음 불러오기를 제거하시겠습니까?",
    removeImportActionUndoneDescription1: "다음 불러오기를 제거하시겠습니까?",
    removeImportActionUndoneDescription2: "이 작업은 실행 취소할 수 없습니다",
    removeImportErrorMessage: "이 화면을 연 이후 불러온 데이터가 변경됐습니다. 제거를 계속하려면 페이지를 새로 고침하여 다시 시도하십시오.",

    /*Disconnect analyzer modal*/
    disconnectAnalyzerModalTitle: "Analyzer 연결 해제",
    disconnectAnalyzerDisconnectButtonLabel: "연결 해제",
    disconnectAnalyzerDescription: "선택한 analyzer를 연결 해제하시겠습니까?",
    disconnectAnalyzerImportsExistErrorMessage: "이 화면을 연 이후 이 연결에 불러오기가 추가됐습니다. 연결된 불러오기를 모두 제거한 후에만 연결을 해제할 수 있습니다. 페이지를 새로 고침하여 다시 시도하십시오.",

    /*Content Update */
    quote: '"',
    performContentUpdate: "내용 업데이트 수행",
    contentupdate: "내용 업데이트",
    btnContentUpdate: "업데이트",
    btnContentUpdateSelected: "업데이트",
    updateSuccessMessage: "내용 업데이트가 제출됐습니다",
    msgContentUpdate: "내용을 업데이트하려면 아래 범주를 하나 이상 선택하십시오. 상당한 업무가 이미 완료됐다면 내용 업데이트가 적합한지 engagement executive와 토의하십시오. 내용 업데이트는 실행 취소할 수 없습니다.",
    msgIndependance: "독립성을 업데이트하면 독립성 확인을 다시 완료해야 할 수 있습니다",
    msgProfile: "프로필을 업데이트하면 engagement 내용에 유의한 영향을 미칠 수 있습니다. 사용자는 신규 프로필이 제출될 때까지 engagement에 접근하지 못할 수 있습니다. 이 작업은 실행 취소할 수 없습니다.",
    msgHistoryContentUpdate: "이전에 수행한 내용 업데이트와 그 상태",
    msgWarningTitle: "경고",
    btnProceedContentUpdate: "계속",
    btnCancelContentUpdate: "취소",
    confirmationMessageP1: "선택한 내용 범주에 대해 내용 업데이트를 완료합니다. 계속하려면",
    confirmationMessageP2: "을(를) 선택하고, 지금 내용 업데이트를 완료하지 않으려면",
    confirmationMessageP3: "을(를) 선택하십시오.",
    warningMessage: "업데이트하려면 내용 유형을 하나 이상 선택해야 합니다",
    groupReportingFormsSent: "그룹 보고 <b>양식 전송됨</b>",
    groupReportingFromStatus: "그룹 보고 양식 상태",
    primaryTeamReviewStatus: "Primary Team 검토 상태",
    reportingStatus: "보고 상태",
    taskStatusLabel: "Task 상태",
    primaryTeam: "Primary Team",
    componentTeam: "부문 팀",
    groupTasksReceived: "그룹 감사 <b>task 수신됨</b>",
    group: "그룹",
    regionalTeam: "지역 팀",
    unlinkedLabel: "링크 해제됨",
    linkedLabel: "링크됨",
    unlinkedTasks: "<b>링크 해제된 task</b>",
    unlinkedTask: "<b>링크 해제된 task</b>",
    primaryTeamGroupTaskPlaceholder: "여기에서 진행상황을 모니터링하려면 부문을 생성하고 그룹지침을 전송하십시오",
    componentTeamGroupTaskPlaceholder: "여기에서 진행 요약을 보려면 primary 팀에게서 받은 부문 그룹 task를 수락하십시오",
    confirmUpdateMessage1: "이 양식을 업데이트하면 내용에 유의한 영향을 미칠 수 있습니다. 시작되고 나면, 완료될 때까지 추가 내용 업데이트를 수행할 수 없습니다.",
    confirmUpdateMessage2: "계속하려면 '계속'을 선택하고 지금 내용 업데이트를 완료하지 않으려면 '취소'를 선택하십시오",
    updateSelectedTitle: "업데이트 선택됨",
    statusCodeForbidden: 403,
    pspAccountHeader: "계정",
    pspAccountDateHeader: "내용 날짜",
    pspAccountStatus: "상태",
    pspAccountSelected: "선택됨",

    /*Preapre for Arc*/
    YearEndDate: "회계연도말일:",
    PeriodEndDate: "보고기간말일:",
    ReportDate: "보고서일:",
    ArcDeadlineDate: "Archive 만료일:",
    ClientCode: "고객 코드:",
    PrimaryEngCode: "주 engagement 코드:",
    SecondaryEngCode: "부 engagement 코드:",
    ReportType: "보고서가 어떤 방식으로든 한정입니까? 그리고/또는 강조사항이 있습니까?:",
    ProtectedDocuments: "주의: 보호 문서는 필요하지 않는 한 engagement 파일에 보관하면 안 됩니다",
    noObjectsAvailable: "사용 가능한 object가 없습니다",
    CurrentlyUnavailable: "현재 사용할 수 없습니다",
    showMoreToggle: "더 표시",
    showLessToggle: "덜 표시",

    //#region Document upload status

	docListUploadTemporaryPlaceholder: '<center>사용 가능한 문서 없음<br />―<br />문서를 하나 이상 끌어서 놓거나 클릭할 수 있습니다 <button class="motif-button motif-text-alt-button motif-button-small">임시 파일 추가</button></center>',
    uploadEvidencePlaceholder: "하나 이상의 문서를 끌어서 놓거나 <a>증거 추가</a>를 클릭합니다",
    uploadTemporaryPlaceholder: "하나 이상의 문서를 끌어서 놓거나 <a>임시 파일 추가</a>를 클릭합니다",

    processing: "처리 중",
    uploading: "업로드 중",
    uploadComplete: "처리 중",
    downloading: "다운로드 중",
    downloadComplete: "다운로드 완료",
    loading: "로드",

    //#region Filter

    filter: "필터",
    noFiltersAvailable: "사용 가능한 필터가 없습니다",
    pickADate: "날짜 고르기",
    filterYes: "예",
    filterNo: "아니오",

    //#region Document list filters
    filterGroupDocumentsLabel: "문서",
    filterDocumentContentLabel: "문서 내용",
    filterSharedEvidenceLabel: "공유 증거",
    filterFileExtensionLabel: "파일 확장자",
    filterDocumentConflictLabel: "충돌",
    filterDuplicateFileNameLabel: "중복 파일 이름",
    filterCanvasFormsLabel: "Canvas 양식",

    filterGroupModificationsLabel: "수정",
    filterLastModifyUserLabel: "최근 수정한 사람",
    filterModifyAfterReviwerSignoffLabel: "검토자 sign-off 후 수정",
    filterModifiedAfterLabel: "다음 후 수정",

    filterGroupReviewNotesLabel: "리뷰노트",
    filterReviewNoteStatusLabel: "상태",
    filterReviewNoteAssignedToLabel: "담당자",
    filterReviewNoteAuthoredByLabel: "작성자",
    filterReviewNoteOtherEngagementLabel: "다른 Engagement에서",

    filterGroupSignOffsLabel: "Sign-off",
    filterSignOffMissingLabel: "Sign-off 누락",
    filterSignedOffByUserLabel: "Sign-off한 사람",
    filterNotSignedOffByUserLabel: "Sign-off하지 않은 사람",
    filterSignOffRequirementsLabel: "Sign-off 요건",

    filterGroupOtherLabel: "기타",
    documentLink: "문서 링크",
    filterByCopyLinkDocument: "링크 문서 복사로 필터링됨",
    filterGroupAuditComponentLabel: "지역/부문 팀",
    noGroupAuditComponents: "부문이 생성되지 않았습니다",
    filterFindingsLabel: "발견사항",
    filterGroupInstruction: "그룹 지침",
    noGroupInstruction: "지침이 생성되지 않았습니다",

    documentSearchPlaceholderLabel: "문서 검색",
    analyticSearchPlaceholderLabel: "분석 검색",
    //#endregion

    //#endregion

    pendingResponseLabel: "응답 보류 중",
    receivedLabel: "수신됨",
    dueToPrimaryTeam: "Due to primary team",
    sentToPrimaryTeam: "Primary team에 전송됨",
    documentationPending: "문서화 보류 중",
    documentationComplete: "문서화 완료",
    viewBytimephaseTextLabel: "시기별 보기",
    showDetails: "세부정보 표시",
    referenceDocAddDocHeaderText: "이 engagement에서 증거나 임시 파일을 연결하여 대시보드에서 접근합니다",
    addDocsToTeam: "팀 문서에 문서 추가",
    addDocsToMy: "내 문서에 문서 추가",
    addDocument: "문서 추가",
    externalUserRemove: "제거",

    // Internal user roles abbr
    adminRole: "관리자",
    readOnlyRoleForThirdPartyUser: "읽기 전용",
    legacy: "무제한",
    permissionLabel: "허가",
    displayPermissionErrorText: "지금은 권한을 표시할 수 없습니다. 다시 시도하고 문제가 지속되면, 헬프 데스크에 문의하십시오.",
    onlyShowRelatedTasks: "연결된 task만 표시",

    softwareUpdate: "소프트웨어 업데이트",
    updateNow: "지금 업데이트",
    updateMsg: "EY Canvas 소프트웨어 업데이트가 가능합니다. 업데이트를 다운로드하여 설치하려면, 지금 업데이트를 선택하십시오. 페이지가 새로 고쳐집니다",

    processingError: "오류 처리 중",

    //Create tag modal labels
    createtags: "태그 생성",
    reportDate: "보고서일:",
    managetags: "태그 관리",
    savechanges: "변경사항 저장",
    manageTagGroupCreate: "생성",
    manageTagGroupDiscard: "폐기",
    manageTagGroupCreateTooltip: "태그 그룹",
    deletetag: "태그 삭제",
    deletetaggroup: "태그 그룹 삭제",
    createTagGroup: "태그 그룹 생성",
    manageTagGroupName: "태그 그룹",
    countOftasksAssigned: "배정된 task 수",
    createTagGroupMessage: "시작하려면 태그 그룹과 태그를 생성하십시오. 태그 그룹을 생성하려면 {0}을(를) 클릭하십시오.",
    tagsContnetSearchPlaceholder: "태그 검색",
    deleteTagHoverText: "저장되고 나면 삭제된 태그나 태그 그룹을 복원할 수 없습니다",
    deleteTagGroupHoverText: "이 태그는 engagement에 있는 모든 task에서 제거됩니다",
    tagSaveChangesInfoText: "이 그룹 내 모든 태그는 삭제되고 engagement에 있는 모든 task에서 제거됩니다",
    tagConfirmModalTitleText: "저장되고 나면 변경사항이 적용됩니다",
    tagConfirmModalPrimaryMessage: "이 변경사항을 저장하시겠습니까?",
    tagConfirmModalSecondaryMessage: "이 변경사항을 저장하시겠습니까?",
    tagDeleteModalSecondaryMessage: "저장되고 나면, 삭제한 태그를 복원할 수 없습니다",
    createNewTag: "신규 태그 생성",
    tagWillBeRemovedFromRequests: "이 태그는 engagement에 있는 모든 요청사항에서 제거됩니다",
    eyTags: "EY 태그",
    clientTags: "고객 태그",
    allTags: "모든 태그",
    // Add canvas form
    addCanvasForm: "Canvas 양식 추가",
    addCanvasFormName: "문서 이름",
    addCanvasFormNameBlankMessage: "문서 이름은 필수 필드입니다",
	addCanvasFormNameInvalidCharacterMessage: '이름에는 다음 문자를 포함할 수 없습니다: */:<br>\\?|"',
    addCanvasFormDigital: "Digital",
    addCanvasFormCore: "Core",
    addCanvasFormNonComplex: "비복잡",
    addCanvasFormComplex: "복잡",
    addCanvasFormListed: "상장",
    addCanvasFormGroupAudit: "그룹감사",
    addCanvasFormPCAOBFS: "PCAOB-FS",
    addCanvasFormPCAOBIA: "PCAOB-IA",
    addCanvasFormStandards: "기준",
    addCanvasFormStandardsNotSelectedMessage: "기준은 필수입니다",
    addCanvasFormLanguage: "언어",
    addCanvasFormLanguageNotSelectedMessage: "언어는 필수입니다",
    addCanvasFormNoResultFound: "결과를 찾을 수 없습니다",
    addCanvasFormManageTasks: "Task 관리",
    addCanvasFormAvailableTasks: "Task 이름",
    addCanvasFormAvailableTaskType: "유형",
    addCanvasFormTypeOfForm: "양식 유형",
    addCanvasFormSubServiceLine: "서브서비스라인",
    addCanvasFormTypeOfFormNotSelectedMessage: "양식 유형은 필수입니다",
    addCanvasFormSelectedTasks: "선택된 task",
	addCanvasFormNoTaskDataAvailable: "선택한 task가 없습니다. 양식을 생성하려면 task를 적어도 하나 이상 선택합니다.",
    addCanvasFormCreateForm: "양식 생성",
    addCanvasFormCancel: "취소",
    addCanvasFormSuccessMessage: "{0}이(가) 생성됐습니다. 내용이 전달되는 데 10분까지 소요될 수 있습니다.",
    // Add Canvas form manage Objects
    addCanvasFormManageObjects: "{0} 관리",
    addCanvasFormAvailableObjects: "{0} 이름 //",
    addCanvasFormSelectedObjects: "선택된 {0}",
    addCanvasFormClickHereToOpenManageTab: "여기를 클릭하여 {0} 관리 탭을 여십시오",
    addCanvasFormNoObjectsDataAvailableRequired: "선택한 {0}이(가) 없습니다. 양식을 생성하려면 하나 이상 선택하십시오.",
	addCanvasFormNoObjectsDataAvailableOptional: "선택한 {0}이(가) 없습니다.",
    addCanvasFormObjectNotDefinedMessage: "이 양식에 사용 가능한 object가 없습니다",
    addCanvasFormOptional: "(선택 사항)",
    addCanvasFormObjects: "Object",
    addCanvasFormObject: "Object",
    addCanvasFormSCOT: "SCOT",
    addCanvasFormSCOTs: "SCOT",
    addCanvasFormITProcess: "IT 프로세스",
    addCanvasFormITProcesses: "IT 프로세스",
    addCanvasFormControl: "통제",
    addCanvasFormControls: "통제",
    addCanvasFormITControl: "IT 통제",
    addCanvasFormITControls: "IT 통제",
    addCanvasFormITApplication: "IT Application",
    addCanvasFormITApplications: "IT Application",
    addCanvasFormSignoffRequirements: "필수 sign-off:",
    addCanvasFormPICCheckBox: "PIC",
    addCanvasFormEQRCheckBox: "EQR",
    itProcessRelatedITGCITSP: "IT 프로세스 및 관련 ITGC/ITSP",
    taskTitle: "IT 프로세스 이해 및 문서화: {0}",
    taskDescription: "IT 프로세스에 대한 이해를 문서화합니다. 관련 양식을 IT 프로세스에 대한 이해를 뒷받침하는 증거로 첨부합니다.<br>ITGC가 Task 정보 섹션에 나타나면, walkthrough 절차를 수행하여 ITGC에 대한 이해를 확인하고 그 설계와 구축을 평가합니다. 절차의 증거를 첨부합니다.",
    addCanvasFormAccounts: "계정",
    addCanvasFormAccount: "계정",
    addCanvasFormErrorMessage: "이 양식은 하나의 계정에만 연결할 수 있습니다",
    addCanvasFormValidationMessage: "선택은 필수입니다",
    addCanvasFormEstimates: "추정치",
    addCanvasFormEstimate: "추정치",
    addEstimateCanvasFormErrorMessage: "이 양식은 하나의 추정치에만 연결할 수 있습니다",
    addControlCanvasFormErrorMessage: "이 양식은 하나의 통제에만 연결할 수 있습니다",
    addScotCanvasFormErrorMessage: "이 양식은 하나의 SCOT에만 연결할 수 있습니다",

    //Independence Confirmation
    sortOrderIndependence: "정렬 순서",
    confirmationStatus: "확인 상태",
    confirmationDate: "확인일",
    independenceConfirmationSearch: "팀 멤버 검색",
    editTemplate: "템플릿 편집",
    viewTemplate: "템플릿 보기",
    confirmedBy: "확인한 사람",
    overriddenBy: "무시한 사람",
    grantedBy: "접근을 부여한 사람",
    deniedBy: "접근을 거부한 사람",
    list: "목록",
    paginationShow: "표시",
    options: "옵션",
    removeTeamMemberModalText: "Engagement에서 이 팀 멤버를 제거하시겠습니까?",
    removeTeamMemberModalTitle: "팀 멤버 제거",
    overrideRemovedBy: "무시 제거한 사람",

    // Custom instructions
    addCustomInstruction: "사용자지정 지침 추가",
    editCustomInstruction: "사용자지정 지침 편집",
    customInstructionInstructionalText: "여기에서 사용자지정 지침을 추가하거나 편집하십시오. 이 지침은 각 팀 멤버의 개인 독립성 확인에 나타나 고객별 질문에 응답하는 방법을 안내합니다.",
    customInstructionPermissionTooltip: "이 작업을 하려면 <b>engagement 관리</b> 권한이 있어야 합니다. 권한을 요청하려면 <b>Engagement 관리자</b>와 얘기하십시오.",
    customInstructionMaxLengthExceeded: "텍스트가 최대 허용 길이를 초과했습니다",

    //Independence Confirmation Details
    details: "세부정보",
    question: "질문",
    answer: "답변",
    countTeamMembers: "팀 멤버 수",
    executiveApproval: "Executive 승인",
    yes: "예",
    no: "아니오",
    independenceModalText: "개별 독립성 확인에서 이 답변을 선택한 팀 멤버를 여기에서 볼 수 있습니다",
    notApplicable: "해당 없음",
    readMore: "더 읽기",
    readLess: "덜 읽기",
    teamMembsersTitle: "팀 멤버 세부정보",

    tasksSelected: "task 선택됨",
    taskSelected: "task 선택됨",
    unselectAll: "모두 선택 해제",
    addForm: "양식 추가",
    addFormName: "이름",
    addFormDigital: "Digital",
    addFormCore: "Core",
    addFormNonComplex: "비복잡",
    addFormComplex: "복잡",
    addFormListed: "상장",
    addFormGroupAudit: "그룹감사",
    addFormPCAOBFS: "PCAOB-FS",
    addFormPCAOBIA: "PCAOB-IA",
    addFormStandards: "기준",
    addFormLanguage: "언어",
    addFormManageTasks: "Task 관리",
    addFormManageObjects: "Object 관리",
    addFormAvailableTasks: "사용 가능한 task",
    addFormAvailableObjects: "사용 가능한 object",
    addFormTypeOfForm: "양식 유형",
    addFormSelectedTasks: "선택된 task",
    addFormSelectedObjects: "선택된 object",
    addFormCreateForm: "양식 생성",
    addFormCancel: "취소",
    createtag: "태그 생성",
    tagsLabel: "태그",

    //Group instruction summary
    sInstruction: "범위",
    iInstruction: "개별",

    //CGT and CGT Unlinked related labels
    cgtSend: "보내기",
    cgtDueDate: "만료일",
    cgtFrom: "From",

    notesSelected: "노트 선택됨",
    noteSelected: "노트 선택됨",
    cgtUnlinkedLabel: "링크 해제됨",
    cgtUnlinkedInformationMessage: "이 task는 다른 그룹 engagement에 더 이상 링크되어 있지 않으며, 더 이상 필요하지 않다면 삭제할 수 있습니다",
    sendtoPrimaryTeam: "Primary team에 보내기",
    sendtoPrimaryTeamdisableBtn: "Primary team에 보내려면, 적어도 하나 이상의 작성자와 검토자 sign-off가 있는 증거가 이 task에 포함돼야 합니다",
	cgtSendModalHeader: 'Primary team에 보낼 문서를 하나 이상 선택하십시오. <span class="modal-instruction-text">Canvas 양식은 PDF 형식으로 전송됩니다. Primary team에 전송된 PDF Canvas 양식 기록은 임시 파일에서 사용할 수 있습니다.</span>',
    cgtNotifyCheck: "더 전송할 문서가 없다는 것을 primary team에 알립니다",
    cgtCanvasFormValidation: "이 Canvas 양식에 미해결 유효성 검증이 있습니다. Primary team에 보내기 전에 유효성 검증을 해결해야 하는지 고려합니다.",
    finalVersionLabel: "최종 버전",
    draftVersionLabel: "초안 버전",
    otherEvidence: "기타 증거",
    selectAtLeastOneDocument: "계속하려면 문서를 하나 이상 선택하십시오",
	cgtsendmodelinstructionheader: 'Primary team에 보낼 문서를 하나 이상 선택하십시오. <span class="modal-instruction-text">문서에 <b>초안 버전</b>을 표시하여, 현재 문서 작업 중이며 추가 버전을 보낼 수 있다는 것을 primary team에 알릴 수 있습니다. 문서에 <b>최종 버전</b>을 표시하여 작업을 완료했고 추가 문서 버전을 보내지 않을 것임을 primary team에 알릴 수 있습니다.</span>',
    //Independence confirmation
    undefined: "미확정",
    incomplete: "완료되지 않음",
    nomattersidentified: "식별한 사항 없음",
    matteridentifiedpendingaction: "식별한 사항 - 보류 중인 조치",
    matterresolveddeniedaccess: "해결한 사항 - 거부된 접근",
    matterresolvedgrantedaccess: "해결한 사항 - 부여된 접근",
    notapplicable: "해당 없음",
    restored: "복원됨",
    overriden: "무시됨",
    override: "무시",
    priornomattersidentified: "이전 - 식별한 사항 없음",
    priormatteridentifiedpendingaction: "이전 - 식별한 사항 - 보류 중인 조치",
    priormatterresolvedgrantedaccess: "이전 - 해결한 사항 - 부여된 접근",
    priormatterresolveddeniedaccess: "이전 - 해결한 사항 - 거부된 접근",
    addTagsLabelForTaskList: "태그 추가",
    addTagLabelForTaskDetails: "+ 태그 추가",
    manageTagsColorInputLabel: "색상",
    manageTagsTagNameInputLabel: "태그 이름",
    addTagRequiredMessage: "필수",
    addNewTagLinkText: "신규 태그 추가",
    manageTagsLabel: "태그 관리",
    manageTagGroupHeader: "여기에서 신규 태그와 그룹을 생성합니다. 기존 태그와 그룹을 편집하고 삭제할 수도 있습니다. Task에 태그하면 engagement 조직과 프로젝트 관리를 개선할 수 있습니다.",
    //add tag color dropdown
    addTagRedColorText: "빨간색",
    addTagOrangeColorText: "귤색",
    addTagTealColorText: "청록색",
    addTagBlueColorText: "파란색",
    addTagPurpleColorText: "보라색",
    addTagGreenColorText: "녹색",
    deleteAssignmentConfirmationMessage: "이 배정을 삭제하시겠습니까?",

    // Return label for Returned document
    recieved: "수신됨",

    selectServiceOffering: "서비스 제공 선택",
    selectTasks: "Task 선택",
    reviewSuggestedTasks: "권장 task 검토",
    reviewAvailableTasks: "사용 가능한 task 검토",
    setDueDate: "만료일 설정",
    schedulerCreateRequestStep4TabText: "운영 및 커뮤니케이션 프로토콜",
    createWorkRequestHeadingpart1: "시작하려면 서비스 요청 이름을 짓고 서비스 제공을 선택하십시오",
    createWorkRequestHeadingpart2: "아래 열거된 서비스 제공은 engagement 프로필 및 region에서 사용 가능한 서비스에 기반합니다. 비용은 배정된 리소스와 복잡성에 따라 달라집니다.",
    createWorkRequestHeadingpart3: "Engagement를 roll-forward한 경우, 전기에 사용된 서비스 제공은 전기 배지 레이블이 붙습니다",
    createWorkRequestHeadingpart4: "전기",
    createWorkRequestHeadingpart5: "배지 레이블이 붙습니다",
    createWorkRequestStep2Headingpart1: "서비스 제공을 위해 권장된 task를 검토합니다",
    createWorkRequestStep2Headingpart2: "service offering.",
    createWorkRequestStep2Headingpart3: "<u>Wave 2 중앙집중화 파일럿에 참여하는 팀에 대해</u>, 다음 기준에 따라 중앙집중식 팀 멤버가 수행할 수 있는 관련 task를 선택하십시오: (1) 객관적인 감사절차 (즉, 판단이 거의 또는 전혀 필요하지 않은 절차), (2) 위험이 낮은 추청치, 또는 고유위험이 낮은 관련 경영진주장에 대해서만 수행하는 주관적인 감사절차 (즉, 판단이 필요한 절차). 다른 중앙집중식 서비스 요청에 이미 포함된 task는 다음 레이블이 붙습니다.",
    createWorkRequestStep2Headingpart4: "전에 이 서비스를 사용했다면, 전기 요청에 포함된 task는 다음 레이블이 붙습니다",
    createWorkRequestStep2Headingpart5: "전기",
    requestName: "요청 이름",
    submittedBy: "제출한 사람",

    // Next wave labels
    totalTasks: "Task",
    noServiceRequest: "서비스 요청사항이 아직 생성되지 않았습니다. 시작하려면 서비스 요청사항을 생성하고 제출하십시오.",
    eyContact: "표시",
    requestStatusText: "요청 상태",
    requestsByStatusText: "상태별 요청사항",
    serviceRequest: "서비스 요청사항",
    serviceGateway: "서비스 게이트웨이",
    centralizedServices: "서비스 요청",
    serviceRequestDueDate: "만료",
    NA: "N/A",
    more: "자세히",
    eycontacts: "EY 연락처",
    addEYContact: "EY 연락처 추가",
    editEYContacts: "EY 연락처 편집",
    addEYContactInstructions: "이 요청에 EY 연락처를 추가하거나 제거하십시오. 업데이트된 EY 연락처는 리소스 매니저와 배정된 인원에 전송됩니다.",
    editEYContactDisabledInstructions: "이 작업을 하려면 <b>서비스 요청</b> 권한이 있어야 합니다. 접근권한을 얻으려면 engagement 관리자와 얘기하십시오.",
    emptyEYContactsPlaceholder: "계속하려면 EY 연락처를 하나 이상 추가하십시오",
    estimatedHours: "완료 시간 (hours)",
    resourceManagers: "리소스 관리자",
    nextWaveServices: "중앙집중식 서비스",
    centralizedservices: "중앙집중식 서비스",
    onlyShowAccepetedRequests: "수락된 요청사항만 표시",
    showSelectedOnly: "선택한 항목만 표시",
    emptyEngCodeMessage: "Engagement에 유효한 코드가 없습니다",
    primary: "Primary",
    estimatedCosts: "추정 비용",
    assignedResources: "배정된 리소스",
    generalAuditTasks: "일반 감사 task",
    generalInfo: "일반 정보",
    requestID: "요청 ID",
    createdDate: "생성됨",
    startDate: "시작",
    serviceRequestDue: "만료",
    comingDueIn: "다음 후 만료 도래",
    comingDueTodayLabel: "오늘 만료 도래",
    daysLabel: "일",
    dayLabel: "일",
    createByLabel: "생성한 사람",
    notProvidedLabel: "제공되지 않음",
    editLabel: "편집",
    serviceRequestNoHistoryLabel: "이 요청 기록이 없습니다",
    serviceRequestHistoryLabel: "기록 로그",
    serviceRequestTasks: "서비스 요청 Task",
    suggestedRequestTasks: "권장 요청 Task",
    estimatedCost: "추정 비용",
    addinstructionsAndRelatedFiles: "이 요청을 위한 기타 운영 및 커뮤니케이션 프로토콜 추가",
    instructionText: "이 요청 관련 증거는 archive되어 roll-forward된 차기 engagement에 이 요청과 함께 포함됩니다. 임시 파일은 archive되지 않고, engagement를 roll-forward하는 경우 이 요청에 포함되지 않습니다.",
    instructionPlaceHolder: "기타 운영 및 커뮤니케이션 프로토콜",
    warningText: "증거는 이 요청과 함께 archive되지만 임시 파일은 그렇지 않습니다",
    availableDocuments: "사용 가능한 문서",
    noDocumentsAvailable: "사용 가능한 문서가 없습니다",
    selectAll: "모두 선택",
    deselectAll: "모두 선택 해제",
    documentsSelected: "문서 선택됨",
    selectedDocuments: "선택된 문서",
    noDocumentSelected: "문서가 아직 선택되지 않았습니다. 시작하려면 문서를 선택하십시오 (선택 사항).",
    TaskName: "Task 이름",
    AssignmentsLabel: "배정",
    noTaskAssociatedToServiceRequest: "이 요청에 연결된 task가 없습니다",
    requestServices: "서비스 요청",

    serviceNotEditable1: "이(this) 요청(request)에(in) 포함된(included) task를(the task) 수정하려면(To modify), task 탭(Tasks tab)에서(on the) 편집을(edit) 선택하십시오(select).",
    serviceNotEditable2: 'Edit ',
    serviceNotEditable3: 'on the ',
    serviceNotEditable4: 'Tasks ',
    serviceNotEditable5: "이 서비스 요청을 추가로 변경하거나 취소하려면",
    serviceNotEditable6: "리소스 관리자에게 문의하십시오",
    serviceNotEditable7: "(배정된 경우).",

    serviceReqMarkComplete: "중앙집중식 서비스 요청에 완료 표시하면, 추가 작업이 필요하지 않으며 귀하가 검토를 마쳤다는 사실이 서비스 제공자에게 전달됩니다. 서비스 요청에 완료 표시한 후에는 실행 취소할 수 없습니다.",
    serviceReqMarkCompleted: "완료됨",
    editServiceRequestTasks1: "이 서비스 요청을 위해 선택한 task를 검토합니다.",
    editServiceRequestTasks2: "서비스 제공(the service offering)을 위해(for) 권장된(that are suggested) task는(tasks) 모두(all) 여기에(here) 표시됩니다(are presented)",
    editServiceRequestTasks3: "Task를 추가하려면, 아래 목록에서 선택하십시오. Task를 제거하려면, 선택을 해제하십시오.",

    submitServiceRequestConfirmation1: "이 서비스 요청을 제출하시겠습니까?",
    submitServiceRequestConfirmation2: "Engagement를 위해 이미 제출된 서비스 제공을 선택했습니다",
    alreadyScheduledHeader: "서비스 제공이 이미 예정됨",

    createServiceRequestPermission1: "계속하려면 서비스 요청 생성 권한이 있어야 합니다",
    createServiceRequestPermission: "이 작업을 하려면 <b>서비스 요청사항 관리</b> 권한이 있어야 합니다. 접근권한을 얻으려면 Engagement 관리자와 얘기하십시오.",
    schedulerRequestSubmissionError: "이 요청이 스케줄러에게 제출되지 않는 오류가 발생했습니다. </b>재제출</b>을 선택하여 다시 시도하십시오. 오류가 지속되면 헬프 데스크에 문의하십시오.",
    resubmit: "재제출",
    noServiceManager: "이 요청에 리소스 관리자가 아직 배정되지 않았습니다",
    noAssignedResource: "이 요청에 리소스가 아직 배정되지 않았습니다",
    noMileStoneSetForService: "이 요청에 milestone 시작일과 만료일이 아직 설정되지 않았습니다",
    isEngagementNominnatedForCentralizeService: "귀하의 Region에서 GDS 중앙집중화 파일럿에 참여하기 위해 귀하의 engagement를 선택하거나 확인했습니까?",
    needApprovalForSericeRequestCreation: "이 서비스 요청을 계속하는 데 적합한 승인을 받으려면 귀하의 Regional Assurance Managing Partner에게 문의하십시오",

    //TaskList Filters
    filterMissingRelatedTaskLabel: "Task에 연결되지 않은 PIC/EQR 문서",
    filterRelatedToRisksLabel: "위험에 연결됨",
    filterGroupTasksLabel: "Task",
    filterGroupAssignmentsLabel: "배정",
    filterGroupDocumentsignoffsLabel: "문서 sign-off",
    filterGroupProjectManagementLabel: "프로젝트 관리",
    filterAssignmentTypeLabel: "배정 유형",
    filterTaskStatusLabel: "Task 상태",
    filterTaskTypeLabel: "Task 유형",
    filterAssignedToLabel: "담당자",
    filterAssignmentStatusLabel: "배정 상태",
    filterTaskReviewNoteStatusLabel: "노트 상태",
    filterTaskCommentStatusLabel: "노트 상태",
    filterTaskReviewNoteAssignedToLabel: "담당자",
    filterTaskReviewNoteAuthoredByLabel: "생성한 사람",
    filterPICDocumentsAssociated: "PIC 문서 연결됨",
    filterEQRDocumentsAssociated: "EQR 문서 연결됨",
    missingSignOffs: "Sign-off 누락",
    signedOffBy: "Sign-off한 사람",
    notSignedOffBy: "Sign-off하지 않은 사람",
    filterTimePhaseLabel: "시기",
    filterMilestoneLabel: "Milestone",
    filterAuditPhaseLabel: "감사 단계",
    filterEngagementPhaseLabel: "Engagement 단계",
    filterDocumentConflictsLabel: "문서 충돌",
    filterEntitiesLabel: "기업",
    missingEntityDocuments: "기업 문서 누락",
    filterDownloadedForOfflineLabel: "오프라인으로 다운로드됨",
    filterNextwaveServicesLabel: "중앙집중식 서비스",
    filterServiceGateway: "서비스 게이트웨이",
    filterScheduledServicesLabel: "연결된 서비스",
    filterSuggestedServicesLabel: "권장 서비스",
    NoDocumentSignedOffLabel: "문서에 sign-off하지 않은 사람",
    SomeDocumentSignedOffLabel: "일부 문서에 sign-off한 사람",
    AllDocumentSignedOffLabel: "모든 문서에 sign-off한 사람",
    usersLabel: "팀 멤버",
    serviceRequests: "중앙집중식 서비스",
    backToMainPage: "메인 페이지로 돌아가기",
    suggestedNextwaveRequests: "권장 중앙집중식 요청사항",
    /* Component Send Status */
    deliveredDate: "전달됨: {0}",
    sentDate: "전송됨: {0}",
    sentFailure: "전달에 실패했습니다. 다시 시도하고 문제가 지속되면 헬프 데스크에 문의하십시오.",
    chooseTaskInstructionLabel: "이 요청에 포함할 task 선택",
    createSRstep2InstructionalTextPart1: "다른 요청에 이미 포함된 task는 다음 레이블이 붙습니다",
    createSRstep2InstructionalTextPart2: ". If you used this service offering before, tasks that were included in your prior period request are labeled as",
    createSRstep2InstructionalTextPart3: "권장 task만 표시하려면 아래 토글을 이용하십시오",
    availableTasksLabel: "사용 가능한 task",
    guidance: "Atlas guidance",
    helixAnalyzers: "Helix analyzers",
    eyHelix: "EY Helix",
    smartAutomationLinks: "스마트 자동화",
    createAutomation: "자동화 생성",
    noProjectTitle: "Helix 프로젝트 연결",
    multipleProjectsTitle: "연결된 Helix 프로젝트 선택",
    noProjectMessage: "이 Helix analyzer를 시작하려면 이 engagement에 Helix 프로젝트를 링크하십시오",
    multipleProjectsMessage: "이 engagement는 여러 Helix 프로젝트에 링크되어 있습니다. 계속하려면 아래 목록에서 Helix 프로젝트를 선택하십시오.",

    automationGuidanceHeader: "권장 자동화",
    helixAnalyzersHeader: "권장 analyzer",
    linkToHelixLabel: "Helix에 링크",
    noSelectedTasksText: "선택한 task가 없습니다. 시작하려면 task를 선택하십시오.",
    selectedTasksLabel: "선택된 task",
    serviceOffering: "서비스 제공",
    submitRequest: "요청 제출",
    scheduleYourRequest: "요청 예정하기",
    serviceRequestStep3HeaderText: "배정된 리소스가 이 task를 시작했으면 하는 날짜를 선택합니다. 그 다음 이 task를 완료해야 하는 날짜를 선택합니다.",
    serviceRequestMilestoneDueDateHeaderText1: "각 milestone에 대해 시작일과 만료일을 선택하십시오",
    startanddue: ' start and due date ',
    eachmilestone: "for each milestone.",
    serviceRequestMilestoneDueDateHeaderText2: "귀하의 팀은 전달된 모든 작업에 최종 책임을 집니다. 따라서, 팀이 전달된 작업을 검토할 시간이 충분하도록 만료일을 선택해야 합니다.",
    serviceRequestMilestoneDueDateHeaderText3: "예상 완료 시간에는 서비스 제공자에게서 발생할 것으로 예상되는 시간만 포함해야 합니다",
    schedulerBudgetMainQuestion: "Engagement 팀은:",
    schedulerBudgetFirstQuestion: "재무, 보수 책정, 계획 프로세스에 이 요청을 위한 업무를 모두 포함했습니까?",
    schedulerBudgetSecondQuestion: "국내 Experience Manager에게 이 요청을 알렸습니까?",
    schedulerBudgetThirdQuestion: "국내 팀 멤버를 위해 시간을 적절히 조정했습니까?",
    timetocompleteinfo1: "예상 완료시간에는",
    timetocompleteinfo2: "서비스 제공업체에서 발생할 것으로 예상되는 시간만 포함해야 합니다",
    serviceRequestStartDate: "시작",
    saveDraft: "초안 저장",
    step3ValidationError: "만료일은 시작일보다 늦어야 합니다",
    scheduledLabel: "예정",
    suggestedLabel: "권장",
    searchTasksLabel: "Task 검색",
    submit: "제출",
    selectTaskRequiredErrorMessage: "계속하려면 task를 하나 이상 선택해야 합니다",
    moveToCompleted: "완료로 이동",
    requestResubmitMessagePart1: "이 요청을 다시 제출하면 상태가",
    requestResubmitMessagePart2: "보류 중으로 재설정됩니다.",
    requestResubmitMessagePart3: "모든 변경사항은 스케줄러에서 검토합니다",
    showSuggestedTaskToggle: "권장 task만 표시",

    // Assignments
    addAssignmentName: "배정 이름 추가",
    editAssignmentName: "배정 이름 편집",
    deleteAssignmentName: "배정 이름 삭제",
    deleteAssignmentNameInstructionalTextHeader: "이 배정 이름을 삭제하시겠습니까?",
    deleteAssignmentNameInstructionalText: "삭제 후에는 engagement 내 모든 팀 멤버와 역할에서 배정이 제거됩니다",
    assignmentType: "배정 유형",
    assignmentTypeInstructionalText: "배정 유형을 선택하고 아래에 이름을 입력하십시오. 완료되면 <b>추가</b>를 클릭하십시오.",
    assignmentEditInstructionalText: "아래에서 배정 유형과 이름을 편집하십시오. 마치려면 <b>변경사항 저장<b/>을 클릭하십시오.",
    noSuggestedTaskLabel: "이 범주에 권장 task가 없습니다",
    manageAssignmentsLabel: "배정 관리",
    myAssignmentsLabel: "내 배정",
    myAssignedTasks: "내 담당 task",
    currentlyAssignedTasks: "현재 배정됨",
    assignmentModalInstructionalText1: "팀 멤버 또는 역할에 배정된 task를 재배정하거나 제거하려면, 아래에서 이름을 선택하십시오. 특정 팀 멤버 또는 역할에 대한 배정을 모두 삭제하려면, <b>삭제<b/> 아이콘도 이용할 수 있습니다. 배정 이름을 편집하거나 삭제하려면 <b>기타</b> 메뉴를 선택하십시오.",
    unassignedTasks: "미배정 task",
    assignedTasks: "배정 task",
    type: "유형",
    priorperiodservicerequests: "전기 서비스 요청",
    unmarkcomplete: "완료 표시 해제",
    taskAttributes: "Task 정보",
    engagementTeam: "Engagement 팀",
    assignTo: "배정 대상",
    reAssignTo: "재배정 대상",
    assign: "배정",
    reAssign: "재배정",
    reAssignWarningLabel: "재배정할 task를 하나 이상 선택하십시오",
    assignWarningLabel: "배정할 task를 하나 이상 선택하십시오",
    searchByTaskName: "Task 이름으로 검색",
    searchByTimePhaseName: "시기 이름으로 검색",
    assignment: "배정",
    noMembersWithThisAssignment: "이 배정에 팀 멤버 또는 역할이 없습니다",
    deleteTaskAssingmentByMemberAndAssignmentIntructionalText: "Engagment 내 모든 task에서 배정이 제거됩니다",
    noTaskAttributes: "이 task 정보가 없습니다. 시작하려면 생성 또는 연결을 선택하십시오.",
    assignmentWithoutAssignedUser: "이 배정 이름은 현재 사용하지 않습니다",

    // v2 profile navigation Zeus to Hercules to Kronos message
    v2ProfileDocumentIdAvailableMessage: "프로필 정보 수집 중, 기다려 주십시오.",
    v2ProfileDocumentIdDeletedMessage: "프로필 정보를 찾을 수 없습니다. 페이지를 새로 고침하여 다시 시도하십시오. 오류가 지속되면 헬프 데스크에 문의하십시오.",
    accountAndRelatedAssertions: "계정 및 관련 경영진주장",
    risks: "위험",
    scotName: "SCOT 이름",
    strategy: "전략",
    transactionType: "거래 유형",
    notSelectedText: "선택되지 않음",
    relatedBy: "연결한 사람",
    collaboration: "공동작업",
    controlsLabel: "통제",
    scotAndRelatedControls: "SCOT 및 관련 통제",
    scotAndRelatedRisks: "SCOT 및 관련 중요왜곡표시위험",
    frequencyLabel: "빈도",
    operatingEffectively: "효과적으로 운영 중",
    designedEffectively: "효과적으로 설계됨",
    timeToCompleteHours: "완료 시간 (hours)",
    completeRequiredFieldValidationError: "계속하려면 필수 필드를 모두 완료하십시오",
    itgcsAndItsps: "ITGC 및 ITSP",
    itprocessItgcsAndItsps: "IT 프로세스 및 ITGC/ITSP",
    approachLabel: "접근법",
    typeLabel: "유형",
    itProcessName: "IT 프로세스 이름",
    processEvaluation: "프로세스 평가",
    unrelatedControls: "연결되지 않은 통제",
    disableNextwavePlaceholder: "해당 국가에서 현재 사용 가능한 중앙집중식 서비스가 없습니다. 페이지를 새로 고침하여 다시 시도하십시오. 오류가 지속되면 헬프 데스크에 문의하십시오.",
    disableNextwavePlaceholderDataCenter: "로컬 데이터 센터에 현재 사용 가능한 중앙집중식 서비스가 없습니다. 페이지를 새로 고침하여 다시 시도하십시오. 오류가 지속되면 헬프 데스크에 문의하십시오.",
    dataPrivacyInviteMessage: "초대하기 전에, 데이터 보호 규칙에 따라 적용 가능한 조서 접근 제한을 적절히 고려했습니까?",
    //Session Timeout
    sessionTimerMsg: "활동이 없어, 현재 작업 세션이 곧 만료됩니다. 보안을 위해 30분 동안 활동이 없으면 EY Canvas 세션이 자동으로 종료됩니다. 현재 세션은 {0}분 후에 만료됩니다. 로그인 상태를 유지하려면 계속을 클릭하십시오.",
    logout: "로그아웃",
    sessionPopupTitle: "보호를 위한 자동 로그아웃",
    allSuggestedTasks: "Task",
    viewByAccount: "계정별 보기",
    viewBySCOT: "SCOT별 보기",
    noServiceOfferingsAvailable: "지금은 engagement에서 사용 가능한 서비스 제공이 없습니다. 페이지를 새로 고침하여 다시 시도하십시오. 오류가 지속되면 헬프 데스크에 문의하십시오.",

    //Collaboration
    myRequests: "내 요청사항",
    allRequests: "모든 요청사항",
    calendar: "일정",
    calendarTodayButton: "오늘",
    requestsListButton: "요청 목록",
    eventsButton: "사건",
    analyticsButton: "분석",
    showAssignedToMe: "내 요청사항 표시",
    selectRequestsTitle: "세부 정보를 보려면 요청사항을 선택하십시오",
    selectRequestsSub1: "한꺼번에 제어하려면, 체크박스를 사용하거나",
    selectRequestsSub2: "shift 키나 control 키를 누른 상태에서 여러 요청을 선택하십시오",
    noTagMessage: "생성된 태그가 없습니다. 시작하려면 <b>여기<b>를 클릭하십시오.",
    tagAs: "태그:",
    addTag: "태그 추가",
    searchTag: "태그 검색",
    documentsAttached: "첨부 문서",
    editDraftRequest: "요청 초안 편집",
    deleteRequest: "요청 삭제",
    deleteLabel: "삭제",
    deleteLabelDisabled: "일괄 삭제할 권한이 없습니다. Engagement 관리자에게 문의하여 일괄 삭제 권한을 요청하십시오.",
    DeleteRequestConfirmMsg1: "이 요청을 삭제하시겠습니까?",
    DeleteRequestConfirmMsg2: "이 작업은 실행 취소할 수 없습니다.",
    deleteRequestSuccess: "요청이 삭제됐습니다",
    DeleteRequestsConfirmMsg1: "이 요청사항 {0}개를 삭제하시겠습니까?",
    dueDateCollabLabel: "만료일",
    requestLabel: "요청",
    statusLabel: "상태",
    inValidRequestTitleLabel: "다음 요청사항은 현재 상태에서 삭제할 수 없습니다",
    bulkSendButton: "보내기",
    bulkDeleteButton: "삭제",
    commentSyncFailedRetry: "Comment를 EY Canvas Client Portal에 전달할 수 없습니다",
    commentSyncFailedRetrySendAgain: "다시 보내기",
    commentDeleted: "이 메시지가 삭제됐습니다",
    CommmentDeletionSyncFailed: "EY Canvas Client Portal에서 comment를 삭제할 수 없습니다",
    clickLabel: 'Click',
    toRetry: "을(를) 클릭하여 다시 시도하십시오.",
    replySyncFailedRetry: "회신을 EY Canvas Client Portal에 전달할 수 없습니다",
    quickFilterPriority: "우선순위",
    quickFilterErrorCounterTooltip: "하나 이상의 요청사항에 오류가 발생하여 주의가 필요합니다",

    eyContactNoResultsFound: "사용자를 찾을 수 없습니다",
    eyContactClear: "처리",
    eyContactSearch: "검색",
    eyContactCollaboration: "EY 연락처",
    eyParticipantsCollaboration: "EY 참여자",
    externalParticipantsCollaboration: "외부 참여자",
    syncInProgressEYContact: "동기화 진행 중",
    syncErrorEyContact: "동기화 오류. 다시 시도하십시오.",
    noAssignedContact: "배정된 연락처 없음",
    noAssignedParticipant: "추가된 참여자 없음",

    commentsTooltipLabel: "Comment",
    recordingVirusScanInProgress1: "바이러스 스캔 진행 중. 완료되고 나면 음성 노트를 사용할 수 있습니다.",
    screenrecordVirusScanInProgress1: "바이러스 스캔 진행 중. 완료되고 나면 화면 기록을 사용할 수 있습니다.",
    recordingVirusScanInProgress2: "페이지를 새로 고침하여 다시 시도하십시오",
    confidentialDocumentsModalTitle: "기밀 문서",
    confidentialDocumentsModalMsg1: "다음 기밀 문서가 요청에 추가됐습니다",
    confidentialDocumentsModalMsg2: "계속을 클릭하면 EY Canvas Client Portal에 문서를 전송하는 데 적합한 기밀 수준이 귀하에게 있으며 요청 배정을 검토했음을 확인하게 됩니다",
    confidentialDocumentsModalMsg3: "하나 이상의 이 문서를 EY Canvas Client Portal로 전송하는 데 적합한 기밀 수준이 귀하에게 없습니다. 계속하려면 접근 권한이 없는 기밀 문서를 제거하십시오.",
    confidentialityLevel: "기밀 수준",
    voiceNoteUploadError: "문서 세부정보를 가져오면서 오류가 발생했습니다. 페이지를 새로 고침하여 다시 시도하십시오. 문제가 지속되면, 헬프 데스크에 문의하십시오.",
    requestEventTitle: "사건",
    noTaskDescription: "Task 설명 없음",

    newRequestLabel: "신규 요청",
    newEventLabel: "신규 사건",

    //Analytics Tab
    analyticsCreateDateLabel: "생성일:",
    createdByLabel: "생성자:",
    expirationDateLabel: "만료일:",
    sharedWithLabel1: "공유 대상",
    sharedWithLabel2: "요청사항",
    sharedWithLabel3: "요청",
    analyticsTabTitle: "분석",
    analyticsTabSubtitle: "연계된 EY Helix 프로젝트에서 고객과 분석을 공유하십시오. 시작하기 위해 고객 질문을 생성할  북마크 창 위치",
    analyticsTabSubtitle2: "EY Helix",
    analyticsTabSubtitle3: '.',
    noActiveAnalyticsLabel: "선택한 분석 없음",
    noActiveAnalyticsSubtitleLabel1: "분석이 생성되지 않았습니다. Click",
    noActiveAnalyticsSubtitleLabel2: "here",
    noActiveAnalyticsSubtitleLabel3: " to get started.",
    noActiveAnalyticsSubtitleLabel4: "EY Helix에서 프로젝트를 링크하고 북마크를 저장한 후, EY Canvas Client Portal에 공유할 수 있는 분석을 미리 보려면 이 페이지로 돌아오십시오",
    selectAnalyticsLabel: "분석 선택",
    analyticsNoPrimaryHelixProjectsMessage: "이 engagement는 주 EY Helix 프로젝트에 링크되어 있지 않습니다",
    selectAnalyticsModal: {
        closeTitleTip: "닫기",
        modalTitle: "분석 선택",
        modalHeader: "외부 팀 멤버와 공유할 분석을 선택하십시오",
        selectAnalyticPlaceholder: "분석 선택",
        selectAnalyticError: "분석은 필수입니다",
        analyticNamePlaceholder: "분석 이름 입력 (필수)",
        analyticNameError: "분석 이름은 필수입니다",
        cancel: "취소",
        viewPreview: "분석 보기",
        noPreviewAvailable: "사용 가능한 미리보기 없음",
        noPreviewDescription: "미리보기를 활성화할 analyzer를 선택하십시오",
        clickPreviewAnalytic: "선택한 분석을 미리 보려면 클릭하십시오",
        documentObservation: {
            label: "선택한 분석에 대한 관찰사항이나 질문을 문서화하십시오",
            placeHolderLabel: "관찰사항 또는 질문 입력 (선택사항)"
        }
    },
    viewAnalyticsModal: {
        closeTitleTip: "닫기",
        observationFieldPlaceholder: "선택된 분석에 대한 관찰사항 또는 질문",
        noObservationField: "이 분석에 대한 관찰사항 또는 질문이 존재하지 않습니다",
        appliedFiltersLabel: "적용된 필터",
        appliedFilters: [{
                id: '1',
                label: "분석 통화"
            },
            {
                id: '2',
                label: "통화 코드"
            },
            {
                id: '3',
                label: "반올림 표시"
            },
            {
                id: '4',
                label: "사업부 그룹"
            },
            {
                id: '5',
                label: "사업부"
            },
            {
                id: '6',
                label: "Primary 계정 유형"
            },
            {
                id: '7',
                label: "Primary 계정 하위 유형"
            },
            {
                id: '8',
                label: "Primary 계정 분류"
            },
            {
                id: '9',
                label: "Primary 계정 하위 분류"
            },
            {
                id: '10',
                label: "Primary 계정 이름"
            },
            {
                id: '11',
                label: "Primary EY 계정 지정"
            },
            {
                id: '12',
                label: "Primary EY 계정"
            },
            {
                id: '13',
                label: "사업부"
            },
            {
                id: '14',
                label: "분석일"
            },
            {
                id: '15',
                label: "비교일"
            },
            {
                id: '16',
                label: "부문 01 그룹"
            },
            {
                id: '17',
                label: "부문 02 그룹"
            },
            {
                id: '18',
                label: "부문 03 그룹"
            },
            {
                id: '19',
                label: "부문 04 그룹"
            },
            {
                id: '20',
                label: "부문 05 그룹"
            }
        ],
        save: "저장",
        cancel: "취소",
        disabledEdit: "요청이 이미 EY Canvas Client Portal로 전송되었기 때문에 관찰을 편집할 수 없습니다. 이 작업을 활성화하려면 요청을 철회하십시오.",
        errors: {
            unautorizedUser: "귀하는 연결된 EY Helix 프로젝트에 권한이 있는 팀 멤버가 아닙니다. 접근권한을 얻으려면 EY Helix 프로젝트 관리자에게 문의하고 다시 시도하십시오.",
            bookmarkNotFound: "선택한 분석이 삭제됐습니다. EY Helix로 가서 삭제된 분석을 관리하거나 신규 분석을 생성하십시오.",
            unautorizedAccessToBookmark: "귀하는 요청된 EY Helix 북마크에 접근권한이 없습니다. 접근권한을 얻으려면 EY Helix 프로젝트 관리자에게 문의하고 다시 시도하십시오.",
            authenticationError: "인증 오류. 페이지를 새로 고침하여 다시 시도하십시오. 문제가 지속되면, 헬프 데스크에 문의하십시오.",
            genericError: "페이지를 새로 고침하여 다시 시도하십시오. 오류가 지속되면, 헬프 데스크에 문의하십시오.",
			defaultError: "{0} 페이지를 새로 고침하여 다시 시도하십시오. 오류가 지속되면, 헬프 데스크에 문의하십시오."
        }
    },
    deleteAnalyticModal: {
        modalTitle: "분석 삭제",
        modalHeader: "이 분석을 삭제하시겠습니까? EY Canvas에서 분석을 더 이상 사용할 수 없습니다."
    },
    // activity feed
    search: "검색",
    searchTeams: "팀 검색",
    clear: "처리",
    groupActivityLabel: "그룹 활동",
    documents: "문서",
    documentLabel: "문서",
    linkRequests: "링크 요청",
    received: "수신됨",
    returned: "반송됨",
    rejected: "거절됨",
    accepted: "수락됨",
    sent: "전송됨",
    unlinked: "링크 해제됨",
    finalized: "마무리됨",
    groupActivityFeed: "그룹 활동 피드",
    component: "부문",
    noExternalApprovalsMessage: "외부 승인이 없습니다",
    noFileSelectedMessage: "세부정보를 보려면 문서를 선택하십시오",
    noInstructionSelectedMessage: "세부정보를 보려면 항목을 선택하십시오",
    noLinkRequestSelectedMessage: "세부정보를 보려면 항목을 선택하십시오",
    noItemSelectedMessage: "세부정보를 보려면 항목을 선택하십시오",
    viewGroupActivity: "그룹 활동 보기",
    pointOfContact: "연락처",
    currentStatus: "현재 상태",
    resolved: "해결됨",
    viewVersion: "버전 보기",

    // activity feed right pane headings
    scope: "범위",
    groupRole: "그룹 역할",
    linkRequestStatus: "링크 요청 상태",
    instructionStatus: "지침 상태",
    linkStatus: "링크 상태",
    today: "오늘",
    yesterday: "어제",
    thisWeek: "이번 주",
    lastWeek: "다음 주",
    twoWeeksAgo: "2주 전",
    threeWeeksAgo: "3주 전",
    lastMonth: "지난달",
    older: "이전",
    actionsDateNote: "날짜와 시간은 모두 GMT 시간으로 보고됩니다",
    noActionsMessage: "표시할 데이터가 없습니다",
    noManageRequestPermissionMessagePart1: "이 작업을 하려면 <b>서비스 요청 관리</b> 권한이 있어야 합니다",
    guidedWorkflow: "EY Canvas FIT enablement",
    navExecution: "실행",
    navCanvasEconomics: "EY Canvas Economics",
    navOversight: "EY Canvas Oversight",
    navConclusion: "결론",
    navTeamMemberIndependence: "팀 멤버 독립성",
    navGroupAudit: "그룹 관리",
    navGroupActivityFeed: "그룹 활동 피드",
    navPrimaryStatus: "Primary 상태",
    navComponentStatus: "부문 상태",
    navGroupStatus: "그룹 상태",
    navEngagementManagement: "Engagement 관리",
    navProfile: "프로필",
    navGroupStructureSummary: "그룹 구조",
    OpenGuidedWorkflowDocument: "EY Canvas FIT enablement를 통해 이 문서를 여십시오",
    navNotApplicable: "해당 없음",
    canvasForms: "Canvas 양식",
    eYCanvasEconomics: "EY Canvas Economics",
    overDueAssignments: "지연 배정",
    comingDueAssignments: "만료 임박 배정",
    overDueReviewNotes: "지연 리뷰노트",
    comingDueReviewNotes: "만료 임박 리뷰노트",

    //Group Audit/Status  for DashboardV2

    Reportingformsbystatus: "상태별 보고 양식",
    ReportingStatusSubTitle: "아래에서 부문 팀에 배정된 그룹 task와 상태별로 수신한 그룹 문서 요약을 봅니다. <br/>세부 진행상황을 팀별 또는 그룹 task별로 검토하도록 선택할 수 있습니다.",

    Total: "합계",
    Returned: "반송됨",
    Overdue: "지연",
    PendingResponse: "응답 보류 중",
    Received: "수신됨",
    ReadyForReview: "리뷰 준비됨",
    messageNoDocument: "수신된 문서 없음",
    byTeam: "팀별",
    byGroupTask: "그룹 task별",
    groupStructureLabel: "그룹 구조",
    instructionPending: "지침 수락 보류 중",
    linkRequestPending: "링크 요청 보류 중",
    notusingeycanvas: "EY Canvas 미사용",
    pendingLabel: "보류 중",
    teams: "팀",
    NoDocumentReceiced: "수신된 문서 없음",
    selectTeamToSeeData: "사용 가능한 데이터가 없습니다. 여기에서 데이터를 보려면 팀을 선택하십시오.",
    noDataAvailable: "사용 가능한 데이터가 없습니다",
    prepared: "작성됨",
    tasksAssigned: "Task 배정됨",
    taskAssigned: "Task 배정됨",
    instructionNotSent: "지침 미전송",
    assignedTeamNotProvidedDocForTasks: "\{0}\ 팀에서 이 task에 대한 문서를 보내지 않았습니다 | \{1}\ 문서 예정",
    documentRecievedOutOfAssignedTasks: "문서 수신됨 <br> 배정된 task \{1}\개 중 <b>\{0}\</b>개",
    documentRecievedOutOfAssignedTeams: "문서 수신됨 <br> 배정된 팀 \{1}\개 중 <b>\{0}\</b>개",

    groupStatusSubTitle: "아래에서 primary team에 배정된 그룹 task와 상태별로 수신한 그룹 문서 요약을 봅니다. <br/>그룹 task를 task 또는 문서 상태별로 필터링하도록 선택할 수 있습니다.",
    notSent: "미전송",
    draftsent: "초안 전송됨",
    finalsent: "최종 전송됨",
    noTaskForComponent: "사용 가능한 데이터가 없습니다. <p> Primary team에서 전송한 그룹 task가 수락되고 나면 여기에 표시됩니다.</p>",
    noTaskForComponentWithStatus: "사용 가능한 데이터가 없습니다. <p> 여기에서 데이터를 보려면 상태 옵션을 하나 이상 선택하십시오.</p>",

    //Dashboard V2 - activity feed
    activityFeedSubHeadingText: "지난 10일 간 관련 engagement 활동을 검토하려면 활동 유형을 선택하십시오. <br/>특정 항목에 대한 모든 활동을 보려면 해당 항목의 <b>활동</b> 아이콘을 클릭하십시오. <br/>토글을 사용하면 선별해서 볼 수도 있습니다.",
    activityFeedSubHeadingGroupAudit: "지난 10일 간 관련 engagement 활동을 검토하려면 활동 유형을 선택하십시오. <br/>특정 항목에 대한 모든 활동을 보려면 해당 항목의 <b>활동</b> 아이콘을 클릭하십시오. <br/>토글을 사용하면 선별해서 볼 수도 있습니다.",
    teamHistoryInstructionalText: "이 팀의 지난 10일 간 활동을 검토하십시오",
    teamHistory: "팀 기록",
    onlySeeMyActivity: "내 활동만 보기",

    taskAddedBy: "Task를 추가한 사람",
    taskMarkedCompleteBy: "Task에 완료 표시한 사람",
    taskUnmarkedCompleteBy: "Task 완료 표시를 해제한 사람",
    taskHandedOffBy: "Task를 hand-off한 사람",
    assignmentAddedBy: "배정을 추가한 사람",
    assignmentEditedBy: "배정을 편집한 사람",
    assignmentClosedBy: "배정을 닫은 사람",
    assignmentReOpenedBy: "배정을 다시 연 사람",
    assignmentDeletedBy: "배정을 삭제한 사람",
    noteAddedBy: "노트 추가한 사람",
    noteClearedBy: "노트 처리한 사람",
    noteClosedBy: "노트 닫은 사람",
    noteReopenedBy: "노트 다시 연 사람",

    linkRequestSent: "링크 요청을 보낸 사람",
    instructionSentBy: "지침을 보낸 사람",
    linkRequestAcceptedBy: "링크 요청을 수락한 사람",
    engagementUnlinkedBy: "Engagement 링크를 해제한 사람",
    instructionAcceptedBy: "지침을 수락한 사람",
    instructionReturnedBy: "지침을 반송한 사람",
    labelTo: "to",
    instructionReceivedFrom: "지침 발신처",
    filtersLabel: "필터",
    advanceOptions: "일괄 작업",
    advanceOptionsLabel: "일괄 작업",
    relatedScots: "연결된 SCOT",
    noRelatedScots: "연결된 SCOT 없음",
    materialityLabel: "중요성",
    currentPeriod: "당기 날짜",
    previousPeriod: "전기 날짜",
    showCurrentPeriod: "당기 날짜 표시",
    showPriorPeriod: "전기 날짜 표시",
    planningMateriality: "Planning materiality",
    tolerableError: "Tolerable error",
    sadNominalAmount: "SAD nominal amount",
    pmLabel: "PM",
    teLabel: "TE",
    sadLabel: "SAD",
    accountBalance: "계정 잔액",
    mapAccountBalances: "계정 잔액 매핑",
    connectToHelixProject: "Helix 프로젝트",
    connectToImportBalances: "에 연결하여 잔액을 불러오십시오",
    helixMultiple: "복수",
    selectMESTentity: "세부정보를 보려면 기업을 선택하십시오",
    relatedWCGWAndControls: "연결된 WCGW 및 통제",
    relateAtLeastOneWCGW: "통제위험이 의존인 각 경영진주장에는 WCGW를 하나 이상 연결해야 합니다",
    notRelyRelateWCGW: 'Assertions with a control risk of Not Rely do not have a requirement to identify a WCGW.',
    relatedITProcesses: "연결된 IT 프로세스",
    noRelatedITProcesses: "연결된 IT 프로세스 없음",
    relatedITRiskITGCs: "연결된 IT 위험, ITGC 및 ITSP",
    relatedITRisks: "연결된 IT 위험",
    ALRAHigherRiskCode: "H",
    materialityMestSelectEntity: "세부정보를 보려면 기업을 선택하십시오",
    OARCurrentPeriod: "분석일",
    OARComparative1Period: "비교일 1",
    xTELabel: "xTE",
    priorPeriodDesignation: "전기 지정:",
    priorPeriodEstimate: "전기 추정치:",
    notApplicableAbbreviation: "N/A",
    accountDetails: "계정 세부정보",
    launchGuidedWorkflow: "가이드 업무흐름 실행",
    guidedWorkflowTitle: 'Guided workflow',
    viewAccountBalace: "계정 잔액 보기",
    viewAccountBalaceForEntity: "계정 잔액을 보려면 기업을 선택하십시오",
    mainActivities: "주요 활동",
    oversightProjectTile: {
        typeOversight: "감독",
        createProject: "프로젝트 생성",
        oversightProjectengagementNotConnectedMessage1: 'The EY Canvas Oversight application summarizes milestone, project management, and group audit progress for connected engagements. Use it to ensure your group audit or portfolio of engagements is on track.',
        oversightProjectengagementNotConnectedMessage2: 'Your engagement is not connected to any EY Canvas Oversight projects.',
        click: 'Click',
        togetstarted: "을(를) 클릭하여 시작하십시오",
        clickProjectmessage: "시작하려면 <b> + 프로젝트 생성</b>을 클릭하십시오",
        lblclient: "고객:",
        lblEngagementCount: "Engagement:",
        lblTaskscompleted: "Task 완료됨:",
        lblMore: "기타",
        myProject: "내 프로젝트",
        OtherProject: "다른 프로젝트",
        oversightNoProjectConnectedMessage: "귀하는 engagement가 연결된 모든 EY Canvas Oversight 프로젝트의 멤버가 아닙니다",
        oversightOtherProjectNotConnectedMessage: "귀하는 engagement가 연결된 모든 EY Canvas Oversight 프로젝트의 멤버입니다",
        draft: "초안",
        allTask: "모든 Task",
        totalTask: "총 Task"
    },

    economicsProjectTile: {
        typeEconomics: "economics",
        economicsProjectengagementNotConnectedMessage1: "EY Canvas Economics application은 재무와 EY Canvas 진행상황을 요약합니다. 이를 사용하여 engagement 포트폴리오의 economics를 관리하십시오.",
        economicsProjectengagementNotConnectedMessage2: "Engagement가 EY Canvas Economics 프로젝트에 연결되지 않았습니다",
        clickProjectmessage: "시작하려면 <b> + 프로젝트 생성</b>을 클릭하십시오",
        economicsNoProjectConnectedMessage: "귀하는 engagement가 연결된 모든 EY Canvas Economics 프로젝트의 멤버가 아닙니다",
        lblForecasted: "예측:",
        lblActual: "실제:",
        lblETC: "ETC:",
        lblVariance: "차이"
    },
    leftNavigation: {

        engagementOverview: "Engagement 개요",
        myProgress: "내 진행상태",
        executiveTasks: "Focus area",
        integration: "통합",
        groupAudit: "그룹 상태",
        pinnedDocuments: "고정된 문서",
        Validations: "유효성 검증",
        activityFeed: "활동 피드",
        primaryStatus: "Primary 상태",
        componentStatus: "부문 상태",
        picProgress: "PIC 진행상황",
        picEQRProgress: "PIC/EQR 진행상황",
        drillDown: "드릴다운",
        maps: "맵",
        financialStatement: "재무제표"
    },
    nowRowOverlayClientRequest: {
        createNew: "요청 추가를 클릭하여 신규 요청을 생성하십시오",
        all: "요청사항이 생성되지 않았습니다",
        draft: "초안 상태인 요청사항이 없습니다",
        pending: "응답 보류 중 상태인 요청사항이 없습니다",
        received: "요청사항이 수신되지 않았습니다",
        accepted: "요청사항이 수락되지 않았습니다",
        customFilter: "일치 항목을 찾을 수 없습니다. 다시 시도하십시오."
    },

    clientRequestPrefixes: {
        draft: "초안",
        returned: "반송됨",
        recalled: "회수됨",
        withdrawn: "철회됨"
    },

    clientRequestsTabHeader: {
        all: "모두",
        draft: "초안",
        pending: "보류 중",
        received: "수신됨",
        accepted: "수락됨"
    },

    clientRequestsPriorityFilters: {
        all: "모두",
        normal: "Normal",
        high: "High",
        critical: "Critical",
        highAndCritical: "High + Critical"
    },

    requestTableHeader: {
        requestId: "요청 ID",
        title: "제목",
        receivedDate: "수신일",
        dueDate: "만료일",
        sentDate: "전송일",
        acceptedDate: "수락일",
        assignedTo: "담당자",
        group: "그룹",
        status: "상태",
        priorityType: "우선순위",
        tags: "태그"
    },

    dropdownColumnsFilter: {
        1: "담당자",
        2: "그룹",
        3: "만료일",
        4: "전송일",
        5: "수신일",
        6: "수락일",
        7: "상태",
        8: "우선순위",
        9: "태그"
    },

    requestTableDropdownFilter: {
        customizeTable: "표 수정",
        selectInfo: "최대 4개 옵션 선택",
        selectInfoTooltip: "최대 4개 열 선택. 계속하려면 옵션을 하나 이상 선택 해제하십시오."
    },

    ClientStatus: {
        1: "초안",
        2: "초안 - 연락처 없음",
        3: "전송됨",
        4: "시스템 오류",
        5: "유효하지 않은 고객 연락처",
        6: "보류 중 응답",
        7: "수신됨",
        8: "수락됨",
        9: "반송됨",
        10: "철회됨",
        11: "전송 진행 중",
        12: "수락 진행 중",
        13: "철회 진행 중",
        14: "삭제 진행 중",
        15: "반송 진행 중",
        16: "응답 진행 중",
        17: "삭제됨",
        18: "유효하지 않은 고객 연락처",
        19: "회수 중",
        20: "회수됨",
        21: "완료 진행 중",
        22: "회수 진행 중"
    },

    analyticStatus: {
        1: "초안",
        2: "승인 보류 중",
        3: "승인됨",
        4: "만료됨"
    },

    paginationControl: {
        firstPage: "첫 페이지",
        lastPage: "마지막 페이지",
        previousPage: "이전 페이지",
        nextPage: "다음 페이지",
        show: "표시"
    },

    auditPlanFilterLabels: {
        showMore: "더",
        filterTypeOfScots: "SCOT",
        noScotsAvailable: "사용 가능한 SCOT 없음",
        filterTypeOfITProcess: "IT 프로세스",
        noITProcessAvailable: "사용 가능한 IT 프로세스 없음"
    },

    controlListBuildStep4FilterLabels: {
        scots: {
            filterTypeOfScots: "SCOT",
            noScotsAvailable: "사용 가능한 SCOT 없음"
        },
        testing: {
            filterTypeOfTesting: "테스트",
            noTestingAvailable: "사용 가능한 테스트 없음"
        },
        designEffectiveness: {
            filterTypeOfDesignEffectiveness: "설계 효과성",
            noDesignEffectivenessAvailable: "사용 가능한 설계 효과성 없음"
        },
    },

    clientRequestsFilterLabels: {
        filterAssignedTo: "담당자",
        filterAttachmentsLabel: "첨부파일 유형",
        filterCreatedByLabel: "생성한 사람",
        filterStatusLabel: "상태",
        filterDueAfterLabel: "이후 만료",
        filterDueBeforeLabel: "이전 만료",
        filterErrorsLabel: "오류",
        filterOverdueLabel: "지연",
        filterTagLabel: "태그",
        filterTimePhaseLabel: "시기",
        filterTypeLabel: "유형",
        filterPriorityLabel: "우선순위",
        searchMembers: "멤버 검색",
        noTags: "태그가 생성되지 않았습니다",
        noTimephase: "시기 없음",
        clearAll: "모두 처리",
        clearHoverText: "처리",
        noResultsFound: "결과를 찾을 수 없습니다",
        yes: "예",
        no: "아니오",
        showMore: "더 표시",
        // Check this
        filterNoMatchesFound: "일치 항목을 찾을 수 없습니다. 다시 시도하십시오.",
        filter: "필터",
        title: "필터",
        noRelatedTask: "연결된 task 없음"
    },
    //Dashboard - integration

    collaborationInstruction: "아래에서 상태별 공동작업 요청사항을 봅니다. <br/> 필터링이 적용된 요청 목록으로 이동하려면 개수를 클릭하십시오.",
    noValidationsAvailable: "이 감사 단계에는 유효성 검증이 없습니다",
    individualView: "개별 보기",
    engagementView: "Engagement 보기",
    centralizedServiceInstruction: "아래에서 중앙집중식 서비스를 활용하는 task 비율과 상태별 요청사항을 보십시오. <section>신규 요청을 생성하려면 <b>서비스 요청</b>을 선택하십시오.</section>",
    // Dashboard - todo list
    todoList: "To-do 목록",
    todoListInProgress: "현재",
    todoListOpen: "임박",
    todoListClosed: "완료됨",
    todoListInstruction: "상태별 만료 도래된 배정 및 리뷰노트 보기. <br /> 보기를 선별하려면 기간 또는 범주를 선택하십시오. <br />항목을 열려면 task 또는 리뷰노트 이름을 클릭하십시오.",
    noOpenAssignments: "처리 전인 배정이 없습니다",
    noInProgressAssignments: "진행 중인 배정이 없습니다",
    noClosedAssignments: "닫힌 배정이 없습니다",
    allLabel: "모두",
    dueLabel: "만료",
    noAssignments: "배정이 없습니다",
    executiveReview: "Executive 검토",
    epTasksStatusSignOffWithoutDetails: "아래에서 PIC 상태 요약을 보십시오",
    epTasksStatusSignOff: "아래에서 PIC 상태 요약을 보십시오. 세부정보를 보려면 <b>세부정보 보기</b>를 선택하십시오.",
    epeqrTasksStatusSignOffWithoutDetails: "아래에서 PIC와 EQR 상태 요약을 보십시오",
    epeqrTasksStatusSignOff: "아래에서 PIC와 EQR 상태 요약을 보십시오. 세부정보를 보려면 <b>세부정보 보기</b>를 선택하십시오.",
    eqrDefaultMessage: "이 engagement는 EQR이 필요하지 않습니다",
    selectPartners: "Partner 선택",
    noPartnersInEng: "Engagement에 partner가 없습니다",
    epTasks: "PIC task",
    eqrTasks: "EQR task",
    viewDetails: "세부정보 보기",
    picReview: "PIC 검토",
    eqrReview: "EQR 검토",
    eqrtasksWithSignOff: "EQR <br/> sign-off 미완료 task",
    eqrdocumentsWithSignOff: "EQR <br/> sign-off 미완료 문서",
    pictasksWithSignOff: "PIC <br/> sign-off 미완료 task",
    picdocumentsWithSignOff: "PIC <br/> sign-off 미완료 문서",
    partnerSignoffs: "Partner sign-off",
    epTaskswithpartnersignoffs: "필터링이 적용된 task 목록으로 이동하려면 개수를 클릭하십시오",
    allDocssignedoff: "모든 문서 <br/>sign-off됨",
    someDocssignedoff: "일부 문서 <br/>sign-off됨",
    noDocssignedoff: "<br/>Sign-off된 문서 없음",
    partnernotinvited: "Partner 초대되지 않음",
    noEQRsinyourengagement: "Engagement에 EQR이 없습니다",
    selectEQRs: "EQR 선택",
    eqrNotinvited: "EQR 초대되지 않음",
    eqrsignoffs: "EQR sign-off",
    eqrtaskswithpartnersignoffs: "필터링이 적용된 task 목록으로 이동하려면 개수를 클릭하십시오",
    allpartners: "모든 partner",
    allEQRs: "모든 EQR",
    reviewComments: "리뷰노트",
    noOpenReviewComments: "처리 전 리뷰노트가 없습니다",
    noClearedReviewComments: "처리된 리뷰노트가 없습니다",
    noClosedReviewComments: "닫힌 리뷰노트가 없습니다",
    noReviewCommentsForSelectedTime: "선택한 기간에 리뷰노트가 없습니다. 계속하려면 다른 기간을 선택하십시오.",
    picTasksSomeDocSignOff: "PIC가 일부 문서에 sign-off한 task",
    picTasksNoDocSignOff: "PIC가 sign-off한 문서가 없는 task",
    eqrTasksSomeDocSignOff: "EQR이 일부 문서에 sign-off한 task",
    eqrTasksNoDocSignOff: "EQR이 sign-off한 문서가 없는 task",
    picNotIdentified: "PIC가 식별되지 않았습니다",
    eqrNotIndentified: "EQR이 식별되지 않았습니다",
    todoReviewNote: "리뷰노트",

    // Dashboard - Executive Tasks
    executiveTasks: "Focus area",
    executiveTasksInstruction: "아래에서 위험 또는 계정별 task를 보도록 선택합니다. <br/> 선택하고 나서 더 자세히 보려면 개수 위로 마우스를 가져갑니다. 또는 특정 세부정보 페이지로 이동할 task를 선택합니다.",
    byRisk: "위험별",
    byAccount: "계정별",
    responsiveTasks: "연결된 Task",
    openNotes: "처리 전 노트",
    lowLabel: "Low",
    mediumLabel: "Medium",
    highLabel: "High",
    criticalLabel: "Critical",
    epRequired: "PIC 필요",
    eqrRequired: "EQR 필요",
    noDocumentsSignedOff: "Sign-off된 문서 없음",
    someDocumentsSignedOff: "일부 문서 sign-off됨",
    allDocumentsSignedOff: "모든 문서 sign-off됨",
    completedAssignments: "완료된 배정",
    designation: "지정",
    significantAccount: "유의적인 계정",
    epSignOff: "PIC sign-off",
    eqrSignOff: "EQR sign-off",
    someLabel: "Some",
    riskNoDataLabel: "이 위험은 task와 연결되지 않았습니다",
    accountNoDataLabel: "이 계정과 관련 경영진주장은 task에 연결되지 않았습니다",
    NoDataLabel: "선택한 아코디언에 사용 가능한 데이터 없음",
    // Manage tags
    manageTagsInstructionalText: "여기에서 신규 태그를 생성하십시오. 기존 태그를 편집하거나 삭제할 수도 있습니다. 요청사항에 태그를 지정하면 engagement 조직과 프로젝트 관리를 개선할 수 있습니다.",
    noTagsAdded: "추가된 태그 없음. 시작하려면 태그를 생성하십시오.",

    // Client Request Comments
    noCommentsCreatedYet: "Comment가 아직 생성되지 않았습니다",
    addCommentTitleTip: "Comment 추가",
    addReplyTitleTip: "회신 추가",
    addAComment: "Comment를 남기십시오…",
    addAReply: "회신 추가",
    deleteCommentConfirmationModalTitle: "Comment 삭제",
    deleteCommentConfirmationModalMessage: "이 comment를 삭제하시겠습니까? 이 comment에 대한 회신도 모두 삭제됩니다.",

    // Client Request Voice Note Comment Labels
    voiceNoteCommentRecordLabel: "음성 노트",
    voiceNoteCommentStopLabel: "정지",
    voiceNoteCommentPlayLabel: "재생",
    voiceNoteCommentDeleteLabel: "삭제",

    //Client Request Status/Tooltip messages
    SendRequestSuccess: "요청이 제출됐습니다",
    BulkSendRequestSuccess: "{0}개의 요청사항이 전송됐습니다",
    BulkSendOneRequestSuccess: "요청 1개가 전송됐습니다",
    SendInProgress: "전송 진행 중",
    AcceptInProgress: "수락 진행 중",
    CompleteInProgress: "완료 진행 중",
    HasErrorState: "요청을 전송하지 못했습니다. 다시 시도하십시오.",
    WithdrawRequestSuccess: "요청이 철회됐습니다",
    WithdrawInProgress: "철회 진행 중",
    WithdrawRequestError: "요청을 철회하지 못했습니다. 다시 시도하십시오.",
    DeleteRequestError: "요청을 삭제할 수 없었습니다. 페이지를 새로 고침하여 다시 시도하십시오.",
    AcceptRequestError: "요청을 수락할 수 없습니다. 다시 시도하십시오.",
    CompleteRequestError: "요청을 완료할 수 없습니다. 다시 시도하십시오.",
    InvalidClientContact: "유효하지 않은 고객 연락처",
    BulkSendInvalid: "선택한 요청사항 중 하나 이상은 추가 조치 없이 보낼 수 없습니다. 검토 후 다시 시도하십시오.",
    returnInProgress: "반송 진행 중",
    returnRequestError: "요청을 반송할 수 없습니다. 다시 시도하십시오.",

    //Client Withdraw Request
    WithdrawRequest: "요청 철회",
    WithdrawReuestConfirmMsg: "이 요청을 철회하시겠습니까? 철회되고 나면 고객은 더 이상 볼 수 없습니다. 완료 후에는 요청이 초안 목록으로 이동됩니다.",
    WithdrawMenuOption: "철회",
    MoreOptions: "추가 옵션",
    Complete: "완료",
    WithdrawLabel: "철회됨",
    CompleteInstructionalText: "고객이 정보를 이미 제공한 경우 완료를 사용합니다",

    //Client Complete Request
    CompleteRequestConfirmMsg: "요청을 완료하면, 고객의 to-do 목록에서 요청이 제거되고 고객 입장에서 상태가 전송됨으로 업데이트됩니다. EY Canvas에서 이 요청이 수신됨 목록으로 이동됩니다. 예를 들어, 대체 수단을 통해 요청 정보를 이미 수신했을 때 이 방법을 사용할 수 있습니다.",
    CompleteRequest: "요청 완료",
    CompleteRequestSuccess: "요청이 완료됐습니다",

    //Client Accept Return Request
    AcceptLabel: "수락",
    ReturnLabel: "반송",
    ReturnRequest: "요청 반송",
    acceptRequest: "요청 수락",
    acceptRequestWithoutTask: "선택한 요청을 수락하시겠습니까?",
    acceptRequestWithTask: "<b>선택한 요청을 수락하시겠습니까?</b> 첨부 문서는 {0} 관련 task의 외부 문서 탭에서 사용할 수 있습니다.",
    acceptRequestSuccess: "요청이 수락됐습니다",
    returnedRequestSuccess: "요청이 반송됐습니다 -",

    // Client Request Relate Files modal
    noRecordsFound: "기록을 찾을 수 없습니다",
    relateSelected: "선택한 항목 연결",
    relateFilesModalHeader: "기존 문서를 이 요청에 연결하려면 문서를 선택하고 선택한 항목 연결을 클릭하십시오.",
    relateAnalyticModalHeader: "기존 분석을 이 요청에 연결하려면, 선택한 분석 상자에 체크하십시오. 사용 가능한 다른 분석을 미리 보려면, click",
    relateAnalyticHereModalHeader: "여기",
    noAnalyticsRecordsFound: "공유 가능한 분석이 없습니다. 시작하려면",
    noAnalyticsRecordsFoundGetStarted: 'to get started.',
    associateExistingDocumentsSelected: "문서 추가됨",
    associateExistingDocumentSelected: "문서 추가됨",

    // Client Request Details Header
    timePhaseLabel: "시기:",
    receivedDateLabel: "수신됨:",
    dueDateLabel: "만료:",
    sentDateLabel: "전송됨:",
    acceptedDateLabel: "수락됨:",
    clientRequestSyncLabel: "EY Canvas Client Portal로 업데이트를 전송 중입니다",
    editDescriptionLabel: "설명 편집",
    createdDateLabel: "생성됨:",

    //Client Advance Search
    advancedSearch: "고급 검색",
    advancedSearchRefereceNumberCheck: "참조 #",
    advancedSearchTitleCheck: "제목",
    advancedSearchDocumentsCheck: "문서",
    advancedSearchCommentsCheck: "Comment",
    advancedSearchApplyButton: "적용",
    searchRequest: "검색",
    clearSearch: "검색 처리",

    //Adjustment Topup module
    adjustmentModule: {
        currencyType: "통화 유형",
        currencyCode: "통화 코드",
        businessUnit: "사업부",
        all: "모두",
        moduleName: "조정사항 모듈",
        financialStatement: "재무제표",
        viewByTrialBalanceType: "시산표 유형별 보기",
        multiEntry: "Multi-entity",
        balanceSheet: "재무상태표",
        incomeStatement: "손익계산서",
        currentperiodUnadjusted: "Analysis date",
        unadjusted: "(조정 전)",
        currentperiodAdjusted: "Analysis date",
        adjusted: "(조정 후)",
        adjustment: "조정사항",
        newAdjustment: "신규 조정사항",
        noRecordsFound: "기록을 찾을 수 없습니다",
        periodEnded: "종료일",
        periodsEnded: "종료일",
        noResultsFound: "결과를 찾을 수 없습니다",
        notApplicableAbbreviation: "N/A",
        noAdjustmentCreated: "생성된 조정사항 없음",
        createAdjustment: "{0}을(를) 생성하십시오",
        next: "다음 페이지",
        previous: "이전 페이지",
        reclassification: "재분류",
        manageAdjustment: "조정사항 관리",
        lastPage: "마지막 페이지",
        firstPage: "첫 페이지",
        filterYes: "예",
        filterNo: "아니오",
        showOnlyAdjustedAccountClasses: "조정된 계정 분류만 표시",
        noneAvailable: "사용 가능한 항목 없음",
        noImportedTrialbalanceAvailable: "불러온 시산표 없음",
        trialBalanceRequired: "시산표",
        comparativeperiodUnadjusted: "비교일",
        comparativeperiodAdjusted: "비교일",
        multityEntityRequired: "Multi-entity",
        placeHolderMessageWhenHelixMappingIsTrue: "불러온 시산표 없음. {0}을(를) 클릭하여 신규 analyzer를 연결하십시오.",
        placeHolderMessageWhenHelixMappingIsFalse: "EY Helix와 통합할 수 없습니다. 페이지를 새로 고침하여 다시 시도하십시오. 문제가 지속되면, 헬프 데스크에 문의하십시오.",
        eyHelixIntegrationLinkText: "EY Helix 연결",
        noEntitiesAvailablePlaceholder: "생성된 기업 없음. 시작하려면 기업을 생성하십시오.",
        search: "검색",
        viewAdjustmentWithValidations: "유효성 검증 ({0}) 있는 조정사항 보기",
    },

    misstatementLabels: {
        name: "이름",
        notes: "노트",
        signOffs: "Sign-off",
        open: "열기",
        openReadOnly: "읽기 전용으로 열기",
        delete: "삭제",
        rename: "이름 바꾸기",
        signOffRequirements: "Sign-off 요건",
        confidentiality: "기밀",
        unlink: "링크 해제",
        removeFromAdjustment: "조정사항에서 제거"
    },

    allControls: "모든 통제",
    //Client Request Document labels
    clientRequestDocuments: {
        externalDocuments: "외부",
        taskDocuments: "문서",
        deletedDocuments: "삭제됨",
        priorPeriodDocuments: "전기",
        priorPeriodInfoMessage: "이 문서를 다운로드할 수 없습니다",
        uploadedBy: "업로드한 사람",
        deletedBy: "삭제한 사람",
        lastModifiedBy: "최근 수정한 사람",
        eyBadge: "문서에서 삭제됨",
        externalBadge: "외부에서 삭제됨",
        uploadInProgress: "업로드 진행 중",
        refreshdocuments: "문서 새로 고침",
        disabledDocument: "이 문서 유형에는 일괄 작업이 허용되지 않습니다",
        menuOptions: {
            delete: "삭제",
            open: "열기",
            openr: "읽기 전용으로 열기",
            restore: "복원",
            remove: "제거",
            rename: "이름 바꾸기",
            editInHelix: "EY Helix에서 편집"
        },
        externalPriorPeriod: "고객",
        eyPriorPeriod: "EY",
        uploadedByEY: "EY"
    },

    //Client Request Assigned To Errors
    clientRequestAssignedToErrorLabel: "배정된 사용자 또는 그룹이 유효하지 않습니다. 계속하려면 배정을 업데이트하십시오.",
    clientRequestAssignedToErrorLabelEnd: "을(를) 클릭하여 외부 팀 멤버를 편집하십시오.",
    clickHereLabel: "여기",
    clientRequestAssignedToIconErrorLabel: "배정된 그룹에 활동 멤버가 없습니다. 계속하려면 요청을 활동 사용자/그룹에 배정하거나 그룹에 멤버를 추가하십시오.",
    clientRequestDueDateErrorLabel: "만료일은 필수입니다. 계속하려면 만료일을 업데이트하십시오.",

    clientRequestDocumentsNoDocsFound: [{
            id: 'externalDocuments',
            label: "추가된 외부 문서 없음"
        },
        {
            id: 'taskDocuments',
            label: "문서를 하나 이상 끌어서 놓거나 문서 추가를 클릭하십시오"
        },
        {
            id: 'deletedDocuments',
            label: "삭제된 문서가 없습니다"
        },
        {
            id: 'searchRequestDocuments',
            label: "No matches found, please try again"
        },
        {
            id: 'priorPeriodDocuments',
            label: "사용 가능한 전기 문서 없음"
        }
    ],

    liveNotifications: {
        "ey.at.hercules.annotation.created": "주석 생성됨",
        "ey.at.hercules.annotation.edited": "주석 편집됨",
        "ey.at.hercules.annotation.replied": "주석 회신됨",
        "ey.at.hercules.contentupdate.updated": "내용 업데이트됨",
        "ey.at.hercules.contentupdate.failed": "내용 업데이트 실패"
    },

    //Assign to
    usersOption: "사용자",
    externalUsersOption: "외부 사용자",
    groupsOption: "그룹",
    lblassignedto: "담당자",
    searchGroup: "그룹 검색",
    requiredAssignedTo: "담당자는 필수입니다",
    rdSubmitRequest: "요청 제출",

    closeDrawer: "모두 닫기 및 선택 해제",
    requestSelected: "요청 선택됨",
    requestsSelected: "요청 선택됨",
    //GA Scopes labels
    engagementScopesAndCustomSubScopes: "Engagement 범위 및 사용자지정 하위 범위",
    defineGroupScopes: "그룹 범위 정의",
    gaScopeIntro: "EY GAM에 따른 engagement 범위가 여기에 기본으로 포함되어 있습니다. 동일한 범위를 공유하는 팀을 위한 그룹 task와 지침을 수정해야 하는 경우, 하위 범위 생성을 고려하십시오. 지침을 보낼 때 각 하위 범위에 다른 버전을 보낼 수 있습니다.",
    addSubScope: "하위 범위 추가",
    customSubScope: "사용자지정 하위 범위",
    noCustomSubscopes1: "이 engagement 범위에 사용자지정 하위 범위가 없습니다",
    noCustomSubscopes2: "시작하려면 <b>하위 범위 추가<b>를 선택하십시오",
    subScopeName: "하위 범위 이름",
    addDescription: "설명 추가",
    textExceedsLength500: "텍스트는 500자를 초과할 수 없습니다",
    manageGroupPermission: "이 작업을 하려면 <b>그룹 관리</b> 권한이 있어야 합니다. 권한을 요청하려면 Engagement 관리자와 얘기하십시오.",
    deleteCustomSubScope: "사용자지정 하위 범위 삭제",
    areYouSureDeleteCustomSubScope: "이 사용자지정 하위 범위를 삭제하시겠습니까?",

    //GA Component labels
    newTeam: "신규 팀",
    teamName: "팀 이름",
    legalEntityName: "법인 이름",
    parentTeam: "상위 팀",
    isReferenceOnly: "참조 전용",
    isNotUsingCanvas: "EY Canvas를 사용하지 않는 팀",

    referenceOnlyTooltip: "<b>참조 전용</b>으로 지정된 팀은 링크 요청, 지침, task를 수신하지 않습니다. 그들은 조직 목적으로만 사용됩니다.",

    canvasFormNotOwnedByEng: "이 engagement 소유가 아닌 공유 Canvas 양식은 EY Canvas Client Portal로 보낼 수 없습니다. 이를 보내거나 원천 engagement에서 보내야 하는 경우에는 이 engagement로 양식을 복사하십시오.",
    canvasFormNotAllowedInCtry: "귀하의 국가에서는 고객과 Canvas 양식을 공유할 수 없습니다",
    on: "on",
    sendRequest: "요청 보내기",
    selectUserOrGroup: "사용자 또는 그룹 선택",
    canvasFormShowAttachments: "{0} 첨부파일 표시",
    canvasFormShowOneAttachment: "1 첨부파일 표시",
    canvasFormHideAttachments: "{0} 첨부파일 숨기기",
    canvasFormHideOneAttachment: "1 첨부파일 숨기기",

    //GA Components
    createGroupStructure: "그룹 구조 생성",
    componentText: "EY Canvas를 통해 산출물을 전송할 각 engagement 팀을 위해 지역과 부문을 생성하십시오. EY Canvas를 통해 산출물을 전송하지 않는 팀은 <b>EY Canvas 미사용</b>으로 지정할 수 있습니다. 조직 목적으로 팀을 생성하여 <b>참조 전용</b>으로 지정할 수도 있습니다. 이 팀은 링크 요청, 지침, task를 수신하지 않습니다. 마치려면, <b>링크 요청 보내기</b>를 선택하십시오.",
    addTeam: "팀 추가",
    sendLinkRequests: "링크 요청 보내기",
    noComponents: "팀이 아직 생성되지 않았습니다. 시작하려면 <b> 팀 추가<b>를 선택하십시오.",
    editTeam: "팀 편집",
    deleteTeam: "팀 삭제",
    deleteInstructional: "이 팀을 삭제하시겠습니까? <br/><br/>이 팀에 대한 링크가 끊어지고 engagement에서 더 이상 문서를 교환할 수 없게 됩니다. 또한, 이 팀에 배정된 사용자지정 지침과 task가 모두 삭제됩니다.",
    linkRequestHasBeenSent: "링크 요청이 이미 전송됐거나 지정이 이미 설정되어 있기 때문에, 이 팀에 대한 범위 또는 지정을 편집할 수 없습니다",
    selectScopes: "범위 선택",
    searchScopes: "범위 검색",
    selectTeams: "팀 선택",
    sendLinkRequestsDescription: "Engagement를 링크하려는 범위 또는 팀을 선택하십시오.<br> 각 팀의 연락처로 링크 요청이 전송됩니다. 담당자가 링크 요청을 수락하면 EY Canvas를 통해 그룹 지침 및 task를 수신하게 됩니다.",
    sendVersionsDescription: "최신 그룹 지침과 task 버전을 보내려는 범위 또는 팀을 선택하십시오.<br> 그룹 지침과 task를 수신할 팀은 귀하의 engagement와 링크되어야 합니다. 팀이 최신 버전을 수락하고 나면 그들의 engagement에서 사용할 수 있습니다.",
    notSentYet: "전송된 버전 없음",
    notLinkedYet: "링크 요청 미전송",
    cardView: "카드 보기",
    noItemsPlaceholder: "버전이 발간되지 않았습니다. 여기에서 데이터를 보려면 그룹 지침 및 task 버전을 발간하십시오.",

    //GA Instructions
    customizeGroupInstructions: "그룹 지침 수정",
    gaInstructionsIntro: "EY GAM에 따른 그룹 지침은 기본으로 포함되며 본질적으로 정보 제공용입니다. 지역과 부문 팀에 주요 정보, 업무 범위, 중앙에서 수행될 절차를 알리기 위한 것입니다. EY GAM에 따른 지침을 상황에 맞게 수정하고, 필요한 경우, 추가 지침을 생성하며, 각 지침이 어느 범위 또는 팀에 배정되어야 할지 지정하십시오. 마치려면, 배정된 범위 또는 팀에 전송할 수 있도록 지침을 발간하십시오.",
    addInstruction: "지침 추가",
    instruction: "지침",
    groupTaskSelected: "그룹 Task",
    assignScopes: "범위에 배정",
    assignTeams: "팀에 배정",
    maxLengthMessage: "텍스트는 <b>500<b>자를 초과할 수 없습니다",
    addScope: "범위 추가",
    editInstruction: "사용자지정 지침 편집",
    editKnowledgeInstruction: "Knowledge 지침 편집",
    editKnowledgeTask: "Knowledge task 편집",
    editCustomTask: "사용자지정 task 편집",
    saveChangesInstruction: "변경사항 저장",
    updatedOnInstruction: "최근 업데이트:",
    knowledgeDescriptionInstruction: "Knowledge 설명",
    editDisabledTitle: "이 작업을 하려면 <b>그룹 관리</b> 권한이 있어야 합니다. 권한을 요청하려면 Engagement 관리자와 얘기하십시오.",
    deleteCustomInstruction: "지침 삭제",
    deleteGroupTask: "그룹 task 삭제",
    areYouSureDeleteCustomInstruction: "이 사용자지정 지침을 삭제하시겠습니까?",
    areYouSureDeleteCustomTask: "이 사용자지정 task를 삭제하시겠습니까?",
    publishAfterDelete: "이 지침을 삭제하면, 변경사항을 발간하고 새로 발간된 지침을 배정된 범위 또는 팀에 재전송해야 합니다",
    publishAfterDeleteGroupTask: "이 그룹 task를 삭제하면, 변경사항을 발간하고 새로 발간된 task를 배정된 범위 또는 팀에 재전송해야 합니다",
    resendPublishInformation: "이 단계에서 변경사항을 발간할 수 있습니다. 새로 발간된 지침은 요약에서 재전송할 수 있습니다.",
    resendPublishInformationGroupTask: "이 단계에서 변경사항을 발간할 수 있습니다. 새로 발간된 task는 요약에서 재전송할 수 있습니다.",
    compareVersionsNoVersionSelectedTitle: "비교할 버전이 선택되지 않았습니다!",
    compareVersionsNoVersionSelectedSubtitle: "드롭다운에서 최신 버전과 비교할 버전을 선택하십시오",

    //Add Section
    addSection: "섹션 추가",
    addSectionInstructionalText: "섹션을 추가하여 사용자지정 지침을 구성하십시오",
    addSectionPlaceholder: "섹션 이름",

    //Edit Section
    editSection: "섹션 이름 편집",
    editSectionInstructionalText: "이 사용자지정 섹션 이름을 변경하십시오. <br> 마치려면, 변경사항을 발간하여 선택한 범위 또는 팀에게 업데이트된 버전을 전송하십시오.",
    editSectionSave: "변경사항 저장",

    //Delete Section
    deleteCustomSection: "섹션 삭제",
    areYouSureDeleteCustomSection: "이 섹션을 삭제하시겠습니까?<br>이 섹션에 있는 지침이 모두 삭제됩니다. 마치려면, 변경사항을 발간하여 선택한 범위 또는 팀에게 업데이트된 버전을 전송하십시오.",
    customSection: "섹션",

    //Publish Changes
    publishChanges: "변경사항 발간",
    publishChangesInstructional: "현재 지침과 task에 대한 변경사항을 발간하시겠습니까? <br><br>이전 지침과 task에 덮어써집니다. 변경사항을 발간하고 나면 업데이트된 지침과 task는 요약에서 전송할 수 있습니다",
    publishChangesNotAvailable: "아직 사용할 수 없음",

    //GA Tasks
    costomizeGroupTasks: "그룹 task 수정",
    gaTasksIntro: "EY GAM에 따른 그룹 task는 기본으로 포함되어 링크된 engagement로 전송됩니다. EY GAM에 따른 task를 상황에 맞게 수정하고, 필요한 경우, 추가 task를 생성하며, 각 task가 어느 범위 또는 팀에 배정되어야 할지 지정하십시오. 마치려면, 배정된 범위 또는 팀에 전송할 수 있도록 task를 발간하십시오.",
    addCustomTask: "사용자지정 task 추가",
    groupTask: "그룹 task",
    gaTasks: "Task",
    attachments: "첨부파일",
    notAvailable: "사용 불가능",
    gaDocument: "문서",
    gaDocuments: "문서",
    gaScope: "범위",
    gaScopes: "범위",
    gaScopesCapitalized: "범위",
    gaTeam: "팀",
    gaTeams: "팀",
    gaUnassignedScopeTeam: "배정되지 않음",
    hideDetails: "세부정보 숨기기",
    gaAssignedScopes: "배정된 범위",
    gaAssignedTeams: "배정된 팀",
    addTask: "신규 task",
    due: "만료",
    noAttachments: "첨부파일이 추가되지 않았습니다",

    // Chip component
    chipMore: "기타",

    // GS Group Summary labels
    assignedTeam: "배정된 팀",
    lastPublished: "최근 발간",
    versionStatus: "버전 상태",
    lastSent: "최근 전송",
    lastSentTooltip: "지침과 task 버전이 각 팀에 마지막으로 전송된 날짜입니다. 팀에 전송된 버전을 보려면 날짜를 클릭하십시오.",
    lastSentBeforeTooltip: "<b><<Scope name>><b>에 사용 가능한 신규 지침과 task 버전이 있습니다. 이 팀에 최신 버전을 전송해야 하는지 고려하십시오.",
    groupSummary: "그룹 요약",
    summarySubTitle: "아래 각 범위와 팀에 배정된 지침 및 task의 가장 최신 버전을 검토하십시오. 이 버전을 배정된 범위와 팀에 전송하려면, <b>버전 보내기</b>를 선택하십시오.<br/>관련 전송일을 선택하면 특정 팀에 보낸 버전도 볼 수 있습니다.",
    compareVersions: "버전 비교",
    sendVersion: "버전 보내기",
    compareVersionsInstructional: "발간된 지침과 task의 최신 버전을 팀에 전송한 버전과 비교하여 차이를 식별합니다. 버전 간 차이가 있는 경우, 신규 버전을 팀에 전송해야 하는지 판단합니다.",
    publishedVersion: "발간된 버전",
    sentVersion: "전송된 버전",
    emptyPublishedVersion: "사용 가능한 범위가 없습니다. <br/>부문 팀에 배정된 범위가 여기에 열거됩니다.",
    emptySentVersion: "사용 가능한 팀이 없습니다",
    selectPublishedVersion: "여기에서 데이터를 보려면 발간된 버전을 선택하십시오",
    selectSentVersion: "여기에서 데이터를 보려면 전송된 버전을 선택하십시오",
    dueDate: "만료일",
    emptyPublishedSnapshot: "선택한 범위에 사용하도록 발간된 지침 및 task 버전이 없습니다. <br/>여기에서 데이터를 보려면 버전을 발간하십시오.",
    emptySentSnapshot: "지침 및 task가 선택한 팀에 전송되지 않았습니다. <br/>여기에서 데이터를 보려면 지침 및 task를 발간하여 이 팀에 전송하십시오.",
    update: "업데이트",
    updates: "업데이트",
    noTeamsPlaceholder: "팀 Placeholder 없음",
    noTeamSelected: "계속하려면 범위 또는 팀을 하나 이상 선택하십시오",
    latestVersionAlreadySent: "팀이 아직 생성되지 않았습니다. 지침과 task 버전을 발간하려면 팀을 하나 이상 생성하십시오.",
    latestHasBeenSended: "최신 지침 및 task 버전이 이미 이 팀에 전송됐습니다",
    noNewVersionToSend: "선택한 범위 또는 팀은 이미 최신 지침과 task 버전을 수신했습니다. 전송 가능한 업데이트가 없습니다.",
    notSelectedTask: "미선택",
    assignedTeams: "배정된 팀",
    noTeamsCreatedYet: "팀이 아직 생성되지 않았습니다. 지침과 task 버전을 발간하려면 팀을 하나 이상 생성하십시오.",
    newersTeamsSended: "최신 지침 및 task 버전이 관련된 범위 또는 팀에 전송됐습니다",
    LinkRequestNotSent: "링크 요청 미전송",
    lastVersionSentInstructionalText: "<b>{sentDate}</b>에 <b>{teamName}</b>에 전송된 task 및 지침 버전이 아래에 표시됩니다. 이것이 이 팀에 전송된 최신 버전입니다.",

    // ReceiveInstructions labels
    receiveInstructionsTitle: "{versionType} 그룹 지침과 task 버전",
    receiveInstructionsInstructional: "{primaryEng}은 {sentDate}에 그룹 지침과 task의 {versionType} 버전을 전송했습니다. 이 버전을 검토하고 수락할지 반송할지 선택하십시오. <b>버전 비교</b> 옵션을 사용하여 이 버전과 이전 버전을 비교할 수 있습니다.",
    fromLabel: "From",
    assignedScope: "배정된 범위",
    dateSent: "전송일",
    acceptVersion: "버전 수락",
    returnVersion: "버전 반송",
    returnPrimaryButton: "반송",
    returnVersionDescription: "이 지침과 task 버전을 primary team에 반송하시겠습니까? <br>이 버전을 engagement에 불러오지 않습니다. Primary team에게 근거를 설명하는 comment를 남기십시오.",
    noContent: "지금 사용 가능한 지침이 없습니다. 나중에 다시 시도하거나 헬프 데스크에 문의하십시오.",
    editorPlaceHolder: "Comment",
    receiveCompareVersionInstructional: "{primaryEng}에서 최근에 수신한 지침 및 task 버전을 이전에 수신한 버전과 비교하여 차이를 식별하십시오",
    latestReceiveCompareVersionInstructional: "{primaryEng}에서 최근에 수신한 지침 및 task 버전을 이전에 수신한 버전과 비교하여 차이를 식별하십시오",
    latestVersion: "최신 버전",
    earlierVersion: "이전 버전",
    earlierVersionEmpty: "비교할 이전 버전이 없습니다",
    selectEarlierVersion: "여기에서 데이터를 보려면 이전 버전을 선택하십시오",
    pstName: "그룹 engagement 지침 검토",
    pstDescription: "그룹감사 지침을 검토하십시오. '실행 - 일반'에서 그룹 task를 완료하십시오. 그룹감사 지침을 수락했을 때 그룹 task가 task 목록에 추가됐습니다.",
    selectedVersion: "선택한 버전",
    issuingEngagement: "Engagement 발급",
    accountsAndDisclosureLink: "계정 및 공시",
    openRiskAssessmentDocuments: "위험평가 문서 열기",
    openRiskAssessmentDocument: "위험평가 문서 열기",

    //Client engagement name labels
    successQueueMessage: "EY Canvas Client Portal에서 engagement 표시 이름이 업데이트됐습니다.",
    clientEngagementInstructionalText: "여기에서 사용자지정 engagement 표시 이름을 추가하거나 편집하십시오. 이 이름은 EY Canvas Client Portal에서 이 engagement에 접속하는 외부 팀 멤버가 볼 수 있습니다.",
    clientEngagementPlaceholder: "Engagement 표시 이름",
    clientEngagementModalTitle: "EY Canvas Client Portal 내 engagement 표시 이름",
    clientDisplayName: "고객 표시 이름",
    textExceedsLength: "텍스트는 100자를 초과할 수 없습니다",

    // Manage client access locations
    location: "위치",
    locationName: "위치 이름",
    accessLocations: "접근 위치",
    inputType: "유형 입력",
    ipAddress: "IP 주소",
    ipAddresses: "IP 주소",
    startOfIpRange: "IP 범위 시작",
    endOfIpRange: "IP 범위 끝",
    cidrNotation: "CIDR 기호",
    manageClientAccessLocationsLink: "위치 추가",
    manageClientAccessLocationsModalTitle: "고객 접근 위치 관리",
    manageClientAccessLocationsInstructionalText: "EY Canvas Client Portal에 위치 기반 접근을 활성화하려면 아래 목록에 IP 주소를 추가합니다. <br>고객 접근 위치가 활성화되면, 여기에 열거된 IP 주소를 가진 외부 팀 멤버만 이 engagement에 접근할 수 있습니다. IP 주소가 추가되지 않으면, 외부 팀 멤버는 어느 위치에서도 이 engagement에 접근할 수 있습니다.<br> 자세히 알아보려면, <b>여기<b>를 클릭하십시오.",
    manageClientAccessLocationsNoResultFound: "이 engagement에 추가된 IP 주소가 없습니다. 내외부 팀 멤버는 어느 위치에서도 이 engagement에 접근할 수 있습니다.",
    deleteAccessLocations: "접근 위치 삭제",
    deleteAccessLocationsInstructionalText: "선택한 접근 위치를 삭제하시겠습니까? <b>외부 팀 멤버가 이 위치에서 EY Canvas Client Portal에 접근하려고 하면 더 이상 이 engagement에 접근할 수 없습니다.",
    locationLengthError: "위치는 100자를 초과할 수 없습니다",
    oneOrMoreIpAddressFormatError: "제공된 IP 주소 중 하나 이상 유효하지 않습니다",
    ipAddressFormatError: "제공된 IP 주소가 유효하지 않습니다",
    ipSuffixError: "IP 주소의 CIDR 마지막 십진수는 1과 32 사이여야 합니다",
    ipRangeStartSmallerThanEnd: "시작 IP는 끝 IP보다 작아야 합니다",
    ipInputTypeInfo: "IP 주소를 선택하여 개별 IP 주소 또는 IP 주소 목록을 입력합니다. IPv4 주소만 지원됩니다. <br> IP 범위를 선택하여 동일한 네트워크 프리픽스 (주소의 처음 세 부분)를 공유하는 IP 주소 범위를 입력합니다. <br>CIDR block을 선택하여 CIDR 기호가 있는 IP 주소 범위를 입력합니다. CIDR 주소만 지원됩니다.",
    ipAddressInfo: "IP 주소는 개별적으로 입력하거나 쉼표로 구분된 목록 또는 각 주소가 신규 행에 있는 목록에 입력할 수 있습니다. <br> 유효한 IPv4 주소는 0에서 255 사이에 있는 정수 4개로 구성되며 마침표로 구분됩니다.",
    ipCidrInfo: "이 engagement에 접근할 수 있는 IP 주소 범위를 나타내는 CIDR 기호를 입력합니다. <br>유효한 CIDR 기호는 유효한 IPv4 주소, 특수문자 '/' 및 1과 32 사이에 있는 십진수로 구성됩니다.",
    ipAddressEg: "예, 192.XXX.X.1 192.XXX.X.2",
    ipRangeStartEg: "예, 192.XXX.X.1",
    ipRangeEndEg: "예, 192.XXX.X.2",
    ipCidrEg: "예, 192.XXX.X.1/22",
    searchIpPlaceholder: "IP 주소 확인",
    ipNotAddedMessage: "이(가) 허용된 목록에 추가되지 않았습니다",
    ipIsAllowedMessage: "IT 주소가 허용됩니다",
    importAccessLocationsLink: "접근 위치 불러오기",
    importAccessLocationsInstructionalText: "전기 engagement에서 접근 위치를 불러올 수 있습니다. <br>접근 위치를 불러오시겠습니까?",
    importAccessLocationsCloseButton: "닫기",
    importAccessLocationsCancelButton: "취소",

    // Export Requests
    exportRequests: "요청사항 내보내기",

    // Add custom request labels
    addCustomRequestModal: {
        titleTip: "신규 요청",
        titleTipAddButton: "신규 추가",
        closeTitleTip: "닫기",
        modalTitle: "신규 요청",
        returnModalTitle: "요청 반송",
        modalHeader: "EY Canvas Client Portal에 보낼 신규 요청 추가",
        requiredAssignedTo: "(필수)",
        assignToError: "담당자는 필수입니다",
        dueDate: "만료일 (필수)",
        dueDateError: "만료일은 필수입니다",
        titlePlaceholder: "제목 (필수)",
        titleError: "제목은 필수입니다",
        description: "설명",
        descriptionplaceholder: "설명 입력",
        descriptionError: "요청 설명이 최대 길이(4,000자)를 초과합니다",
        associateDocuments: "문서 연결",
        emptyAssociatedDocumentsList: "문서를 하나 이상 끌어서 놓거나 문서 추가를 클릭하십시오",
        addDocumentButton: "문서 추가",
        signOffCheckbox: "EY Canvas Client Portal에 업로드된 문서는 sign-off가 필요합니다",
        sendRequest: "요청 보내기",
        returnRequest: "요청 반송",
        saveAsDraft: "초안 저장",
        cancel: "취소",
        copyTitleAndDescription: "Task에서 제목과 설명 복사",
        copyAssociatedDocuments: "Task에서 문서 복사",
        priority: "우선순위 요청",
        addNewRequestButton: "신규 요청 추가",
        addExistingRequestButton: "기존 요청 추가"
    },
    addCustomEventModal: {
        titleTip: "신규 사건",
        closeTitleTip: "닫기",
        modalTitle: "신규 사건",
        eventDate: "사건 날짜",
        eventDateError: "날짜는 필수입니다",
        titlePlaceholder: "제목",
        titleError: "제목은 필수입니다",
        description: "설명 (선택사항)",
        descriptionplaceholder: "설명 입력",
        descriptionError: "사건 설명이 최대 글자수(4,000자)를 초과했습니다",
        sendEvent: "사건 보내기",
        saveAsDraft: "사건 초안 저장",
        cancel: "취소",
        eyParticipantsCollaborationError: "하나 이상의 EY 참여자는 필수입니다",
        externalParticipantsCollaborationError: "하나 이상의 외부 참여자는 필수입니다"
    },
    eyHelixInstructionText: "아래에서 링크된 EY Helix 프로젝트 및 권장 analyzer를 검토합니다. <br/> 특정 EY Helix 페이지로 이동하려면 프로젝트 또는 analyzer를 클릭하십시오.",
    smartAutomationInstrText: "아래에서 현재 사용하고 있는 스마트 자동화 솔루션을 검토합니다. <br/> 스마트 자동화 허브로 이동하려면 솔루션을 클릭하십시오.",
    smartAutomationSolutionsNotAvailable: "지금은 engagement에 사용 가능한 스마트 자동화 솔루션이 없습니다",
    noSmartAutomationAvailable: "Engagement에 사용 가능한 스마트 자동화 솔루션이 없습니다",
    availableSolutions: "사용 가능한 솔루션",
    useOfSuggestedSolutions: "권장 솔루션 사용",
    useOfOtherSolutions: "다른 솔루션 사용",
    suggestedSolutions: "권장 솔루션",
    otherSolutions: "다른 솔루션",
    currentlyusing: "현재 사용 중",
    suggested: "권장",
    primaryProject: "Primary 프로젝트",
    noLinkedProjects: "Engagement에 링크된 프로젝트가 없습니다",
    noSuggestedAnalyzers: "Engagement에 권장 analyzer가 없습니다",
    eyHelixNotAvailable: "EY Helix 사용 불가능",
    helixNotAvailableMessage: "지금은 engagement에 사용 가능한 EY Helix가 없습니다",

    noGroupTaskCreatedYet: "그룹 task가 아직 생성되지 않았습니다",
    noInstructionsCreatedYet: "지침이 아직 생성되지 않았습니다",
    documentsReceived: "문서 수신됨",
    documentsPending: "문서 보류 중",

    teamLabel: "팀",
    scopeLabel: "범위",

    documentSignOffby: "문서에 sign-off한 사람",
    documentAddedBy: "문서를 추가한 사람",
    documentModifiedBy: "문서를 수정한 사람",
    documentDeletedBy: "문서를 삭제한 사람",
    commentAddedBy: "노트 추가한 사람",
    commentClearedBy: "노트 처리한 사람",
    commentClosedBy: "노트 닫은 사람",
    commentReopenedBy: "노트 다시 연 사람",

    documentAssignedTo: "문서 담당자",
    draftDocReceivedFrom: "초안 문서 발신처",
    finalDocReceivedFrom: "최종 문서 발신처",
    documentReturnedBy: "문서를 반송한 사람",
    returnedDocumentClearedBy: "반송된 문서를 처리한 사람",
    documentConflictResolvedBy: "문서 충돌을 해결한 사람",
    draftDocumentSentBy: "초안 문서를 보낸 사람",
    documentReturnedFrom: "문서 반송처",
    finalDocumentSentBy: "최종 문서를 보낸 사람",
    noActivityAvailable: "사용 가능한 활동이 없습니다",
    allEngagementFilterLabel: "다른 모든 engagement",
    otherEngagementComments: "다른 engagement 노트",
    engagements: "Engagement",
    engagement: "Engagement",
    view: "보기",
    notesModalInstructionalText: "아래에서 선택된 {0}에 대한 노트를 보고 응답하십시오",

    //New collaboration Related Labels
    searchRelateFileNoMatchesFound: "일치 항목을 찾을 수 없습니다. 다시 시도하십시오.",

    //New collaboration Related tasks
    relatedTasksLabel: "연결된 task",
    selectRelatedTasks: "Task 선택",
    searchAndPressEnter: "검색하고 Enter키를 누르십시오.",
    noRelatedTasksSelected: "선택한 관련 task 없음",
    relatedTasksCount: "연결된 task",
    notFoundTasks: "Task를 찾을 수 없습니다",
    dueDateDetailLabel: "만료일",
    requestType2MessageTitle: "이 요청은 신규 탭에서 열립니다",
    requestType2MessageSubtitle: "업데이트를 보려면 페이지를 새로 고침하십시오",
    requestType2InTrnasitMessageTitle: "이 요청은 전송 중이므로 열 수 없습니다",
    requestType2InTrnasitMessageSubtitle: "동기화가 완료될 때까지 기다렸다가 페이지를 새로 고침하여 다시 시도하십시오",

    //New collaboration Time Phase
    selectTimePhase: "시기 선택",
    timePhaseNotFound: "시기를 찾을 수 없습니다",

    understandITProcess: "IT 프로세스 이해",

    //New collaboration Access Location
    accessLocationLabel: "접근 위치 활성화됨",
    accessLocationTitle: "승인된 네트워크 위치에서 연결하는 사용자만 이 engagement를 위한 EY Canvas Client Portal에 접근할 수 있습니다. 옵션 메뉴에 있는 접근 위치에서 허용 위치를 관리할 수 있습니다.",

    // Reporting Labels
    summaryScreenLabel: "요약 화면",
    dataExportLabel: "데이터 내보내기",
    projectManagementLabel: "프로젝트 관리",
    reportingHeaderName: "보고",
    repAllTasks: "모든 task",
    repDeletedTasks: "삭제된 task",
    repMultiEntityTasks: "Multi-entity task",
    repAllAuditPlan: "감사 계획",
    repITAppSOSummary: "IT App/SO 요약",
    repITProcessScotControls: "IT 프로세스, SCOT 및 통제",
    repTaskAssignments: "Task 배정",
    repTaskDetails: "Task 세부정보",
    repTaskAnalysis: "Task 분석",
    repTaskSummary: "Task 요약 (파일럿)",
    repExportToExcel: "데이터 내보내기",
    repExportDate: "내보낸 날짜",
    repEngInfo: "Engagement 정보",
    repNoRecordMessage: "표시할 기록 없음",
    dateInUTC: "UTC 기준",
    repSCOTsControls: "SCOT 및 통제",
    repITProcessSummary: "IT 프로세스 요약",
    repCanvasForms: "Canvas 양식",
    repControlForms: "통제 양식",
    projectInsight: "프로젝트 인사이트",
    archiveForm: "Archive 양식",
    archive: "Archive",
    repCanvasFormResponse: "Canvas 양식 응답",
    repCanvasFormRelatedComments: "연결된 comment",
    repControlFormResponse: "통제 양식 응답",
    repNoRecordFound: "기록을 찾을 수 없습니다",
    repCanvasFormsIncomplete: "미완료 응답",
    repCanvasFormRelatedObjects: "연결된 object",
    voiceNoteLabel: "음성 노트",
    repComponentTeamGroup: "부문 팀",
    componentTeamCanvasFormExport: "Canvas 양식 내보내기",

    // Reporting Tasks
    repTaskTitle: "Task 제목",
    repTaskDescription: "Task 설명",
    repTaskSource: "Task 원천",
    repTaskNature: "Task 성격",
    repTaskCloseEarly: "일찍",
    repTaskCloseLate: "늦게",

    // Reporting Documents
    repAllDocuments: "모든 문서",
    repSignOffs: "Sign-off",
    repDocumentsModified: "RRD 후 수정된 문서",

    //Reporting Collaboration
    repRequestsAndTasks: "요청사항 및 task",
    repRequestsTasksComments: "요청사항/task comment",

    SCOTSummaryReportHeader: "SCOT 요약",
    GroupReportHeader: "그룹 보고서",
    SCOTSummaryEffective: "Effective",
    GroupInstructionSummary: "그룹 지침 요약",
    GroupActivity: "부문 계정 매핑 기록",
    SEMReportHeader: "SEM",
    GroupComponentAccountReportHeader: "그룹 부문 계정 매핑",
    AccountDisclosuresReportHeader: "계정 및 공시",

    //Reporting Collaboation Details
    collaborationDetails: "공동작업 세부정보",
    collaborationSummary: "요약",
    collaborationActivity: "활동 세부정보",
    ReviewNotesReportHeader: "리뷰노트",

    GroupStructureSummary: "그룹 구조 요약",

    //Reporting CRT Summary
    wcgwSummary: "WCGW 요약",
    crtlabel: "통제 검토 도구 (CRT)",
    assertionSummary: "경영진주장 요약",
    scotSummary: "SCOT 요약",
    noRecordsToExport: "내보낼 기록 없음",
    statisticsSummary: "통계",
    qualityChecks: "품질 검증",
    controlSummary: "통제 요약",
    filterBySCOT: "SCOT별 필터",

    //Reporting manage team
    independenceSummaryReportTabName: "독립성 요약",

    //MEST dashboard
    viewAllRiskTypesAndAssertions: "모든 위험 유형 및 경영진주장 보기",
    riskRelatedToAssertion: "경영진주장에 연결된 위험",
    higherRiskRelatedToAssertion: "경영진주장에 연결된 높은 위험",
    noRisksAvailable: "사용 가능한 위험 없음",
    relatedEstimates: "연결된 추정치",
    viewAllAssertions: "경영진주장 모두 보기",
    wcgwRelatedToAssertion: "경영진주장에 연결된 WCGW",
    noWcgwsAvailable: "사용가능한 WCGW 없음",
    goTo: "이동",
    allItems: "모든 항목",

    // Create TimePhase Labels
    createTimePhaseLabels: {
        modalTitle: "시기 추가",
        modalDescription: "정보를 추가하고 저장&닫기 또는 저장 &추가를 클릭하십시오",
        timephaseNameLabel: "시기 이름",
        milestoneSelectLabel: "Milestone",
        timephaseLabel: "시기",
        startDateLabel: "시작일",
        endDateLabel: "종료일",
        startDateErrorMessage: "시작일은 필수입니다",
        endDateErrorMessage: "종료일은 필수입니다",
        timephaseNameErrorMessage: "이름은 필수입니다",
        milestoneErrorMessage: "Milestone은 필수입니다",
        isKeyEvent: "주요 이벤트",
        timephaseDescription: "설명 (선택사항)",
        addSuccessMessage: "시기가 추가됐습니다"
    },

    AccountListHeaderLabels: {
        pspAndosp: "PSP/OSP",
        limitRiskAssertionLabel: "Limited risk 계정",
        heading: "계정 및 공시, 관련 항목",
        accountsOrDisclosure: "계정 및 공시",
        psps: "PSP",
        rejected: "거절됨",
        remove: "제거",
        risks: "위험",
        assertions: "경영진주장",
        noRecordsFound: "사용 가능한 계정 또는 공시 없음",
        noResultsFound: "결과를 찾을 수 없습니다",
        responsiveHeading: "대응",
        rejectedPspsHeading: "거절된 PSP",
        importPsps: "PSP 불러오기",
        importOsps: "OSP 불러오기",
        addOsps: "OSP 추가",
        pspEnded: "하여 시작하십시오.",
        noPspsandOsps: "사용 가능한 {0} 없음",
        allAreRejected: "모든 PSP가 거절됐습니다",
        rejectButton: "거절",
        acceptButton: "수락",
        additionalInfo: "근거:",
        noAssertionsAvailableLabel: "사용 가능한 경영진주장 없음",
        noAssertionAvailableTooltip: "사용 가능한 경영진주장 없음. <strong>계정 및 공시 관리</strong>를 클릭하여 경영진주장을 추가하십시오.",
        importFromKnowledge: "Knowledge에서 불러오기",
        disabledAddOspTooltip: "실증 task에 추가할 경영진주장이 하나 이상 있어야 합니다. <strong>계정 및 공시 관리</strong>를 클릭하여 경영진주장을 추가하십시오.",
        noPsps: "사용 가능한 PSP 없음. {0}하여 시작하십시오.",
        noOspsPsps: "사용 가능한 PSP/OSP 없음. {0}, {1} 또는 {2}하여 시작하십시오.",
        acceptErrorMsg: "거절된 task를 수락할 수 없습니다. 페이지를 새로 고침하여 다시 시도하십시오. 문제가 지속되면, 헬프 데스크에 문의하십시오.",
        build7NoPspOrOspAttachedToAssertion: "각 경영진주장에 대응하는 실증절차가 하나 이상 있어야 합니다. 다음 경영진주장에 대응하는 PSP/OSP가 없습니다: <b>{orphanAssertions}</b>. {0}, {1}, 또는 계정에 대한 모든 경영진주장에 대응하는 {2}을(를) 추가, 또는 이 계정에 대응하는 기존 PSP/OSP를 다른 경영진주장에 연결하기 위해 편집 아이콘을 클릭하십시오.",
        build7NoPspOrOsp: "각 경영진주장에 대응하는 실증절차가 하나 이상 있어야 합니다. 대응 PSP/OSP가 있는 경영진주장이 없습니다. {0}, {1}, 또는 계정에 대한 모든 경영진주장에 대응하는 {2}을(를) 생성하십시오.",
        build7NoOspsAndAllPspAreRejected: "각 경영진주장에 대응하는 실증절차가 하나 이상 있어야 합니다. PSP가 모두 거절됐으며 대응 PSP/OSP가 있는 경영진주장이 없습니다. {0}, 또는 계정에 대한 모든 경영진주장에 대응하는 {1}을(를) 생성하십시오.",
        build6And7NoAssertions: "각 유의적인 계정 또는 유의적인 공시에 실증절차를 추가할 수 있는 관련 경영진주장이 하나 이상 있어야 합니다. {0}을(를) 클릭하여 경영진주장을 추가하십시오.",
        build7LimitedAccountNoPspOsp: "각 limited risk 계정에 대응하는 실증절차가 하나 이상 있어야 합니다. {0}, 또는 이 계정 위험에 대응하는 {1}을(를) 생성하십시오.",
        manageAccountAndDisclosures: "계정 및 공시 관리"
    },

    AddTaskLabels: {
        accountLabel: "계정:",
        taskSectionLabel: "Task 섹션:",
        ospModelTitle: "신규 OSP",
        ostModelTitle: "신규 OST",
        saveAndClose: "저장",
        saveAndCreate: "저장 및 추가 생성",
        cancel: "취소",
        prefix: "Prefix",
        title: "제목",
        suffix: "Suffix",
        timePhase: "시기",
        description: "수정된 설명",
        descriptionPlaceholder: "수정된 task 설명 (필수)",
        assertions: "경영진주장",
        optional: "(선택사항)",
        required: "필수",
        noResultFound: "결과를 찾을 수 없습니다",
        of: "of",
        characters: "characters",
        descriptionMaxLengthError: "설명 길이가 최대 허용 길이를 초과합니다",
        noteDiscriptionErrorMessage: "응답에 {0}자가 포함되어 최대치 {1}자를 초과합니다. 텍스트 또는 서식을 줄여 설명을 조정한 후 다시 시도하십시오. 문제가 지속되면, 헬프 데스크에 문의하십시오.",
        customizeDescription: "수정된 task 설명 (필수)",
        errorMsg: "OSP를 추가하지 못했습니다. 페이지를 새로 고침하여 다시 시도하십시오. 문제가 지속되면, 헬프 데스크에 문의하십시오.",
        customizeTaskDescription: "Task 설명 수정"
    },

    RemoveTaskLabels: {
        modelOspTitle: "OSP 삭제",
        modelOstTitle: "OST 삭제",
        deleteBtn: "삭제",
        cancel: "취소",
        confimationOspMsg: "선택한 OSP를 삭제하시겠습니까?",
        confimationOstMsg: "선택한 OST를 삭제하시겠습니까?",
        warning1Msg: "연결된 증거 중 이 engagement의 다른 task에 연결되지 않은 증거는 임시 파일로 이동됩니다.",
        warning2Msg: "다른 증거와 연결되지 않은 발견사항 및 응답 task가 삭제됩니다."
    },

    TaskReportHeaderLabels: {
        Tasktype: "Task 유형",
        Taskstatus: "Task 상태",
        Taskassignedto: "Task 담당자",
        Tasktitleprefix: "Task 제목 prefix",
        Tasktitle: "Task 제목",
        Tasktitlesuffix: "Task 제목 suffix",
        Taskdescription: "Task 설명",
        Knowledgetasktitle: "Knowledge task 제목",
        Knowledgetaskdescription: "Knowledge task 설명",
        Oldtaskname: "이전 task 이름",
        Oldtaskdetail: "이전 task 세부정보",
        Rejected: "거절됨",
        Rationalforrejection: "거절 근거",
        Auditphase: "감사 단계",
        Timephasetype: "Milestone",
        Timephase: "시기",
        Timephasestartdate: "시기 시작일",
        Timephaseduedate: "시기 만료일",
        Keyevent: "주요 이벤트",
        Tasksource: "Task 원천",
        Tasknature: "Task 성격",
        Lasttaskstatuschangedate: "최근 task 상태 변경일",
        Taggroup: "태그 그룹",
        Tags: "태그",
        RelatedMESTentities: "연결된 MEST 기업",
        Schedulednextwaveservices: "예정된 NextWave 서비스",
        Priority: "우선순위",
        Taskid: "Task ID",
        Roleid: "역할 ID",
        Tasktypeid: "Task 유형 ID",
        Taskstatusid: "Task 상태 ID",
        Auditphaseid: "감사 단계 ID",
        Timephasetypeid: "Milestone ID",
        Tasksourceid: "Task 원천 ID",
        Tasknatureid: "Task 성격 ID"
    },

    glAccountDocumentLabels: {
        modelTitle: "GL 계정",
        modelName: "증거 연결",
        documentName: "문서 이름",
        documentCounter: "{0} 문서",
        documentsCounter: "{0} 문서",
        btnCancel: "취소",
        btnSave: "저장",
        errorMessage: "계속하려면 문서를 선택하십시오",
        noResultsFound: "결과를 찾을 수 없습니다",
        newTickMark: "신규 tickmark",
        bulkModePlaceholder: "연결하려면 증거를 선택하고 <strong>\'저장\'</strong>을 선택하여 마치십시오"
    },

    // Edit TimePhase Labels
    editTimePhaseLabels: {
        modalTitle: "시기 편집",
        modalDescription: "속성을 편집하고 <b>저장</b>을 클릭하십시오",
        editSuccessMessage: "시기가 업데이트됐습니다"
    },

    // Delete TimePhase Labels
    deleteTimePhaseLabels: {
        deleteTimePhaseModalTitle: "시기 삭제",
        deleteDescription: "이 시기를 삭제하시겠습니까?",
        showTimePhaseName: "시기",
        showMileStone: "Milestone",
        showStartDate: "시작일",
        showEndDate: "종료일",
        showDescription: "설명:",
        showAssignedTasks: "배정된 task 수",
        showAssignedAssignments: "배정 수",
        deleteSuccessMessage: "시기가 삭제됐습니다"
    },

    // Create Tag Labels
    createTagGrouplabels: {
        modalTitle: "태그 그룹 추가",
        modalDescription: "계속하려면 이름을 입력하고 저장 & 닫기 또는 저장 & 추가를 클릭하십시오",
        tagGroupNameLabel: "태그 그룹",
        tagGroupNameErrorMessage: "태그 그룹 필요",
        saveAndClose: "저장 & 닫기",
        saveAndAdd: "저장 & 추가",
        addSuccessMessage: "태그 그룹이 추가됐습니다"
    },

    // Bulk Tags
    tags: {
        noTagsAvailabel: "사용 가능한 태그 없음",
        deleteTag: "태그 삭제",
        deleteDescription: "태그 삭제는 실행 취소할 수 없습니다. 계속하시겠습니까?",
        showDeleteTagName: "태그",
        showDeleteTagGroupName: "태그 그룹",
        showAssignedTasks: "배정된 task",
        deleteSuccessMessage: "태그가 삭제됐습니다",
        task: "Task",
        tasks: "Task",
        addTagGrouplabels: "태그 그룹 추가",
        addTag: "태그 추가",
        action: "작업",
        addTagDesc: "<h3>태그 추가</h3><p>태그를 추가하는 데 활용할 신규 태그 그룹을 생성하려면 ‘태그 그룹 추가’를 클릭하십시오.</p>",
        assignTagDesc: "<h3>태그 배정</h3><p>선택한 항목을 태그 그룹 아래 원하는 태그로 끌어서 놓으십시오.</p>",
        editTagDesc: "<h3>태그 편집</h3><p>태그 정보를 편집하려면 오버플로우 메뉴(점 세 개)를 클릭하고 편집를 선택하십시오.</p>",
        deleteTagDesc: "<h3>태그 삭제</h3><p>태그를 삭제하려면 오버플로우 메뉴(점 세 개)를 클릭하고 삭제를 선택하십시오.</p>",
        removeTagDesc: "<h3>태그 제거</h3><p>태그를 제거하려면 기존 태그가 있는 하나 이상의 항목을 태그 그룹 아래 연결된 태그 이름으로 끌어오십시오.</p>",
        expand: "확장",
        collapse: "축소",
        TagName: "태그 이름",
        TagGroupName: "태그 그룹 이름",
        addTagSuccessMessage: "태그가 추가됐습니다",
        editTagSuccessMessage: "태그가 업데이트됐습니다",
        addTagModalTitle: "태그 추가 대상",
        editTagModalTitle: "태그 편집",
        addTagModalDescription: "계속하려면 신규 태그를 생성하고 저장 & 닫기 또는 저장 & 추가를 클릭하십시오",
        editTagModalDescription: "정보를 편집하고 <b>저장</b>을 클릭하십시오",
        tagSetSuccessMessage: "태그를 설정했습니다",
        tagsSetSuccessMessage: "태그를 설정했습니다",
        tagRemoveSuccessMessage: "태그가 제거됐습니다",
        tagsRemoveSuccessMessage: "태그가 제거됐습니다",
        tagRemovedSuccessfully: "태그가 제거됐습니다"
    },

    relateEvidenceHeader: "조정사항 정보를 제공하는 증거를 연결하십시오",
    relatedDocumentCounter: "{0} 문서",
    relatedDocumentsCounter: "{0} 문서",
    documentsLocationLabel: "문서 위치",
    relateTemporaryFilesHeader: "이 engagement에서 임시 문서 연결",

    // Create Assignment Labels
    addAssignmentlabels: {
        modalTitle: "배정 추가",
        modalDescription: "마치려면 이름을 입력하고 저장을 클릭하십시오",
        assignmentNameLabel: "배정 이름",
        assignmentNameErrorMessage: "Assignment 이름은 비워둘 수 없습니다",
        saveAndClose: "저장 & 닫기",
        saveAndAdd: "저장 & 추가",
        addSuccessMessage: "배정이 추가됐습니다"
    },
    addUserOrRoleLabelto: "사용자 또는 역할 추가 대상",
    addUserOrRoleheader: "추가하려는 팀 멤버 또는 역할 검색",
    saveAndAdd: "저장 & 추가",

    // Bulk Assignment
    BulkActionsLabel: "일괄 작업",
    BulkAssignmentAction: "작업",
    BulkShow: "표시",
    BulkActionsInstructionalText: "끌어서 놓기를 사용하여 task를 한꺼번에 그룹화하십시오. 특정 task 그룹에서 개별 task를 보려면 task 그룹에 마우스를 놓고 화살표 아이콘을 클릭하십시오.",
    bulkOperationsModalDescription: "Task 일괄 작업을 수행하십시오. Task 그룹별 개별 task를 보려면 task 그룹에 마우스를 놓고 화살표 아이콘을 클릭하십시오.",
    selectRequest: "전송할 요청을 선택하십시오",
    replaceLabel: "교체",
    labelStaff: "staff -",
    addModeLabel: "추가",
    replaceModeLabel: "교체",
    dueDateModeLabel: "만료일 업데이트",
    searchByAssignmentName: "검색",
    addTeamMemberLabel: "팀 멤버 추가",
    noTeamMembersFound: "가능한 팀 멤버 없음",
    addMemberSuccessMessage: "팀 멤버가 추가됐습니다",
    addAssignmentLabel: "배정 추가",
    addAssignmentNameLabel: "배정 이름 추가",
    noAvailableAssignmentsMessage: "사용 가능한 배정 없음",
    showDuplicateError: "선택한 팀 멤버 또는 역할에는 선택한 task를 중복 배정할 수 없습니다. 계속하려면 다른 배정, 팀 멤버 또는 역할을 선택하십시오.",
    infoBulkAssignments: "대량 배정",
    infoBulkAssignmentDesc: "신규 배정을 생성하거나 기존 배정을 교체하려면 task 그룹을 하나 이상 선택하십시오. 배정을 생성하거나 편집한 경우, 현재 배정된 팀 멤버는 배정이 가장 먼저 만료되는 팀 멤버로 재계산됩니다.",
    infoAssignmentsDueDate: "배정 만료일 설정",
	infoAssignmentsDueDateDesc: '날짜 선택 / 날짜 계산 " 토글로 배정 만료일을 설정하십시오. 토글은 task에 특정 만료일이나 시기 종료일 전 남은 기간을 지정하는 데 사용할 수 있습니다.',
    infoAddAssignmentExisting: "기존 팀 멤버에게 배정 추가",
    infoAddAssignmentExistingDesc: "배정을 추가하려면 만료일까지 남은 날짜를 설정해야 합니다. 또는 달력 통제를 사용하여 정확한 만료일을 설정할 수 있습니다. 이를 수행하고 나면, 선택한 항목을 끌어서 놓아 신규 배정 설정을 생성합니다.",
    infoAddAssignmentNew: "신규 팀 멤버에게 배정 추가",
    infoAddAssignmentNewDesc: "주어진 배정에 팀 멤버 또는 역할이 표시되지 않으면, 팀 멤버 추가를 클릭하여 사용 가능한 팀 멤버 또는 역할 목록을 봅니다. 선택하고 나면, 해당 팀 멤버는 목록 하단에 추가되어 배정을 끌어서 놓을 수 있습니다.",
    infoRemove: "배정 제거",
    infoRemoveDesc: "배정을 제거하려면 하나 이상의 항목을 배정 이름 아래 팀 멤버로 끌어오십시오. 해당 팀 멤버에게 미완료 배정이 있는 경우 제거됩니다. 완료된 배정은 제거되지 않습니다.",
    infoReplace: "배정 바꾸기",
    infoReplaceDesc: "배정을 바꿀 때, 하나 이상의 항목을 배정 이름 아래에 있는 팀 멤버에게 끌어서 놓습니다. 동일한 배정 이름을 가진 기존 배정은 선택한 팀 멤버에게 재배정됩니다. 해당 배정 이름에 대해 여러 팀 멤버에게 배정이 있다면, 선택한 사용자로 통합됩니다. 배정 바꾸기를 사용할 때 남은 날짜를 설정하는 것은 선택사항입니다. 남은 날짜를 설정하지 않으면 기존 남은 날짜가 적용됩니다.",
    infoUpdateDueDate: "남은 날짜 업데이트",
	infoUpdateDueDateDesc: '날짜 선택 " 또는 "날짜 계산 "으로 새로운 "만료 전 기간"을 설정하고 나서 만료 전 기간을 변경할 팀 멤버에게 끌어서 놓습니다. 그 팀 멤버의 처리 전 및 진행 중 배정에 만료 전 기간이 업데이트됩니다. 완료된 배정은 변경되지 않습니다. ',
    infoDelete: "배정 삭제",
    infoDeleteDesc: "오른쪽에 있는 배정을 클릭하면 해당 배정 설정을 삭제할 수 있는 옵션이 나타납니다",
    infoExecutive: "Executive 배정",
    infoExecutiveDesc: "Executive에게 적용되는 task를 필터링하여 더 빠르게 배정하려면 필터와 검색 기능을 사용합니다",
    infoSpecificTask: "특정 task에 배정",
    infoSpecificTaskDesc: "Task 수준에서 배정해야 하는 경우, 왼쪽 그룹에 마우스를 가져가 개별 task를 볼 수 있는 옵션을 선택합니다. 이렇게 하면 그룹의 개별 task가 표시되고 세밀하게 배정할 수 있습니다",
    unassignedLabel: "배정되지 않음",
    replaceSignleSuccessMessage: "task가 업데이트됐습니다",
    replaceMultipleSuccessMessage: "task가 업데이트됐습니다",
    dueDateSingleSuccessMessage: "배정이 업데이트됐습니다",
    dueDateMultipleSuccessMessage: "배정이 업데이트됐습니다",
    invalidAssignmentUpdate: "남은 날짜를 업데이트하려면 task를 동일한 사람에게 배정하십시오",
    removeSuccessMessage: "배정이 업데이트됐습니다",
    colorCode: "색상 코드",
    removeSuccessSingleMessage: "배정이 업데이트됐습니다",
    removeSuccessMultipleMessage: "배정이 업데이트됐습니다",
    assignmentRemovedSuccessfully: "배정이 제거됐습니다",

    // Bulk Task
    itemsSelected: "task 선택됨",
    itemSelected: "task 선택됨",
    dragAndDrop: "끌어서 놓기",
    currentApplication: "Current application",
    allAssignmentsClosed: "모든 배정 닫힘",
    allAssignmentsCompleted: "모든 배정 완료됨",

    onOrBeforeCurrentDate: "오늘 이전",
    withInCurrentWeek: "이번 주",
    quickFilter: "빠른 필터",
    suggestedFilters: "권장 필터",
    showXMore: "{0} 더 표시",

    // Task due date Events
    addEventlabels: {
        modalTitle: "사건 추가",
        startDateLabel: "시작일",
        modalDescription: "정보를 추가하고 저장&닫기 또는 저장 &추가를 클릭하십시오",
        eventNameLabel: "사건 이름",
        eventType: "사건 유형",
        singleDay: "하루",
        dateRange: "날짜 범위",
        eventDate: "사건 날짜",
        eventDescription: "설명 (선택사항)",
        isEvent: "고객과 사건 공유",
        EventNameErrorMessage: "사건 이름은 필수입니다",
        eventDateErrorMessage: "사건 날짜는 필수입니다",
        addSuccessMessage: "사건이 추가됐습니다"
    },

    // Bulk Notes
    DeleteSomeNotesAreClosed: "<b>선택한 노트 중 일부만 닫힘 상태이며 삭제할 수 있습니다.</b> <br /> 계속을 선택하면 아래 열거된 노트가 삭제됩니다.",
    DeleteSomeNotesAreNotClosed: "아래 열거된 노트는 닫히지 않아서 삭제할 수 없습니다",
    DeleteDontHaveClosedNotes: "아래 열거된 노트는 닫히지 않아서 삭제할 수 없습니다",
    someNotesAreOpen: "<b>선택한 노트 중 일부만 처리 전 상태입니다.</b> <br/> 계속을 선택하면 아래 열거된 노트가 업데이트됩니다.",
    someNotesAreNotOpen: "아래 열거된 노트는 이미 처리됐거나 닫혀서 업데이트할 수 없습니다",
    dontHaveOpenNotes: "아래 열거된 노트는 이미 처리됐거나 닫혀서 업데이트할 수 없습니다",
    ShowNumberMore: "{0} 더 표시",

    // Drag and Drop
    assignmentLabel: "배정",
    assignmentsLabel: "배정",
    singleAssignmentCreatedMessage: "배정이 생성됐습니다",
    multipleAssignmentCreatedMessage: "배정이 생성됐습니다",
    daysPriorWarning: "배정 생성 전에 만료 전 날짜를 설정합니다",



    // Related Tasks - Engagement selector
    selectEngagement: "Engagement 선택",
    thisEngagement: "이 engagement",
    noResultsFoundLabel: "결과를 찾을 수 없습니다",
    taskLocationLabel: "Task 위치",

    // Delete Assginment
    deleteDescription: "배정 삭제는 실행 취소할 수 없습니다. 계속하시겠습니까?",
    deleteAssignmentModalTitle: "배정 삭제",
    deleteSingleSuccessMessage: "배정이 삭제됐습니다",
    deleteMultipleSuccessMessage: "배정이 삭제됐습니다",
    teamMemberLabel: "팀 멤버",
    assignedTasksCountLable: "배정 task",
    deleteAssignmentLabel: "배정",
    selectengagement: "Engagement 선택",

    //Due Days
    dueDateTitle: "만료일 입력",
    dueDatedescription: "시기 만료일 며칠 전에 배정을 완료해야 하는지 입력하십시오",
    dueDateAssign: "배정",
    dueDateSelect: "선택",
    dueDateCalculate: "계산",

    // Tasklist - bulk markcomplete
    markComplete: "완료 표시",
    markCompleteMessgae1: "<b>선택한 task를 완료</b>하시겠습니까? <br /> 선택한 task에 있는 미완료 배정은 닫힙니다.",
    markCompleteMessgae2: "선택한 task 중 일부만 완료 표시할 수 있습니다. <br /> 계속하기로 선택하면, <b>아래 열거된 task는 완료 표시됩니다</b>. 미완료 배정은 닫힙니다.",
    markCompleteMessgae3: "<b> 아래 열거된 task는 완료 표시되지 않습니다</b>. 연결된 증거가 없거나 연결된 증거에 sign-off가 누락됐기 때문입니다.",
    markCompleteMessgae4: "<b> 아래 열거된 task는 완료 표시할 수 없습니다</b>. 연결된 증거가 없거나 연결된 증거에 sign-off가 누락됐기 때문입니다.",

    // Tasklist - bulk handoff
    handOffLabel: "Hand-off",
    confirmHandOff: "Hand-off 확인",
    handOffMessgae1: "배정된 다음 팀 멤버에게 <b>선택한 task를 hand-off</b>하시겠습니까? <br /> 선택한 task에 있는 미완료 배정은 닫힙니다.",
    handOffMessgae2: "선택한 task 중 일부에만 배정된 다른 팀 멤버가 있습니다. <br /> 계속하기로 선택하면, <b>아래 열거된 task는 hand-off됩니다</b>. 선택한 task에 있는 미완료 배정은 닫힙니다.",
    handOffMessgae3: "<b> 아래 열거된 task는 hand-off되지 않습니다</b>. 미완료 배정이 없기 때문입니다.",
    handOffMessgae4: "<b> 아래 열거된 task는 hand-off할 수 없습니다</b>. 미완료 배정이 없기 때문입니다.",
    closeMyAssignments: "내 배정 닫기",

    saveQuickFilter: "빠른 필터 저장",
    saveQuickFilterModalHeader: "적용한 필터 칩을 빠른 필터로 저장하십시오",
    saveQuickFilterModalText: "이 engagement에 다시 접근할 때 시간을 절약하려면 저장된 빠른 필터와 권장 빠른 필터를 선택하십시오. Engagement별로 저장된 빠른 필터를 5개까지 생성할 수 있습니다.",
    quickfiltername: "빠른 필터 이름",
    taskCategory: "Task 범주",

    cannotsavefilter: "사용자지정 빠른 필터를 저장할 수 없습니다",
    cannotsavefiltermodalheadertext: "<b>Engagement별로 사용자지정 빠른 필터를 5개만 저장할 수 있습니다.</b> <br /> 계속하려면 기존 사용자지정 빠른 필터 중 하나를 삭제하고 다시 시도하십시오.",
    savedFilters: "저장된 필터",
    taskassignedto: "Task 담당자",
    noteassignedto: "노트 담당자",
    taskPrefix: "Task prefix",
    taskSuffix: "Task suffix",

    // Mark complete/HandOff Evidences category
    noSignOffs: "Sign-off 없음",
    noSignOffsByMe: "내 sign-off 없음",
    myPreparerSignOffs: "내 작성자 sign-off",
    myReviewerSignOffs: "내 검토자 sign-off",
    myPreparerAndReviewerSignOffs: "내 작성자 및 검토자 sign-off",

    notificationDownErrorMessage: "알림 기능을 잠시 사용할 수 없습니다. 페이지를 새로 고침하여 다시 시도하십시오. 오류가 지속되면 헬프 데스크에 문의하십시오.",
    notificationUpbutSomeLoadingErrorMessage: "알림 센터를 잠시 사용할 수 없습니다. 페이지를 새로 고침하여 다시 시도하십시오. 잠시 후 사용할 수 있습니다.",

    timeTrackerErrorFallBackMessage: "시간 추적 기능을 잠시 사용할 수 없습니다. 페이지를 새로 고침하여 다시 시도하십시오. 오류가 지속되면 헬프 데스크에 문의하십시오.",
    timeTrackerLoadingFallbackMessage: "시간 추적 기능을 잠시 사용할 수 없습니다. 잠시 후 사용할 수 있습니다.",

    signOffOnAllAs: "다음 역할로 모두 sign-off",
    accountType: "계정 유형",

    openDocumentInstructionalText: "이 문서는 자동으로 열립니다.<b>문서를 열기 위해 클릭하지 않아도 됩니다.</b><br>문서가 열리면 이 탭을 닫으십시오.",
    closeTab: "탭 닫기",

    // Build Step - Add Due Date
    milestones: "Milestone",
    events: "사건",
    noTimePhasesHaveBeenIdentified: "시기가 식별되지 않았습니다",

    wcgws: "WCGW",
    relatedControls: "연결된 통제",
    relatedControlsWCGWsRatio: "연결된 통제/ WCGW",
    wcgwsToControlsRatio: "통제 대비 WCGW 비율",
    controlsToWCGWsRatio: "WCGW 대비 통제 비율",
    testedControls: "테스트된 통제",

    // Collaboration request to Task relation
    CollaborationModalTitle: "Task에 요청사항 연결",
    CollaborationModalDescription: "Task에 요청을 연결하려면, 아래 task에 요청을 하나 이상 끌어서 놓으십시오",
    noDataFound: "데이터를 찾을 수 없습니다",
    taskName: "Task",
    showMessage: "시작하려면 범주와 task 그룹을 선택하십시오",
    showCategory: "범주",
    showTaskGroup: "Task 그룹",
    optionITProcesses: "IT 프로세스",
    optionExecutionGeneral: "실행 일반",
    relatedRequestsLabel: "연결된 요청사항",
    relatedRequestsFormatted: "연결된 요청사항 {0}개",
    relatedRequestFormatted: "연결된 요청사항 {0}개",
    relatedRequests: "연결된 요청사항",
    relatedTasks: "연결된 task",
    relatedSuccessSingleMessage: "{0} 요청이 task에 연결됐습니다",
    relatedSuccessMultipleMessage: "{0} 요청이 task에 연결됐습니다",
    showUnrelated: "연결되지 않은 {0} 표시",
    unrelate: "연결 해제",
    noRequestsMessage: "사용 가능한 요청사항 없음",
    requestNumber: "요청 번호",
    sortAscending: "오름차순 정렬",
    sortDescending: "내림차순 정렬",
    removeSorting: 'Remove sorting',

    // PIC Dashboard
    groupBy: "그룹 기준",
    allTasks: "모든 task",
    iTSOs: "IT/SO",
    generalExecution: "일반 실행",
    PICSignOff: "PIC sign-off",
    EQRSignOff: "EQR sign-off",
    completed: "완료됨",
    allAssigned: "모두 배정됨",
    picTaskAssignmentLabel: "귀하의 배정",
    assignReadyForReview: "현재",
    assignUpcomingForReview: "임박",
    assignReadyForReviewTasks: "현재 배정",
    assignUpcomingForReviewTasks: "임박한 배정",
    picTaskSignoffInComplete: "<b>PIC</b> sign-off 미완료 task",
    picDocSignoffInComplete: "<b>PIC</b> sign-off 미완료 문서",
    eqrTaskSignoffInComplete: "<b>EQR</b> sign-off 미완료 task",
    eqrDocSignoffInComplete: "<b>EQR</b> sign-off 미완료 문서",
    collapseCards: "카드 축소",
    expandCards: "카드 확장",
    noUserSelectedPlaceholder1: "{0}이(가) 식별되거나 engagement에 초대되지 않았습니다",
    noUserSelectedPlaceholder2: "여기를 클릭하여",
    noUserSelectedPlaceholder3: "{0}를 식별하거나 초대하십시오",
    notInvitedLabel: "초대되지 않음",
    noTasksPlaceholder: "이 감사 단계에서 <br/>milestone에 연결된 task가 없습니다",
    noTasksTilesPlaceholder: "선택한 사용자에게 배정된 task 없음",
    noAssignmentPlaceholder: "발견된 배정 없음",
    dueDateAssignmentPlaceholder: "만료일별 배정",
    countAssignmentPlaceholder: "배정 개수",
    OverduetPlaceholder: "지연",
    TodayPlaceholder: "오늘",
    tasksView: "Task 보기",
    documentsView: "문서 보기",
    picAndEqr: "PIC & EQR",
    ResponsiveToSR: "⚡SR에 연결됨",
    responsiveToFR: "⚡FR에 연결됨",
    relatedTasksFormatted: "{0} 연결된 task",
    relatedTaskFormatted: "{0} 연결된 task",
    autoAssignWarning2: "click here",
    toAssign: "to assign",
    taskAssignWarning: "task에 {0} sign-off 요건 배정되지 않음",
    tasksAssignWarning: "task에 {0} sign-off 요건 배정되지 않음",
    taskAdditionalFuncText1: "<b>이 task에 추가 기능이 있습니다. 그리 이동하려면 </b>",
    taskAdditionalFuncText2: "<b>하십시오.</b><p>PIC/EQR 리뷰가 필요하지 않은 Build Task는 완료 표시하기 위해 증거를 연결할 필요가 없습니다.</p>",
    taskadditionalfunctionality: "<b>이 task에 추가 기능이 있습니다. 추가 기능으로 이동하려면 </b> {0} <b>하십시오.</b><p>이 task에 PIC/EQR 검토가 필요하지 않은 한, Build Task는 완료 표시하기 위해 증거를 연결할 필요가 없습니다. </p>",
    taskclickhere: "여기를 클릭하여",
    taskAutoAssignModalTitle: "자동 배정",
	taskAutoAssignModalDescription: 'EQR sign-off 요건이 있는 {0} task에 {1}이(가) 배정되지 않았습니다. "배정"을 클릭하여 {1}에게 EQR 배정을 생성하십시오. ',
	tasksAutoAssignModalDescription: 'EQR sign-off 요건이 있는 {0} task에 {1}이(가) 배정되지 않았습니다. "배정"을 클릭하여 {1}에게 EQR 배정을 생성하십시오. ',
    picTaskAutoAssignSuccessMessage: "task with PIC sign-off requirement assigned to",
    picTasksAutoAssignSuccessMessage: "tasks with PIC sign-off requirement assigned to",
    eqrTaskAutoAssignSuccessMessage: "task with EQR sign-off requirement assigned to",
    eqrTasksAutoAssignSuccessMessage: "tasks with EQR sign-off requirement assigned to",
    taskEntityDocumentValidationMsg: "이 task에 대응 증거가 없는 기업이 있습니다.  추가 문서화가 필요한 기업을 보려면 기업별 보기로 토글하십시오.",
    // PIC/EQR Sign-Off validation message
    picSignOffValidationMsg: "이 task는 PIC sign-off가 필요하지만, PIC 문서가 연결되지 않았습니다. 이 요건이 있는 문서를 하나 이상 추가하십시오.",
    eqrSignOffValidationMsg: "이 task는 EQR sign-off가 필요하지만, EQR 문서가 연결되지 않았습니다. 이 요건이 있는 문서를 하나 이상 추가하십시오.",
    picAndEQRSignOffValidationMsg: "이 task는 PIC/EQR sign-off가 필요하지만 PIC/EQR 문서가 연결되지 않았습니다. 이 요건이 있는 문서를 하나 이상 추가하십시오.",
    updateDataOnPicEqrDashboardBannerMessage: "변경사항이 아래에 업데이트되지 않았습니다. {0} 페이지를 새로 고침하십시오.",
    showMissingSignOffByLabel: "{0} sign-off 누락 문서 표시",

    FindingsReportName: "발견사항",
    FindingsDeficiencyReportTabName: "미비점",
    FindingsMisstatementReportTabName: "왜곡표시",
    FindingsDeficiencyITReportTabName: "미비점-IT",
    auditPlanRelatedEvidenceReporLabel: "감사 계획 및 연결된 증거",
    groupStructureSummaryReportReportLabel: "그룹 구조 요약",
    auditPlanReportLabel: "감사 계획 보고서",
    itAppSOSummaryReportLabel: "IT App/SO 요약",
    craSummaryReportLabel: "CRA 요약",
    teamMembersLabel: "팀 멤버",
    ipeLabel: 'Information produced by the entity (IPE)',
    validationChecksReportLabel: "유효성 검증",
    trialBalanceReportLabel: "시산표",
    trialBalanceReportTabLabel: "시산표 보고서",
    reportLabelYes: "예",
    reportLabelNo: "아니오",
    assignedBy: "배정한 사람",
    openInReviewNotesHub: "리뷰노트 허브에서 열기",
    nextNote: "다음",
    previousNote: "이전",

    //component team group tab names
    accountInfoCanvasFormExport: "계정 정보",

    //project insight tab names
    projectInsightCanvasFormExport: "Canvas 양식 내보내기",
    projectInsightSCOTToWCGWToControl: "SCOT - WCGW - 통제",
    projectInsightControlToITApplication: "통제 - IT application",
    projectInsightControlToAssertion: "통제 - 경영진주장",
    projectInsightRiskToWCGW: "WCGW 대 위험",

    //IPE Report
    ipeControlsReport: 'Controls',
    ipeSubstantiveReport: 'Substantive',
    ipeITGCReport: 'ITGC',

    // Milestone tab names
    milestonesReport: "Milestone 보고서",
    unmappedTasks: "매핑되지 않은 task",

    // Effective
    isEffective: "Effective",
    inEffective: "Ineffective",
    nonEffective: "Non Effective",

    clientRequests: "고객 요청사항",
    externalTasks: "외부 task",
    requestPriority: "우선순위 요청",
    scot: "SCOT",
    assertionR: "경영진주장",
    wcgwToControlMappingTotal: "WCGW 대 통제 매핑 합계",

    //CRA build step
    buildStep2EntityHeaderText: "유의적인 계정 및 공시, 경영진주장, 관련 WCGW 및 통제",
    buildStep4EntityHeaderText: "유의적인 계정, 공시 및 관련 경영진주장",
    accountNameHeader: "유의적인 계정 및 공시",
    noAssertionsLabel: "연결된 경영진주장 없음. 시작하려면 <a>계정 및 공시 관리</a>를 클릭하십시오.",
    noAssertionsBuildStep2text1: "이 계정에 경영진주장을 하나 이상 연결해야 합니다.",
    accountWithoutAssertionsBuildStep2text1: "각 유의적인 계정 또는 공시에는 경영진주장을 하나 이상 연결해야 합니다. Click",
    noAssertionsBuildStep2text2: "계정 및 공시 관리",
	noAccountsLabel: '유의적인 계정 또는 공시가 생성되지 않았습니다. 시작하려면 <span class="bold-text">계정 및 공시 관리</span>를 클릭하십시오.',
	noAccountsLabelPlaceHolder: '유의적인 계정 또는 공시가 생성되지 않았습니다. 시작하려면 <span class="bold-text">계정 및 공시 관리</span>를 하십시오.',
    noAccountsOrDiscloserPreText: "유의적인 계정 또는 공시가 생성되지 않았습니다",
    noAccountsOrDiscloserText: "계정 및 공시 관리",
    noAccountsOrDiscloserPostText: "로 시작하십시오",
    noAssertionsBuildStep1text1: "이 위험에 경영진주장을 하나 이상 연결해야 합니다.",
    noAssertionsBuildStep1text1Msg: "각 위험에는 경영진주장을 하나 이상 연결해야 합니다",
    noAssertionsBuildStep1text2: "경영진주장 연결을",
    noAssertionsBuildStep1text3: "시작하려면",
    editRisk: "위험 편집",
    deleteRisk: "위험 삭제",
    noControlsRelatedWWCGW: "연결된 통제 없음",
    noControlsRelatedWCGW: "통제위험이 의존인 경영진주장에 연결된 WCGW마다 테스트할 통제를 하나 이상 선택해야 합니다.",
    noControlsRelatedWCGWNewCont: " 신규 통제 생성",
    noControlsRelatedWCGWor: "또는",
    noControlsRelatedWCGWRelateCont: " 기존 통제 연결",
    noControlsForWCGW: "의존하지 않는 통제위험이 있는 경영진주장은 통제를 식별할 필요가 없습니다",
    noControlsRelatedWCGWFooter: "하여 시작하십시오.",
    relateWCGWs: "<a>WCGW 연결</a>",
    noWCGWs: "연결된 WCGW 없음",
    noWCGWsClick: " Click",
    noWCGWsFooter: " to get started.",
    showOnlyRisksWithNoAssertion: "경영진주장이 연결되지 않은 위험만 표시",
    showIncomplete: "미완료 CRA가 있는 경영진주장만 표시",
    showOnlyInvalidBuildStep2: "필수 세부정보가 누락된 계정만 표시",
    noTestedControlsWithRelyAssertion: "통제위험이 의존인 경영진주장에 연결된 WCGW마다 테스트할 통제를 하나 이상 선택해야 합니다",

    // Account build step
    accountOrDisclosure: "계정 / 공시",
    relatedAssertions: "연결된 경영진주장",
    relatedAccountsAndAssertions: "연결된 계정 및 경영진주장",
    pspIndexTitle: "PSP index",
    statementTypeTitle: "재무제표 유형",
    significantAccountLabel: "유의적",
    limitedRiskLabel: "Limited risk",
    insignificant: "InSignificant",
    significantDiscloure: "유의적인 공시",
	accountAddedMessage: '계정 "##"이(가) 생성됐습니다',
    accounHeaderText: "계정 및 공시",

    // Add accounts / disclosures Modal labels
    accountsListTitle: "계정 / 공시 및 연결된 경영진주장",
    addAccountsDisclosures: "계정 / 공시 추가",
    editAccountsDisclosures: "계정/공시 편집",
    accountNameLabel: "계정 이름 (필수)",
    accountDesignationLabel: "지정 (필수)",
    accountEstimateLabel: "계정에 추정치가 있습니다",
    accountStatementTypeLabel: "재무제표 유형 (필수)",
    pspIndexDropdownLabel: "PSP index (필수)",
    removePSPIndexLabel: "PSP index 제거",
    assertionsLabel: "경영진주장 (필수)",
    noAccounsMessage: "계정을 찾을 수 없습니다. 시작하려면 계정을 추가하십시오.",

    //Delete account / disclosure modal labels
    deleteAccountDisclosure: "계정/공시 삭제",
    deleteAcConfirmMessage: "계정/공시 {0}을(를) 삭제하시겠습니까? 연결된 경영진주장은 모두 삭제됩니다. 선택한 계정/공시에만 연결된 task도 삭제됩니다.",

    true: "참",
    false: "거짓",
    taskSummaryReportEngagementInfo: "복수 engagement",
    viewPriority: "우선순위 보기",
    priorityRequestsSent: "우선순위 요청사항 전송됨",

    //reactive frame
    maxTabsLocked: "최대 허용 탭 수에 도달했습니다. 새 탭을 열려면 탭 하나를 고정 해지하고 닫으십시오.",
    openInNewTab: "신규 탭에서 열기",
    copyLink: "링크 복사",
    copySuccess: "클립보드에 복사된 링크",
    copyFailure: "클립보드에 링크 복사 실패",
    minimize: "최소화",

    //Risk status for account cards
    riskStatusLabels: {
        NoAssertionsAvailableLabel: "사용 가능한 경영진주장 없음",
        SignificanceNotSelectedLabel: "유의성 미선택",
        InsignificantLabel: "비유의적"
    },

    lockTab: "탭 고정",
    keyDocuments: "주요 문서",
    suggestedDocuments: "권장 문서",
    noSuggestedDocuments: "권장 문서 없음",
    exitBulkMode: "일괄 모드 종료",
    bulkLabel: "일괄",

    me: "Me",
    viewByUser: "사용자별 보기",
    unsentDraftCapitalized: "미전송 초안",
    picSignoffInComplete: "PIC sign-off 미완료",
    eqrSignOffIncomplete: "EQR Sign-off 미완료",

    tableView: "표 보기",
    noRelatedAssertions: "연결된 경영진주장 없음",

    multiEntityTileMessage1: "기업별 상태를 보려면",
    multiEntityTileMessage2: "여기",
    multiEntityTileMessage3: "을(를) 클릭하십시오",
    allItemsMessage: " to see all items",

    EntitySelector: "시작하려면 기업을 선택하십시오",
    allEntities: "모든 기업",
    multiEntity: "Multi-entity",
    ungrouped: "그룹화되지 않음",
    numberSelected: "{0} 선택됨",
    allTimePhases: "모두",
    timePhases: "시기",
    noTimePhaseFound: "시기를 찾을 수 없습니다",
    unrelatedAssignments: "연결되지 않은 배정",
    unrelatedRequests: "연결되지 않은 요청사항",
    relateRequests: "요청사항 연결",
    taskWithoutAnyAssignments: "배정이 없는 task",
    privacyNotice: "개인정보보호 고지",
    lastPublishedAndSent: "최근 발간되고 전송됨",
    drafts: "초안",
    allEntitiesTask: "모든 기업에 연결된 engagement 차원 task입니다",
    noRelatedEntities: "연결된 기업 없음",
    clickNewRisk: "시작하십시오",
    relatedAccountsDisclosuresAndAssertions: "관련 유의적인 계정, 공시 및 경영진주장",
    relateAssertion: "경영진주장 연결",
    taskByEntity: "기업별 task",
    engagementWideTask: "Engagement 차원 task",
    componentEngagementPill: "CT",
    primaryAndComponentEngagementPill: "PT/CT",
    // Scot build steps
    scotHeader: "SCOT",
    searchScot: "검색",
    manageScots: "SCOT 관리",
    superModelStep1ScotMessage: "유의적인 계정, 공시 및 관련 SCOT",
    scotRelatedITApplicationServiceOrg: "SCOT 및 관련 IT application과 서비스조직",
    noScotsAvailable: "결과를 찾을 수 없습니다",
    searchScotPlaceholder: "검색",
    searchScotClearHoverText: "처리",
    showOnlyUnrelatedScotToggleSwitch: "연결되지 않은 항목만 표시",
    newScot: "신규 SCOT",
    importFromKnowledgeScot: "SCOT 불러오기",
    importAccountsAndDisclosures: "계정 및 공시 불러오기",
    showOnlyAccountRelatedScot: "유의적인 계정 및 공시가 연결되지 않은 SCOT만 표시",
    warningMessageEstimateScotNotAssociatedWithEstimatedAccount: "각 추정 SCOT에는 추정치가 있는 유의적인 계정 또는 유의적인 공시를 하나 이상 연결해야 합니다. 관련 유의적인 계정 또는 유의적인 공시에 이 SCOT을 끌어서 놓으십시오.",
    warningMessageScotNotAssociatedWithAccount: "각 SCOT에는 유의적인 계정 또는 유의적인 공시를 하나 이상 연결해야 합니다. 관련 유의적인 계정 또는 유의적인 공시에 이 SCOT을 끌어서 놓으십시오.",
    showvalidations: "유효성 검증 표시",

    scotRelatedWCGWandControls: "SCOT, 관련 WCGW 및 통제",
    newWcgw: "신규 WCGW",
    manageWCGWs: "WCGW 관리",
    manageControl: "통제 관리",
    importWCGWs: "WCGW 불러오기",
    relateWCGWs: "WCGW 연결",
    newControl: "신규 통제",
    importControl: "통제 불러오기",
    importControls: "통제 불러오기",
    relateControl: "통제 연결",
    scotStrategyIsControlMessage: "이 WCGW에 식별된 통제 없음. SCOT 전략이 정의되지 않았습니다.",
    scotStrategyIsWCGWMessage: "이 SCOT에 식별된 WCGW 없음. SCOT 전략이 정의되지 않았습니다.",
    controlsPlaceholderWithNoRelatedWCGWsMessage: "각 SCOT에는 WCGW을 하나 이상 연결해야 합니다.",
    controlsPlaceholderWithNoRelatedControlsMessage: "각 WCGW에는 통제를 하나 이상 연결해야 합니다.",
    noITApplicationSOMessage: "이 SCOT에 식별된 IT Application 또는 서비스조직 없음.",
    relatedItAppSOHeaderMessage: "연결된 IT application/서비스조직",
    substantivePlaceholderWithNoRelatedControlsMessage: "이 SCOT에 식별된 통제 없음. 실증 전략 SCOT에 통제를 식별할 필요가 없습니다.",
    substantivePlaceholderWithNoRelatedWCGWsMessage: "이 SCOT에 식별된 WCGW 없음. 실증 전략 SCOT에 WCGW을 식별할 필요가 없습니다.",
    noITApplicationSOMessageText: "을(를) 클릭하여 필요한 경우 연결하십시오",
    notSelected: "미선택",
    or: "또는",

    //WCGWControls
    showOnlyWCGWRelatedControls: "연결된 항목만 표시",

    createorRelateControl: "신규 통제를 생성하거나 기존 통제를 연결하십시오",

    //Accounts Scot build steps
    accountHeader: "계정",
    searchAccount: "계정 검색",
    searchAccountPlaceholder: "검색",
    manageAccounts: " 계정 및 공시 관리",
    showOnlyUnrelatedAccountToggleSwitch: "연결되지 않은 항목만 표시",
    searchAccountClearHoverText: "처리",
    noAccountsAvailable: "결과를 찾을 수 없습니다",
    showOnlyScotRelatedAccount: "SCOT이 연결되지 않은 유의적인 계정 및 공시만 표시",
    warningMessageEstimateAccountNotAssociatedWithEstimatedScot: "추정치가 있는 각 유의적인 계정 또는 공시에는 추정 SCOT을 하나 이상 연결해야 합니다. 이 유의적인 계정 또는 유의적인 공시에 기존 관련 SCOT을 끌어서 놓으십시오.",
    warningMessageAccountNotAssociatedWithScot: "각 유의적인 계정 및 공시에는 SCOT을 하나 이상 연결해야 합니다. 이 유의적인 계정 또는 유의적인 공시에 기존 관련 SCOT을 끌어서 놓으십시오.",
    significantAccountsAndDisclosures: "유의적인 계정 및 공시",
    // Independence Only

    independenceOnlyStatus: "독립성 전용",

    //Controls
    controlDesignEffectivenessWarningValidation: "통제는 설계 효과성을 선택해야 합니다",
    controlHeader: "SCOT 및 관련 통제",
    manageControls: "통제 관리",
    manageITApplications: "IT application 관리",
    searchControlClearHoverText: "처리",
    searchControlPlaceholder: "검색",
    noControlsAvailable: "결과를 찾을 수 없습니다",
    controlName: "통제 이름",
    frequency: "빈도",
    type: "유형",
    newSO: "신규 SO",
    designEffectiveness: "설계 효과성",
    testing: "테스트",
    strategyTypeName: "SCOT 전략",
    controlTestingYes: "예",
    controlTestingNo: "아니오",
    effective: "효과적",
    ineffective: "비효과적",
    noControlsResult: "결과를 찾을 수 없습니다",
    noControlsLabel: "결과를 찾을 수 없습니다",
    relatedControl: "연결된 통제",
    relateControls: "통제 연결",
    controlTypeValues: {
        itApplication: "IT Application 통제",
        itDependentManual: "IT 의존 수동 통제",
        manualPrevent: "수동 예방",
        manualDetect: "수동 적발"
    },
    controlFrequencyTypes: {
        manyTimesPerDay: "하루에 여러 번",
        daily: "매일",
        weekly: "매주",
        monthly: "매월",
        quarterly: "매분기",
        annually: "매년",
        iTApplicationControl: "IT Application 통제",
        other: "기타"
    },
    filterTypeOfScots: "SCOT",
    noScotsAvailable: "결과를 찾을 수 없습니다",


    onlyShowControlsWithNoDesignEffectiveness: "설계 효과성이 선택되지 않은 통제만 표시",

    // control Tasks
    controlCount: "{0} 통제",

    //Create and Edit WCGW
    wcgwInputName: "WCGW 이름",
    editWCGW: "WCGW 편집",
    createNewWCGW: "신규 WCGW 생성",
    editTheWCGW: "WCGW 편집",
    createEditWCGWSave: "저장",
    createEditWCGWClose: "취소",
    createEditWCGWModelScot: "SCOT",
    newWCGWTitel: "신규 WCGW",
    wcgwNameIsRequired: "WCGW 이름은 필수입니다",
    deleteWCGW: "WCGW 삭제",


    //Audit Plan
    importPSPButtonText: "PSP 불러오기",
    commonContentUpdateSuccessMessage: "내용 업데이트 진행 중. 완료하는 데 최대 15분까지 소요될 수 있습니다. 새로 불러온 PSP를 보려면 페이지를 새로 고침하십시오.",
    responsivetoRisks: "위험에 대응",
    procedures: "절차",
    toc: "TOC",
    significantandFraudRisksHeading: "유의적인 위험, 부정 위험, 대응 절차 및 통제",
    risksBeingRespondedToByComponentTeam: "위험은 부문 팀이 대응하고 있습니다",
    responsivecontrolsandTOCs: "대응 통제 및 TOC",
    ResponsivePSPOSP: "대응 PSP/OSP",
    responsivePSPsOSPs: "대응 PSP/OSP",
    responsiveTOC: "대응 TOC",
    responsiveControl: "대응 통제",
    responsivePSPOPSMessage: "이 위험에 대한 이 경영진주장에 대응하는 실증절차를 하나 이상 식별해야 합니다. {0}을(를) 클릭하여 대응하는 실증절차를 식별하십시오.",
    responsiveControlMessage: "이 위험에 대한 이 경영진주장에 대응하는 (설계 효과성 평가가 완료된) 통제를 하나 이상 식별해야 합니다. {0}을(를) 클릭하여 대응 통제를 식별하십시오. {1}을(를) 클릭하여 설계 효과성 또는 테스트 전략을 설정하십시오.",
    responsiveTOCMessage: "통제위험이 '의존'인 경영진주장에는 (1) 낮은 위험으로 지정되지 않고 (2) 설계 효과성 평가가 완료된 통제위험에 대응하는 TOC가 하나 이상 있어야 합니다. <b>대응 TOC</b>를 클릭하여 대응 TOC를 식별하십시오.",
    notcompleted: "미완료",
    noResponsiveTOCAvailable: "이 통제에 식별된 대응 TOC가 없습니다",
    refresh: "데이터 새로 고침",
    tocHoverOverWhenControlTestingHasNoorNotCompleted: "이 통제는 테스트를 위해 선택되지 않았습니다. 테스트 선택을 변경하려면 <b>통제 관리</b>를 사용하십시오.",
    noresponsiveTOCIdentified: "대응 TOC가 식별되지 않았습니다.",
    taskAssertionnotModified: "Task 경영진주장이 수정됐습니다. 계속하려면 경영진주장 연결을 편집하고 나가려면 취소를 클릭하십시오.",
    failedToEditRelatedAssertions: "Task에 연결된 경영진주장을 편집하지 못했습니다. 페이지를 새로 고침하여 다시 시도하십시오. 문제가 지속되면, 헬프 데스크에 문의하십시오.",
    assertionCannotEdited: "비활성화된 체크박스가 있는 경영진주장은 EY GAM에 따라 설정된 것이며 편집할 수 없습니다",
    editAssertionInfoMessage: "Task에 경영진주장을 추가하거나 제거하십시오. 선택된 경영진주장이 하나 이상 있어야야 합니다.",
    editRelatedAssertions: "연결된 경영진주장 편집",
    loweRiskHeader: "낮은 위험",
    placeholderWhenControlTestingHasNotCompleted: "이 통제는 테스트를 위해 선택되지 않았습니다. 테스트 선택을 변경하려면 {0}을(를) 사용하십시오.",
    pspandOSP: "PSP/OSP",
    tocs: "TOC",
    norelatedAssertionPlaceHolder: "각 유의적인 위험 또는 부정 위험에는 이 위험에 관련되는 것으로 식별된 경영진주장이 하나 이상 있어야 합니다. {0}을(를) 클릭하여 관련 경영진주장을 식별하십시오.",
    assertionMustHaveOneControlWithCompleteDesignEffectiveness: "각 경영진주장에는 이 위험에 대응하는 것으로 식별되고 설계 효과성 평가가 완료된 통제가 하나 이상 있어야 합니다. {0}을(를) 클릭하여 대응하는 통제를 식별하십시오.",
    controlRiskRelyNotLowerRisk: "통제위험이 '의존'인 각 경영진주장에는 (1) 낮은 위험으로 지정되지 않고 (2) 효과적으로 설계됐으며 (3) 테스트를 위해 선택된 통제가 하나 이상 있어야 합니다. {0}을(를) 클릭하여 대응하는 통제를 식별하십시오.",
    controlRiskRelyWithDesignEffectively: "통제위험이 '의존'인 각 경영진주장에는 (1) 효과적으로 설계되었고 (2) 테스트를 위해 선택된 통제가 하나 이상 있어야 합니다. {0}을(를) 클릭하여 대응하는 통제를 식별하십시오.",

    assertionWithControlRiskNotRely: "의존하지 않는 통제위험이 있는 경영진주장은 통제테스트를 식별할 필요가 없습니다",
    thisControlNotSelectedForTesting: "이 통제는 테스트를 위해 선택되지 않았습니다. 테스트 선택을 변경하려면 {0}을(를) 클릭하십시오.",
    testControlRelatedToControlAsLowerRisk: "낮은 위험으로 지정된 통제에 연결된 통제테스트는 이 경영진주장에 대한 위험에 대응하지 않습니다",
    testControlWithoutCompleteDE: "설계 효과성 평가가 완료되지 않은 통제에 연결된 통제테스트는 이 경영진주장에 대한 위험에 대응하지 않습니다. {0}을(를) 클릭하여 설계 효과성을 설정하십시오.",
    testControlrelatedToineffective: "설계 효과성 평가가 유효하지 않은 통제에 연결된 통제테스트는 이 경영진주장에 대한 위험에 대응하지 않습니다. {0}을(를) 클릭하여 설계 효과성을 변경하십시오.",
    anotherTestControlIdentified: "다른 통제테스트를 이 경영진주장의 위험에 대응하는 것으로 식별했으며 추가 통제테스트를 식별할 필요가 없습니다. 이 통제에 대응하는 TOC가 식별되지 않았습니다.",
    eachControlMustHaveOneToc: "통제위험이 의존인 각 경영진주장에는 (1) 낮은 위험으로 지정되지 않고 (2) 설계 효과성 평가가 완료됐으며 (3) 테스트를 위해 선택된 통제의 위험에 대응하는 TOC가 하나 이상 있어야 합니다. 이 통제에 대응하는 TOC가 식별되지 않았습니다.  {0}을(를) 클릭하여 대응하는 TOC를 식별하십시오.",
    eachAssertionControlHaveAtleasetOneTOC: "통제위험이 의존인 각 경영진주장에는 (1) 설계 효과성 평가가 완료되었고 (2) 테스트를 위해 선택된 통제의 위험에 대응하는 TOC가 하나 이상 있어야 합니다. 이 통제에 대응하는 TOC가 식별되지 않았습니다.  {0}을(를) 클릭하여 대응하는 TOC를 식별하십시오.",
    norepsonsivePSPOSPplaceholder: "각 경영진주장에는 이 위험에 대응하는 것으로 식별된 실증절차가 하나 이상 있어야 합니다. {0}을(를) 클릭하여 대응하는 실증절치를 식별하십시오.",

    //Reject Task
    rejectPspModalTitle: "PSP 거절",
    rationaleRequired: "필수",
    rationaleTextEditorLabel: "PSP 거절 근거",
    rejectTaskErrorMessage: "Task를 거절할 수 없습니다. 페이지를 새로 고침하여 다시 시도하십시오. 문제가 지속되면, 헬프 데스크에 문의하십시오.",
    rejectTaskModalHeader: "선택한 PSP를 거절하시겠습니까?",
    rejectTaskModaWarningText: "연결된 증거 중 이 engagement의 다른 task에 연결되지 않은 증거는 임시 파일로 이동됩니다",
    rejectTaskRationaleLabel: "근거 (필수)",

    // Adobe Analytics
    aaCookieConsentTitle: "Welcome to",
    aaCookieContentPrompt: "쿠키를 허용하시겠습니까?",
	aaCookieConsentExplanation: '<p>이 웹사이트를 운영하는 데 반드시 필요한 쿠키 외에도 귀하의 사용자 경험과 당사의 서비스를 개선하기 위해 다음 유형의 쿠키를 사용합니다: 사용자 경험을 향상시키기 위한 <strong>기능 쿠키</strong>(예: 설정 기억), 웹사이트 성능을 측정하고 사용자 경험을 개선하기 위한 <strong>성능 쿠키</strong>, 당사가 광고 캠페인을 실행하고 귀하와 관련된 광고를 제공하도록 제3자가 설정한 <strong>광고/대상선정 쿠키</strong>.</p><p>추가 정보는 <a target="_blank" href="https://www.ey.com/en_us/cookie-policy">쿠키 정책</a>을 참고하십시오.</p>',
	aaCookieConsentExplanationWithDoNotTrack: '<p>이 웹사이트를 운영하는 데 반드시 필요한 쿠키 외에도 귀하의 사용자 경험과 당사의 서비스를 개선하기 위해 다음 유형의 쿠키를 사용합니다: 사용자 경험을 향상시키기 위한 <strong>기능 쿠키</strong>(예: 설정 기억), 웹사이트 성능을 측정하고 사용자 경험을 개선하기 위한 <strong>성능 쿠키</strong>, 당사가 광고 캠페인을 실행하고 귀하와 관련된 광고를 제공하도록 제3자가 설정한 <strong>광고/대상선정 쿠키</strong>.</p><p>귀하의 브라우저에서 Do Not Track 설정을 활성화한 것이 감지됐습니다; 따라서, 광고/대상선정 쿠키가 자동으로 비활성화됩니다.</p><p> 추가 정보는 <a target="_blank" href="https://www.ey.com/en_us/cookie-policy">쿠키 정책</a>을 참고하십시오.</p>',
    aaCookieConsentDeclineOptionalAction: "선택 쿠키를 거부합니다",
    aaCookieConsentAcceptAllAction: "모든 쿠키를 수락합니다",
    aaCookieConsentCustomizeAction: "쿠키 수정",
    aaCookieConsentCustomizeURL: 'https://www.ey.com/en_us/cookie-settings',

    //Task Sections
    taskSectionLabels: {
        taskSectionHeader: "Task 그룹 및 연결된 task",
        manageTaskSections: "Task 그룹 관리",
        taskSectionsAccordionHeader: "Task 그룹",
        phaseAccordionHeader: "단계",
        tasksAccordionHeader: "Task",
        rejectedAccordionHeader: "거절됨",
        noRelatedTasksMessage: "사용 가능한 PST/OST 없음. 시작하려면 {0}을/를 생성하십시오.",
        taskSectionTaskHeader: "Task",
        newOSTButtonText: "신규 OST",
        cutomTaskSectionBadgeText: "사용자지정",
        rejectedTasksLabel: "거절된 PST",
        additionalInfo: "근거",
        rejectButton: "거절",
        acceptButton: "수락",
        removeButton: "제거",
        addButton: "추가",
        allPSTsRejectedMessage: "모든 PST가 거절됐습니다.",
        rejectModalTitle: "PST 거절",
        rationaleTextEditorLabel: "PST 거절 근거",
        rejectTaskModalHeader: "선택한 PST를 거절하시겠습니까?",
        noResultsMessage: "결과를 찾을 수 없습니다",
        noTaskSetionsAvailableMessage: "사용 가능한 task 섹션 없음",
        rejectTaskModaWarningText: "이 engagement에 있는 다른 task에 연결되지 않은 관련 증거는 임시 파일로 이동됩니다. EY Canvas 전달 문서가 있는 PST는 거절할 수 없습니다.",
        rejectTaskRationaleLabel: "근거 (필수)"
    },

    // Cookie Settings
    cookieSettings: {
        title: "쿠키 설정",
        explanation: "ey.com과 My EY 플랫폼에서 쿠키 사용에 동의하십시오. 아래에 열거된 쿠키 유형을 하나 이상 선택한 후 저장하십시오. 쿠키 유형과 그 목적에 관한 세부정보는 아래 목록을 참조하십시오.",
        emptyCookieListNotice: "이 범주의 쿠키는 이 앱에서 사용되지 않습니다",
        nameTableHeader: "쿠키 이름",
        providerTableHeader: "쿠키 제공자",
        purposeTableHeader: "쿠키 목적",
        typeTableHeader: "쿠키 유형",
        durationTableHeader: "쿠키 기간",
        formSubmit: "내 선택 저장",
        requiredCookieListTitle: "필수 쿠키",
        functionalCookieListTitle: "기능 쿠키",
        functionalCookieAcceptance: "아래 기능 쿠키를 수락합니다",
        functionalCookieExplanation: "기능 쿠키, (귀하가 선택했던 설정을 기억하는 등) 사용자 경험을 향상시킵니다",
        performanceCookieListTitle: "성능 쿠키",
        performanceCookieAcceptance: "아래 성능 쿠키를 수락합니다",
        performanceCookieExplanation: "성능 쿠키, 웹사이트 성능을 측정하고 사용자 경험을 개선하는 데 도움을 줍니다. 성능 쿠키를 사용할 때, 개인 데이터를 저장하지 않으며, 이러한 쿠키를 통해 수집된 정보를 익명으로 집계한 형태로만 사용합니다.",
        advertisingCookieListTitle: "대상선정 쿠키",
        advertisingCookieAcceptance: "아래 광고/대상선정 쿠키를 수락합니다",
        advertisingCookieExplanation: "광고/대상선정 쿠키는 사용자 활동과 세션을 추적하는 데 사용하며 이로써 더욱 개인화된 서비스를 제공할 수 있습니다. (광고 쿠키의 경우) 당사가 광고 캠페인을 실행하고 귀하와 관련된 광고를 제공하도록 제3자가 설정합니다.",
        doNotTrackNotice: "귀하의 브라우저에서 Do Not Track 설정을 활성화한 것이 감지됐습니다; 따라서, 광고/대상선정 쿠키가 자동으로 비활성화됩니다.",
    },

    //Task Sections and related Tasks
    taskSectionAndRelatedTask: "Task 섹션 및 연결된 Task",
    manageTaskSections: "Task 섹션 관리",

    // Financial Statments
    financialStatementLabels: {
        financialStatements: "재무제표",
        trialBalance: "시산표",
        okButton: "확인",
        leadSheet: "리드 시트",
        balanceSheet: "재무상태표",
        incomeStatement: "손익계산서",
        eyreferences: "참조",
        currenPeriod: "분석일",
        comparativePeriod: "비교일",
        changeFrom: "변동 from",
        percentageChangeFrom: "% 변동 from",
        notesColumn: "노트",
        viewTrialBalanceType: "시산표 유형별 보기",
        multiEntity: "Multi-entity",
        placeHolderText: "계정 분류 검색",
        currencyType: "통화 유형",
        currencyCode: "통화 코드",
        businessUnit: "사업부",
        periodEnded: "종료일",
        periodsEnded: "종료일",
        searchGLAccountPlaceholder: "GL 계정 검색",
        eyReferenceDocuments: "{0} 문서",
        relatedNotes: "연결된 노트",
        notAvailable: "사용 불가능",
        significantDisclosures: "유의적인 공시",
        noResultFound: "결과를 찾을 수 없습니다",
        openEYHelixProjects: "EY Helix 프로젝트 열기",
        openAdjustmentModule: "조정 모듈 열기",
        goToSubstantiveProcedureLink: "실증절차로 이동",
        cancel: "취소",
        remove: "제거"
    },

    financialStatementsClassView: {
        bulk: "일괄",
        eyAccount: "EY 계정",
        placeHolderText: "GL 계정 검색",
        noAccountDesignation: "계정 지정이 설정되지 않았습니다",
        insignificantLeadSheetMessage: "비유의적인 계정의 리드 시트가 표시되지 않았습니다",
        unmappedGLAccounts: "매핑되지 않은 계정의 리드 시트가 표시되지 않았습니다",
        unmappedAccountText: 'Unmapped'
    },
    financialStatementTypeIds: [{
            id: 1,
            label: "자산 "
        },
        {
            id: 4,
            label: "부채"
        },
        {
            id: 7,
            label: "자본 "
        },
        {
            id: 8,
            label: "수익"
        },
        {
            id: 9,
            label: "비용"
        },
        {
            id: 17,
            label: "순이익"
        }
    ],
    copyrightMessage: "Copyright © <year> all rights reserved",
    createNotes: {
        notesPlaceholderText: "{0} 또는 {1}을(를) 클릭하여 노트를 추가하십시오",
        newNote: "노트 추가",
        relateNote: "노트 연결",
        addNewNotesHeader: "아래에 노트 세부정보를 입력하고 <b>\저장 및 닫기\</b>를 선택하여 마칩니다. 다른 노트를 더 생성하려면 <b>\저장 및 추가 생성 \</b>을 선택하십시오.",
        noteIndex: "Index",
        noteIndexRequired: "Index (필수)",
        noteDescription: "설명",
        noteDescriptionRequired: "설명 (필수)",
        saveAndClose: "저장 및 닫기",
        newTickmarkDescription: "이 GL 계정에 참조된 증거가 없는 이유를 선택하십시오",
        newTickmarkBulkModalDescription: "선택한 GL 계정에 참조된 증거가 없는 이유를 선택하십시오"
    },
    deleteNotes: {
        deleteNote: "노트 삭제",
        deleteNoteTitle: "선택한 노트를 삭제하시겠습니까?",
        delete: "삭제",
        cancel: "취소"
    },
    editNotes: {
        editNote: "노트 편집",
        editNotesHeader: "아래에서 노트 세부정보를 편집하고 <b>\저장 및 닫기\</b>를 선택하여 마칩니다",
        edit: "편집",
        cancel: "취소"
    },
    notesListLabels: {
        actions: "작업",
        noteCount: "{0} 노트",
        notesCount: "{0} 노트"
    },
    relateNotes: {
        relateNoteLabel: "노트 연결",
        searchPlaceholder: "검색",
        accountLabel: "계정",
        indexLabel: "Index",
        descriptionLabel: "설명",
        addedLabel: "추가됨",
        showOnlyRelatedLabel: "연결된 항목만 표시",
        noResultsFoundMessage: "결과를 찾을 수 없습니다",
        noteCount: "{0} 노트",
        notesCount: "{0} 노트",
        closeBtnTitle: "닫기"
    },
    uploadEvidenceDocuments: {
        addnewEvidencesPlaceholderandLinks: "{0} 또는 {1}을(를) 클릭하여 증거를 추가하거나 {2}을(를) 클릭하여 증거 필요 없음으로 지정하십시오",
        newEvidence: "신규 증거",
        relateEvidence: "증거 연결",
        newTickMark: "신규 tickmark",
        relateTasks: 'Relate task',
        noTasksSeleted: "계속하려면 task를 선택하십시오",
        relateTaskPlaceholder: "신규 참조는 하나 이상의 task에 연결해야 합니다.  이 문서가 증거로 추가돼야 하는 task를 선택하십시오.",
        confirmButtonTitle: "계속",
        closeButtonTitle: "취소",
        noResultsFound: "결과를 찾을 수 없습니다",
        taskType: "유형",
        taskName: "Task 이름",
        taskCount: "{0} Task",
        tasksCount: "{0} Task",
        title: "참조",
        removeReference: "참조 제거"
    },
    glAccountAssociatedNotes: {
        aggregatedNotesPlaceholder: "사용 가능한 노트 없음. 노트를 생성하려면 GL 계정을 선택하십시오.",
        notes: "노트",
        relatedGlAccountPlaceholder: "연결된 GL 계정"

    },
    finacialStatementsBulkOperations: {
        relateEvidenceLabel: "증거 연결",
        selectedCountGLAccount: "{0} GL 계정 선택됨",
        selectedCountGLAccounts: "{0} GL 계정 선택됨",
        selectAll: "모두 선택",
        deselectAll: "모두 선택 해제",
        exitBulkMode: "일괄 모드 종료",
        noGLAccountsSelectedValidationMessageEvidence: "GL 계정을 하나 이상 선택하여 증거를 연결하거나 일괄 모드 종료를 클릭하십시오",
        noGLAccountsSelectedValidationMessageTickmark: "신규 tickmark에 대해 GL 계정을 하나 이상 선택하거나 일괄 모드 종료를 클릭하십시오",
        noGLAccountsSelectedValidationMessageRemoveReference: "GL 계정을 하나 이상 선택하여 참조를 제거하거나 일괄 모드 종료를 클릭하십시오",
        relateTickmarkLabel: "신규 tickmark",
        removeReferenceLabel: "참조 제거",
        removeReferenceConfirmationMsg: "선택한 모든 GL 계정에 대한 참조를 제거하려면 확인하십시오"

    },
    financialStatementsFilters: {
        referenceFilterKey: "참조 누락 GL 계정",
        accountFilterKey: "매핑 없는 GL 계정",
        noResultsPlaceholder: "결과를 찾을 수 없습니다",
        trialBalance: "시산표",
        noneAvailable: "사용 가능한 항목 없음",
        search: "검색",
        multityEntity: "Multi-entity",
        placeHolderMessageWhenHelixMappingIsTrue: "불러온 시산표 없음. {0}을(를) 클릭하여 신규 analyzer를 연결하십시오.",
        placeHolderMessageWhenHelixMappingIsFalse: "EY Helix와 통합할 수 없습니다. 페이지를 새로 고침하여 다시 시도하십시오. 문제가 지속되면, 헬프 데스크에 문의하십시오.",
		eyHelixIntegrationLinkText: "EY Helix 통합",
        noEntitiesAvailablePlaceholder: "생성된 기업 없음. 시작하려면 기업을 생성하십시오."
    },
    //Group instructions
    assertionTabButton: "경영진주장",
    inherentRiskFactorButton: "고유위험요소",
    accountsAndDisclosure: "계정/공시",
    assertions: "경영진주장",
    assertionC: "C",
    assertionEO: "E/O",
    assertionMV: "M/V",
    assertionRO: "R&O",
    assertionPO: "P&D",

    complexity: "복잡성",
    subjUncertainty: "주관성 불확실성",
    fraudOrError: "부정 또는 오류",
    change: "변경",
    natureOfAccount: "계정 성격",
    relatedParties: "특수관계자",
    higherInherentRiskLabel: "높은 고유위험",
    lowerInherentRiskLabel: "낮은 고유위험",
    relevantLabel: "위험 연결됨",
    relevantContributeLabel: "높은 고유위험에 연결되고 기여하는 위험",
    incompleteInherentRiskTooltip: "미완료 고유위험",
    estimateLabel: "추정치",
    riskAssociatedLabel: "위험 연결됨",
    greaterExtentLabel: "더 큰 범위",
    lesserExtentLabel: "더 작은 범위",
    accordionNoRiskLabel: "이 계정 경영진주장에 연결된 위험 없음",
    accordionNoRiskAccountLabel: "이 계정에 연결된 위험 없음",
    accordionNoAssertionsLabel: "이 계정에 연결된 경영진주장 없음",
    accordionLimitedRiskLabel: "계정이 limited risk로 식별됐습니다",

    maps: "맵",
    financialStatements: "재무제표",
    serviceGatewayAutomation: "서비스 게이트웨이 & 자동화",
    manageTaskGroups: "Task 그룹 관리",
    openAssignmentsLabel: "처리 전 배정",
    inProgressAssignmentsLabel: "진행 중 배정",
    // My Progress collaboration view.
	calendarDays: [
		"일요일",
		"월요일",
		"화요일",
		"수요일",
		"목요일",
		"금요일",
		"토요일"
	],
	calendarMonths: [
		"1월",
		"2월",
		"3월",
		"4월",
		"5월",
		"6월",
		"7월",
		"8월",
		"9월",
		"10월",
		"11월",
		"12월"
	],
    myProgressToday: "오늘",
    noDueDateAssignedGroup: "배정된 만료일 없음",
    myProgressStatusTile: {
        yourRequests: "귀하의 요청사항",
        totalCount: "총 개수",
        requestStatus: "요청 상태",
        draft: "초안",
        pending: "보류 중",
        received: "수신됨",
        accepted: "수락됨",
        overdue: "지연",
        noRelatedTasks: "Task가 연결되지 않은 {0}",
        oneNoRelatedTask: "Task가 연결되지 않은 1",
        addRequest: "신규 요청",

        //Requests dues tile 2
        pendingRequestsByDueDate: "만료일별 보류 중인 요청사항",
        requestsYAxisLabel: "요청사항",
        requestsXAxisLabel: "일",
        tooltipDaysLabel: "일",
        tooltipTotalLabel: "합계:",
        normalLabel: "Normal",
        highLabel: "High",
        criticalLabel: "Critical",
        overdueLabel: "지연",
        overDueCatFirst: ">90 지연",
        overDueCatSecond: "31-90 지연",
        overDueCatThird: "10-30 지연",
        overDueCatFourth: 'Overdue 1-9',
        catFifth: '1-9',
        catSixth: '10-30',
        catSeventh: '31-90',
        catEighth: '> 90',
        noRequestsFound: "요청사항을 찾을 수 없습니다",
        daysOverdue: 'Days overdue',
        daysComingDue: 'Days coming due'
    },
    documentAttributeReference: {
        name: "이름",
        notes: "노트",
        signOffs: "Sign-off",
        tasks: "연결된 task",
        open: "열기",
        openReadOnly: "읽기 전용으로 열기",
        delete: "삭제",
        rename: "이름 바꾸기",
        signOffRequirements: "Sign-off 요건",
        confidentiality: "기밀",
        unlink: "링크 해제",
        relateTasks: "Task 연결"
    },
    aiChatbot: 'EYQ Assurance Knowledge',
    selectDueDate: "만료일을 선택하십시오",
    daysOverdue: 'Days overdue',
    daysComingdue: 'Days coming due',
    loadingDataMessage: 'Loading data... this may take a few seconds'
};

/*RBAC Errors*/
export const RbacErrors = {
    106: "내용을 편집할 권한이 없습니다. Engagement 관리자와 협의하여 충분한 권한을 얻으십시오."
};

/*Errors*/
export const Errors = {
    /*Doc Helper Custom Messages */
    0: "연결이 끊어졌습니다. 재연결 후 다시 시도하십시오. 문제가 지속되면 헬프 데스크에 문의하십시오.",
    101: "유효하지 않은 Engagement 상태",
    102: "유효한 engagement 사용자를 찾을 수 없습니다",
    103: "Engagement 사용자 독립성 준수 누락",
    104: "필수 Azure AD 범위 누락",
    105: "Engagement 권한을 받는 동안 오류가 발생했습니다. 페이지를 새로 고침하여 다시 시도하십시오. 문제가 지속되면 헬프 데스크에 문의하십시오.",
    106: "이 작업을 수행하는 데 필요한 권한이 없습니다",
    107: "유효한 engagement 사용자를 찾을 수 없습니다. 페이지를 새로 고침하여 다시 시도하십시오. 문제가 지속되면 헬프 데스크에 문의하십시오.",
    108: "Engagement 프로필이 완료되지 않았습니다. 랜딩 페이지로 이동하여 프로필을 완료하십시오.",
    303: "이름이 동일한 문서를 현재 업로드 중입니다",
    401: "작업을 완료할 수 없습니다. 페이지를 새로 고침하여 다시 시도하십시오. 문제가 지속되면, 헬프 데스크에 문의하십시오.",
    403: "은(는) 지원되지 않는 파일 형식이므로 업로드되지 않았습니다. 문서를 유효한 파일 형식으로 재저장하고 다시 시도하십시오. 문제가 지속되면 헬프 데스크에 문의하십시오.",
    410: "이 문서는 삭제되어 열 수 없습니다",
    411: "빈 문서는 허용되지 않습니다",
    412: "이 engagement에 이름이 동일한 문서가 이미 있습니다",
    413: "문서가 최대 허용 가능 파일 크기(250mb)를 초과하여 업로드되지 않았습니다. 파일 크기를 줄여 다시 시도하십시오.",
    500: "연결이 끊어졌습니다. 재연결 후 다시 시도하십시오. 문제가 지속되면 헬프 데스크에 문의하십시오.",
    414: "이름이 최대 길이({0}자)를 초과합니다",
    600: "지금은 작업을 완료할 수 없습니다. 페이지를 새로 고침하여 다시 시도하십시오. 문제가 지속되면, 헬프 데스크에 문의하십시오.",
    601: "이름이 동일한 문서가 있습니다",
    602: "문서가 이미 공동작업에 있습니다",
    603: "문서를 찾을 수 없습니다",
    'zip': "이 .zip 파일이 지원할 수 없는 파일 유형을 하나 이상 포함하고 있거나 최대 용량을 초과하여 업로드할 수 없습니다",
    401000: "네트워크 변경이 감지됐습니다. 계속하려면 페이지를 다시 로드하십시오.",

    /*Accounts*/
    1001: "계정 생성 호출 실패",
    1002: "계정 이름 누락",
    1003: 'The selected Account has been deleted. Close this modal to see the updated list.',
    1004: "결과를 찾을 수 없습니다 페이지를 새로 고침하여 다시 시도하십시오. 문제가 지속되면, 헬프 데스크에 문의하십시오.",
    1005: "유효하지 않은 Engagement ID",
    1006: "유효하지 않은 계정 유형",
    1007: "유효하지 않은 재무제표 유형",
    1008: 'The selected Account has been deleted. Close this modal to see the updated list.',
    1009: "ID별 계정 가져오기 호출 실패",
    1010: "Engagement ID별 계정 가져오기 호출 실패",
    1011: "유효하지 않은 요청으로 인해 계정 ID에 대한 SEM 요약 가져오기 호출 실패",
    1012: "유효하지 않은 요약 유형",
    1013: "계정 검토 생성 호출 실패",
    1014: "계정 검토 삭제 호출 실패",
    1015: "유효하지 않은 계정 검토 생성 요청",
    1016: "유효하지 않은 계정 검토 ID",
    1017: "계정이 이 Engagement에 속하지 않거나 삭제됐습니다",
    1018: "다른 사용자가 계정 검토를 생성했습니다",
    1019: "다른 사용자가 계정을 삭제했습니다. 페이지를 새로 고침하여 다시 시도하십시오.",
    1020: "계정 PSP를 업데이트해야 합니다.",
    1024: "계정 이름이 500자를 초과합니다",
    1025: "Limited Risk 또는 비유의적인 계정은 추정할 수 없습니다",
    1026: "계정에 중복된 경영진주장이 있을 수 없습니다",
    1027: "유효하지 않은 경영진주장 ID",
    1037: "중복된 PSP index는 있을 수 없습니다",
    1039: 'The selected Account has been deleted. Close this modal to see the updated list.',
    1048: "계정이 유효하지 않은 실행 유형입니다",
    1053: "위험이나 추정치가 연결된 계정은 Limited Risk 또는 비유의적인 계정으로 설정할 수 없습니다",
    1054: "삭제될 경영진주장에 위험 또는 추정치가 연결되어 있습니다",
    1065: "유의적인 위험, 부정위험, 중요왜곡표시위험 또는 추정치가 연결된 경영진주장은 변경할 수 없습니다. 이러한 연결을 먼저 제거해야 합니다.",

    1266: 'Engagement has reached maximum number of multi-edit mode documents.  Check some documents back in and try again.  If the issue persists contact the Help Desk.',
    1267: 'Document is conflicted. Resolve conflicts and try again.  If the issue persists, contact the Help Desk.',
    1268: 'Document is already in co-edit mode. end co-edit mode and try again.  If the issue persists, contact the Help Desk.',
    1269: 'Document is a shared evidence. Unlink and try again.  If the issue persists, contact the Help Desk.',

    /*Assertions*/
    2001: "유효하지 않은 생성 요청",
    2002: "경영진주장 이름 누락",
    2003: "경영진주장 누락",
    2004: "경영진주장 가져오기 호출 실패",
    2005: "유효하지 않은 Engagement ID",
    2006: "ID별 경영진주장 가져오기 호출 실패",
    2007: "경영진주장 WCGW 가져오기 호출 실패",
    2050: "경영진주장을 찾을 수 없습니다. 페이지를 새로 고침하여 다시 시도하십시오. 문제가 지속되면, 헬프 데스크에 문의하십시오.",
    /*Tags*/
    5120: "태그 ID를 찾을 수 없습니다",
    5121: "태그 ID 누락",
    5123: "중복 태그 연결",
    5124: "태그 연결을 찾을 수 없습니다",


    /*Risks*/
    4001: "지금은 작업을 완료할 수 없었습니다. 페이지를 새로 고침하여 다시 시도하십시오. 문제가 지속되면, 헬프 데스크에 문의하십시오.",
    4002: "위험 이름 누락",
    4003: "위험 누락",
    4004: "위험 가져오기 호출 실패",
    4005: "유효하지 않은 Engagement ID",
    4006: "ID별 위험 가져오기 호출 실패",
    4007: "유효하지 않은 쿼리 요청",
    4008: 'The selected Risk has been deleted. Close this modal to see the updated list.',
    4009: "유효하지 않은 업데이트 요청",
    4010: "이 위험에 이미 배정된 특정 WCGW",
    4011: "WCGW 목록은 null일 수 없습니다",
    4012: "위험 유형 가져오기 실패",
    4013: "유효하지 않은 생성 요청",
    4014: "연결된 경영진주장이 유효하지 않습니다. 페이지를 새로 고침하여 다시 시도하십시오. 오류가 지속되면 헬프 데스크에 문의하십시오.",
    4015: "WCGW이 유효하지 않습니다. 페이지를 새로 고침하여 다시 시도하십시오. 이 오류가 지속되면 헬프 데스크에 문의하십시오.",
    4016: 'The selected Risk has been deleted. Close this modal to see the updated list.',
    4017: "경영진주장이 위험에 유효하지 않습니다. 페이지를 새로 고침하여 다시 시도하십시오. 이 오류가 지속되면 헬프 데스크에 문의하십시오.",
    4018: "전달된 위험 유형 ID가 유효하지 않습니다",
    4019: "위험 이름이 유효하지 않습니다",
    4020: "유효하지 않은 문서 ID",
    4021: "위험 이름은 500자를 초과할 수 없습니다",
    4023: "경영진주장 ID는 null일 수 없습니다",
    4024: "오류로 인해 limited risk 조서 양식을 생성할 수 없습니다. 페이지를 새로 고침하여 다시 시도하십시오. 문제가 지속되면, 헬프 데스크에 문의하십시오.",
    4025: "유효하지 않은 계정 ID",
    4026: "유효하지 않은 경영진주장 ID",
    4027: "경영진주장 위험 모델은 비워둘 수 없습니다",
    4031: "유효하지 않은 위험 또는 양식 본문 옵션",

    4035: "유의적인 위험 또는 부정위험에 대해서는 높은 위험을 편집할 수 없습니다",
    4036: "전달된 경영진주장 ID가 없다면 Knowledge 경영진주장 ID는 비워둘 수 없습니다. Knowledge 경영진주장 ID는 목록에 있어야 합니다.",
    4037: "Knowledge 경영진주장 ID가 이미 이 계정에 있습니다",
    4038: "위험 유형 ID가 허용되는 옵션과 일치하지 않습니다",
    4040: "이 작업은 수행할 수 없습니다. 페이지를 새로 고침하여 다시 시도하십시오. 문제가 지속되면, 헬프 데스크에 문의하십시오.",

    /*TASK*/
    5001: "모두 가져오기 실패",
    5002: "이 engagement에서 이 task를 더 이상 사용할 수 없습니다",
    5003: "Task에 대한 문서 가져오기 실패. 유효하지 않은 요청 파라미터.",
    5004: "문서 관련 task 가져오기 실패. 유효하지 않은 요청 파라미터.",
    5005: "ID별 task 가져오기 실패",
    5006: "Task 범주 가져오기 호출 실패",
    5007: "Task 하위 범주 가져오기 호출 실패",
    5008: "Task 설명 가져오기 호출 실패",
    5009: "Task 고객 요청사항 가져오기 호출 실패",
    5010: "Task 고객 요청사항 저장 호출 실패",
    5011: "항목을 연결하려는 task가 삭제됐거나 거절됐습니다",
    5012: "연결하려는 항목이 삭제됐습니다",
    5013: "항목을 연결하려는 task가 삭제됐거나 거절됐습니다",
    5014: "연결하려는 문서가 삭제됐습니다",
    5015: "Task 증거 가져오기 호출 실패",
    5016: "WCGW Task 가져오기 호출 실패",
    5017: "Engagement ID는 0보다 커야 합니다",
    5018: "이 작업은 수행할 수 없습니다. 페이지를 새로 고침하여 다시 시도하십시오. 문제가 지속되면, 헬프 데스크에 문의하십시오.",
    5019: "Task 설명이 비었습니다",
    5020: "선택한 task가 삭제됐거나 거절됐습니다. 따라서, 이 작업은 지금 완료할 수 없습니다.",
    5021: "원천 engagement ID가 없습니다",
    5022: "주석 저장 실패",
    5023: "Engagement 사용자를 찾을 수 없습니다",
    5024: "Task 삭제 호출 실패",
    5025: "Task 삭제 호출 실패",
    5026: "Task 목록이 비었습니다",
    5027: "리뷰노트를 찾을 수 없습니다",
    5028: "파일 이름은 필수입니다",
    5029: "파일 확장자는 필수입니다",
	5030: '파일 이름에 다음을 포함할 수 없습니다: */:<>\\?|\"',
    5031: "문서 이름 업데이트 오류",
    5032: "유효하지 않은 문서 ID",
    5033: "작업 유형을 찾을 수 없습니다",
    5034: "Task 상태 변경 실패",
    5035: "수행하려는 작업을 지금 완료할 수 없습니다. 나중에 다시 시도하십시오. 오류가 지속되면 헬프 데스크에 문의하십시오.",
    5036: "호출에서 본문은 null이거나 비워둘 수 없습니다",
    5037: "호출에서 요청은 null일 수 없습니다",
    5038: "계속하려면 고유한 파일 이름을 입력하십시오",
    5039: "파일 이름은 필수입니다",
    5040: "파일 이름은 100자로 제한됩니다",
	5041: '파일 이름에 다음을 포함할 수 없습니다: */:<>\\?|\"',
    5042: "선택한 task가 거절됐습니다",
    5043: "이 task는 작성 단계 task입니다",
    5044: "이 task는 milestone task입니다",
    5045: "이 task는 PSP 또는 OSP 유형이 아닙니다",
    5046: "문자 한도를 초과했습니다",
    5047: "문자 한도를 초과했습니다",
    5048: "필수 필드",
    5049: "선택한 문서를 이 task에서 제거할 수 없습니다. 페이지를 새로 고침하여 다시 시도하십시오. 문제가 지속되면 헬프 데스크에 문의하십시오.",
    5050: "Task 그룹 ID는 유효하지 않거나 0일 수 없습니다",
    5051: "Task 섹션 ID는 유효하지 않거나 0일 수 없습니다",
    5052: "현재 task에 이 문서 추가 시도 중 오류. 호출 실패.",
    5053: "현재 task 내 이 문서 업데이트 시도 중 오류. 호출 실패.",
    5054: "현재 task 내 이 문서 복사본 추가 시도 중 오류. 호출 실패.",
    5055: "문서 이름 바꾸기 시도 중 오류. 호출 실패.",
    5056: "Knowledge 또는 그룹 task에 대한 task 제목을 편집할 수 없습니다",
    5057: "Task 유형이 OST 유형이어야 합니다",
    5058: "시스템과 관련되어 있으므로 이 문서를 task에서 제거할 수 없습니다",
    5059: "유효하지 않은 시기 값",
    5060: "증거 추가 오류. 호출 실패.",
    5061: "다른 사용자가 표시된 정보를 업데이트했습니다. 페이지를 새로 고침하여 다시 시도하십시오. 오류가 지속되면 헬프 데스크에 문의하십시오.",
    5062: "귀하의 engagement에서 선택된 EY Atlas 채널에는 요청된 문서가 없습니다. 추후 포함할 정보를 내용 작성자에게 제공하도록 헬프 데스크에 연락하십시오.",
    5063: "유효하지 않은 패치 작업",
    5064: "선택한 task가 삭제됐거나 거절됐습니다. 따라서, 이 작업은 지금 완료할 수 없습니다.",
    5065: "Task 원천 유형을 업데이트할 수 없습니다. 요청이 유효하지 않습니다.",
    5066: "Guidance 가져오기 오류. 호출 실패.",
    5067: "Task 성격 유형을 업데이트할 수 없습니다. 요청이 유효하지 않습니다.",
    5068: "Task 성격 유형을 업데이트할 수 없습니다. 요청이 유효하지 않습니다.",
    5069: "Task 배정 삭제 호출 실패",
    5070: "선택한 task가 하나 이상 삭제됐습니다. 다시 시도하거나 오류가 지속되면 헬프 데스크에 문의하십시오.",
    5071: "배정을 업데이트할 수 없습니다. 요청이 유효하지 않습니다.",
    5072: "작성자를 찾을 수 없습니다. 요청이 유효하지 않습니다.",
    5073: "배정을 찾을 수 없습니다.",
    5074: "Task 배정 저장 실패",
    5075: "선택한 팀 멤버 또는 역할에는 선택한 task를 중복 배정할 수 없습니다. 계속하려면 다른 배정, 팀 멤버 또는 역할을 선택하십시오. 오류가 지속되면 헬프 데스크에 문의하십시오.",
    5076: "선택한 팀 멤버가 이 engagement의 활동 멤버가 아닙니다. 다시 시도하거나 오류가 지속되면 헬프 데스크에 문의하십시오.",
    5077: "선택한 task가 하나 이상 삭제됐습니다. 다시 시도하거나 오류가 지속되면 헬프 데스크에 문의하십시오.",
    5078: "선택한 task 배정이 제거되었습니다. 다시 시도하거나 오류가 지속되면 헬프 데스크에 문의하십시오.",
    5079: "선택한 task가 하나 이상 삭제됐습니다. 다시 시도하거나 오류가 지속되면 헬프 데스크에 문의하십시오.",
    5080: "문서 버전 기록이 없습니다",
    5081: "현재 이 task에 배정된 사용자는 작성자로 재배정할 수 없습니다. 다시 시도하거나 오류가 지속되면 헬프 데스크에 문의하십시오.",
    5082: "업데이트 실패. 문서 이름은 engagement 내에서 고유해야 합니다. 페이지를 새로 고침하여 이 메시지를 제거하십시오.",
    5083: "Task 세부정보 문자 한도를 초과했습니다",
    5084: "Task 문서 생성 호출 실패",
    5085: "Task 문서 삭제 호출 실패",
    5086: "Task hand-off 생성 호출 실패",
    5087: "Task 패치 호출 실패",
    5088: "Hand-off하려면 이 task에 증거가 있어야 합니다. 다시 시도하거나 헬프 데스크에 문의하십시오.",
    5089: "이 task에 연결된 모든 증거(paper profile 제외)에는 작성자와 완료 표시할 검토자가 하나 이상 있어야 합니다. 다시 시도하고 오류가 지속되면 헬프 데스크에 문의하십시오.",
    5091: "Engagement에 Paper profile 이름이 이미 있습니다.",
    5092: "이름에 다음 문자를 포함할 수 없습니다: */:<>\\?|\\",
    5093: "Paper profile 이름이 최대 길이(100자)를 초과합니다",
    5101: "Task 생성 실패",
    5102: "Task 설명이 없습니다",
    5103: "Task 제목이 없습니다",
    5104: "Task 시기가 없습니다",
    5105: "Task 연결을 편집할 수 없습니다. 페이지를 새로 고침하여 다시 시도하십시오. 문제가 지속되면, 헬프 데스크에 문의하십시오.",
    5106: "감사 단계가 유효하지 않습니다",
    5107: "감사 단계는 범위 및 전략’ 또는 실행’이어야 합니다",
    5108: "Task 설명이 너무 깁니다",
    5109: "유효하지 않은 역할 유형 파라미터",
    5110: "배정 ID는 0보다 커야 합니다",
    5111: "Task에 연결하려는 항목이 삭제됐습니다 페이지를 새로 고침하여 다시 시도하십시오. 문제가 지속되면, 헬프 데스크에 문의하십시오.",
    5112: "Task에 연결하려는 항목이 삭제됐습니다 페이지를 새로 고침하여 다시 시도하십시오. 문제가 지속되면, 헬프 데스크에 문의하십시오.",
    5113: "Task에 연결하려는 항목이 삭제됐습니다 페이지를 새로 고침하여 다시 시도하십시오. 문제가 지속되면, 헬프 데스크에 문의하십시오.",
    5116: "문서 유형이 유효하지 않습니다",
    5119: "선택한 task 중 일부 상태가 업데이트되지 않았습니다. 페이지를 새로 고침하여 다시 시도하십시오. 오류가 지속되면 헬프 데스크에 문의하십시오.",
    5127: "연결을 완료할 수 없습니다. 페이지를 새로 고침하여 다시 시도하십시오. 문제가 지속되면, 헬프 데스크에 문의하십시오.",
    5129: "연결을 완료할 수 없습니다. 페이지를 새로 고침하여 다시 시도하십시오. 문제가 지속되면, 헬프 데스크에 문의하십시오.",
    5133: "연결을 완료할 수 없습니다. 페이지를 새로 고침하여 다시 시도하십시오. 문제가 지속되면, 헬프 데스크에 문의하십시오.",
    5137: "Task 연결을 편집할 수 없습니다. 페이지를 새로 고침하여 다시 시도하십시오. 문제가 지속되면, 헬프 데스크에 문의하십시오.",
    5138: "Task 연결을 편집할 수 없습니다. 페이지를 새로 고침하여 다시 시도하십시오. 문제가 지속되면, 헬프 데스크에 문의하십시오.",
    5140: "Task 연결을 편집할 수 없습니다. 페이지를 새로 고침하여 다시 시도하십시오. 문제가 지속되면, 헬프 데스크에 문의하십시오.",
    5146: "Task에 완료 표시하려면, (paper profile을 제외한) 모든 연결된 증거에 하나 이상의 작성자 및 검토자 sign-off가 있어야 합니다. 페이지를 새로 고침하여 다시 시도하십시오. 오류가 지속되면 헬프 데스크에 문의하십시오.",
    5150: "지금은 자동화 일부를 선택한 task에 연결할 수 없습니다. 페이지를 새로 고침하여 다시 시도하십시오. 오류가 지속되면 헬프 데스크에 문의하십시오.",
    5156: "Task 연결을 편집할 수 없습니다. 페이지를 새로 고침하여 다시 시도하십시오. 문제가 지속되면, 헬프 데스크에 문의하십시오.",
    5157: "Task 연결을 편집할 수 없습니다. 페이지를 새로 고침하여 다시 시도하십시오. 문제가 지속되면, 헬프 데스크에 문의하십시오.",
    5159: "공유된 문서 유형이 유효하지 않습니다",
    5160: "문서에 링크하는 동안 오류가 발생했습니다. 페이지를 새로 고침하여 다시 시도하십시오. 문제가 지속되면 헬프 데스크에 문의하십시오.",
    5174: "Task는 하나 이상의 기업에 연결되어야 합니다. 해당 task를 engagement 차원으로 만들려면 기업별 task 토글을 변경하십시오.",
    5184: "Task 유형이 주요 표준 Task 또는 PSP Task가 아닙니다",
    5185: "EY Canvas 전달 문서가 있는 Task는 거절할 수 없습니다",
    5188: "유효하지 않은 문서 또는 링크 해제 진행 중",
    5189: "Task에 링크된 증거 또는 링크된 응답인 문서가 있습니다",
    5190: "Task에 경영진주장이 하나 이상 있어야 합니다",
    5191: "연결을 완료할 수 없습니다. 페이지를 새로 고침하여 다시 시도하십시오. 문제가 지속되면, 헬프 데스크에 문의하십시오.",
    5192: "Task에 연결하려는 항목이 삭제됐습니다 페이지를 새로 고침하여 다시 시도하십시오. 문제가 지속되면, 헬프 데스크에 문의하십시오.",
    5193: "선택한 항목이 삭제됐습니다. 페이지를 새로 고침하여 다시 시도하십시오. 문제가 지속되면, 헬프 데스크에 문의하십시오.",


    /*WCGW*/
    6001: "WCGW 생성 호출 실패",
    6002: "WCGW 이름 누락",
    6003: "WCGW 누락",
    6004: "WCGW 가져오기 호출 실패",
    6005: "유효하지 않은 Engagement ID",
    6006: "경영진주장 ID가 유효하지 않거나 삭제되었기 때문에 요청된 작업을 완료할 수 없습니다. 페이지를 새로 고침하여 다시 시도하십시오.",
    6007: "ID별 WCGW 가져오기 호출 실패",
    6008: "유효하지 않은 요청",
    6009: "WCGW ID가 유효하지 않거나 삭제되었기 때문에 요청된 작업을 완료할 수 없습니다. 페이지를 새로 고침하여 다시 시도하십시오.",
    6010: "Task를 WCGW과 연결할 수 없었습니다",
    6011: "선택한 WCGW이 삭제됐습니다",
    6012: "Task와 WCGW이 동일한 경영진주장에 연결되지 않았습니다",
    6013: "선택한 task가 동일한 engagement에 속하지 않습니다",
    6014: "Task를 WCGW에서 분리할 수 없습니다",
    6015: "Task를 WCGW과 연결할 수 없었습니다",
    6016: "Task가 거절되어 WCGW과 연결할 수 없습니다",
    6017: "Task는 milestone task가 아니며 WCGW과 연결할 수 없습니다",
    6018: "Task가 작성 단계 task가 아니므로 WCGW과 연결할 수 없습니다",
    6019: "Task는 PSP나 OSP가 아니며 WCGW과 연결할 수 없습니다",
    6020: "Task와 WCGW은 동일한 경영진주장에 연결되며 WCGW에 연결될 수 없습니다",
    6027: "유효하지 않은 WCGW ID 또는 통제 ID",
    6028: "연결을 완료할 수 없습니다. 페이지를 새로 고침하여 다시 시도하십시오. 문제가 지속되면, 헬프 데스크에 문의하십시오.",
    6029: "제거를 완료할 수 없습니다. 페이지를 새로 고침하여 다시 시도하십시오. 문제가 지속되면, 헬프 데스크에 문의하십시오.",

    /*Engagement*/
    7001: "ID별 가져오기를 찾을 수 없습니다",
    7002: "Workspace ID별 engagement 가져오기 호출 실패",
    7003: "모든 engagement 엔터티 가져오기 호출 실패",
    7004: "ID별 engagement 가져오기 호출 실패",
    7005: "모든 engagement 사용자 가져오기 호출 실패",
    7006: "성은 250자를 초과할 수 없습니다",
    7007: "유효하지 않은 사용자 유형 오류",
    7008: "이름은 250자를 초과할 수 없습니다",
    7009: "사용자 GUI는 null일 수 없습니다",
    7010: "유효하지 않은 사용자 상태 오류",
    7011: "Engagement 사용자 생성 호출 실패",
    7012: "{0} {1}은(는) 이미 활동 또는 보류 중인 팀 멤버이기 때문에 초대할 수 없습니다",
    7013: "이니셜은 3자를 초과할 수 없습니다",
    7014: "지금 EY Canvas 랜딩 페이지에 접근할 수 없습니다. 다시 시도하십시오. 문제가 지속되면 헬프 데스크에 문의하십시오.",
    7015: "{0} {1}은(는) 다음 접근 그룹으로 초대할 수 없습니다: {2}이(가) engagement에서 삭제됐습니다. 새로 고침하여 다시 시도하십시오.",
    7016: "사용자가 이미 다음 접근 그룹의 활동 팀 멤버이므로 {0} {1}은(는) 초대할 수 없습니다: {2}",
    7017: "선택한 다음 그룹에 도메인이 허용되지 않습니다: {0}",
    7018: "이메일 주소는 null일 수 없습니다",
    7019: "이름은 null일 수 없습니다",
    7020: "성은 null일 수 없습니다",
    7021: "사용자 이니셜은 null일 수 없습니다",
    7022: "사용자 Primary Office는 null일 수 없습니다",
    7023: "사용자 로그인 이름은 null일 수 없습니다",
    7024: "사용자 EY 역할은 null일 수 없습니다",
    7025: "사용자 Engagement 역할은 null일 수 없습니다",
    7026: "작업을 완료할 수 없습니다. 다시 시도하십시오. 문제가 지속되면 헬프 데스크에 문의하십시오.",
    7027: "유효하지 않은 이메일 주소",
    7028: "Engagement 사용자 패치 호출 실패",
    7029: "Engagement 사용자 - 유효하지 않은 Engagement 사용자 상태 ID",
    7030: "Engagement 사용자 - 유효하지 않은 Engagement 사용자 역할 ID",
    7031: "하나 이상의 engagement 사용자 ID를 찾을 수 없습니다",
    7032: "이메일은 250자를 초과할 수 없습니다",
    7033: "요청된 사용자는 Null일 수 없습니다",
    7034: "Universal 메시지 프로세서 대기 실패",
    7035: "이니셜은 3자를 초과할 수 없습니다",
    7036: "이름은 250자를 초과할 수 없습니다",
    7037: "성은 250자를 초과할 수 없습니다",
    7038: "외부 사용자 생성 호출 실패",
    7039: "하나 이상의 사용자가 이미 활동 또는 보류 중인 팀 멤버이기 때문에 초대할 수 없습니다. 페이지를 새로 고침하여 다시 시도하십시오. 문제가 지속되면 헬프 데스크에 문의하십시오.",
    7040: "이름은 250자를 초과할 수 없습니다",
    7041: "성은 250자를 초과할 수 없습니다",
    7042: "이니셜은 3자를 초과할 수 없습니다",
    7043: "GPN은 250자를 초과할 수 없습니다",
    7044: "GUI는 250자를 초과할 수 없습니다",
    7045: "ID별 외부 사용자 가져오기 실패",
    7046: "사용자는 null일 수 없습니다",
    7047: "지금은 변경사항을 저장할 수 없습니다. 다시 시도하고 문제가 지속되면, 헬프 데스크에 문의하십시오.",
    7048: "지금은 EY Canvas 랜딩 페이지에 접근할 수 없으며 편집이 필요합니다. 다시 시도하고 문제가 지속되면 헬프 데스크에 문의하십시오.",
    7049: "Engagement 사용자 업데이트 호출 실패",
    7050: "멤버를 비활성화할 수 없습니다. Engagement에는 engagement를 관리할 권한을 가진 멤버가 하나 이상 있어야 합니다. 선택을 업데이트하고 다시 시도하십시오. 문제가 지속되면 헬프 데스크에 문의하십시오.",
    7051: "ID별 내부 사용자 가져오기 실패",
    7052: "사용자를 찾을 수 없습니다",
    7053: "ID별 가져오기를 찾을 수 없습니다",
    7054: "Engagement ID별 빠른 링크 가져오기 호출 실패",
    7055: "이전 멤버를 추가할 권한이 없습니다. 이 작업을 하려면 적합한 권한이 있는 engagement 팀 멤버와 얘기하십시오.",
    7056: "지금은 EY Canvas에서 변경사항을 저장할 수 없습니다. 다시 시도하고 문제가 지속되면 헬프 데스크에 문의하십시오.",
    7057: "신규 멤버를 추가할 권한이 없습니다. 이 작업을 하려면 적합한 권한이 있는 engagement 팀 멤버와 얘기하십시오.",
    7058: "사용자 상태가 변경됐습니다. 페이지를 새로 고침하여 다시 시도하십시오. 문제가 지속되면, 헬프 데스크에 문의하십시오.",
    7062: "지금 EY Canvas Client Portal에 접근할 수 없으며 기존 멤버 정보를 업데이트해야 합니다. 다시 시도하고 문제가 지속되면, 헬프 데스크에 문의하십시오.",
    7063: "외부 멤버를 비활성화할 수 없습니다. 새로 고침하여 다시 시도하십시오. 문제가 지속되면 헬프 데스크에 문의하십시오.",
    7064: "유효하지 않은 패치 작업",
    7065: "{0} {1}을(를) 하나 이상의 접근 그룹에서 활성화할 수 없습니다. 선택한 다음 그룹에서 도메인이 허용되지 않습니다: {2}.",
    7066: "{0}은(는) 유효한 사용자가 아닙니다",
    7067: "외부 사용자 입력 호출 실패",
    7068: "지금 EY Canvas Client Portal에 접근할 수 없으며 기존 멤버 정보를 업데이트해야 합니다. 다시 시도하고 문제가 지속되면, 헬프 데스크에 문의하십시오.",
    7069: "선택한 다음 접근 그룹이 활성 상태가 아닙니다: {0}. 제거하고 다시 시도하십시오.",
    7072: "Engagement 링크 해제 과정에서 오류가 발생했습니다. 페이지를 새로 고침하고 다시 시도하십시오. 오류가 지속되면 헬프 데스크에 문의하십시오.",
    7074: "변경사항을 저장할 수 없습니다. Engagement에는 engagement를 관리할 권한을 가지고 독립성이 해결된 활동 멤버가 하나 이상 있어야 합니다. 문제가 지속되면 헬프 데스크에 문의하십시오.",
    7075: "{0} {1}은(는) 이미 활동 팀 멤버이므로 초대할 수 없습니다",
    7077: "한 명 이상의 사용자를 비활성화할 수 없습니다. 페이지를 새로 고침하여 다시 시도하십시오. 문제가 지속되면 헬프 데스크에 문의하십시오.",
    7079: "도메인이 허용되지 않습니다. 다시 시도하고 문제가 지속되면 헬프 데스크에 문의하십시오.",
    7080: "제3자 멤버를 초대할 권한이 없습니다. 페이지를 새로 고침하여 다시 시도하십시오. 문제가 지속되면 헬프 데스크에 문의하여 적합한 권한을 얻으십시오.",
    7094: "선택한 팀 멤버는 이 engagement에서 문서에 sign-off했기 때문에 제거할 수 없습니다",
    7100: "제한된 필드에 대한 편집을 처리할 수 없습니다. 새로 고침하여 다시 시도하십시오.",

    /*SCOT*/
    8001: "SCOT 생성 호출 실패",
    8002: "SCOT 이름 누락",
    8003: "SCOT 누락",
    8004: "SCOT 가져오기 호출 실패",
    8005: "유효하지 않은 Engagement ID",
    8006: "유효하지 않은 경영진주장 ID",
    8007: "ID별 SCOT 가져오기 호출 실패",
    8008: "유효하지 않은 요청",
    8009: 'The selected SCOT has been deleted. Close this modal to see the updated list.',
    8028: 'The selected SCOT has been deleted. Close this modal to see the updated list.',

    /*User*/
    10001: "로그인한 사용자 기본 설정을 찾을 수 없습니다",
    10002: "사용자 모두 가져오기 호출 실패",
    10003: "사용자 기본 설정 가져오기 호출 실패",

    /*Risk Type*/
    11001: "유효하지 않은 생성 요청",
    11002: "위험 유형 이름 누락",
    11003: "위험 유형 누락",
    11004: "위험 유형 가져오기 호출 실패",
    11005: "유효하지 않은 Engagement ID",

    /* Annotation Errors*/
    12001: "유효하지 않은 요청 파라미터",
    12002: "주석 생성 호출 실패",
    12003: "주석 가져오기 실패",
    12004: "유효하지 않은 Engagement ID",
    12005: "컬렉션 내 ID는 0보다 커야 합니다",
    12006: "ID 컬렉션은 비워둘 수 없습니다",
    12007: "유효하지 않은 task ID",
    12008: "유효하지 않은 문서 ID",
    12009: "유효한 문서 ID, Task ID 또는 재무제표 ID가 있어야 합니다",
    12010: "회신에는 parent가 필요합니다",
    12011: "유효하지 않은 상태 ID",
    12012: "문서 유형은 440GL이어야 합니다",
    12013: "유효하지 않은 주석 유형",
    12014: "유효하지 않은 engagement 사용자",
    12015: "다른 사용자가 이 문서를 삭제했습니다",
    12016: "주석 업데이트 호출 실패",
    12017: "회신하려는 노트를 다른 팀 멤버가 삭제했습니다. 페이지를 새로 고침하여 다시 시도하십시오.",
    12018: "주석 변경 작업 유형은 null일 수 없습니다",
    12019: "리뷰노트 삭제됨",
    12020: "유효하지 않은 수행 작업",
    12021: "사용자가 주석을 작성하지 않았습니다",
    12022: "작성자 누락",
    12023: "작성자가 engagement에 존재하지 않거나 속하지 않습니다",
    12024: "배정된 사용자 필요",
    12025: "배정된 사용자가 engagement에 존재하지 않거나 속하지 않습니다",
    12026: "유효하지 않은 노트",
    12027: "노트는 비워둘 수 없습니다",
    12028: "만료일 필요",
    12029: "유효한 우선순위 필요",
    12030: "이 노트의 상태가 변경됐습니다. 더 이상 이 노트를 편집하거나 응답할 수 없습니다. 창을 닫았다가 다시 열어 업데이트된 데이터를 확인하고 계속 편집하십시오.",
    12031: "주석은 최상위 수준이어야 합니다",
    12032: "주석은 최상위 수준이 아니어야 합니다",
    12033: "다음 값 중 적어도 하나는 비어 있으면 안됩니다: 우선순위 유형, 만료일, 상태, 배정된 사용자",
    12034: "노트가 최대 길이(4,000자)를 초과합니다",
    12035: "검색 문자열이 최대 길이(500자)를 초과합니다",
    12036: "Task ID 또는 문자 ID만 수락되어야 합니다. 둘 다는 허용되지 않습니다.",
    12037: "유효하지 않은 패치 작업",
    12038: "더 이상 존재하지 않는 노트를 편집하려고 합니다. 페이지를 새로 고침하여 다시 시도하십시오.",
    12039: "다른 팀멤버와 동일한 노트를 편집하려고 합니다. 페이지를 새로 고침하여 다시 시도하십시오.",
    12040: "주석 사용자 가져오기 호출 실패",
    12041: "주석 사용자 가져오기 호출 실패. 유효하지 않은 쿼리 값.",
    12042: "주석을 생성하는 데 문서 유형이 유효하지 않습니다.",
    12043: "더 이상 존재하지 않는 task 또는 문서에 노트를 추가하려고 합니다. 페이지를 새로 고침하여 다시 시도하십시오.",
    12044: "더 이상 존재하지 않는 노트에 대한 회신을 편집하려고 합니다. 페이지를 새로 고침하여 다시 시도하십시오.",
    12045: "리뷰노트를 찾을 수 없습니다",
    12046: "다른 팀 멤버가 이미 삭제한 노트를 삭제하려고 합니다. 페이지를 새로 고침하여 다시 시도하십시오.",
    12047: "처리 전 상태인 노트에 대한 회신만 삭제할 수 있습니다. 페이지를 새로 고침하여 다시 시도하십시오.",
    12048: "더 이상 존재하지 않는 노트의 상태를 변경하려고 합니다. 페이지를 새로 고침하여 다시 시도하십시오.",
    12049: "다른 팀 멤버가 이미 삭제한 노트에 대한 회신을 삭제하려고 합니다. 페이지를 새로 고침하여 다시 시도하십시오.",
    12050: "닫힌 상태인 노트만 삭제할 수 있습니다",
    12059: "리뷰노트는 이를 생성한 사용자만 삭제할 수 있습니다",
    12066: "처리 전 노트에만 회신할 수 있습니다",
    12067: "다른 팀 멤버가 이미 삭제한 comment에 대한 회신을 삭제하려고 합니다. 페이지를 새로 고침하여 다시 시도하십시오.",
    12068: "Comment를 추가할 수 없습니다. 페이지를 새로 고침하여 다시 시도하십시오. 문제가 지속되면, 헬프 데스크에 문의하십시오.",
    12070: "재무제표별로 comment를 하나만 추가할 수 있습니다. 기존 comment를 편집하십시오.",
    12071: "정보를 삭제하지 못했습니다. 다시 시도하십시오. 문제가 지속되면 헬프 데스크에 문의하십시오.",

    /*Configuration*/
    13001: "설정을 찾을 수 없습니다",
    13002: "설정 API 가져오기 호출 실패",

    /*Documents*/
    14001: "요청이 null이므로 호출을 수행할 수 없습니다",
    14002: "문서를 찾을 수 없습니다. 호출 실패.",
    14003: "Engagement ID는 0보다 커야 합니다",
    14004: "문서 ID는 null이거나 비워둘 수 없습니다",
    14005: "연결된 task를 가져오려는 동안 오류가 발생했습니다. 호출 실패.",
    14006: "선택한 문서를 삭제할 수 없습니다. 나중에 다시 시도하십시오. 문제가 지속되면 헬프 데스크에 문의하십시오.",
    14007: "예상치 못한 오류가 발생했습니다",
    14008: "Sign-off 중에 예상치 못한 오류가 발생했습니다",
    14009: "Sign-off를 추가하는 동안 오류가 발생했습니다",
    14010: "승인 ID는 0보다 커야 합니다",
    14011: "Sign-off를 삭제하는 동안 오류가 발생했습니다",
    14012: "본문은 비워둘 수 없습니다",
    14013: "선택한 문서는 링크 해체할 수 없습니다. 나중에 다시 시도하십시오. 문제가 지속되면 헬프 데스크에 문의하십시오.",
    14014: "문서 ID별 계정 가져오기 호출 실패",
    14015: "유효하지 않은 관련 엔터티",
    14016: "문서 승인 가져오기 호출 실패",
    14017: "문서 발견사항 모두 가져오기 호출 실패",
    14018: "문서 모두 가져오기 호출 실패",
    14019: "Sign-off를 찾을 수 없습니다",
    14020: "유효하지 않은 작업 값",
    14021: "유효하지 않은 발견사항 유형",
    14022: "문서가 engagement에 속하지 않습니다",
    14023: "문서 변경 유형이 유효하지 않습니다",
    14024: "모든 문서 가져오기 호출 실패. 파라미터가 유효하지 않습니다.",
    14025: "문서 검토를 생성하는 동안 오류가 발생했습니다. API 호출이 실패했습니다.",
    14026: "문서 검토를 삭제하는 동안 오류가 발생했습니다. API 호출이 실패했습니다.",
    14027: "Engagement ID는 null이거나 비워둘 수 없습니다",
    14028: "사용자 ID가 유효하지 않습니다",
    14029: "사용자는 이 작업을 수행할 권한이 없습니다",
    14030: "이 engagement에서 통과된 ID가 있는 문서를 찾을 수 없습니다",
    14031: "문서 검토 ID가 유효하지 않습니다",
    14032: "문서 검토를 찾을 수 없습니다",
    14033: "문서가 이미 승인됐습니다",
    14034: "Workspace 내 다른 engagement에서 링크 해제 진행 중이거나 이 문서가 이미 링크 해제됐습니다. 페이지를 새로 고침하여 다시 시도하십시오. 문제가 지속되면 헬프 데스크에 문의하십시오.",
    14035: "문서가 주어진 engagement와 공유되지 않았습니다",
    14036: "버전 번호는 0보다 커야 합니다",
    14037: "지금은 작업을 완료할 수 없습니다. 페이지를 새로 고침하여 다시 시도하십시오. 문제가 지속되면, 헬프 데스크에 문의하십시오.",
    14038: "문서 변경 사유를 가져오지 못했습니다",
    14039: "ID별 문서 변경 사유를 가져오지 못했습니다",
    14040: "변경 사유를 업데이트하지 못했습니다",
    14041: "유효하지 않은 변경 사유",
    14042: "변경 사유 업데이트 실패",
    14043: "변경 사유를 생성하지 못했습니다",
    14044: "변경 사유를 삭제하지 못했습니다",
    14045: "유효하지 않은 변경 사유 ID",
    14046: "문서를 사용할 수 없습니다. 페이지를 새로 고침하여 다시 시도하십시오. 문제가 지속되면 헬프 데스크에 문의하십시오.",
    14047: "문서에 배정된 변경 사유가 이미 있습니다",
    14048: "문서에 충돌이 있습니다. 계속하기 전에 해결하십시오.",
    14049: "문서가 팀이나 사용자에 추가됐는지 확인할 데이터가 유효하지 않습니다",
    14050: "참조 문서를 제거하는 동안 오류가 발생했습니다",
    14051: "모든 공유 증거 링크 해제 체크리스트를 찾을 수 없습니다",
    14052: "검색 텍스트가 최대 허용 길이(500자)를 초과합니다",
    14053: "요청이 null이므로 호출을 수행할 수 없습니다",
    14054: "유효하지 않은 패치 작업",
    14055: "문서 기록 해결 호출 실패",
    14056: "메시지를 대기 행렬에 넣는 동안 오류가 발생했습니다",
    14057: "이름이 동일한 문서가 engagement에 이미 있습니다",
    14058: 'More than one document version with the same number has been found. Please contact Help Desk for further assistance.',
    14059: 'The selected document version couldnt be found. Please refresh the page and try again. If the issue persists, please contact Help Desk for further assistance.',
    14060: 'The operation couldnt be completed at the time. Please try again later. If the issue persists, please contact Help Desk for further assistance.',
    14061: 'Document is not shared, cant unlink the document. If the issue persists, please contact Help Desk for further assistance.',
    14062: 'The document confidentiality type id is not valid.',
    14063: 'Cannot change confidentiality type of this document type.',
    14064: 'User doesnt have permission.',
    14065: 'Invalid custom description.',
    14066: 'Failed to update extension.',
    14067: 'Invalid extension.',
    14068: 'Failed to get document extensions.',
    14069: "이 문서는 다른 팀 멤버가 이미 링크 해제했습니다. 페이지를 새로 고침하고 오류가 지속되면 헬프 데스크에 문의하십시오.",
    14070: "유효하지 않은 파일 유형",
    14071: "선택된 문서 버전은 더 이상 사용할 수 없습니다. 기록된 버전 중 최신 문서를 보려면 이 창을 닫았다가 다시 여십시오.",
    14072: 'Source document Id should not be null or empty.',
    14073: 'Canvas form ids should not be null or empty.',
    14074: "Canvas form ID's should not be duplicates.",
    14075: 'Failed to associate document to canvas forms.',
    14076: "원천 문서와 연결된 Canvas 양식을 찾을 수 없습니다",
    14077: 'Source document not found. Call failed.',
    14078: 'Current document is already associated with given canvas forms.',
    14079: "이 문서는 삭제되어 열 수 없습니다",
    14080: 'The source approval user id is invalid.',
    14081: 'The source approval user id should valid GUID and must not be empty GUID.',
    14082: 'The modify user id is invalid.',
    14083: 'The modify user id should be a valid GUID and must not be empty GUID.',
    14084: 'File name cannot include: */:<>\\?|""',
    14085: 'The document name exceeded maximum length allowed.',
    14086: 'DocService failed while updating document details.',
    14087: 'The input is not valid.',
    14088: 'A input has duplicate document names.',
    14089: "북마크 관찰이 유효하지 않습니다",
    14090: "요청 상태가 변경됐습니다. 필요한 경우, 페이지를 새로 고침하여 다시 시도하십시오. 문제가 지속되면 헬프 데스크에 문의하십시오.",
    14091: "이 요청이 삭제됐습니다. 업데이트된 데이터를 보려면 페이지를 새로 고침하십시오. 문제가 지속되면 헬프 데스크에 문의하십시오.",
    14092: 'Document not eligible for update. Refresh the page and try again.  If the issue persists, contact the Help Desk.',

    /*SEM*/
    15001: "유효하지 않은 요청으로 인해 계정 ID에 대한 SEM 요약 가져오기 호출 실패",
    15002: "유효하지 않은 계정 ID",
    15003: "유효하지 않은 Engagement ID",
    15004: "유효하지 않은 요약 유형",
    15005: "연결된 계정을 찾을 수 없습니다. 페이지를 새로 고침하여 다시 시도하십시오. 문제가 지속되면 헬프 데스크에 문의하십시오.",

    /*Timephase*/
    16001: "시기 가져오기 실패",
    16002: "Engagement는 0보다 커야 합니다",
    16003: "시기는 0보다 커야 합니다",
    16004: "유효하지 않은 task ID 값",
    16005: "유효하지 않은 시기 값",

    /*Validations*/
    17001: "작성 단계 ID 또는 문서 유형 ID 누락",

    /*TaskGroupSection*/
    18001: "모든 task 그룹 가져오기 그룹 호출 실패",
    18005: "이 engagement에서 이 task 그룹을 더 이상 사용할 수 없습니다",
    18006: 'This task group is no longer available. Refresh the page and try again. If the issue persists, contact the Help Desk.',
    18016: "연결된 task가 없을 때만 task 그룹을 삭제할 수 있습니다. 연결된 task를 삭제하거나 이동한 후 다시 시도하십시오.",
    18019: "업데이트하려는 task 그룹이 이미 삭제됐습니다",

    /*Assignments*/
    19001: "배정 생성 호출 실패",
    19002: "배정 가져오기 호출 실패",
    19003: "배정 이름은 고유해야 합니다",
    19004: "유효하지 않은 배정 이름",
    19005: "배정 이름 길이가 100자를 초과합니다",
    19006: "유효하지 않은 배정 유형",
    19007: "배정 검색 길이가 500자를 초과합니다",
    19008: "다른 팀 멤버가 이 배정 이름을 삭제했습니다. 페이지를 새로 고침하여 다시 시도하십시오.",

    19012: "이 Task ID는 반복될 수 없습니다",
    19013: "역할 ID와 사용자 ID 필드는 동시에 값을 가질 수 없습니다",
    19014: "사용자 ID는 기본값이 될 수 없습니다",
    19016: "PIC 사용자가 유효하지 않거나 PIC 사용자가 초대되지 않았습니다",
    19017: "EQR 사용자가 유효하지 않거나 EQR 사용자가 초대되지 않았습니다",
    19018: "만료 전 기간 값이 0보다 크고 1000보다 작아야 합니다",
    19019: "Task 자동 배정 생성 호출 실패",

    /*Client Request*/
    21001: "요청을 EY Canvas Client Portal에 전송하지 못했습니다. 페이지를 새로 고침하여 다시 시도하십시오. 문제가 지속되면 헬프 데스크에 문의하십시오.",
    21002: "요청이 삭제됐습니다. 업데이트된 데이터를 보려면 페이지를 새로 고침하십시오. 문제가 지속되면 헬프 데스크에 문의하십시오.",
    21009: "고객 요청 문서 삭제 호출 실패",
    21010: "회신하려는 comment를 다른 팀 멤버가 삭제했습니다. 페이지를 새로 고침하여 다시 시도하십시오.",
    21011: "고객 요청 문서가 삭제됐습니다",
    21012: "고객 요청 문서를 찾을 수 없습니다",
    21013: "문서 요청이 비었습니다",
    21014: "문서 ID가 비었습니다",
    21015: "고객 요청 ID가 비었습니다",
    21016: "고객 요청 문서 생성 호출 실패",
    21017: "하나 이상의 연결된 문서가 engagement에서 삭제됐습니다. 이 요청에서 삭제된 문서를 제거하거나 페이지를 새로 고침하여 다시 시도하십시오.",
    21018: "문서를 찾을 수 없습니다",
    21019: "고객 요청 상태가 변경됐습니다",
    21030: "고객 그룹 ID가 일치하지 않습니다",
    21031: "요청 상태가 변경됐습니다. 필요한 경우, 페이지를 새로 고침하여 다시 시도하십시오. 문제가 지속되면 헬프 데스크에 문의하십시오.",
    21032: "고객 그룹 연락 담당자가 활동 상태가 아닙니다",
    21033: "고객 그룹이 활성 상태가 아닙니다",
    21034: "고객 그룹에 활동 사용자가 없습니다",
    21045: "요청 상태가 변경됐습니다. 최신 변경사항을 보려면 페이지를 새로 고침하십시오.",
    21046: "요청을 EY Canvas Client Portal에 전송하지 못했습니다. 페이지를 새로 고침하여 다시 시도하십시오. 문제가 지속되면 헬프 데스크에 문의하십시오.",
    21050: "요청사항을 삭제할 수 없었습니다. 페이지를 새로 고침하여 다시 시도하십시오. 문제가 지속되면 헬프 데스크에 문의하십시오.",
    21053: "Engagement에서 task를 더 이상 사용할 수 없습니다. 페이지를 새로 고침하여 목록을 업데이트하십시오.",
    21057: "EY 연락처를 배정할 수 없습니다. 페이지를 새로 고침하여 다시 시도하십시오.",
    21028: "만료일은 필수입니다",
    21036: "시기를 찾을 수 없습니다",
    21064: "Task를 요청과 연결할 수 없습니다. 요청사항은 최대 25개 task와 연결할 수 있습니다. 새로운 task에 연결하려면 연결된 task를 하나 이상 제거하십시오.",
    21065: "하나 이상의 기밀 문서가 요청사항에 추가됐습니다. 이 문서 중 하나 이상을 EY Canvas Client Portal로 전송하는 데 적합한 기밀 수준이 귀하에게 없습니다. 계속하려면 접근 권한이 없는 기밀 문서를 제거하십시오.",
    21066: "데이터 검색에 오류가 발생했습니다. 페이지를 새로 고침하여 다시 시도하십시오. 오류가 지속되면 헬프 데스크에 문의하십시오.",
    21067: "우선순위를 업데이트할 수 없습니다. 페이지를 새로 고침하여 다시 시도하십시오. 문제가 지속되면 헬프 데스크에 문의하십시오.",
    21035: "고객 요청을 찾을 수 없습니다",
    21074: "수신된 요청은 제목, 설명, 우선순위를 변경할 수 없습니다",
    21075: "수락된 요청은 제목, 설명, (그룹) 담당자, (사용자) 담당자, 만료일, 우선순위를 변경할 수 없습니다",
    21077: "수신됨 및 보류 중 상태인 고객 요청사항에는 만료일이 필수입니다",
    21039: "고객 그룹 ID를 찾을 수 없습니다",
    21078: "그룹 담당자 또는 사용자 담당자를 업데이트할 때는 그룹과 사용자가 모두 필수입니다",
    21079: "날짜 형식이 유효하지 않습니다",
    21027: "요청 제목은 필수입니다",
    21041: "요청 제목 길이가 최대 허용 문자수를 초과합니다",
    21042: "요청 설명 길이가 최대 허용 문자수를 초과합니다",
    21060: "고객 사용자 ID가 비었습니다",
    21076: "우선순위 유형이 허용되지 않습니다",

    /* Group Components*/
    22001: "연결된 부문 가져오기 호출 실패",
    22002: "그룹 부문 가져오기 호출 실패",
    22003: "그룹 부문 생성 호출 실패",
    22004: "유효하지 않은 상위 부문 ID. 귀하가 지정한 상위 부문이 존재하지 않습니다.",
    22005: "팀 이름이 최대 길이를 초과했습니다",
    22006: "팀 법적 이름이 최대 길이를 초과했습니다",
    22008: "귀하가 지정한 범위가 존재하지 않습니다",
    22009: "유효하지 않은 부문 이름",
    22010: "유효하지 않은 부문 법인 이름",
    22011: "유효하지 않은 부문 범위 ID",
    22012: "연락처 이메일이 제공됐다면 연락처 안내는 null이거나 비워둘 수 없습니다",
    22013: "연락처 이메일이 제공됐다면 연락처 텍스트는 null이거나 비워둘 수 없습니다",
    22016: "이 팀을 다른 팀 멤버가 이미 삭제했습니다. 페이지를 새로 고침하여 다시 시도하십시오.",
    22022: "팀 이름이 이 engagement에 이미 있습니다",
    22043: "지침 보내기 호출 실패",

    /*User Presence*/
    23001: "로그인한 사용자 기본 설정을 찾을 수 없습니다",
    23002: "사용자 기본 설정 가져오기 호출 실패",
    23003: "사용자 기본 설정 문서 유효성 검증 실패",
    23004: "사용자 기본 설정 삭제 호출 실패",
    23005: "다른 사용자가 더 이상 문서를 열고 있지 않습니다. 페이지를 새로 고침하여 다시 시도하십시오. 문제가 지속되면 헬프 데스크에 문의하십시오.",

    /* Forms */
    24001: "양식 가져오기 호출 실패",
    24002: "유효하지 않은 Engagement ID",
    24003: "문서 ID는 null이거나 비워둘 수 없습니다",
    24004: "유효하지 않은 문서 ID",
    24005: "유효하지 않은 양식 머리글 ID",
    24006: "유효하지 않은 양식 섹션 ID",
    24007: "유효하지 않은 요청 파라미터",
    24008: "머리글 ID는 null이거나 비워둘 수 없습니다",
    24009: "섹션 ID는 null이거나 비워둘 수 없습니다",
    24010: "양식 본문 응답 업데이트 작업 실패",
    24011: "유효하지 않은 양식 본문 응답 업데이트 요청",
    24012: "유효하지 않은 본문 ID",
    24013: "유효하지 않은 양식 본문 옵션 ID",
    24014: "유효하지 않은 양식 본문 유형 ID",
    24015: "주어진 본문 유형 ID에 대한 유효하지 않은 요청 본문",
    24016: "주어진 본문 유형 ID에 대한 유효하지 않은 자유 텍스트",
    24017: "Rich text 서식 태그를 포함한 최대 문자 수. 길이를 줄이거나 불필요한 서식을 제거하고 다시 시도하십시오.",
    24018: "지정된 본문 유형 ID의 경우, 응답이 허용되지 않습니다",
    24019: "본문 ID는 null이거나 비워둘 수 없습니다",
    24020: "유효하지 않은 요청 본문",
    24021: "본문이 삭제됐습니다",
    24038: "문서가 유효하지 않거나 존재하지 않습니다",
    24049: "선택한 object가 삭제됐습니다. 페이지를 새로 고침하여 다시 시도하십시오. 오류가 지속되면 헬프 데스크에 문의하십시오.",
    24057: "문서 양식 프로필 유효성 검증 실패",
    24063: "국가 ID가 유효하지 않습니다",
    24064: "언어 ID가 유효하지 않습니다",

    /*Document Change Types*/
    25001: "문서 변경 유형 가져오기 호출 실패",
    25002: "유효하지 않은 Engagement ID",
    25003: "유효하지 않은 요청",

    /* Manage team */
    26001: "고객 사용자 그룹 모두 가져오기 호출 실패",
    26002: "신규 고객 그룹 / 이메일 도메인 생성 호출 실패",
    26003: "그룹 이름은 null일 수 없습니다",
    26004: "이메일 도메인은 null일 수 없습니다",
    26005: "{0} 이메일 도메인 레이블은 263을 초과할 수 없습니다",
    26006: "{0} 이메일 도메인은 263자를 초과할 수 없습니다",
    26007: "{0} 이메일 도메일 첫 부분은 * 또는 문자나 숫자이며 기타 특수문자는 허용되지 않습니다",
    26008: "{0} 첫 부분에 와일드카드가 있으면 그 다음 부분은 둘 이상이어야 합니다.",
    26009: "{0} 첫 부분은 * 또는 문자나 숫자이며 기타 도메인 부분에 특수문자는 허용되지 않습니다",
    26010: "이메일 도메인은 고유해야 합니다",
    26011: "제공된 고객 접근 그룹 ID가 유효하지 않습니다",
    26012: "접근 그룹을 삭제하는 동안 오류가 발생했습니다. 이 그룹 또는 이 그룹의 멤버에게 배정된 요청사항/외부 Task가 없는지 확인하고 다시 시도하십시오.",
    26013: "접근 그룹이 이미 삭제됐습니다. 최신 데이터를 가져오려면 페이지를 새로 고침하십시오.",
    26014: "하나 이상의 이메일 도메인은 필수입니다",
    26015: "지금 EY Canvas Client Portal에 접근할 수 없으며 기존 멤버 정보를 업데이트해야 합니다. 다시 시도하고 문제가 지속되면, 헬프 데스크에 문의하십시오.",
    26016: "삭제 작업 중 오류.",
    26017: "데이터 가져오기 작업 실패",
    26018: "동시성 문제. 접근 그룹이 더 이상 활성 상태가 아닙니다. 페이지를 새로 고침하고 다시 시도하십시오.",
    26019: "저장 작업 실패",
    26020: "이메일 도메인에 활동 사용자가 배정되어 있으므로 이를 제거할 수 없습니다. 변경사항은 저장되지 않습니다.",


    /* TimePhaseTypes - Milestones */
    27001: "Milestone 세부정보 가져오기 실패",

    /*Client Request Counts*/
    28001: "고객 요청사항 정보 가져오기 호출이 결과를 가져오지 못했습니다",

    /*Content updates Error messages*/
    29001: "ID별 가져오기를 찾을 수 없습니다",
    29002: "작업 유형을 찾을 수 없습니다",
    29003: "내용 ID를 찾을 수 없습니다",
    29004: "내용 업데이트 API 호출 실패",
    29005: "내용 업데이트 진행 중. 나중에 다시 시도하십시오. 문제가 지속되면 헬프 데스크에 문의하십시오.",
    29006: "유효하지 않은 요청 파라미터",
    29010: "내용을 새로 고치고 있습니다. 나중에 다시 시도하십시오. 문제가 오래 지속되면 IT 헬프 데스크에 문의하십시오.",
    29012: "Engagement에 적용 기준 프로필 질문이 없습니다. IT 헬프 데스크에 문의하십시오.",
    29013: "공유된 EY Canvas FIT enablement 활동이 있는 경우 주요 표준 task(PST)와 프로필 내용 업데이트가 허용되지 않습니다. PST 또는 프로필 내용을 업데이트하려면 해당 활동에서 링크를 해제하십시오. 여러 내용 업데이트 유형을 선택한 경우, PST 및/또는 프로필 선택을 해제하고 업데이트를 다시 개시하십시오.",
    /*IT Process*/
    30001: "모든 IT 프로세스 가져오기 실패",
    30002: "모든 IT 프로세스 가져오기 - 유효하지 않은 engagement ID",
    30003: "IT 프로세스 이름은 비워둘 수 없습니다",
    30004: "IT 프로세스 이름은 500자를 초과할 수 없습니다",
    30005: "IT 프로세스 ID가 유효하지 않습니다",
    30006: "ID별 IT 프로세스 가져오기 호출 실패",
    30007: "유효하지 않은 요청",
    30008: "IT 프로세스가 유효하지 않습니다",
    30009: "문서를 찾을 수 없습니다",
    30010: "IT 프로세스 삭제 실패",
    30012: "유효하지 않은 IT 위험",

    /*Checklist*/
    31001: "모든 체크리스트 가져오기 호출 실패",
    31002: "체크리스트 입력 호출 실패",
    31003: "유효하지 않은 체크리스트 파라미터",
    31004: "유효하지 않은 Engagement 오류",
    31005: "유효하지 않은 요청 파라미터 오류",
    31006: "유효하지 않은 확인 요청 파라미터 오류",

    /*Archive*/
    32001: "Engagement 상태가 유효하지 않습니다. 유효성 검증을 해결하고 archive 프로세스를 다시 시도하십시오. 오류가 지속되면 헬프 데스크에 문의하십시오.",
    32002: "양식 본문 표시 상태를 업데이트하는 동안 archive에 실패했습니다. 다시 시도하십시오. 오류가 지속되면 헬프 데스크에 문의하십시오.",
    32003: "Engagement 상태를 업데이트하는 동안 archive에 실패했습니다. 다시 시도하십시오. 오류가 지속되면 헬프 데스크에 문의하십시오.",
    32004: "Engagement 캐시를 무효화하는 동안 archive에 실패했습니다. 다시 시도하십시오. 오류가 지속되면 헬프 데스크에 문의하십시오.",
    32005: "내용 업데이트가 진행 중입니다. 내용 업데이트가 완료될 때까지 이 engagement를 archive할 수 없습니다. 나중에 다시 시도하고 오류가 지속되면 헬프 데스크에 문의하십시오.",
    32006: "이 engagement에 해결되지 않은 유효성 검증이 있습니다. 페이지를 새로 고침하여 유효성 검증을 해결하고 archive 프로세스를 다시 시도하십시오. 오류가 지속되면 헬프 데스크에 문의하십시오.",
    32007: "ARC 요청 모델을 작성하는 동안 archive에 실패했습니다. 다시 시도하십시오. 오류가 지속되면 헬프 데스크에 문의하십시오.",
    32008: "Arc API URL을 가져오는 동안 archive에 실패했습니다. 다시 시도하십시오. 오류가 지속되면 헬프 데스크에 문의하십시오.",
    32009: "Arc API를 호출하는 동안 archive에 실패했습니다. 다시 시도하십시오. 오류가 지속되면 헬프 데스크에 문의하십시오.",
    32010: "Arc API 응답에서 데이터가 누락되어 archive에 실패했습니다. 다시 시도하십시오. 오류가 지속되면 헬프 데스크에 문의하십시오.",
    32011: "Arc 양식 세부정보를 저장하는 동안 archive에 실패했습니다. 다시 시도하십시오. 오류가 지속되면 헬프 데스크에 문의하십시오.",
    32012: "재시도를 위해 Engagement 상태를 업데이트하는 동안 archive에 실패했습니다. 다시 시도하십시오. 오류가 지속되면 헬프 데스크에 문의하십시오.",
    32013: "Archive 메시지를 대기 행렬에 넣는 동안 archive에 실패했습니다. 다시 시도하십시오. 오류가 지속되면 헬프 데스크에 문의하십시오.",
    32014: "Archive에 성공했으나, Universal 상태 업데이트 메시지를 대기 행렬에 넣는 동안 오류가 발생했습니다. 오류가 지속되면 헬프 데스크에 문의하십시오.",
    32015: "Archive에 성공했으나 CCP 상태 업데이트 메시지를 대기 행렬에 넣는 동안 오류가 발생했습니다. 오류가 지속되면 헬프 데스크에 문의하십시오.",
    32016: "Archive 프로세스를 재시도하려면 Engagement 상태가 Archive 오류 상태여야 합니다",
    32017: "Engagement를 찾을 수 없습니다. 다시 시도하십시오. 오류가 지속되면 헬프 데스크에 문의하십시오.",
    32019: "지금은 귀하의 요청을 처리할 수 없습니다. 다시 시도하십시오. 문제가 지속되면, EY Support에 문의하십시오.",
    32020: "ARC URL이 구성되지 않았습니다. 다시 시도하십시오. 오류가 지속되면 헬프 데스크에 문의하십시오.",
	32200: 'Engagement에 해결되지 않은 유효성 검증이 있습니다. 보고에서 유효성 검증 보고서를 실행하거나 "기타 " 메뉴에 있는 "유효성 검증 도움말 " 링크에서 추가 세부정보를 참조합니다. 오류가 지속되면 헬프 데스크에 문의하십시오. ',
    32400: "ARC 시스템과 통신하는 동안 다음 오류가 발생했습니다. 계속하려면 헬프 데스크에 문의하여 이 오류 메시지를 보여 주십시오.",

    /*RBAC*/
    33001: "ARC 유효성 검증 오류, 페이지를 새로 고침하고 유효성 검증을 해결한 후 archive 프로세스를 다시 시도하십시오. 오류가 지속되면 헬프 데스크에 문의하십시오.",
    33002: "더 이상 존재하지 않는 comment를 편집하려고 합니다. 페이지를 새로 고침하여 다시 시도하십시오.",

    /*Helix Linked Projects*/
    34001: "EY Helix 프로젝트가 이미 링크 해제됐습니다. 페이지를 새로 고침하여 다시 시도하십시오. 문제가 지속되면 헬프 데스크에 문의하십시오",
    34002: "Engagement ID는 null이거나 비워둘 수 없습니다",
    34003: "호출에서 본문은 null이거나 비워둘 수 없습니다",
    34004: "프로젝트 ID는 null이거나 비워둘 수 없습니다",
    34005: "프로젝트 이름은 null이거나 비워둘 수 없습니다",
    34006: "EY Helix 프로젝트가 이미 링크됐습니다. 페이지를 새로 고침하여 다시 시도하십시오. 문제가 지속되면 헬프 데스크에 문의하십시오",
    34007: "모든 Helix 프로젝트 가져오기 호출 실패",
    34008: "Engagement ID는 0보다 커야 합니다",
    34009: "작업을 완료할 수 없었습니다. 페이지를 새로 고침하여 다시 시도하십시오. 문제가 지속되면 헬프 데스크에 문의하십시오.",
    34020: "Helix Project에 링크할 수 없습니다.  페이지를 새로 고침하여 다시 시도하십시오. 문제가 지속되면 헬프 데스크에 문의하십시오.",
    34024: "Helix에 알림을 보낼 수 없습니다. 이 프로젝트에 region 정보가 누락됐습니다.",
    34029: "프로젝트 위치가 EY Canvas engagement의 위치와 일치하지 않기 때문에 프로젝트가 연결되지 않았습니다",
    34030: "Analyzer를 링크할 수 없습니다. 귀하는 선택한 analyzer에 권한이 있는 팀 멤버가 아닙니다. 접근권한을 얻으려면 EY Helix 프로젝트 관리자에게 문의하고 다시 시도하십시오.",
    34031: "귀하는 이전에 EY Helix application에 접속한 적이 없는 것으로 보입니다",
    34038: "선택한 분석을 더 이상 사용할 수 없습니다. 페이지를 새로 고침하여 다시 시도하십시오. 문제가 지속되면, 헬프 데스크에 문의하십시오.",
    34043: "선택된 EY Helix 프로젝트를 더 이상 사용할 수 없습니다. ‘프로젝트 링크’를 클릭하여 다른 프로젝트를 링크하십시오.",
    34044: "선택된 EY Helix 프로젝트가 삭제 표시됐습니다. ‘프로젝트 링크’를 클릭하여 다른 프로젝트를 링크하십시오.",
    34045: "선택된 EY Helix 프로젝트가 저장 표시됐습니다. ‘프로젝트 링크’를 클릭하여 다른 프로젝트를 링크하십시오.",
    34046: "유효하지 않거나 EY Helix에서 누락된 analyzer. 페이지를 새로 고침하여 다시 시도하십시오. 문제가 지속되면, 헬프 데스크에 문의하십시오.",
    34047: "선택된 analyzer를 EY Helix에서 사용할 수 없습니다. 페이지를 새로 고침하여 다시 시도하십시오. 문제가 지속되면, 헬프 데스크에 문의하십시오.",
    34048: "분석을 링크된 프로젝트에서 사용할 수 없습니다. 계속하려면 EY Helix로 이동하여 데이터 및 분석 처리 단계를 완료하십시오.",
    34080: "최대 Engagement Helix 연결 수가 초과됐습니다",

    /* PAANS */
    35001: "지금은 EY 정책 작성, 승인 및 알림 서비스를 사용할 수 없습니다. 따라서 관련 정책이 모두 완료됐는지 확인할 수 없습니다. 관련 정책을 검토하지 않았다면, 페이지를 새로 고침하여 다시 시도하십시오. 문제가 지속되면 헬프 데스크에 문의하십시오.",

    /*Engagement Comments*/
    38001: "Engagement comment 생성 호출 실패",
    38002: "모든 engagement comment 가져오기 호출 실패",
    38003: "이 작업을 완료할 수 없습니다. 페이지를 새로 고침하여 다시 시도하십시오. 오류가 지속되면 헬프 데스크에 문의하십시오.",
    38004: "이 작업을 완료할 수 없습니다. 페이지를 새로 고침하여 다시 시도하십시오. 오류가 지속되면 헬프 데스크에 문의하십시오.",
    38005: "이 작업을 완료할 수 없습니다. 페이지를 새로 고침하여 다시 시도하십시오. 오류가 지속되면 헬프 데스크에 문의하십시오.",
    38006: "이 작업을 완료할 수 없습니다. 페이지를 새로 고침하여 다시 시도하십시오. 오류가 지속되면 헬프 데스크에 문의하십시오.",
    38007: "이 작업을 완료할 수 없습니다. 페이지를 새로 고침하여 다시 시도하십시오. 오류가 지속되면 헬프 데스크에 문의하십시오.",
    38008: "이 작업을 완료할 수 없습니다. 페이지를 새로 고침하여 다시 시도하십시오. 오류가 지속되면 헬프 데스크에 문의하십시오.",
    38009: "이 작업을 완료할 수 없습니다. 페이지를 새로 고침하여 다시 시도하십시오. 오류가 지속되면 헬프 데스크에 문의하십시오.",
    38010: "본문은 null일 수 없습니다",
    38011: "Comment 텍스트는 null이거나 비워둘 수 없습니다",
    38012: "주어진 engagement에 기업이 존재하지 않습니다",
    38013: "Engagement comment 상태 ID는 0보다 커야 합니다",
    38014: "Parent engagement comment ID는 0보다 커야 합니다",
    38015: "지정 조건과 일치하는 Canvas 양식 본문이 없습니다",
    38016: "회신하려는 노트를 다른 팀 멤버가 삭제했습니다. 페이지를 새로 고침하여 다시 시도하십시오.",
    38017: "제공된 parent engagement comment가 처리됐습니다",
    38018: "제공된 parent engagement comment는 회신 그 자체입니다",
    38019: "제공된 comment 텍스트는 1자보다 짧으면 안 되며 4,000자보다 길어도 안 됩니다",
    38020: "제공된 기업 UID가 유효하지 않습니다",
    38021: "제공된 지배기업 UID가 유효하지 않습니다",
    38022: "Engagement comment 삭제 호출 실패",
    38023: "Comment ID는 비워둘 수 없습니다",
    38024: "작업은 유효한 작업이어야 합니다",
    38025: "노트의 상태가 변경됐습니다. 페이지를 새로 고침하여 다시 시도하십시오.",
    38026: "리뷰노트는 이를 생성한 사용자만 삭제할 수 있습니다",
    38027: "더 이상 존재하지 않는 comment를 편집하려고 합니다. 페이지를 새로 고침하여 다시 시도하십시오.",
    38028: "처리된 comment에 대한 업데이트는 허용되지 않습니다",
    38029: "작성자만 comment의 텍스트를 수정할 수 있습니다",
    38030: "Engagement comment ID가 유효하지 않습니다",
    38031: "Comment 상태 ID는 비워둘 수 없습니다",
    38032: "요청된 사용자와 engagement 간 관계 기록이 없습니다. 페이지를 새로 고침하여 다시 시도하십시오. 오류가 지속되면 헬프 데스크에 문의하십시오.",
    38033: "업데이트 작업이 유효하지 않습니다",
    38034: "요청된 comment ID가 이미 다른 comment에 사용되고 있습니다",
    38035: "제공된 comment ID가 유효하지 않습니다",
    38036: "문서 ID는 null이거나 비워둘 수 없습니다",
    38037: "Comment가 배정될 사용자 ID는 null일 수 없습니다",
    38038: "Comment를 열거나 닫는 동안 재배정하면 안 됩니다",
    38039: "삭제하려는 회신이 있는 노트가 이미 삭제됐습니다. 페이지를 새로 고침하여 다시 시도하십시오.",
    38040: "회신에 만료일이 없어야 합니다",
    38041: "회신에 우선순위가 없어야 합니다",
    38042: "Comment에 만료일이 있어야 합니다",
    38043: "Comment에 우선순위가 있어야 합니다",
    38044: "더 이상 존재하지 않는 comment에 대한 회신을 편집하려고 합니다. 페이지를 새로 고침하여 다시 시도하십시오.",
    38045: "사용자에게 배정된 Engagement 상태 ID와 그 내용, 또는 우선순위를 모두 편집하는 것은 허용되지 않습니다",
    38046: "Engagement comment 업데이트 호출 실패",
    38047: "처리 전 노트에만 회신할 수 있습니다",

    /*Tags*/
    39004: "편집하고 있는 태그 그룹을 다른 팀 멤버가 삭제했습니다. 페이지를 새로 고침하여 다시 시도하십시오.",
    40003: "선택한 태그 그룹을 다른 팀 멤버가 삭제했습니다. 계속하려면 다른 태그 그룹을 선택합니다.",
    40007: "선택한 노트가 하나 이상 삭제됐습니다. 페이지를 새로 고침하여 다시 시도하십시오. 오류가 지속되면 헬프 데스크에 문의하십시오.",
    40011: 'Note index cannot exceed 5 characters.',
    40012: "태그 색상 코드가 유효하지 않습니다. 페이지를 새로 고침하여 다시 시도하십시오.",
    40014: "편집하고 있는 태그가 포함된 태그 그룹을 다른 팀 멤버가 삭제했습니다. 페이지를 새로 고침하여 다시 시도하십시오.",
    40016: "선택한 task 중 일부에 태그를 추가하거나 제거할 수 없습니다. 페이지를 새로 고침하여 다시 시도하십시오. 오류가 지속되면 헬프 데스크에 문의하십시오.",
    40019: "편집하고 있는 태그 중 일부를 다른 팀 멤버가 삭제했습니다. 페이지를 새로 고침하여 다시 시도하십시오.",
    40020: "일부 태그를 지금 바로 동기화할 수 없습니다. 페이지를 새로 고침하여 다시 시도하십시오. 오류가 지속되면 헬프 데스크에 문의하십시오.",
    40021: "선택한 태그 중 일부가 삭제됐습니다. 페이지를 새로 고침하여 다시 시도하십시오.",
    40022: "이 engagement에 외부 팀 멤버를 하나 이상 추가한 후 이 작업을 다시 시도하십시오. 이 오류가 지속되면 헬프 데스크에 문의하십시오.",
    40027: 'Description is too long.',

    // Scheduler request
    70022: "이 서비스 요청에 연결된 task가 없습니다. 계속하려면 페이지를 새로 고침하고 삭제되지 않은 task를 하나 이상 선택하십시오. 오류가 지속되면 헬프 데스크에 문의하십시오.",
    70024: "Engagement에서 사용 가능한 중앙집중식 서비스가 없습니다. 페이지를 새로 고침하여 다시 시도하십시오. 오류가 지속되면 헬프 데스크에 문의하십시오.",
    70025: "해당 국가에서 현재 사용 가능한 중앙집중식 서비스가 없습니다. 페이지를 새로 고침하여 다시 시도하십시오. 오류가 지속되면 헬프 데스크에 문의하십시오.",

    /* TaskDocumnet */
    80001: "Task 문서 연결 생성 실패",
    80002: "요청에는 task가 하나 이상 있어야 합니다",
    80003: "문서 ID가 있어야 합니다",
    80004: "선택한 task가 삭제됐습니다. 페이지를 새로 고침하여 다시 시도하십시오. 오류가 지속되면 헬프 데스크에 문의하십시오.",
    80005: "문서 ID가 유효하지 않습니다",
    80006: "사용자에게 이 작업을 수행할 권한이 없습니다",
    80007: "Task 문서 연결 실패",
    80008: "Task 문서 연결 후, task 상태 변경 실패",
    80011: "기밀 문서는 공유할 수 없습니다",
    80012: "유효하지 않거나 비어 있는 요청 페이로드",
    80013: "Task 한도를 초과했습니다. 한 번에 300개 이하의 task를 선택하십시오.",
    80014: "문서에 링크하는 동안 오류가 발생했습니다. 페이지를 새로 고침하여 다시 시도하십시오. 문제가 지속되면 헬프 데스크에 문의하십시오.",

    /* ITApplication / SO */
    81001: "모든 IT Application 가져오기 실패",
    81002: "모든 IT Application 가져오기 - 유효하지 않은 engagement ID",
    81003: "선택한 IT application은 삭제됐습니다. 업데이트된 목록을 보려면 이 모달을 닫으십시오.",
    81004: "이름은 비워둘 수 없습니다",
    81005: "이름은 500자를 초과할 수 없습니다",
    81006: "유효하지 않은 전략 유형 ID",
    81007: "유효하지 않은 문서 ID",
    81008: "ID별 IT Application 가져오기 실패",
    81009: "유효하지 않은 분류",
    81010: "유효하지 않은 SCOT",
    81011: "유효하지 않은 통제",
    81012: "IT Application ID는 null이거나 비워둘 수 없습니다",
    81013: "IT Application을 찾을 수 없습니다",
    81014: "IT Application IT Process 삭제 호출 실패",
    81015: "IT Application IT Process ID는 비워둘 수 없습니다",
    81016: "유효하지 않은 IT Application IT Process ID",
    81017: "IT Application IT Process를 찾을 수 없습니다",
    81018: "IT Application IT Process 생성 호출 실패",
    81019: "IT Application 대신 서비스조직을 통과했습니다",

    /* Controls */
    83001: "통제를 가져오지 못했습니다",
    83002: "이 작업을 수행할 수 없습니다. 페이지를 새로 고침하여 다시 시도하십시오. 문제가 지속되면, 헬프 데스크에 문의하십시오.",
    83003: "통제 ID는 null이거나 비워둘 수 없습니다",
    83004: 'The selected Control has been deleted. Close this modal to see the updated list.',
    83005: "문서 ID가 유효하지 않습니다",
    83006: "통제 이름 누락",
    83007: "유효하지 않은 통제 이름 길이",
    83008: "유효하지 않은 요청",
    83009: "유효하지 않은 통제 빈도 ID",
    83010: "유효하지 않은 통제 유형 ID",
    83011: "유효하지 않은 통제 IT application",
    83012: "유효하지 않은 통제 설계 효과성 유형 ID",
    83013: "유효하지 않은 IT Applicatin ID",
    83014: "통제 유형이 수동 예방 또는 수동 적발 유형인 경우 SO 유형 IT Application만 허용됩니다",
    83015: "ITDM만 수동 IPE 테스트를 선택할 수 있습니다",
    83016: "이 프로필이 있는 engagement에는 위험이 낮은 통제가 허용되지 않습니다",
    83017: "중복 필터 SCOT",
    83018: "통제 이름이 500자를 초과합니다",
    83019: "유효하지 않은 WCGW ID",
    83020: "중복 WCGW ID가 허용되지 않습니다",
    83021: "중복 IT Application ID가 허용되지 않습니다",
    83023: "유효하지 않은 현재 페이지",
    83024: "유효하지 않은 페이지 크기",
    83025: "검색 문자열은 100자를 초과할 수 없습니다",
    83026: "서비스 조직이 없는 IT Application은 IT 의존 수동 통제 또는 IT Application 통제 유형에만 연결될 수 있습니다",
    83027: "중복 필터 WCGW",
    83028: "유효하지 않은 Knowledge 통제 ID",

    /* ITControl */
    84001: "IT 통제를 가져오지 못했습니다",
    84002: "ID별 IT 통제를 가져오지 못했습니다",
    84003: "IT 통제 ID가 null이거나 비어 있습니다",
    84004: "유효하지 않은 IT 통제 ID",
    84005: "문서 ID가 유효하지 않습니다",
    84006: "IT 통제 이름 누락",
    84007: "유효하지 않은 IT 통제 이름 길이",
    84008: "유효하지 않은 IT 통제 빈도 ID",
    84009: "유효하지 않은 IT 통제 접근법 유형 ID",
    84010: "유효하지 않은 IT 통제 설계 효과성 유형 ID",
    84011: "유효하지 않은 IT 통제 테스트 값",
    84012: "유효하지 않은 IT 통제 운영 효과성 유형 ID",
    84013: "IT 통제 빈도 누락",
    84014: "IT 통제 삭제 실패",
    84015: "검색 문자열은 100자를 초과할 수 없습니다",

    /*GroupTasks*/
    85001: "선택한 작업은 지금 완료할 수 없습니다. 페이지를 새로 고침하여 다시 시도하십시오. 오류가 지속되면 헬프 데스크에 문의하십시오.",
    85002: "선택한 작업은 지금 완료할 수 없습니다. 페이지를 새로 고침하여 다시 시도하십시오. 오류가 지속되면 헬프 데스크에 문의하십시오.",
    85003: "선택한 작업은 지금 완료할 수 없습니다. 페이지를 새로 고침하여 다시 시도하십시오. 오류가 지속되면 헬프 데스크에 문의하십시오.",
    85004: "선택한 작업은 지금 완료할 수 없습니다. 페이지를 새로 고침하여 다시 시도하십시오. 오류가 지속되면 헬프 데스크에 문의하십시오.",
    85005: "선택한 작업은 지금 완료할 수 없습니다. 페이지를 새로 고침하여 다시 시도하십시오. 오류가 지속되면 헬프 데스크에 문의하십시오.",
    85006: "선택한 작업은 지금 완료할 수 없습니다. 페이지를 새로 고침하여 다시 시도하십시오. 오류가 지속되면 헬프 데스크에 문의하십시오.",
    85007: "선택한 작업은 지금 완료할 수 없습니다. 페이지를 새로 고침하여 다시 시도하십시오. 오류가 지속되면 헬프 데스크에 문의하십시오.",
    85008: "선택한 작업은 지금 완료할 수 없습니다. 페이지를 새로 고침하여 다시 시도하십시오. 오류가 지속되면 헬프 데스크에 문의하십시오.",
    85009: "선택한 작업은 지금 완료할 수 없습니다. 페이지를 새로 고침하여 다시 시도하십시오. 오류가 지속되면 헬프 데스크에 문의하십시오.",
    85010: "선택한 작업은 지금 완료할 수 없습니다. 페이지를 새로 고침하여 다시 시도하십시오. 오류가 지속되면 헬프 데스크에 문의하십시오.",
    85011: "선택한 작업은 지금 완료할 수 없습니다. 페이지를 새로 고침하여 다시 시도하십시오. 오류가 지속되면 헬프 데스크에 문의하십시오.",
    85012: "선택한 문서는 다른 region 또는 부문에 이미 배정됐습니다. 따라서 배정할 수 없습니다. 페이지를 새로 고침하거나 다시 시도하십시오.",
    85013: "선택한 작업은 지금 완료할 수 없습니다. 페이지를 새로 고침하여 다시 시도하십시오. 오류가 지속되면 헬프 데스크에 문의하십시오.",
    85014: "선택한 작업은 지금 완료할 수 없습니다. 페이지를 새로 고침하여 다시 시도하십시오. 오류가 지속되면 헬프 데스크에 문의하십시오.",
    85015: "선택한 작업은 지금 완료할 수 없습니다. 페이지를 새로 고침하여 다시 시도하십시오. 오류가 지속되면 헬프 데스크에 문의하십시오.",
    85016: "Engagement ID는 0보다 커야 합니다",
    85017: "이 engagement에서 이 task를 더 이상 사용할 수 없습니다",
    85018: "유효하지 않은 문서 ID",
    85019: "귀하에게 이 문서를 전송하는 데 적합한 기밀 수준이 없습니다. 페이지를 새로 고침하여 다시 시도하십시오. 오류가 지속되면 헬프 데스크에 문의하십시오.",
    85020: "전송하려는 문서 중 하나 이상을 더 이상 전송할 수 없습니다. 페이지를 새로 고침하여 다시 시도하십시오. 오류가 지속되면 헬프 데스크에 문의하십시오.",
    85021: "Primary Team에 전송할 수 없는 양식",
    85022: "하나 이상의 문서를 전송하지 못했습니다. 페이지를 새로 고침하여 다시 시도하십시오. 오류가 지속되면 헬프 데스크에 문의하십시오.",

    /* ITRisk */
    86001: "IT 위험 이름은 비워둘 수 없습니다",
    86002: "IT 위험 이름은 500자를 초과할 수 없습니다",
    86003: "유효하지 않은 IT 위험 ID",
    86004: "ID별 IT 위험 가져오기 호출 실패",
    86005: "IT 위험을 찾을 수 없습니다",
    86006: "IT 위험 IT 통제 생성 호출 실패",
    86007: "유효하지 않은 IT 통제 ID",
    86008: "IT 위험 IT 통제 삭제 호출 실패",
    86009: "유효하지 않은 IT 위험 IT 통제 ID",
    86010: "IT 위험 삭제 실패",


    /*Copyhub*/
    88017: "내보내기 프로세스 서비스가 중단됐습니다 - 패키지가 일부 생성됐습니다",
    88018: "패키지 전송을 위해 선택한 사용자가 유효하지 않습니다 (유효하지 않은 이메일, GUI 또는 성명)",
    88033: "불러올 복사 패키지 상태가 유효하지 않습니다",
    88042: "한꺼번에 내보낼 권한이 없습니다",
    88045: "템플릿 engagement를 생성할 권한이 없습니다",
    88048: "현재 다른 사용자가 패키지를 불러오고 있습니다. 나중에 다시 시도하십시오.",
    88049: "패키지가 더 이상 존재하지 않습니다. 탭을 새로 고침하십시오.",
    88050: "다른 engagement 복사본이 현재 진행 중입니다",
    88051: "Engagement에 진행 중인 복사본이 너무 많습니다. 다른 복사를 개시하기 전에 복사가 완료될 때까지 기다리십시오.",
    88056: "작업을 완료할 수 없습니다. 페이지를 새로 고침하여 다시 시도하십시오. 문제가 지속되면, 헬프 데스크에 문의하십시오.",
    88057: "일부 선택한 문서에는 연결된 증거가 multi-user 편집 활성 모드로 포함되어 있습니다. 계속하려면 연결된 증거를 체크인하십시오. 오류가 지속되면, 헬프 데스크에 문의하십시오.",

    /* Group Scopes */
    92001: "모든 그룹 범위 가져오기 호출 실패",
    92002: "그룹 범위 생성 호출 실패",
    92003: "유효하지 않은 그룹 범위 업데이트 요청",
    92004: "유효하지 않은 범위 이름",
    92005: "유효하지 않은 Parent 범위 ID",
    92006: "Parent 범위가 존재하지 않습니다",
    92007: "유효하지 않은 범위 설명",
    92008: "그룹 범위 이름 길이가 100자를 초과합니다",
    92009: "그룹 범위 설명 길이가 500자를 초과합니다",
    92010: "그룹 범위 삭제 호출 실패",
    92011: "편집하고 있는 사용자지정 하위 범위를 다른 팀 멤버가 삭제했습니다. 페이지를 새로 고침하여 다시 시도하십시오. 오류가 지속되면 헬프 데스크에 문의하십시오.",
    92012: "지정 범위 ID가 유효하지 않습니다",
    92013: "이 사용자지정 하위 범위는 하나 이상의 팀에 배정되어 삭제할 수 없습니다",
    92014: "삭제하려는 사용자지정 하위 범위를 다른 팀 멤버가 이미 삭제했습니다. 페이지를 새로 고침하여 다시 시도하십시오.",
    92015: "사용자에게 이 작업을 수행할 권한이 없습니다.",
    92016: "이 engagement에 범위 이름이 이미 있습니다",
    92017: "ID별 그룹 범위 가져오기 호출 실패",

    /* Group Sections */
    101001: "그룹 섹션 생성 호출 실패",
    101002: "그룹 이름은 비워두거나 null일 수 없습니다",
    101003: "그룹 섹션 이름 길이가 100자를 초과합니다",
    101004: "이 engagement에 섹션 이름이 이미 있습니다",
    101005: "그룹 섹션 편집 호출 실패",
    101006: "섹션 ID가 유효하지 않습니다",
    101007: "그룹 섹션이 없습니다",
    101008: "유효하지 않은 Engagement ID",
    101009: "유효하지 않은 그룹 Knowledge 섹션",

    /* Group Documents */
    110001: "유효하지 않은 Engagement ID",
    110002: "유효하지 않은 지침 상태",
    110003: "ID별 engagement 가져오기 호출 실패",

    /* ClientEngagement */
    93001: "고객 engagement 설명을 찾을 수 없습니다",
    93002: "고객 engagement 설명은 100자보다 길 수 없습니다",
    93003: "고객 engagement 요청이 비었습니다",
    93004: "고객 engagement 가져오기 호출 실패",
    93005: "고객 engagement 업데이트 호출 실패",
    93006: "지금 Engagement 표시 이름을 업데이트할 수 없습니다. 페이지를 새로 고침하여 다시 시도하십시오. 오류가 지속되면 헬프 데스크에 문의하십시오.",

    /*IP FIltering */
    96005: "{0}이(가) 허용 목록에 추가되지 않았습니다",
    96015: "원천 engagement에 불러올 수 있는 접근 위치가 없습니다",
    96016: "원천 engagement에 불러올 수 있는 접근 위치가 없습니다",

    /*RBAC SchedulerRequests */
    'permissionIssueForScheduler': "서비스를 요청할 권한이 없습니다. 이 작업을 하려면 Engagement 관리자에게 문의하여 권한을 요청하십시오.",

    /* GroupInstructions */
    98001: "그룹 지침 가져오기 호출 실패",
    98002: "하나 이상의 Knowledge 지침 섹션 ID가 유효하지 않습니다",
    98003: "그룹 지침 생성 호출 실패",
    98004: "지침 이름은 비워둘 수 없습니다",
    98005: "지침 이름은 500자를 초과할 수 없습니다",
    98006: "지침 설명은 비워둘 수 없습니다",
    98007: "지침 설명은 4,자를 초과할 수 없습니다",
    98008: "범위 또는 팀에 지침을 배정해야 합니다",
    98009: "이 engagement에 지침 이름이 이미 있습니다",
    98011: "다른 팀 멤버가 이 그룹 지침을 이미 삭제했습니다. 페이지를 새로 고침하여 다시 시도하십시오. 오류가 지속되면 헬프 데스크에 문의하십시오.",
    98012: "다른 팀 멤버가 이 그룹 지침을 삭제했습니다. 페이지를 새로 고침하여 다시 시도하십시오. 오류가 지속되면 헬프 데스크에 문의하십시오.",
    98016: "편집하고 있는 그룹 지침을 다른 팀 멤버가 삭제했습니다. 페이지를 새로 고침하여 다시 시도하십시오. 오류가 지속되면 헬프 데스크에 문의하십시오.",
    98017: "다른 팀 멤버가 이 그룹 지침을 이미 삭제했습니다. 페이지를 새로 고침하여 다시 시도하십시오. 오류가 지속되면 헬프 데스크에 문의하십시오.",
    98018: "다른 팀 멤버가 이 그룹 지침을 삭제했습니다. 페이지를 새로 고침하여 다시 시도하십시오. 오류가 지속되면 헬프 데스크에 문의하십시오.",
    98019: "기업을 찾을 수 없습니다",

    /* Group Snapshots */
    102001: "그룹 지침 스냅샷 생성 호출 실패",
    102002: "유효하지 않은 요청 파라미터 오류",
    102003: "유효하지 않은 Engagement 오류",
    102004: "모든 그룹 스냅샨 가져오기 호출 실패",
    102005: "ID별 그룹 스냅샷 가져오기 호출 실패",
    102006: "스냅샷을 찾을 수 없습니다",
    102007: "유효하지 않은 스냅샷이 선택됐습니다",

    /* Group Links - Send link request */
    106001: "그룹 링크 보내기 호출 실패",
    106002: "팀 목록은 비워둘 수 없습니다",
    106003: "선택한 팀 중 하나 이상이 유효하지 않습니다",
    106004: "그룹 링크 메시지 대기 실패",
    106005: "팀은 반복될 수 없습니다",
    106006: "동시성 토큰은 반복될 수 없습니다",

    /* GroupInstructions - Send Version request */
    22019: "팀이 제거됐습니다",
    22023: "지침 보내기 호출 실패",
    22024: "지침을 보내려는 부문이 사용 가능하지 않거나 이미 삭제됐습니다",
    22025: "Engagement ID는 비워둘 수 없습니다",
    22026: "부문 ID는 비워둘 수 없습니다",
    22027: "만료일 없는 그룹 지침이 있습니다",
    22028: "부문에 대한 범위 지침이 아직 발간되지 않았습니다",
    22029: "부문에 전송하기 위해 발간된 신규 지침이 없습니다",
    22030: "다른 팀 멤버가 이 지침 및 task 버전을 이미 수락했습니다. 페이지를 새로 고침하여 다시 시도하십시오. 오류가 지속되면 헬프 데스크에 문의하십시오.",

    22031: "그룹 버전 호출 실패",

    /* GroupVersion */
    22032: "지침이 존재하지 않습니다",

    22034: "ID별 그룹 버전 가져오기 호출 실패",
    22035: "지침 설정 ID는 비워둘 수 없습니다",

    /* Return instruction concurrency scenario*/
    22036: "신규 지침 및 task 버전을 사용할 수 있습니다. 페이지를 새로 고침하여 다시 시도하십시오. 오류가 지속되면 헬프 데스크에 문의하십시오.",
    22037: "다른 팀 멤버가 신규 지침 및 task 버전을 이미 수락했습니다. 페이지를 새로 고침하여 다시 시도하십시오. 오류가 지속되면 헬프 데스크에 문의하십시오.",
    22038: "다른 팀 멤버가 신규 지침 및 task 버전을 이미 반송했습니다. 페이지를 새로 고침하여 다시 시도하십시오. 오류가 지속되면 헬프 데스크에 문의하십시오.",

    37018: "이 GL 계정을 더 이상 사용할 수 없습니다. 페이지를 새로 고침하여 다시 시도하십시오. 오류가 지속되면 헬프 데스크에 문의하십시오.",
    37019: "문서 연결을 편집할 수 없습니다. 페이지를 새로 고침하여 다시 시도하십시오. 오류가 지속되면, 헬프 데스크에 문의하십시오.",
    37030: "이 GL 계정을 더 이상 사용할 수 없습니다. 페이지를 새로 고침하여 다시 시도하십시오. 오류가 지속되면 헬프 데스크에 문의하십시오.",
    37032: "문서 연결을 편집할 수 없습니다. 페이지를 새로 고침하여 다시 시도하십시오. 오류가 지속되면, 헬프 데스크에 문의하십시오.",
    37033: "문서 연결을 편집할 수 없습니다. 페이지를 새로 고침하여 다시 시도하십시오. 오류가 지속되면, 헬프 데스크에 문의하십시오.",
    37034: "문서 연결을 편집할 수 없습니다. 페이지를 새로 고침하여 다시 시도하십시오. 오류가 지속되면, 헬프 데스크에 문의하십시오.",
    37037: "이 조정사항을 더 이상 사용할 수 없습니다. 페이지를 새로 고침하여 다시 시도하십시오. 오류가 지속되면 헬프 데스크에 문의하십시오.",

    /* EngagementReports */
    111001: "보고서 유형별 보고서 가져오기 호출 실패",
    113015: "시산표를 사용할 수 없습니다. 페이지를 새로 고침하여 다시 시도하십시오. 문제가 지속되면, 헬프 데스크에 문의하십시오.",
    113025: "계정 분류 ID 또는 계정 ID 필터링 필요, 진행할 수 없습니다",
    113050: "시산표 또는 재무제표가 이 engagement에 속하지 않거나 삭제됐을 수 있어, 진행할 수 없습니다",

    /*Information Security */
    200001: "수행한 작업은 EY 정보 보안에 의해 금지됐습니다. 페이지를 새로 고침하여 다시 시도하십시오. 문제가 지속되면, 헬프 데스크에 문의하십시오.",

    /*GL account concurrency scenario*/
    113043: "이 조정 계정을 더 이상 사용할 수 없습니다. 페이지를 새로 고침하여 다시 시도하십시오. 오류가 지속되면 헬프 데스크에 문의하십시오.",
    113019: "이 조정 계정을 더 이상 사용할 수 없습니다. 페이지를 새로 고침하여 다시 시도하십시오. 오류가 지속되면 헬프 데스크에 문의하십시오.",
    113022: "작업을 완료할 수 없습니다. 페이지를 새로 고침하여 다시 시도하십시오. 문제가 지속되면 헬프 데스크에 문의하십시오.",
    113039: "이 GL 계정에 이미 참조가 연결되어 있습니다. 페이지를 새로 고침하여 다시 시도하십시오. 오류가 지속되면, 헬프 데스크에 문의하십시오.",
    113021: "This GL account is no longer available. Refresh the page and try again. Contact the Help Desk if the error persists.",
    113035: "이 GL 계정에 이미 참조가 연결되어 있습니다. 페이지를 새로 고침하여 다시 시도하십시오. 오류가 지속되면, 헬프 데스크에 문의하십시오.",
    113020: "이 증거를 더 이상 사용할 수 없습니다. 페이지를 새로 고침하여 다시 시도하십시오. 오류가 지속되면, 헬프 데스크에 문의하십시오.",
    113037: "이 GL 계정을 더 이상 사용할 수 없습니다. 페이지를 새로 고침하여 다시 시도하십시오. 오류가 지속되면, 헬프 데스크에 문의하십시오.",
    40029: "이 GL 계정을 더 이상 사용할 수 없습니다. 페이지를 새로 고침하여 다시 시도하십시오. 오류가 지속되면, 헬프 데스크에 문의하십시오.",

    /*Trial balance*/
    113060: "MEST engagement에는 Multi-Entity가 필요합니다",
    113061: "비 MEST engagement에는 Multi-Entity가 필요하지 않습니다",
    113057: "Engagement helix를 찾을 수 없습니다",
    113094: "업데이트할 시산표는 계획과 시산표입니까가 참이어야 합니다",
    113095: "재무 유형이 시산표일 때 업데이트할 시산표는 계획과 시산표입니까가 참이어서는 안 됩니다",
    113069: "이 engagement에 범위 및 전략이 이미 있습니다",
    113009: "유효하지 않은 시산표 ID, 진행할 수 없습니다",
    113092: "시산표가 계획과 재무제표 둘 다입니다. 논리 삭제를 진행할 수 없습니다.",
    114033: "All business units mapped to a given entity must share at least one currency type and currency code. Please re-map your data and try again."

};

export const controlRiskTypeStep2 = [{
        id: 1,
        name: "Rely"
    },
    {
        id: 2,
        name: "Not Rely"
    },
    {
        id: 3,
        name: "MP 테스트"
    }
];

/*Label Collections */
//Canvas Forms Statuses
export const canvasFormStatus = [{
        id: 1,
        value: "업데이트 진행 중"
    },
    {
        id: 3,
        value: "오류"
    },
    {
        id: 5,
        value: "업데이트 진행 중"
    },
    {
        id: 6,
        value: "오류"
    }
];

export const riskTypes = [{
        id: 1,
        name: "유의적인 위험",
        abbrev: "SR",
        title: "유의적인 위험"
    },
    {
        id: 2,
        name: "부정 위험",
        abbrev: "FR",
        title: "부정 위험"
    },
    {
        id: 3,
        name: "중요왜곡표시위험",
        abbrev: "R",
        title: "ROMM/고유 위험"
    }
];

export const riskTypesToolTip = [{
        id: 1,
        name: "유의적인 위험",
        abbrev: 'SR',
        label: "유의적",
        title: "유의적인 위험"
    },
    {
        id: 2,
        name: "부정 위험",
        abbrev: "FR",
        label: "부정",
        title: "부정 위험"
    },
    {
        id: 3,
        name: "중요왜곡표시위험",
        abbrev: "R",
        label: "중요왜곡표시위험",
        title: "중요왜곡표시위험"
    }
];

export const risksTypes = [{
        id: 1,
        name: "유의적인 위험",
        abbrev: "SR",
        title: "유의적인 위험"
    },
    {
        id: 2,
        name: "부정 위험",
        abbrev: "FR",
        title: "부정 위험"
    },
    {
        id: 3,
        name: "중요왜곡표시위험",
        abbrev: "R",
        title: "중요왜곡표시위험"
    }
];

export const emptyRiskTypes = [{
        id: 1,
        label: "유의적인 위험이 식별되지 않았습니다"
    },
    {
        id: 2,
        label: "부정위험이 식별되지 않았습니다"
    },
    {
        id: 3,
        label: "중요왜곡표시위험이 식별되지 않았습니다"
    }
];

export const controlRiskType = [{
        id: 1,
        name: "Rely"
    },
    {
        id: 2,
        name: "Not Rely"
    },
    {
        id: 3,
        name: "MP 테스트"
    }
];
export const inherentRiskType = [{
        id: 1,
        name: "Higher"
    },
    {
        id: 2,
        name: "Lower"
    }
];
export const CRAStrings = {
    Minimal: "Minimal",
    Low: "Low",
    'Low +SC': "Low+SC",
    Moderate: "Moderate",
    High: "High",
    'High +SC': "High+SC"
};
export const priorityType = [{
        id: 1,
        name: "Low",
        className: 'Low',
        label: "L"
    },
    {
        id: 2,
        name: "Medium",
        className: 'Medium',
        label: "M"
    },
    {
        id: 3,
        name: "High",
        className: 'High',
        label: "H"
    },
    {
        id: 4,
        name: "Critical",
        className: 'Critical',
        label: "C"
    }
];
export const reviewNoteFilterTypes = [{
        value: 0,
        label: "모두"
    },
    {
        value: 1,
        label: "처리 전"
    },
    {
        value: 2,
        label: "처리됨"
    },
    {
        value: 3,
        label: "닫힘"
    }
];
export const reviewStatus = [{
        id: 1,
        name: "처리 전"
    },
    {
        id: 2,
        name: "처리됨"
    },
    {
        id: 3,
        name: "닫힘"
    }
];
export const reviewNoteOpenStatusOption = [{
        value: 2,
        label: "처리"
    },
    {
        value: 3,
        label: "닫기"
    }
];
export const reviewNoteClearedStatusOption = [{
        value: 1,
        label: "다시 열기"
    },
    {
        value: 3,
        label: "닫기"
    }
];
export const reviewNoteBulkClearedStatusOption = [{
        value: 1,
        label: "다시 열기"
    },
    {
        value: 2,
        label: "처리"
    },
    {
        value: 3,
        label: "닫기"
    }
];
export const reviewNoteClosedStatusOption = [{
    value: 1,
    label: "다시 열기"
}];
export const signOffTypes = [{
        value: 0,
        label: "작성자"
    },
    {
        value: 1,
        label: "검토자"
    },
    {
        value: 2,
        label: "없음"
    }
];
export const RNHNoteStatusOptions = [{
        value: 1,
        label: "처리 전"
    },
    {
        value: 2,
        label: "닫힘"
    },
    {
        value: 3,
        label: "처리됨"
    }
];
export const assertions = [{
        id: 1,
        assertionname: "완전성",
        assertionabbreviation: "C",
        statementtypeid: 2,
        displayorder: 1
    },
    {
        id: 2,
        assertionname: "실재성",
        assertionabbreviation: "E",
        statementtypeid: 2,
        displayorder: 2
    },
    {
        id: 3,
        assertionname: "평가",
        assertionabbreviation: "V",
        statementtypeid: 2,
        displayorder: 3
    },
    {
        id: 4,
        assertionname: "권리와 의무",
        assertionabbreviation: "R&O",
        statementtypeid: 2,
        displayorder: 4
    },
    {
        id: 5,
        assertionname: "표시와 공시",
        assertionabbreviation: "P&D",
        statementtypeid: 2,
        displayorder: 5
    },
    {
        id: 6,
        assertionname: "완전성",
        assertionabbreviation: "C",
        statementtypeid: 1,
        displayorder: 6
    },
    {
        id: 7,
        assertionname: "발생사실",
        assertionabbreviation: "O",
        statementtypeid: 1,
        displayorder: 7
    },
    {
        id: 8,
        assertionname: "측정",
        assertionabbreviation: "M",
        statementtypeid: 1,
        displayorder: 8
    },
    {
        id: 9,
        assertionname: "표시와 공시",
        assertionabbreviation: "P&D",
        statementtypeid: 1,
        displayorder: 9
    },
    {
        id: 10,
        assertionname: "완전성",
        assertionabbreviation: "C",
        statementtypeid: 3,
        displayorder: 10
    },
    {
        id: 11,
        assertionname: "실재성/발생사실",
        assertionabbreviation: "E/O",
        statementtypeid: 3,
        displayorder: 11
    },
    {
        id: 12,
        assertionname: "측정/평가",
        assertionabbreviation: "M/V",
        statementtypeid: 3,
        displayorder: 12
    },
    {
        id: 13,
        assertionname: "권리와 의무",
        assertionabbreviation: "R&O",
        statementtypeid: 3,
        displayorder: 13
    },
    {
        id: 14,
        assertionname: "표시와 공시",
        assertionabbreviation: "P&D",
        statementtypeid: 3,
        displayorder: 14
    }
];
//Add Review Note
export const priorityTypes = [{
        value: 1,
        label: "Low"
    },
    {
        value: 2,
        label: "Medium"
    },
    {
        value: 3,
        label: "High"
    },
    {
        value: 4,
        label: "Critical"
    }
];
/*Cog Menu*/
export const cogMenuOptions = {
    Open: "열기",
    'Start Co-edit mode': "Multi-user 편집 시작",
    'End Co-edit mode': "Multi-user 편집 종료",
    'Open read-only': "읽기 전용으로 열기",
    'View history': "기록 보기",
    CopyLink: "링크 복사",
    Rename: "이름 바꾸기",
    Delete: "삭제",
    'Remove from task': "Task에서 제거",
    Remove: "제거",
    Unlink: "링크 해제",
    RelateTasks: "Task 연결",
    RelateEntities: "기업 연결",
    Restore: "복원",
    PermanentlyDelete: "영구 삭제",
    ChangeReason: "사유 편집",
    Confidentiality: "기밀",
    SignoffRequirements: "Sign-off 요건",
    AssignRegionComponent: "지역 또는 부문에 배정",
    UnassignRegionComponent: "지역 또는 부문 배정취소",
    ReturnToRegionComponent: "지역 또는 부문으로 반송",
    ClearReturnToRegionComponent: "지역 또는 부문으로 반송 처리",
    OverwriteForm: "양식 덮어쓰기",
    Finalize: "문서 마무리"
};

export const pagingSvgHoverText = {
    first: "첫 페이지",
    previous: "이전 페이지",
    next: "다음 페이지",
    last: "마지막 페이지"
};
export const controlFrequencyType = {
    1: "하루에 여러 번",
    2: "매일",
    3: "매주",
    4: "매월",
    5: "매분기",
    6: "매년",
    7: "IT Application 통제",
    8: "기타"
};
export const itApproachType = {
    1: "통제",
    2: "실증"
};
export const controlType = {
    1: "IT Application",
    2: "IT 의존 수동",
    3: "수동 예방",
    4: "수동 적발"
};
export const aggregateITEvaluationType = {
    1: "Support",
    2: "Not Support",
    3: "FS & ICFR Support",
    4: "FS Only Support"
};
export const entityType = {
    'ENTITY3': "계정",
    'ENTITY4': "SCOT",
    'ENTITY5': "IT프로세스",
    'ENTITY7': "위험",
    'ENTITY18': "WCGW",
    'ENTITY19': "통제",
    'ENTITY20': "IT SO Application",
    'ENTITY24': "경영진주장",
    'ENTITY34': "IT 통제",
    'ENTITY35': "IT 위험"
};
export const trueFalseToYesNo = {
    'true': "예",
    'false': "아니오"
}
export const trueFalseToYesOnly = {
    'true': "예"
}
export const yesNoLocalized = {
    'Yes': "예",
    'No': "아니오"
}
export const iTProcessEvaluationType = {
    1: "Effective",
    2: "Ineffective",
    3: "Reliable",
    4: "테스트되지 않음"
};

export const strategyType = {
    1: "통제",
    2: "실증",
    3: "Rely",
    4: "Not Rely"
};
export const accountType = {
    1: "유의적인 계정",
    2: "Limited risk 계정"
};

export const scotTypes = {
    1: "일상적",
    2: "비일상적",
    3: "추정"
};
export const taskNavigation = {
    1: "내 Task",
    2: "모든 Task",
    3: "범위 및 전략",
    4: "SCOT",
    5: "IT/SO",
    6: "계정",
    7: "일반 실행",
    8: "결론",
    9: "팀 요약",
    10: "위험"
};
export const subCategoty = {
    1: "모두 표시",
    2: "작성",
    3: "리뷰"
};
export const subCategoryType = {
    AllTasks: {
        id: 1,
        title: "모두 표시",
        label: "모두 표시"
    },
    ToPrepare: {
        id: 2,
        title: "작성",
        label: "작성"
    },
    ToReview: {
        id: 3,
        title: "리뷰",
        label: "리뷰"
    },
    Preparers: {
        id: 2,
        title: "작성자",
        label: "작성자"
    },
    Reviewers: {
        id: 3,
        title: "검토자",
        label: "검토자"
    }
};
/*Task Types*/
export const taskType = {
    1: "표준 Task",
    2: "주요 표준 Task",
    3: "Walkthrough Task",
    4: "통제 Task",
    5: "실증 Task",
    6: "PSP Task",
    7: "응답 Task",
    8: "그룹 Task"
};

export const taskTypesForAddTask = {
    importfromknowledge: "Knowledge에서 불러오기",
    custom: "사용자지정",
    account: "계정",
    itsubstantive: "IT 실증절차",
    scotwalkthroughtask: "SCOT walkthrough",
    scotcontroltask: "SCOT 통제",
    itwalkthroughtask: "IT walkthrough",
    itcontroltask: "IT 통제"
};

export const taskTypeBadge = {
    1: "OST",
    2: "PST",
    3: "WT",
    4: "TOC",
    5: "OSP",
    6: "PSP",
    7: "RT",
    8: "GT",
    9: "PIC",
    10: "EQR",
    11: "PIC/EQR",
    22: "ACT",
    23: "UDP"
};
/*Task Types*/
export const taskTypeAbbreviation = {
    1: "TOC",
    2: "TOC",
    3: "TOC",
    4: "TOC",
    5: "TOC",
    6: "TOC",
    7: "RT",
    8: "RT",
    9: "RT",
    10: "RT",
    11: "RT",
    13: "OST",
    14: "PST",
    16: "OSP",
    17: "PSP",
    18: "WT",
    19: "UDP",
    20: "WT",
    22: "ACT",
    23: "GT",
    24: "GT",
    25: "GT",
    26: "OSP",
    27: "GT"
};
export const auditPhase = {
    1: "범위 및 전략",
    2: "실행",
    3: "결론"
};
export const ProfileActionType = {
    1: "프로필 제출 - 초도",
    2: "프로필 제출 - RollForward",
    3: "프로필 편집",
    4: "글로벌 내용 업데이트",
    5: "PSP 불러오기",
    6: "PST 불러오기",
    7: "Canvas 양식 내용 업데이트",
    8: "그룹감사지침 불러오기",
    9: "수동 양식 추가",
    10: "프로필 전달",
    11: "필수 내용 업데이트",
    12: "Canvas 양식 프로필 동기화"
};

export const taskGroup = {
    1: "기타 계획 절차 수행",
    2: "계정 흐름",
    3: "SCOT 흐름",
    4: "IT Application 및 서비스조직 흐름",
    5: "CRA 흐름",
    6: "감사 계획 흐름",
    7: "마무리 절차 수행",
    8: "SAD(감사 차이 요약)",
    9: "감사 결과 평가",
    10: "기타 감사절차 수행",
    11: "그룹감사 구조",
    12: "그룹감사 지침",
    13: "주 그룹 작업",
    14: "부문 그룹 Task",
    15: "작업 계획",
    16: "Accounts Flow - MEST",
    17: "검토 절차 수행",
    18: "예비적인 engagement 활동 완료",
    19: "팀 구성",
    20: "데이터와 함께 engagement 활성화",
    21: "RA 분석 절차 수행 및 중요성 결정",
    22: "Identify significant accounts - MEST",
    23: "위험 평가를 위한 추가 절차",
    24: "원천 식별",
    25: "유의적인 계정 식별",
    26: "SCOT 식별 및 이해",
    27: "IT 프로세스와 서비스조직 식별 및 이해",
    28: "전략과 CRA 확인",
    29: "추가적인 필수 위험 식별 절차 수행",
    30: "내부감사 활용 고려",
    31: "위험 평가에 대응",
    32: "전략 마무리",
    33: "EQR 절차",
    34: "절차 설계",
    35: "감사증거 평가 및 결론",
    36: "커뮤니케이션과 산출물 발행",
    37: "EQR 절차",
    38: "감사보고서 작성 및 발행",
    39: "문서화와 archive 마무리",
    40: "전사적 수준 통제 테스트",
    41: "자동화 기법에 이용한 데이터 평가",
    42: "필수 부정 절차 실행",
    43: "내부감사와 전문가 절차 실행",
    44: "IT 프로세스 평가",
    45: "회의록, 계약서 및 소송 검토",
    46: "재무제표 절차 수행",
    47: "특수관계자 거래, 계속기업 및 법규 절차 실행",
    48: "감사전략 변경 논의",
    49: "실행 결론",
    50: "EQR 절차",
    51: "범위 및 전략 품질 활동 완료",
    52: "초도감사 절차 수행",
    53: "위험 평가 절차 수행",
    54: "서비스조직 식별",
    55: "Digital - Task 그룹 5",
    56: "IT 프로세스 식별 및 이해",
    57: "계획 절차 수행",
    58: "그룹 구조, 지침 및 관여",
    59: "유의적인 공시 식별",
    60: "유의적인 보고 프로세스 식별 및 이해",
    61: "Digital - Task 그룹 11",
    62: "Digital - Task 그룹 12",
    63: "Digital - Task 그룹 13",
    64: "Digital - Task 그룹 14",
    65: "Digital - Task 그룹 15",
    66: "Digital - Task 그룹 16",
    67: "Digital - Task 그룹 17",
    68: "중간감사 후 프로젝트 관리 활동 완료",
    69: 'Execute substantive procedures - Governance',
    70: 'Execute substantive procedures - Strategy',
    71: 'Execute substantive procedures - Risk Management',
    72: 'Execute substantive procedures - Metrics and Targets',
    73: "실증 절차 실행 - 기타",
    74: "타인 작업 평가",
    75: "Digital - Task 그룹 25",
    76: "Digital - Task 그룹 26",
    77: "Digital - Task 그룹 27",
    78: "Digital - Task 그룹 28",
    79: "Digital - Task 그룹 29",
    80: "Digital - Task 그룹 30",
    81: "Digital - Task 그룹 31",
    82: "Digital - Task 그룹 32",
    83: "Digital - Task 그룹 33",
    84: "Digital - Task 그룹 34",
    85: "검토증거 평가 및 결론",
    86: "일반 인증 절차 수행",
    87: "증거 평가 및 결론",
    88: "Digital - Task 그룹 38",
    89: "Digital - Task 그룹 39",
    90: "Digital - Task 그룹 40",
    91: "Digital - Task 그룹 41",
    92: "Digital - Task 그룹 42",
    93: "Digital - Task 그룹 43",
    94: "Digital - Task 그룹 44",
    95: "Digital - Task 그룹 45",
    96: "Digital - Task 그룹 46",
    97: "Digital - Task 그룹 47",
    98: "Digital - Task 그룹 48",
    99: "Digital - Task 그룹 49",
    100: "Digital - Task 그룹 50"
};
export const AutomationHubRequestStatus = {
    Draft: "초안",
    Submitted: "제출됨",
    Sent: "전송 진행 중",
    InProgress: "처리 중",
    Failed: "오류 처리 중",
    Completed: "완료됨",
    FailedToSendToBP: "오류 처리 중",
    QueueingFailed: "제출 실패",
    ActionRequired: "작업 필요"
};
export const milestonesLabels = {
    1: "범위",
    2: "전략",
    3: "Walkthrough",
    4: "중간 통제 테스트",
    5: "중간 실증 테스트",
    6: "Walkthrough (기말 프로세스)",
    7: "기말 통제 테스트",
    8: "기말 실증 테스트",
    9: "결론",
    10: "해당 없음",
    11: "실행",
    12: "범위 및 전략 품질 활동",
    13: "기타 범위 및 전략",
    14: "CRA",
    15: "위험 평가 및 중요성",
    16: "범위 및 전략 마무리",
    17: "중간감사 후 프로젝트 관리"
};

export const TasksFilterGroups = {
    Tasks: "Task",
    Assignments: "배정",
    ReviewNotes: "리뷰노트",
    ProjectManagement: "프로젝트 관리",
    Other: "기타"
};

export const TasksFilterTypes = {
    TaskStatus: "Task 상태",
    TaskType: "Task 유형",
    AssignedTo: "담당자",
    OpenAssignments: "처리 전 배정",
    ReviewNotesStatus: "리뷰노트 상태",
    ReviewNotesAssignedTo: "리뷰노트 담당자",
    ReviewNotesCreatedBy: "리뷰노트 생성자",
    TimePhase: "시기",
    Milestone: "Milestone",
    AuditPhase: "감사 단계",
    DocumentConflict: "문서 충돌",
    Findings: "발견사항",
    Entity: "기업",
    IsBookmarked: "오프라인으로 다운로드됨"
};

export const quickFilterTaskStatus = [{
        value: '1',
        label: "처리 전"
    },
    {
        value: '2',
        label: "진행 중"
    },
    {
        value: '3',
        label: "리뷰 중"
    },
    {
        value: '4',
        label: "완료"
    }
];

export const quickFilterAssignmentStatus = [{
        value: '1',
        label: "처리 전"
    },
    {
        value: '2',
        label: "진행 중"
    },
    {
        value: '3',
        label: "닫힘"
    },
    {
        value: '4',
        label: "배정되지 않음"
    }
];

export const dataExport = [
	// 'Archive Form',
	// 'Canvas Forms',
	"공동작업",
	// 'Control Forms',
	"문서",
	"Task",
	"SCOT 요약",
	// 'Team Members',
	// 'Trial Balance'
];
export const dataExportReportNames = {
    'Archive Form': "Archive 양식",
    'Canvas Forms': "Canvas 양식 보고서",
    'Collaboration': "공동작업",
    'Control Forms': "통제 보고서",
    'Documents': "모든 문서 보고서",
    'Tasks': "모든 Task 보고서",
    'Team Members': "팀 멤버",
    'Trial Balance': "Number 보고서"
};
export const projectManagement = [
	"공동작업 세부정보",
	// 'Digital scorecard',
	// 'Milestones',
	// 'Review Notes',
	// 'Validation Checks'
];

export const projectManagementReportNames = {
    'Collaboration Details': "고객 협업 대시보드",
    'Milestones': "Milestone 보고서",
    'Review Notes': "리뷰노트 보고서",
    'Validation Checks': "유효성 검증 보고서"
};

export const taskQuickFilterOptions = [{
        id: 'taskToPreparer',
        label: "작성할 task",
        uiViewId: uiViews.taskSystemSuggestedFilter
    },
    {
        id: 'tasksReadyForReview',
        label: "검토 준비된 task",
        uiViewId: uiViews.taskSystemSuggestedFilter
    },
    {
        id: 'allAssignedTasks',
        label: "배정된 모든 task",
        uiViewId: uiViews.taskSystemSuggestedFilter
    },
    {
        id: 'allOverdueTasks',
        label: "지연 task",
        uiViewId: uiViews.taskSystemSuggestedFilter
    },
    {
        id: 'allTasksDueThisWeek',
        label: "이번 주 만료 도래 task",
        uiViewId: uiViews.taskSystemSuggestedFilter
    }
];

export const noDefaultFilter = {
    id: 'noDefaultFilter',
    label: "기본 필터 없음"
};

export const taskTypes = [{
        id: '1',
        label: "통제 task"
    },
    {
        id: '2',
        label: "통제 Task - 통제"
    },
    {
        id: '3',
        label: "통제 Task - ELC"
    },
    {
        id: '4',
        label: "통제 Task - IT/SO"
    },
    {
        id: '5',
        label: "통제 Task - MP"
    },
    {
        id: '6',
        label: "통제 Task - SO"
    },
    {
        id: '7',
        label: "응답 Task"
    },
    {
        id: '8',
        label: "현금흐름 왜곡표시 응답 Task"
    },
    {
        id: '9',
        label: "미비점 응답 Task"
    },
    {
        id: '10',
        label: "공시 왜곡표시 응답 Task"
    },
    {
        id: '11',
        label: "왜곡표시 응답 Task"
    },
    {
        id: '12',
        label: "표준 Task"
    },
    {
        id: '13',
        label: "기타 표준 Task"
    },
    {
        id: '14',
        label: "주요 표준 Task"
    },
    {
        id: '15',
        label: "실증 Task"
    },
    {
        id: '16',
        label: "OSP Task"
    },
    {
        id: '17',
        label: "PSP Task"
    },
    {
        id: '18',
        label: "Walkthrough Task"
    },
    {
        id: '19',
        label: "Walkthrough Task - IT/SO"
    },
    {
        id: '20',
        label: "Walkthrough Task - SCOT"
    },
    {
        id: '21',
        label: "To-do"
    },
    {
        id: '22',
        label: "계정 결론 Task"
    },
    {
        id: '23',
        label: "그룹 Task"
    },
    {
        id: '24',
        label: "Primary 그룹 Task"
    },
    {
        id: '25',
        label: "부문 그룹 Task"
    },
    {
        id: '26',
        label: "IT/SO OSP Task"
    },
    {
        id: '27',
        label: "링크 해제된 부문 그룹 Task"
    }
];

export const filterAssignmentType = [{
        value: '1',
        label: "작성자"
    },
    {
        value: '2',
        label: "세부 검토자"
    },
    {
        value: '3',
        label: "일반 검토자"
    },
    {
        value: '4',
        label: "Partner"
    },
    {
        value: '5',
        label: "EQR"
    },
    {
        value: '6',
        label: "기타"
    }
];

export const filterTaskStatus = [{
        value: '1',
        label: "열기"
    },
    {
        value: '2',
        label: "진행 중"
    },
    {
        value: '3',
        label: "리뷰 중"
    },
    {
        value: '4',
        label: "완료"
    },
    {
        value: '5',
        label: "증거 없음"
    }
];

export const filterAssignmentStatus = [{
        value: '1',
        label: "처리 전"
    },
    {
        value: '2',
        label: "진행 중"
    },
    {
        value: '3',
        label: "닫힘"
    },
    {
        value: '4',
        label: "배정되지 않음"
    }
];

export const filterTaskType = [{
        value: '1',
        label: "통제 Task"
    },
    {
        value: '7',
        label: "응답 Task"
    },
    {
        value: '13',
        label: "기타 표준 Task"
    },
    {
        value: '14',
        label: "주요 표준 Task"
    },
    {
        value: '16',
        label: "OSP Task"
    },
    {
        value: '17',
        label: "PSP Task"
    },
    {
        value: '18',
        label: "Walkthrough/ UDP task"
    },
    {
        value: '22',
        label: "계정 결론 Task"
    },
    {
        value: '999',
        label: "PIC Sign-off 필요"
    },
    {
        value: '1000',
        label: "EQR Sign-off 필요"
    }
];

export const filterTaskTypeGroupEngagement = [{
        value: '1',
        label: "통제 Task"
    },
    {
        value: '7',
        label: "응답 Task"
    },
    {
        value: '13',
        label: "기타 표준 Task"
    },
    {
        value: '14',
        label: "주요 표준 Task"
    },
    {
        value: '16',
        label: "OSP Task"
    },
    {
        value: '17',
        label: "PSP Task"
    },
    {
        value: '18',
        label: "Walkthrough/ UDP task"
    },
    {
        value: '22',
        label: "계정 결론 Task"
    },
    {
        value: '23',
        label: "그룹 Task"
    },
    {
        value: '999',
        label: "PIC Sign-off 필요"
    },
    {
        value: '1000',
        label: "EQR Sign-off 필요"
    }
];

export const filterTaskTypeInterimEngagement = [{
        value: '14',
        label: "주요 표준 Task"
    },
    {
        value: '13',
        label: "기타 표준 Task"
    },
    {
        value: '23',
        label: "그룹 Task"
    },
    {
        value: '999',
        label: "PIC sign-off 필요"
    },
    {
        value: '1000',
        label: "EQR Sign-off 필요"
    }
];

export const filterMilestones = [{
        value: '1',
        label: "범위",
        hideFromMenu: true
    },
    {
        value: '2',
        label: "전략",
        hideFromMenu: true
    },
    {
        value: '12',
        label: "범위 및 전략 품질 활동"
    },
    {
        value: '13',
        label: "기타 범위 및 전략"
    },
    {
        value: '14',
        label: "CRA"
    },
    {
        value: '15',
        label: "위험 평가 및 중요성"
    },
    {
        value: '16',
        label: "범위 및 전략 마무리"
    },
    {
        value: '17',
        label: "중간감사 후 프로젝트 관리"
    },
    {
        value: '3',
        label: "Walkthrough"
    },
    {
        value: '4',
        label: "중간 통제 테스트"
    },
    {
        value: '5',
        label: "중간 실증 테스트"
    },
    {
        value: '6',
        label: "Walkthrough (기말 프로세스)"
    },
    {
        value: '7',
        label: "기말 통제 테스트"
    },
    {
        value: '8',
        label: "기말 실증 테스트"
    },
    {
        value: '11',
        label: "실행"
    },
    {
        value: '9',
        label: "결론"
    },
    {
        value: '10',
        label: "N/A"
    },
    {
        value: '0',
        label: "Milestone 없음"
    }
];

export const documentListMilestones = [{
        value: '1',
        label: "범위"
    },
    {
        value: '12',
        label: "범위 및 전략 프로젝트 관리"
    },
    {
        value: '13',
        label: "기타 범위 및 전략"
    },
    {
        value: '2',
        label: "전략"
    },
    {
        value: '14',
        label: "CRA"
    },
    {
        value: '15',
        label: "위험 평가 및 중요성"
    },
    {
        value: '16',
        label: "범위 및 전략 마무리"
    },
    {
        value: '17',
        label: "중간감사 후 프로젝트 관리"
    },
    {
        value: '3',
        label: "Walkthrough"
    },
    {
        value: '4',
        label: "중간 통제테스트"
    },
    {
        value: '5',
        label: "중간 실증 테스트"
    },
    {
        value: '6',
        label: "Walkthrough (기말 프로세스)"
    },
    {
        value: '7',
        label: "기말 통제테스트"
    },
    {
        value: '8',
        label: "기말 실증 테스트"
    },
    {
        value: '11',
        label: "실행"
    },
    {
        value: '9',
        label: "결론"
    },
    {
        value: '10',
        label: "N/A"
    }
];

export const filterAuditPhases = [{
        value: '1',
        label: "범위 및 전략"
    },
    {
        value: '2',
        label: "실행"
    },
    {
        value: '3',
        label: "결론"
    }
];


export const filterDocListReviewNoteStatus = [{
        value: 1,
        label: "처리 전 "
    },
    {
        value: 5,
        label: "처리됨 "
    },
    {
        value: 2,
        label: "닫힘"
    }
];

export const filterDocumentConflicts = [{
    value: '1',
    label: "예"
}, {
    value: '0',
    label: "아니오"
}];
export const filterDownloadedForOffline = [{
    value: '1',
    label: "예"
}, {
    value: '2',
    label: "아니오"
}];

export const missingEntityDocuments = [{
    value: 10034,
    label: "예"
}]


export const filterTaskFindings = [{
        value: '1',
        label: "미비점"
    },
    {
        value: '2',
        label: "왜곡표시"
    }
];

export const ConfidentialityTypes = [{
        id: 1,
        Name: "기본"
    },
    {
        id: 2,
        Name: "Low"
    },
    {
        id: 3,
        Name: "Moderate"
    },
    {
        id: 4,
        Name: "High"
    },
    {
        id: 5,
        Name: "기밀"
    }
];

export const RoleForMember = [{
        id: 1,
        role: "Partner in Charge",
        roleAbbreviation: "PIC",
        displayOrder: 9
    },
    {
        id: 2,
        role: "Engagement Partner",
        roleAbbreviation: "EP",
        displayOrder: 8
    },
    {
        id: 3,
        role: "Executive Director",
        roleAbbreviation: "ED",
        displayOrder: 5
    },
    {
        id: 4,
        role: "Principal",
        roleAbbreviation: "Principal",
        displayOrder: 6
    },
    {
        id: 5,
        role: "Senior Manager",
        roleAbbreviation: "Sr.Manager",
        displayOrder: 4
    },
    {
        id: 6,
        role: "Manager",
        roleAbbreviation: "Manager",
        displayOrder: 3
    },
    {
        id: 7,
        role: "Senior",
        roleAbbreviation: "Senior",
        displayOrder: 2
    },
    {
        id: 8,
        role: "Staff",
        roleAbbreviation: "Staff",
        displayOrder: 1
    },
    {
        id: 9,
        role: "Intern",
        roleAbbreviation: "Intrn"
    },
    {
        id: 10,
        role: "Engagement Quality Reviewer",
        roleAbbreviation: "EQR",
        displayOrder: 10
    },
    {
        id: 11,
        role: "Other Partner",
        roleAbbreviation: "Other Partner",
        displayOrder: 7
    },
    {
        id: 12,
        role: "GDS - Staff",
        roleAbbreviation: "GDS Staff",
        displayOrder: 13
    },
    {
        id: 13,
        role: "Advisory (ITRA,TAS,Human Capital or Other)",
        roleAbbreviation: "ADV"
    },
    {
        id: 14,
        role: "Tax",
        roleAbbreviation: "Tax"
    },
    {
        id: 15,
        role: "Executive Support Services",
        roleAbbreviation: "ESS"
    },
    {
        id: 16,
        role: "General Counsel",
        roleAbbreviation: "GCO",
        displayOrder: 12
    },
    {
        id: 17,
        role: "Audit Quality Reviewer",
        roleAbbreviation: "AQR",
        displayOrder: 11
    },
    {
        id: 18,
        role: "ML Component Team",
        roleAbbreviation: "MCT"
    },
    {
        id: 19,
        role: "Client Supervisor",
        roleAbbreviation: "C. Supervisor"
    },
    {
        id: 20,
        role: "Client Staff",
        roleAbbreviation: "C. Staff"
    },
    {
        id: 21,
        role: "Internal Audit Supervisor",
        roleAbbreviation: "IA Supervisor"
    },
    {
        id: 22,
        role: "Internal Audit Staff",
        roleAbbreviation: "IA Staff"
    },
    {
        id: 23,
        role: "Regulator",
        roleAbbreviation: "Regulator"
    },
    {
        id: 24,
        role: "Other (e.g. due diligence review)",
        roleAbbreviation: "Other"
    },
    {
        id: 25,
        role: "Office",
        roleAbbreviation: "Office"
    },
    {
        id: 26,
        role: "Area",
        roleAbbreviation: "Area"
    },
    {
        id: 27,
        role: "Industry",
        roleAbbreviation: "IND"
    },
    {
        id: 28,
        role: "National",
        roleAbbreviation: "NAT"
    },
    {
        id: 29,
        role: "Global",
        roleAbbreviation: "GBL"
    },
    {
        id: 30,
        role: "GDS - Senior",
        roleAbbreviation: "GDS Senior",
        displayOrder: 14
    },
    {
        id: 31,
        role: "GDS - Manager",
        roleAbbreviation: "GDS Manager",
        displayOrder: 15
    }
];

export const SubServiceLines = [{
        subServiceLineId: 1,
        subServiceLineName: "Audit",
        displayOrder: 1
    },
    {
        subServiceLineId: 2,
        subServiceLineName: "FIDS",
        displayOrder: 2
    },
    {
        subServiceLineId: 9,
        subServiceLineName: "FAAS",
        displayOrder: 3
    },
    {
        subServiceLineId: 11,
        subServiceLineName: "CCaSS",
        displayOrder: 4
    },
    {
        subServiceLineId: 12,
        subServiceLineName: "BTS",
        displayOrder: 5
    },
    {
        subServiceLineId: 13,
        subServiceLineName: "Human Capital",
        displayOrder: 6
    },
    {
        subServiceLineId: 14,
        subServiceLineName: "Law",
        displayOrder: 7
    },
    {
        subServiceLineId: 15,
        subServiceLineName: "Indirect Tax",
        displayOrder: 8
    },
    {
        subServiceLineId: 16,
        subServiceLineName: "GCR",
        displayOrder: 9
    },
    {
        subServiceLineId: 17,
        subServiceLineName: "Transaction Tax",
        displayOrder: 10
    },
    {
        subServiceLineId: 18,
        subServiceLineName: "ITS",
        displayOrder: 11
    },
    {
        subServiceLineId: 19,
        subServiceLineName: "GCO",
        displayOrder: 12
    },
    {
        subServiceLineId: 20,
        subServiceLineName: "Business Consulting",
        displayOrder: 13
    },
    {
        subServiceLineId: 21,
        subServiceLineName: "Technology Consulting",
        displayOrder: 14
    },
    {
        subServiceLineId: 22,
        subServiceLineName: "Transactions and Corporate Finance",
        displayOrder: 15
    },
    {
        subServiceLineId: 23,
        subServiceLineName: "EY Parthenon",
        displayOrder: 16
    },
    {
        subServiceLineId: 24,
        subServiceLineName: "Other",
        displayOrder: 17
    },
    {
        subServiceLineId: 25,
        subServiceLineName: "Technology Risk",
        displayOrder: 18
    }
];

export const SchedulerRequestRole = [{
        id: 31,
        userTypeId: 4,
        label: "GDS Manager"
    },
    {
        id: 31,
        userTypeId: 3,
        label: "요청 Manager"
    }
];

/* Task Status */
export const TaskStatus = [{
        id: 1,
        label: "처리 전"
    },
    {
        id: 2,
        label: "진행 중"
    },
    {
        id: 3,
        label: "리뷰 중"
    },
    {
        id: 4,
        label: "완료"
    },
    {
        id: 5,
        label: "제거됨"
    },
    {
        id: 6,
        label: "PIC/EQR sign-off 완료"
    }
];
/* GATaskSendStatus*/
export const GATaskSendStatus = [{
        id: 1,
        label: "전송되지 않음"
    },
    {
        id: 2,
        label: "진행 중"
    },
    {
        id: 3,
        label: "전송됨"
    },
    {
        id: 4,
        label: "반송됨"
    }
];
// 9 - Return error (UI value, doesn't exist in database)
export const GAComponentDocumentStatusLabels = [{
        id: GAComponentDocumentStatus.Open,
        label: "처리 전"
    },
    {
        id: GAComponentDocumentStatus.InProgress,
        label: "수신됨"
    },
    {
        id: GAComponentDocumentStatus.Submitted,
        label: "제출됨"
    },
    {
        id: GAComponentDocumentStatus.Returned,
        label: "반송됨"
    },
    {
        id: GAComponentDocumentStatus.InReview,
        label: "작성됨"
    },
    {
        id: GAComponentDocumentStatus.Complete,
        label: "리뷰됨"
    },
    {
        id: GAComponentDocumentStatus.Dismissed,
        label: "해제됨"
    },
    {
        id: GAComponentDocumentStatus.RejectInTransit,
        label: "반송 진행 중"
    },
    {
        id: GAComponentDocumentStatus.ReturnError,
        label: "반송 오류"
    }
];
export const TeamSummaryPreparerTaskStatus = [{
        id: 1,
        label: "처리 전"
    },
    {
        id: 2,
        label: "진행 중"
    },
    {
        id: 3,
        label: "닫힘"
    }
];
export const TeamSummaryReviewerTaskStatus = [{
        id: 1,
        label: "처리 전"
    },
    {
        id: 2,
        label: "진행 중"
    },
    {
        id: 3,
        label: "닫힘"
    }
];

export const DocumentHelper = {
    401: "작업을 완료할 수 없습니다. 페이지를 새로 고침하여 다시 시도하십시오. 문제가 지속되면 헬프 데스크에 문의하십시오.",
    413: "문서가 최대 허용 가능 파일 크기(250mb)를 초과하여 업로드되지 않았습니다. 파일 크기를 줄여 다시 시도하십시오.",
    412: "이 engagement에 이름이 있는 문서가 이미 있습니다",
    414: "이름이 최대 길이({0}자)를 초과합니다",
    410: "이 문서는 삭제되어 열 수 없습니다",
    411: "빈 문서는 허용되지 않습니다"
};

export const reviewNoteCategories = [{
        value: reviewNoteRoutes.path.all.id,
        path: reviewNoteRoutes.path.all.path,
        label: "모든 노트"
    },
    {
        value: reviewNoteRoutes.path.document.id,
        path: reviewNoteRoutes.path.document.path,
        label: "문서 노트"
    },
    {
        value: reviewNoteRoutes.path.task.id,
        path: reviewNoteRoutes.path.task.path,
        label: "Task 노트"
    },
    {
        value: reviewNoteRoutes.path.form.id,
        path: reviewNoteRoutes.path.form.path,
        label: "Canvas 양식 comment"
    }
];

export const reviewNoteStatus = [{
        value: '1',
        label: "처리 전"
    },
    {
        value: '2',
        label: "처리됨"
    },
    {
        value: '3',
        label: "닫힘"
    }
];

/* RNH Review note hub */
export const reviewNoteTypes = [{
        id: 1,
        type: 'document',
        label: "문서 노트"
    },
    {
        id: 2,
        type: 'task',
        label: "Task 노트"
    }
];

export const accountConclusionTabs = {
    details: "세부정보",
    conclusions: "결론"
};


export const rnhFilterType = [{
        id: 0,
        filterType: rnhFilterTypeQuery.annotationStatusIds,
        name: "노트 상태 ID",
        inDropDown: false
    },
    {
        id: 1,
        filterType: rnhFilterTypeQuery.authoredBy,
        name: "작성자",
        inDropDown: true
    },
    {
        id: 2,
        filterType: rnhFilterTypeQuery.assignedTo,
        name: "담당자",
        inDropDown: true
    },
    {
        id: 3,
        filterType: rnhFilterTypeQuery.priority,
        name: "우선순위",
        inDropDown: true,
        filterOptions: [{
            id: "1",
            label: "Low"
        }, {
            id: "2",
            label: "Medium"
        }, {
            id: "3",
            label: "High"
        }, {
            id: "4",
            label: "Critical"
        }]
    },
    {
        id: 4,
        filterType: rnhFilterTypeQuery.dueBefore,
        name: "이전 만료",
        inDropDown: true,
        isDateTime: true
    },
    {
        id: 5,
        filterType: rnhFilterTypeQuery.dueAfter,
        name: "이후 만료",
        inDropDown: true,
        isDateTime: true
    }
];

export const rnhSortingOptions = [{
        id: 'Number',
        label: '#'
    },
    {
        id: 'DueDate',
        label: "만료"
    },
    {
        id: 'Priority',
        label: "우선순위"
    },
    {
        id: 'Status',
        label: "상태"
    }
];

export const userConfidentiality = [{
        id: 1,
        value: "일반"
    },
    {
        id: 2,
        value: "Low"
    },
    {
        id: 3,
        value: "Medium"
    },
    {
        id: 4,
        value: "High"
    },
    {
        id: 5,
        value: "제한"
    },
    {
        id: 6,
        value: "기밀"
    }
];

export const externalUserStatus = {
    active: "활동",
    inactive: "비활동"
};

export const engagementStatus = {
    1: "활성",
    2: "보류됨",
    3: "거절됨",
    4: "비활성",
    13: "예정됨 - 비활동"
};

export const copyRequestStatus = {
    0: "만료됨",
    1: "준비 완료",
    2: "전송됨",
    3: "수신됨",
    4: "내보내기 진행 중",
    5: "내보내기 성공",
    6: "내보내기 오류",
    7: "불러오기 진행 중",
    8: "불러오기 성공",
    9: "불러오기 오류",
    10: "거부됨",
    11: "복사 진행 중",
    13: "초안",
    14: "전송 진행 중",
    15: "전달 진행 중",
    16: "전달 오류"
}

export const copyObjectGrouptype = {
    21: "Engagement",
    22: "계정",
    23: "SCOT",
    20: "증거",
    24: "기존에서 roll forward",
    25: "템플릿",
    26: "한꺼번에 내보내기",
    27: "외부 문서",
    28: "가이드 업무흐름",
    29: "기업별 engagement"
}

export const independenceStatus = {
    0: labels.undefined,
    1: labels.incomplete,
    2: labels.nomattersidentified,
    3: labels.matteridentifiedpendingaction,
    4: labels.matterresolveddeniedaccess,
    5: labels.matterresolvedgrantedaccess,
    6: labels.notapplicable,
    7: labels.restored,
    8: labels.overriden,
    9: labels.priornomattersidentified,
    10: labels.priormatteridentifiedpendingaction,
    11: labels.priormatterresolvedgrantedaccess,
    12: labels.priormatterresolveddeniedaccess
};

export const independenceStatusFilterOptions = [{
        value: 3,
        label: labels.matteridentifiedpendingaction
    },
    {
        value: 4,
        label: labels.matterresolveddeniedaccess
    },
    {
        value: 5,
        label: labels.matterresolvedgrantedaccess
    },
    {
        value: 8,
        label: labels.override
    },
    {
        value: 1,
        label: labels.incomplete
    },
    {
        value: 2,
        label: labels.nomattersidentified
    },
    {
        value: 7,
        label: labels.restored
    },
    {
        value: 6,
        label: labels.notapplicable
    }
];

export const independenceConfirmationStatus = {
    0: labels.undefined,
    1: labels.incomplete,
    2: labels.nomattersidentified,
    3: labels.matteridentifiedpendingaction,
    4: labels.matterresolveddeniedaccess,
    5: labels.matterresolvedgrantedaccess,
    6: labels.notapplicable,
    7: labels.restored,
    8: labels.override,
    9: labels.priornomattersidentified,
    10: labels.priormatteridentifiedpendingaction,
    11: labels.priormatterresolvedgrantedaccess,
    12: labels.priormatterresolveddeniedaccess
};

export const timePhaseTypes = {
    1: "범위",
    2: "전략",
    3: "Walkthrough",
    4: "중간 통제 테스트",
    5: "중간 실증 테스트",
    6: "Walkthrough (기말 프로세스)",
    7: "기말 통제 테스트",
    8: "기말 실증 테스트",
    9: "결론",
    10: "N/A",
    11: "실행",
    12: "범위 및 전략 품질 활동",
    13: "기타 범위 및 전략",
    14: "CRA",
    15: "위험 평가 및 중요성",
    16: "범위 및 전략 마무리",
    17: "중간감사 후 프로젝트 관리"
};

export const engagementMetricsComingDueOptions = [{
        value: 1,
        label: "내일"
    },
    {
        value: 3,
        label: "다음 3일"
    },
    {
        value: 5,
        label: "다음 5일",
        isDefault: true
    },
    {
        value: 10,
        label: "다음 10일"
    },
    {
        value: 30,
        label: "다음 30일",
        isMax: true
    }
];

export const engagementMetricsWhatsNewOptions = [{
        value: 1,
        label: "어제"
    },
    {
        value: 3,
        label: "최근 3일"
    },
    {
        value: 5,
        label: "최근 5일",
        isDefault: true
    },
    {
        value: 10,
        label: "최근 10일",
        isMax: true
    }
];

export const engagementMetricsDisplayedAttributes = {
    preparer: "작성",
    forMyReview: "리뷰",
    upcomingReview: "임박한 리뷰",
    reviewNotesAssigned: "내가 받은 노트",
    reviewNotesAuthored: "내가 작성한 노트",
    partnerTasks: "Partner task",
    eqrTasks: "EQR task",
    timephases: "시기",
    groupTasks: "그룹 task",
    groupDeliverables: "그룹 산출물",
    automation: "자동화",
    requests: "요청사항"
};

export const quickLinks = {
    linkAccountSummary: "계정 요약",
    linkScotSummary: "SCOT 요약",
    linkITSummary: "IT 요약",
    linkCRASummary: "CRA 요약",
    linkGAStructureSummary: "그룹 구조 요약",
    linkGAInstrcutionSummary: "그룹 지침 요약",
    linkSEM: "실증절차평가표",
    linkAuditPlan: "감사 계획",
    linkWorkPlan: "작업 계획",
    linkITProcessEvaluation: "IT Evaluation",

    linkGeneral: "일반",
    linkScots: "SCOT",
    linkITSO: "IT/SO",
    linkAccounts: "계정",
    linkResponseTask: "응답 Task",
    linkWrapupEngagement: "Engagement 마무리",
    linkArchive: "Archive 체크리스트"
};

export const customKeyEvents = {
    reportDate: "보고서일",
    endDatePeriodCovered: "보고기간말일",
    archiveDeadlineDate: "Archive 만료일"
};

export const filterReviewNoteStatus = [{
        value: filters.reviewNoteStatus.open,
        label: "처리 전"
    },
    {
        value: filters.reviewNoteStatus.cleared,
        label: "처리됨"
    },
    {
        value: filters.reviewNoteStatus.closed,
        label: "닫힘"
    }
];

export const filterFileExtension = [{
        value: filters.fileExtension.canvasForm,
        label: "Canvas 양식"
    },
    {
        value: filters.fileExtension.email,
        label: "이메일"
    },
    {
        value: filters.fileExtension.excel,
        label: "Excel"
    },
    {
        value: filters.fileExtension.paperProfile,
        label: "Paper Profile"
    },
    {
        value: filters.fileExtension.pdf,
        label: "PDF"
    },
    {
        value: filters.fileExtension.powerPoint,
        label: 'PowerPoint'
    },
    {
        value: filters.fileExtension.smartAutomation,
        label: 'Smart Automation'
    },
    {
        value: filters.fileExtension.visio,
        label: "Visio"
    },
    {
        value: filters.fileExtension.word,
        label: "Word"
    },
    {
        value: filters.fileExtension.zip,
        label: "Zip"
    },
    {
        value: filters.fileExtension.other,
        label: "기타"
    }
];

export const filterDocumentContent = [{
        value: filters.documentContent.trackedChanges,
        label: "추적된 변경사항"
    },
    {
        value: filters.documentContent.comments,
        label: "Comment"
    },
    {
        value: filters.documentContent.formulaError,
        label: "수식 오류 (Excel 파일 전용)"
    },
    {
        value: filters.documentContent.highlightsWordFilesOnly,
        label: "하이라이트 (Word 파일 전용)"
    },
    {
        value: filters.documentContent.hiddenSheets,
        label: "숨긴 시트"
    },
    {
        value: filters.documentContent.embeddedFiles,
        label: "내장 파일"
    },
    {
        value: filters.documentContent.ProtectedFiles,
        label: "보호됨"
    },
    {
        value: filters.documentContent.DocumentContentNotAvailable,
        label: "문서 내용을 사용할 수 없음"
    },
    {
        value: filters.documentContent.DocumentsInCollaborationMode,
        label: "Multi-user 편집 모드인 문서"
    },
];

export const filterSharedEvidence = [{
        value: filters.sharedEvidence.source,
        label: "원천"
    },
    {
        value: filters.sharedEvidence.target,
        label: "대상"
    }
];

export const filterFindings = [{
        value: filters.findings.misstatement,
        label: "왜곡표시"
    },
    {
        value: filters.findings.deficiency,
        label: "미비점"
    }
];

export const filterSignoffRequirements = [{
        value: filters.signoffRequirements.picMandatory,
        label: "PIC 필수"
    },
    {
        value: filters.signoffRequirements.picTeamAssigned,
        label: "PIC 팀 배정됨"
    },
    {
        value: filters.signoffRequirements.eqrMandatory,
        label: "EQR 필수"
    },
    {
        value: filters.signoffRequirements.eqrTeamAssigned,
        label: "EQR 팀 배정됨"
    }
];

export const filterResponsiveToRisks = [{
        value: filters.responsiveToRisk.responsiveToSignificantRisk,
        label: "유의적인 위험"
    },
    {
        value: filters.responsiveToRisk.responsiveToFraudRisk,
        label: "부정 위험"
    },
    {
        value: filters.responsiveToRisk.responsiveToHigherInherentRisk,
        label: "높은 고유위험"
    }
];

export const filterMissingRelatedTask = [{
        value: filters.missingRelatedTask.picSignoffRequired,
        label: "PIC sign-off 필요"
    },
    {
        value: filters.missingRelatedTask.eqrSignoffRequired,
        label: "EQR sign-off 필요"
    }
];

export const filterCanvasForms = [{
        value: filters.canvasForms.incompleteResponses,
        label: "미완료 응답"
    },
    {
        value: filters.canvasForms.unresolvedComments,
        label: "미해결 Comment"
    }
];

export const documentChangeTypes = {
    0: "선택한 변경사항 사유 없음",
    1: "비 관리사항 변경",
    2: "변경사항 추적 기능을 이용한 경우 변경사항 수락",
    3: "이미 존재하는 증거에 상호참조 추가",
    4: "이전에 팩스나 이메일로 회수한 조회서 원본 추가",
    5: "미관 변경",
    6: "Form AP 및 substantial role 평가 완료",
    7: "대체된 문서 삭제 또는 폐기",
    8: "Management letter 작성",
    9: "Archive 프로세스 관련 체크리스트 완료 시 sign-off",
    10: "최종 문서 정렬, 대조 및 상호참조",
    11: "현지 시간대로 조정하면, 보고서일 이전에 수정됐습니다 (아메리카 전용)"
};

export const documentChangeTypesOptions = [{
        value: 1,
        label: "비관리적 변경사항"
    },
    {
        value: 2,
        label: "해당 기능을 이용한 경우 변경사항/comment 수락"
    },
    {
        value: 3,
        label: "이미 존재하는 증거에 상호참조 추가"
    },
    {
        value: 4,
        label: "이전에 팩스나 이메일로 회수한 조회서 원본 추가"
    },
    {
        value: 5,
        label: "미관 변경"
    },
    {
        value: 6,
        label: "Form AP 및 substantial role 평가 완료"
    },
    {
        value: 7,
        label: "감사증거를 구성하지 않는 문서 삭제 또는 폐기"
    },
    {
        value: 8,
        label: "우리의 의견을 뒷받침하지 않는 문서 작성 또는 추가"
    },
    {
        value: 9,
        label: "Archive 프로세스 관련 체크리스트 완료 시 sign-off"
    },
    {
        value: 10,
        label: "최종 문서 정렬, 대조 및 상호참조"
    },
    {
        value: 12,
        label: "MEST 전용: EY Canvas에 있는 보고서일보다 보고서일이 늦은 기업과 관련된 증거 수정"
    },
    {
        value: 11,
        label: "현지 시간대로 조정하면, 보고서일 이전에 수정됐습니다 (아메리카 전용)"
    }
];

export const FourFortyFilterTypes = [{
        id: 0,
        filterType: 'QuickFilter',
        name: "빠른 필터",
        hasChild: false
    },
    {
        id: 1,
        filterType: 'TaskStatus',
        name: "Task 상태",
        hasChild: false
    },
    {
        id: 2,
        filterType: 'TaskType',
        name: "Task 유형",
        hasChild: false
    },
    {
        id: 3,
        filterType: 'AssignedTo',
        name: "담당자",
        hasChild: false,
        loadOptionsFromServer: true
    },
    {
        id: 4,
        filterType: 'OpenAssignment',
        name: "처리 전 배정",
        hasChild: false,
        loadOptionsFromServer: true
    },
    {
        id: 5,
        filterType: 'AssignmentsUsersEngagementRoles',
        name: "처리 전 배정",
        hideDisplay: true,
        loadOptionsFromServer: true
    },
    {
        id: 6,
        filterType: 'ReviewNotesStatus',
        name: "리뷰노트 상태",
        hasChild: false
    },
    {
        id: 7,
        filterType: 'ReviewNotesAssignedTo',
        name: "리뷰노트 담당자",
        hasChild: false,
        loadOptionsFromServer: true
    },
    {
        id: 8,
        filterType: 'ReviewNotesCreatedBy',
        name: "리뷰노트 생성자",
        hasChild: false,
        loadOptionsFromServer: true
    },
    {
        id: 9,
        filterType: 'TimePhase',
        name: "시기",
        hasChild: false,
        loadOptionsFromServer: true
    },
    {
        id: 10,
        filterType: 'Milestone',
        name: "Milestone",
        hasChild: false
    },
    {
        id: 11,
        filterType: 'AuditPhase',
        name: "감사 단계",
        altName: "Engagement 단계",
        hasChild: false
    },
    {
        id: 12,
        filterType: 'DocumentConflict',
        name: "문서 충돌",
        hasChild: false
    },
    {
        id: 13,
        filterType: 'Findings',
        name: "발견사항",
        hasChild: false,
        hideForNonAudit: true
    },
    {
        id: 14,
        filterType: 'Entity',
        name: "기업",
        hasChild: false,
        loadOptionsFromServer: true,
        hideForNonMest: true
    },
    {
        id: 15,
        filterType: 'IsBookmarked',
        name: "오프라인으로 다운로드됨",
        hasChild: false
    }
];

/* Arc Timeline */
export const arcValidationGroups = [{
        id: 1,
        label: "작성 단계 29 ???"
    },
    {
        id: 2,
        label: "작성 단계 30 ???"
    },
    {
        id: 3,
        label: "SEM (평가표) ???"
    },
    {
        id: ArcTimelineGroups.FinalizeEvidence,
        label: "증거 마무리"
    },
    {
        id: ArcTimelineGroups.CompleteRemainingTasks,
        label: "나머지 Task 완료"
    },
    {
        id: ArcTimelineGroups.ResolveValidations,
        label: "나머지 유효성 검증 해결"
    },
    {
        id: 7,
        label: "Archive 준비"
    },
    {
        id: 8,
        label: "Engagement 대시보드"
    },
    {
        id: 9,
        label: "Canvas 양식 (개별)"
    },
    {
        id: 10,
        label: "Canvas 양식 (모두)"
    }
];

export const checkListTypes = [{
        id: 7,
        label: "하드카피 파일과 폴더 마무리"
    },
    {
        id: 13,
        label: "주요 engagement 날짜 정확성 확인"
    },
    {
        id: 14,
        label: "Engagement 코드 정확성 확인"
    },
    {
        id: 15,
        label: "고객 코드 정확성 확인"
    },
    {
        id: 10,
        label: "그룹에서 이 Engagement 링크 해제"
    },
    {
        id: 16,
        label: "보고서 유형 검증"
    },
    {
        id: 17,
        label: "보고서 발행일 후 수정된 파일에 대해 임시 파일 검토"
    },
    {
        id: 18,
        label: "보고서 발행일 후 수정된 파일에 대해 삭제 파일 검토"
    },
    {
        id: 19,
        label: "Engagement 프로필 변경사항 제출 확인"
    },
    {
        id: 20,
        label: "보호 문서 검토"
    },
    {
        id: 95,
        label: "총괄 담당자 지정"
    }
];

export const arcValidationTypes = [{
        id: ArcTimeLineValidationTypes.DocumentConflict,
        label: "나머지 문서 충돌 해결"
    },
    {
        id: ArcTimeLineValidationTypes.DocumentsInMultiUserEditMode,
        label: "Multi-user 편집 중인 문서"
    },
    {
        id: ArcTimeLineValidationTypes.DocumentsWithIsProtected,
        label: "보호 문서 검토"
    },
    {
        id: ArcTimeLineValidationTypes.DocumentIsNotFinalized,
        label: "문서 내용을 사용할 수 없음"
    },
    {
        id: ArcTimeLineValidationTypes.AddressAllOpenReviewNotes,
        label: "해결되지 않은 리뷰노트 모두 닫기"
    },
    {
        id: ArcTimeLineValidationTypes.RemoveTrackedChangesFromEvidence,
        label: "증거에서 변경사항 추적 제거"
    },
    {
        id: ArcTimeLineValidationTypes.FinalizeSmartAutomationEvidenceFiles,
        label: "스마트 자동화 증거 파일 마무리"
    },
    {
        id: ArcTimeLineValidationTypes.FinalizeCompleteAllPICSignoffRequirements,
        label: "모든 PIC sign-off 요건 완료"
    },
    {
        id: ArcTimeLineValidationTypes.FinalizeCompleteAllEQRSignoffRequirements,
        label: "모든 EQR sign-off 요건 완료"
    },
    {
        id: ArcTimeLineValidationTypes.PICEvidenceWithoutAtLeastOneRelatedPICTask,
        label: "PIC 문서를 PIC task에 연결하십시오"
    },
    {
        id: ArcTimeLineValidationTypes.EQREvidenceWithoutAtLeastOneRelatedEQRTask,
        label: "EQR 문서를 EQR task에 연결하십시오"
    },
    {
        id: ArcTimeLineValidationTypes.EvidencemissingSignoffs,
        label: "모든 증거에 sign-off"
    },
    {
        id: ArcTimeLineValidationTypes.CanvasFormComment,
        label: "Canvas 양식 comment 해결"
    },
    {
        id: ArcTimeLineValidationTypes.UnlinkedSharedEvidence,
        label: "공유 증거 링크 해제"
    },
    {
        id: ArcTimeLineValidationTypes.TaskswithoutEvidence,
        label: "처리 전 task에 증거 추가"
    },
    {
        id: ArcTimeLineValidationTypes.PICTaskWithoutAtLeastOneRelatedPICEvidence,
        label: "모든 PIC task에 PIC 문서가 포함되어 있는지 확인하십시오"
    },
    {
        id: ArcTimeLineValidationTypes.EQRTaskWithoutAtLeastOneRelatedEQREvidence,
        label: "모든 EQR task에 EQR 문서가 포함되어 있는지 확인하십시오"
    },
    {
        id: ArcTimeLineValidationTypes.RelateEvidenceToEntityTask,
        label: "기업 task에 증거 연결"
    },
    {
        id: ArcTimeLineValidationTypes.MarkTasksComplete,
        label: "Task에 완료 표시"
    },
    {
        id: ArcTimeLineValidationTypes.AccountsSummary,
        label: "계정 요약"
    },
    {
        id: ArcTimeLineValidationTypes.ScotSummary,
        label: "SCOT 요약"
    },
    {
        id: ArcTimeLineValidationTypes.CraSummary,
        label: "CRA 요약"
    },
    {
        id: ArcTimeLineValidationTypes.ITSummary,
        label: "IT 요약"
    },
    {
        id: ArcTimeLineValidationTypes.ConfirmAccuracyOfAuditorReport,
        label: "감사보고서 데이터 정확성 확인"
    },
    {
        id: ArcTimeLineValidationTypes.CompleteArchiveForm,
        label: "Archive 양식 완료"
    },
    {
        id: ArcTimeLineValidationTypes.CompleteArchiveTask,
        label: "Archive Task 완료"
    },
    {
        id: ArcTimeLineValidationTypes.UnlinkGroupSharedEvidence,
        label: "그룹 공유 증거 링크 해제"
    },
    {
        id: ArcTimeLineValidationTypes.AuditPlan,
        label: "감사 계획"
    },
    {
        id: ArcTimeLineValidationTypes.UnassociateFinding,
        label: "연결되지 않은 발견사항"
    },
    {
        id: ArcTimeLineValidationTypes.IndependenceCompliance,
        label: "독립성 준수"
    },
    {
        id: ArcTimeLineValidationTypes.IncompleteCanvasFormResponses,
        label: "미완료 Canvas 양식 응답 마무리"
    },
    {
        id: ArcTimeLineValidationTypes.WCGWwithNoRelatedsubstantivetask,
        label: "실증절차평가표"
    },
    {
        id: ArcTimeLineValidationTypes.ITEvaluation,
        label: "IT Evaluation"
    },
    {
        id: ArcTimeLineValidationTypes.DocumentModifiedAfterReportReleaseDate,
        label: "보고서 발행일 후 수정된 문서"
    },
    {
        id: ArcTimeLineValidationTypes.DuplicateFileNames,
        label: "중복된 파일 이름이 있는 증거 파일 이름을 바꾸십시오"
    },
    {
        id: ArcTimeLineValidationTypes.ITFlowCanvasForm,
        label: "IT 흐름"
    },
    {
        id: ArcTimeLineValidationTypes.AdjustmentsModule,
        label: "조정사항"
    },
    {
        id: ArcTimeLineValidationTypes.CanvasFormsWithNoContent,
        label: "내용 없는 Canvas 양식 검토"
    },
    {
        id: ArcTimeLineValidationTypes.PersonInCharge,
        label: "담당자"
    },
    {
        id: ArcTimeLineValidationTypes.EstimateAccountWithoutEstimatePSPindex,
        label: ''
    },
    {
        id: ArcTimeLineValidationTypes.TempFilesWithPreparerAndReviewerSignoffsError,
        label: "증거에 포함되거나 삭제되어야 하는 파일에 대해 작성자 및 검토자 sign-off가 있는 임시 파일을 검토하십시오"
    },
    {
        id: ArcTimeLineValidationTypes.TemporaryFilesWithPICRequirementUserOrKnowledge,
        label: "PIC 태그가 있는 임시 파일에, 증거에 포함해야 하는 파일 또는 삭제된 태그가 있는지 검토하십시오"
    },
    {
        id: ArcTimeLineValidationTypes.TemporaryFileWithEQRRequirementUserOrKnowledge,
        label: "EQR 태그가 있는 임시 파일에, 증거에 포함해야 하는 파일 또는 삭제된 태그가 있는지 검토하십시오"
    },
    {
        id: ArcTimeLineValidationTypes.DeletedFilesWithPICRequirementUserOnly,
        label: "PIC 태그가 있는 삭제된 파일에, 증거에 포함해야 하는 파일 또는 삭제된 태그가 있는지 검토하십시오"
    },
    {
        id: ArcTimeLineValidationTypes.DeletedFilesWithEQRRequirementUserOnly,
        label: "EQR 태그가 있는 삭제된 파일에, 증거에 포함해야 하는 파일 또는 삭제된 태그가 있는지 검토하십시오"
    },
    {
        id: ArcTimeLineValidationTypes.DocumentAssociatedToInvalidObject,
        label: "이 engagement에서 더이상 사용할 수 없는 object에 연결된 문서"
    }
];

export const ArchiveErrors = {
    32204: "Engagement에 증거 없는 task가 있습니다",
    32209: "Engagement에 미완료 Canvas 양식이 있습니다",
    32210: "Engagement에 처리 전 리뷰노트가 있습니다",
    32212: "Engagement에 미완료 task가 있습니다",

    32402: "Archive ID가 null이거나 비었습니다",
    32403: "파일 GUID가 null이거나 비었습니다",
    32404: "ARC 파일 저장 호스트가 null이거나 비었습니다",
    32424: "Primary engagement 코드가 누락됐거나 유효하지 않습니다",
    32425: "보고서 발행일은 오늘 이후 날짜일 수 없습니다",
    32426: "보고서 발행일은 engagement 종료일보다 늦어야 합니다",
    32427: "Engagement에 partner가 초대돼야 합니다",
    32428: "ARC에 조서 유형 데이터가 누락됐습니다",
    32429: "Archive 양식에서 보고서 유형을 선택해야 합니다",
    32430: "Archive 양식에서 한정 보고서를 선택해야 합니다",
    32431: "ARC와의 통합으로 인해 archive 프로세스 동안 오류가 발생했습니다. 이 오류를 보고하려면 헬프 데스크에 문의하십시오."
};

export const validationTypes = [{
        id: 1,
        label: "독립성 준수 처리 전",
        altLabel: "미완료 양식",
        errorLabel: "독립성 준수 처리 전"
    },
    {
        id: 2,
        label: "최신 버전이 아닌 독립성 양식",
        altLabel: "구 양식",
        errorLabel: "최신 버전이 아닌 독립성 양식"
    },
    {
        id: 3,
        label: "부적격 역할에 의해 부여된 접근",
        altLabel: "PPEDD가 승인하지 않음",
        errorLabel: "부적격 역할에 의해 부여된 접근"
    },
    {
        id: 4,
        label: "부적격 역할에 의한 재지정",
        altLabel: "PPEDD가 무시하지 않음",
        errorLabel: "부적격 역할에 의한 무시"
    },
    {
        id: 5,
        label: "연결되지 않은 SCOT (계정 없음)",
        errorLabel: "연결되지 않은 SCOT"
    },
    {
        id: 6,
        label: "연결되지 않은 통제 (WCGW 없음)",
        errorLabel: "연결되지 않은 통제"
    },
    {
        id: 7,
        label: "WCGW 연결 없이 통제 전략이 선택되었습니다",
        errorLabel: "WCGW 연결 없이 통제 전략이 선택됐습니다"
    },
    {
        id: 8,
        label: "통제 연결 없이 통제 전략이 선택되었습니다",
        errorLabel: "통제 연결 없이 통제 전략이 선택됐습니다"
    },
    {
        id: 9,
        label: "테스트할 통제 연결 없이 통제 전략이 선택되었습니다",
        errorLabel: "테스트할 통제 연결 없이 통제 전략이 선택됐습니다"
    },
    {
        id: 10,
        label: "통제 전략이 선택되었는데 테스트할 통제가 연결되지 않은 WCGW이 있습니다",
        errorLabel: "통제 전략이 선택됐는데 테스트할 통제가 연결되지 않은 WCGW이 있습니다"
    },
    {
        id: 11,
        label: "연결되지 않은 위험",
        errorLabel: "연결되지 않은 위험"
    },
    {
        id: 12,
        label: "이 경영진주장에 대해 CRA를 완료하십시오",
        errorLabel: "이 경영진주장에 대해 CRA를 완료하십시오"
    },
    {
        id: 13,
        label: "연결되지 않은 WCGW",
        errorLabel: "연결되지 않은 WCGW"
    },
    {
        id: 14,
        label: "유의적인 계정에 연결된 SCOT이 없습니다",
        errorLabel: "유의적인 계정에 연결된 SCOT이 없습니다"
    },
    {
        id: 15,
        label: "WCGW 연결 없이 의존 전략이 선택되었습니다",
        errorLabel: "WCGW 연결 없이 의존 전략이 선택됐습니다"
    },
    {
        id: 16,
        label: "통제 연결 없이 의존 전략이 선택되었습니다",
        errorLabel: "통제 연결 없이 의존 전략이 선택됐습니다"
    },
    {
        id: 17,
        label: "테스트할 통제 연결 없이 의존 전략이 선택되었습니다",
        errorLabel: "테스트할 통제 연결 없이 의존 전략이 선택됐습니다"
    },
    {
        id: 18,
        label: "의존 전략이 선택되었는데 테스트할 통제가 연결되지 않은 WCGW이 있습니다",
        errorLabel: "의존 전략이 선택됐는데 테스트할 통제가 연결되지 않은 WCGW이 있습니다"
    },
    {
        id: 19,
        label: "연결되지 않은 IT App/SO",
        errorLabel: "연결되지 않은 IT App/SO"
    },
    {
        id: 20,
        label: "연결되지 않은 통제 / IT 실증절차",
        errorLabel: "연결되지 않은 통제/IT 실증절차"
    },
    {
        id: 21,
        label: "연결된 IT Application/SO가 없습니다",
        errorLabel: "연결된 IT Application/SO 없음"
    },
    {
        id: 22,
        label: "연결된 위험이 없습니다",
        errorLabel: "연결된 위험 없음"
    },
    {
        id: 23,
        label: "연결된 통제/IT 실증절차가 없습니다",
        errorLabel: "연결된 통제/IT 실증절차 없음"
    },
    {
        id: 24,
        label: "테스트를 위해 선택된 연결된 통제/IT 실증절차가 없습니다",
        errorLabel: "테스트를 위해 선택한 관련 통제/IT 실증절차 없음"
    },
    {
        id: 25,
        label: "테스트할 통제 / IT 실증절차가 연결되지 않은 위험이 있습니다",
        errorLabel: "테스트할 통제 / IT 실증절차가 연결되지 않은 위험이 있습니다"
    },
    {
        id: 26,
        label: "Limited Risk 계정에 연결된 실증 task가 없습니다",
        errorLabel: "Limited Risk 계정에 연결된 실증 task가 없습니다"
    },
    {
        id: 27,
        label: "실증 task가 경영진주장과 연결되지 않았습니다",
        errorLabel: "실증 task가 경영진주장과 연결되지 않았습니다"
    },
    {
        id: 28,
        label: "연결되지 않은 TOC",
        errorLabel: "연결되지 않은 TOC"
    },
    {
        id: 29,
        label: "연결되지 않은 Walkthrough",
        errorLabel: "연결되지 않은 Walkthrough"
    },
    {
        id: 30,
        label: "Walkthrough task가 이 SCOT과 연결되지 않았습니다",
        errorLabel: "Walkthrough task가 이 SCOT과 연결되지 않았습니다"
    },
    {
        id: 31,
        label: "통제 task가 테스트할 통제에 연결되지 않았습니다",
        errorLabel: "통제 task가 테스트할 통제에 연결되지 않았습니다"
    },
    {
        id: 32,
        label: "연결되지 않은 IT/SO Walkthrough",
        errorLabel: "연결되지 않은 IT/SO Walkthrough"
    },
    {
        id: 33,
        label: "연결되지 않은 IT/SO TOC",
        errorLabel: "연결되지 않은 IT/SO TOC"
    },
    {
        id: 34,
        label: "연결되지 않은 IT/SO OSP",
        errorLabel: "연결되지 않은 IT/SO OSP"
    },
    {
        id: 35,
        label: "IT/SO 프로세스에 연결된 Walkthrough task가 없습니다",
        errorLabel: "IT/SO 프로세스에 연결된 Walkthrough task가 없습니다"
    },
    {
        id: 36,
        label: "통제에 연결된 TOC가 없습니다",
        errorLabel: "통제에 연결된 TOC가 없습니다"
    },
    {
        id: 37,
        label: "IT 실증절차에 연결된 OSP가 없습니다",
        errorLabel: "IT 실증절차에 연결된 OSP가 없습니다"
    },
    {
        id: 38,
        label: "문서 충돌",
        errorLabel: "미해결 충돌"
    },
    {
        id: 39,
        label: "동기화 충돌 - 공유 증거 - Canvas 유효성 검증 개수에 표시되지 않음",
        errorLabel: "공유 증거 - 동기화 충돌"
    },
    {
        id: 40,
        label: "Sign-off가 없는 증거",
        errorLabel: "모든 증거에 sign-off"
    },
    {
        id: 41,
        label: "증거가 없는 Task",
        errorLabel: "처리 전 task에 증거 추가"
    },
    {
        id: 42,
        label: "유효하지 않은 Engagement 코드",
        errorLabel: "유효하지 않은 Engagement 코드"
    },
    {
        id: 43,
        label: "유효하지 않은 고객 코드",
        errorLabel: "유효하지 않은 고객 코드"
    },
    {
        id: 44,
        label: "중복된 파일 이름",
        errorLabel: "중복 파일 이름"
    },
    {
        id: 45,
        label: "모순된 IT Evaluation",
        errorLabel: "미완료 IT 프로세스 평가"
    },
    {
        id: 46,
        label: "미완료 IT 프로세스 평가",
        errorLabel: "미완료 IT 프로세스 평가"
    },
    {
        id: 47,
        label: "미완료 Aggregate IT Evaluation",
        errorLabel: "미완료 Aggregate IT Evaluation"
    },
    {
        id: 48,
        label: "응답 미완료",
        errorLabel: "근거 미완료"
    },
    {
        id: 49,
        label: "연결되지 않은 왜곡표시",
        errorLabel: "연결되지 않은 왜곡표시"
    },
    {
        id: 50,
        label: "연결되지 않은 미비점",
        errorLabel: "연결되지 않은 미비점"
    },
    {
        id: 51,
        label: "실증 task가 연결되지 않은 WCGW",
        errorLabel: "실증 task가 연결되지 않은 WCGW"
    },
    {
        id: 52,
        label: "WCGW이 연결되지 않은 위험",
        errorLabel: "WCGW 없는 위험"
    },
    {
        id: 53,
        label: "추정 PSP index가 없는 추정 계정",
        errorLabel: "추정치 PSP index가 없는 추정치 계정"
    },
    {
        id: 54,
        label: "추정 SCOT이 없는 추정 계정",
        errorLabel: "추정 SCOT이 없는 추정치 계정"
    },
    {
        id: 55,
        label: "추정 계정이 없는 추정 SCOT",
        errorLabel: "추정치 계정이 없는 추정 SCOT"
    },
    {
        id: 56,
        label: "통제 위험이 의존 전략이지만 대응 TOC가 없는 경영진주장",
        errorLabel: "통제 위험이 의존 전략이지만 대응 TOC가 없는 경영진주장"
    },
    {
        id: 57,
        label: "통제위험이 의존전략임에도, 낮지 않은 위험에 대응하고 효과적으로 설계된 통제와 연결된 TOC가 하나 이상 연결되어 있지 않은 경영진주장",
        errorLabel: "통제위험이 의존전략임에도, 낮지 않은 위험에 대응하고 효과적으로 설계된 통제와 연결된 TOC가 하나 이상 연결되어 있지 않은 경영진주장"
    },
    {
        id: 58,
        label: "대응 실증 task가 없는 경영진주장",
        errorLabel: "대응 실증 task가 없는 경영진주장"
    },
    {
        id: 59,
        label: "대응 통제가 없는 경영진주장",
        errorLabel: "대응 통제가 없는 경영진주장"
    },
    {
        id: 60,
        label: "Canvas 양식 comment",
        errorLabel: "Canvas 양식 comment"
    },
    {
        id: 61,
        label: "Canvas 양식 미완료 응답",
        errorLabel: "Canvas 양식 미완료 응답"
    },
    {
        id: 62,
        label: "닫거나 삭제해야 하는 처리 전 또는 처리된 리뷰노트",
        errorLabel: "닫거나 삭제해야 하는 처리 전 또는 처리된 리뷰노트"
    },
    {
        id: 63,
        label: "변경사항 추적이 있는 증거",
        errorLabel: "변경사항 추적이 있는 증거"
    },
    {
        id: 64,
        label: "완료 표시되지 않은 task",
        errorLabel: "Task 완료 표시"
    },
    {
        id: 65,
        label: "링크 해제되지 않은 공유 증거",
        errorLabel: "링크 해제된 공유 증거"
    },
    {
        id: 66,
        label: "수정 유형이 선택되지 않은 문서",
        errorLabel: "수정 유형이 선택되지 않은 문서"
    },
    {
        id: 67,
        label: "변경 사유(근거)가 없는 비관리적 변경사항",
        errorLabel: "변경 사유(근거)가 없는 비관리적 변경사항"
    },
    {
        id: 68,
        label: "적합한 역할에 의해 승인받지 않은 비관리적 변경 수정",
        errorLabel: "적합한 역할에 의해 승인받지 않은 비관리적 변경 수정"
    },
    {
        id: 69,
        label: "440 GL executive 검토자 sign-off 누락",
        errorLabel: "44 GL executive 검토자 sign-off 누락"
    },
    {
        id: 70,
        label: "링크 해제되지 않은 그룹 engagement",
        errorLabel: "그룹에서 이 Engagement 링크 해제"
    },
    {
        id: 71,
        label: "머리글 없는 Canvas 양식",
        altLabel: "머리글 없는 Canvas 양식",
        errorLabel: "머리글 없는 Canvas 양식"
    },
    {
        id: 72,
        label: "내용이 누락된 그룹 부문 요약 문서",
        errorLabel: "내용이 누락된 그룹 부문 요약 문서"
    },
    {
        id: 73,
        label: "승인 무관 미완료 Canvas 양식 응답",
        errorLabel: "미완료 Canvas 양식"
    },
    {
        id: 74,
        label: "프로필 V2 변경 제출되지 않음",
        errorLabel: "프로필 변경사항 미제출"
    },
    {
        id: 75,
        label: "0 바이트 전자 파일",
        errorLabel: "0 바이트 전자 파일"
    },
    {
        id: 76,
        label: "독립성 양식 제출 후 편집됨",
        altLabel: "양식 제출되지 않음",
        errorLabel: "독립성 양식 제출 후 편집됨"
    },
    {
        id: 77,
        label: "개별과 다른 독립성 양식",
        altLabel: "개별과 다른 독립성 양식",
        errorLabel: "개별과 다른 독립성 양식"
    },
    {
        id: 78,
        label: "IT 프로세스가 하나 이상 연결되어 있지 않은 IT Application (SO 아님)",
        errorLabel: "연결되지 않은 IT application"
    },
    {
        id: 79,
        label: "ITGC에 연결된 IT 위험이 없거나 HasNoITGC = 1인 IT 위험과 연결되어 있습니다",
        errorLabel: "연결되지 않은 ITGC"
    },
    {
        id: 80,
        label: "ITSP에 연결된 IT 위험이 없습니다",
        errorLabel: "연결되지 않은 ITSP"
    },
    {
        id: 81,
        label: "IT 프로세스에 연결된 IT Application이 없습니다",
        errorLabel: "연결되지 않은 IT 프로세스"
    },
    {
        id: 82,
        label: "IT Application을 통해 (예외 없이) 연결된 ITAC 또는 ITDM이 있는 IT 위험이 없는 IT 프로세스",
        errorLabel: "IT 위험 누락"
    },
    {
        id: 83,
        label: "IT 위험(HasNoITGC = 0)에 연결된 ITGC가 없습니다",
        errorLabel: "ITGC 또는 미존재 표시 누락"
    },
    {
        id: 84,
        label: "연결된 IT Application이 없는 ITDM/ITAC",
        errorLabel: "IT app이 없는 App/ITDM 통제"
    },
    {
        id: 85,
        label: "해당 본문이 표시되지 않으면 ITSP가 삭제되지 않습니다",
        errorLabel: "삭제될 ITSP"
    },
    {
        id: 86,
        label: "해당 본문이 표시되지 않으면 ITGC가 삭제되지 않습니다",
        errorLabel: "삭제될 ITGC"
    },
    {
        id: 87,
        label: "해당 본문이 표시되지 않으면 IT 위험이 삭제되지 않습니다",
        errorLabel: "삭제될 IT 위험"
    },
    {
        id: 88,
        label: "해당 본문이 표시되지 않으면 HasITControlTesting = 1이 있는 ITGC가 존재합니다",
        errorLabel: "테스트 전략이 유효하지 않은 ITGC"
    },
    {
        id: 89,
        label: "선택된 설계 효과성이 없는 ITGC",
        errorLabel: "ITGC 설계 효과성 누락"
    },
    {
        id: 90,
        label: "선택된 설계 효과성이 없는 통제",
        errorLabel: "선택된 설계 효과성이 없는 통제"
    },
    {
        id: 91,
        label: "HasNoITApplication = 0인 IT Application이 없는 SCOT",
        errorLabel: "연결되지 않은 SCOT"
    },
    {
        id: 92,
        label: "유의적인 위험에 대응하지만 그 위험과 관련된 WCGW에는 대응하지 않는 실증절차 및 통제테스트",
        errorLabel: "모순된 위험 Task 연결 vs 위험 > WCGW > Task 관계"
    },
    {
        id: 93,
        label: "모순된 통제 테스트 응답",
        errorLabel: "모순된 통제 테스트 응답"
    },
    {
        id: 94,
        label: "HasNoITApplication = 0이 있는 SCOT에 ITDM 또는 App 통제가 있습니다",
        errorLabel: "SCOT에 IT application 누락"
    },
    {
        id: 95,
        label: "전반적으로 책임질 팀 멤버가 배정되지 않았습니다",
        altLabel: "전반적으로 책임질 팀 멤버가 배정되지 않았습니다",
        errorLabel: "전반적으로 책임질 팀 멤버가 배정되지 않았습니다"
    },
    {
        id: 96,
        label: "위험에 연결되지 않았거나 ROMM 아님으로 표시되지 않은 위험요소",
        errorLabel: "위험에 연결되지 않았거나 ROMM 아님으로 표시되지 않은 위험요소"
    },
    {
        id: 97,
        label: "Risks unrelated to an Assertion",
        errorLabel: "Risks unrelated to an Assertion"
    },
    {
        id: 98,
        label: "미완료 측정 기준 예측 금액",
        errorLabel: "미완료 측정 기준 예측 금액"
    },
    {
        id: 99,
        label: "미완료 측정 기준 예측 금액",
        errorLabel: "미완료 측정 기준 예측 금액"
    },
    {
        id: 100,
        label: "미완료 측정 기준 조정 금액",
        errorLabel: "미완료 측정 기준 조정 금액"
    },
    {
        id: 101,
        label: "미완료 계획 중요성 (PM)",
        errorLabel: "미완료 계획 중요성 (PM)"
    },
    {
        id: 102,
        label: "최대 금액보다 큰 계획 중요성 (PM)",
        errorLabel: "최대 금액보다 큰 계획 중요성 (PM)"
    },
    {
        id: 103,
        label: "미완료 계획 중요성 (PM) 근거",
        errorLabel: "미완료 계획 중요성 (PM) 근거"
    },
    {
        id: 104,
        label: "미완료 허용 오류 (TE)",
        errorLabel: "미완료 허용 오류 (TE)"
    },
    {
        id: 105,
        label: "허용 범위를 벗어난 TE",
        errorLabel: "허용 범위를 벗어난 TE"
    },
    {
        id: 106,
        label: "미완료 허용 오류 (TE) 근거",
        errorLabel: "미완료 허용 오류 (TE) 근거"
    },
    {
        id: 107,
        label: "미완료 SAD",
        errorLabel: "미완료 SAD"
    },
    {
        id: 108,
        label: "최대치보다 큰 SAD",
        errorLabel: "최대치보다 큰 SAD"
    },
    {
        id: 109,
        label: "미완료 SAD 근거",
        errorLabel: "미완료 SAD 근거"
    },
    {
        id: 110,
        label: "미완료 PACE 선택",
        errorLabel: "미완료 PACE 선택"
    },
    {
        id: 111,
        label: "연결된 문서 없음",
        errorLabel: "연결된 문서 없음"
    },
    {
        id: 112,
        label: "PIC 증거가 하나 이상 연결되지 않은 PIC task",
        errorLabel: "PIC 증거가 하나 이상 연결되지 않은 PIC task"
    },
    {
        id: 113,
        label: "EQR 증거가 하나 이상 연결되지 않은 EQR task",
        errorLabel: "EQR 증거가 하나 이상 연결되지 않은 EQR task"
    },
    {
        id: 114,
        label: "PIC task가 하나 이상 연결되지 않은 PIC 증거",
        errorLabel: "PIC task가 하나 이상 연결되지 않은 PIC 증거"
    },
    {
        id: 115,
        label: "EQR task가 하나 이상 연결되지 않은 EQR 증거",
        errorLabel: "EQR task가 하나 이상 연결되지 않은 EQR 증거"
    },
    {
        id: 116,
        label: "PIC sign-off가 하나 이상 없는 PIC 증거",
        errorLabel: "PIC sign-off가 하나 이상 없는 PIC 증거"
    },
    {
        id: 117,
        label: "EQR sign-off가 하나 이상 없는 EQR 증거",
        errorLabel: "EQR sign-off가 하나 이상 없는 EQR 증거"
    },
    {
        id: 118,
        label: "Archive 되지 않을 증거가 여전히 있습니다",
        errorLabel: "Archive 되지 않을 증거가 여전히 있습니다"
    },
    {
        id: 119,
        label: "작성자 및 검토자 sign-off가 있는 임시 파일",
        errorLabel: "작성자 및 검토자 sign-off가 있는 임시 파일"
    },
    {
        id: 120,
        label: "모든 처리 전 또는 처리된 Canvas 양식 comment",
        errorLabel: "모든 처리 전 또는 처리된 Canvas 양식 comment"
    },
    {
        id: 121,
        label: "PIC 요건이 있는 임시 파일",
        errorLabel: "PIC 요건이 있는 임시 파일"
    },
    {
        id: 122,
        label: "EQR 요건이 있는 임시 파일",
        errorLabel: "EQR 요건이 있는 임시 파일"
    },
    {
        id: 123,
        label: "PIC 요건이 있는 삭제 파일",
        errorLabel: "PIC 요건이 있는 삭제 파일"
    },
    {
        id: 124,
        label: "EQR 요건이 있는 삭제 파일",
        errorLabel: "EQR 요건이 있는 삭제 파일"
    },
    {
        id: 125,
        label: "보호 문서 검토",
        errorLabel: "보호 문서 검토 "
    },
    {
        id: 126,
        label: "문서 내용을 사용할 수 없음",
        errorLabel: "문서 내용을 사용할 수 없음"
    },
    {
        id: 127,
        label: "데이터 없는 손익계산서 본문",
        errorLabel: "데이터 없는 손익계산서 본문"
    },
    {
        id: 128,
        label: "데이터 없는 재무상태표 본문",
        errorLabel: "데이터 없는 재무상태표 본문"
    },
    {
        id: 129,
        label: "Multi-entity - 관련 계정에 대한 모든 PSP/ACT에 연결되지 않은 multi-entity",
        errorLabel: "Multi-entity - 관련 계정에 대한 모든 PSP/ACT에 연결되지 않은 multi-entity"
    },
    {
        id: 130,
        label: "개별 위험평가 양식이 없는 계정",
        errorLabel: "개별 위험평가 양식이 없는 계정"
    },
    {
        id: 131,
        label: "추정치 문서화가 없는 추정치",
        errorLabel: "추정치 문서화가 없는 추정치"
    },
    {
        id: 132,
        label: "개별 분석 양식이 없는 계정",
        errorLabel: "개별 분석 양식이 없는 계정"
    },
    {
        id: 133,
        label: "개별 프로필 양식이 없는 multi-entity",
        errorLabel: "개별 프로필 양식이 없는 multi-entity"
    },
    {
        id: 134,
        label: "계정 - 계정 유형 ID가 작업과 일치하지 않습니다",
        errorLabel: "계정 - 계정 유형 ID가 작업과 일치하지 않습니다"
    },
    {
        id: 135,
        label: "계정 - 추정치 있음이 작업과 일치하지 않습니다",
        errorLabel: "계정 - 추정치 있음이 작업과 일치하지 않습니다"
    },
    {
        id: 136,
        label: "계정 - 계정 양식 옵션에 계정에 연결되지 않은 관련 위험이 있습니다",
        errorLabel: "계정 - 계정 양식 옵션에 계정에 연결되지 않은 관련 위험이 있습니다"
    },
    {
        id: 137,
        label: "계정 - 높은 위험이 연결되지 않은 높은 고유위험 경영진주장",
        errorLabel: "계정 - 높은 위험이 연결되지 않은 높은 고유위험 경영진주장"
    },
    {
        id: 138,
        label: "Multi-entity - 관련 계정에 연결된 실증절차가 없는 multi-entity",
        errorLabel: "Multi-entity - 관련 계정에 연결된 실증절차가 없는 multi-entity"
    },
    {
        id: 139,
        label: "그룹 관여 양식이 없는 부문 (참조 전용 부문 제외)",
        errorLabel: "그룹 관여 양식이 없는 부문 (참조 전용 부문 제외)"
    },
    {
        id: 140,
        label: "관련 그룹 위험평가 지침이 없는 부문 (Full/Sepecific) (참조 전용 부문 제외)",
        errorLabel: "관련 그룹 위험평가 지침이 없는 부문 (Full/Sepecific) (참조 전용 부문 제외)"
    },
    {
        id: 141,
        label: "Multi-entity - 연결된 Multi-entity가 없는 계정",
        errorLabel: "Multi-entity - 연결된 Multi-entity가 없는 계정"
    },
    {
        id: 142,
        label: "유효하지 않은 object에 연결된 문서.스마트 증거 원천 ID",
        errorLabel: "유효하지 않은 object에 연결된 문서.스마트 증거 원천 ID"
    },
    {
        id: 143,
        label: "계정 - 높은 위험이 연결되지 않은 높은 고유위험 경영진주장",
        errorLabel: "계정 - 높은 위험이 연결되지 않은 높은 고유위험 경영진주장"
    },
    {
        id: 144,
        label: "그룹 - 연결된 부문이 없는 계정 (다른 engagement에서 실행됨)",
        errorLabel: "그룹 - 연결된 부문이 없는 계정 (다른 engagement에서 실행됨) "
    },
    {
        id: 145,
        label: "계정 - 추정치 PSP index가 없는 추정치 계정",
        errorLabel: "계정 - 추정치 PSP index가 없는 추정치 계정"
    },
    {
        id: 146,
        label: "Multi-entity - Multi-entity 개별 프로필 변동 제출되지 않음 (개별 문서)",
        errorLabel: "Multi-entity - Multi-entity 개별 프로필 변동 제출되지 않음 (개별 문서)"
    },
    {
        id: 147,
        label: "Multi-entity - Multi-entity 개별 프로필 변동 제출되지 않음 (개별 문서)",
        errorLabel: "Multi-entity - Multi-entity 개별 프로필 변동 제출되지 않음 (개별 문서)"
    },
    {
        id: 148,
        label: "계정 - 불완전하거나 유효하지 않은 계정 정보",
        errorLabel: "계정 - 불완전하거나 유효하지 않은 계정 정보"
    },
    {
        id: 149,
        label: "문서 업로드 - 필수 PIC/EQR Sign-off 누락",
        errorLabel: "문서 업로드 - 필수 PIC/EQR Sign-off 누락"
    },
    {
        id: 150,
        label: "문서 업로드 - 필수 PIC/EQR Sign-off 요건 누락",
        errorLabel: "문서 업로드 - 필수 PIC/EQR Sign-off 요건 누락"
    },
    {
        id: 151,
        label: "계정 - 경영진주장이 연결되지 않은 유의적인 계정 / 공시",
        errorLabel: "계정 - 경영진주장이 연결되지 않은 유의적인 계정 / 공시"
    },
    {
        id: 152,
        label: "문서 업로드 - 작성자 및 검토자 Sign-off 누락",
        errorLabel: "문서 업로드 - 작성자 및 검토자 Sign-off 누락"
    },
    {
        id: 153,
        label: "증거가 없는 조정사항",
        errorLabel: "증거가 없는 조정사항"
    },
    {
        id: 154,
        label: "계정이 연결되지 않은 추정치",
        errorLabel: "계정이 연결되지 않은 추정치"
    },
    {
        id: 155,
        label: "비추정치 계정에 연결된 높은/낮은 위험 추정치",
        errorLabel: "비추정치 계정에 연결된 높은/낮은 위험 추정치"
    },
    {
        id: 156,
        label: "‘추정치 편집’에서 지정한 사항과 일치하지 않는 추정치 범주 응답",
        errorLabel: "‘추정치 편집’에서 지정한 사항과 일치하지 않는 추정치 범주 응답"
    },
    {
        id: 157,
        label: "유효한 SCOT이 없는 추정치",
        errorLabel: "유효한 SCOT이 없는 추정치"
    },
    {
        id: 158,
        label: "Account without valid estimate",
        errorLabel: "Account without valid estimate"
    },
    {
        id: 159,
        label: "높은 또는 낮은 위험 추정치가 없는 추정치 계정",
        errorLabel: "높은 또는 낮은 위험 추정치가 없는 추정치 계정"
    },
    {
        id: 160,
        label: "높은 또는 낮은 위험 추정치가 없는 추정 SCOT",
        errorLabel: "높은 또는 낮은 위험 추정치가 없는 추정 SCOT"
    },
    {
        id: 161,
        label: "상계되지 않는 조정사항",
        errorLabel: "상계되지 않는 조정사항"
    },
    {
        id: 162,
        label: "유효한 위험이 연결되지 않은 높은 위험 추정치",
        errorLabel: "유효한 위험이 연결되지 않은 높은 위험 추정치"
    },
    {
        id: 163,
        label: "문서 - 공동작업을 위해 체크아웃되었거나 체크아웃 진행 중인 문서",
        errorLabel: "문서 - 공동작업을 위해 체크아웃되었거나 체크아웃 진행 중인 문서"
    },
    {
        id: 164,
        label: "증거가 누락된 비 engagement 차원 task",
        errorLabel: "증거가 누락된 비 engagement 차원 task"
    },
    {
        id: 165,
        label: "EP 또는 EQR Sign-off 요건이 응답과 일치하지 않습니다",
        errorLabel: "EP 또는 EQR Sign-off 요건이 응답과 일치하지 않습니다"
    },
    {
        id: 166,
        label: "높은 위험이 아닌 추정치에 연결된 유의적인/부정 위험",
        errorLabel: "높은 위험이 아닌 추정치에 연결된 유의적인/부정 위험"
    }
];

export const contentType = {
    1: "PST",
    2: "PSP Index",
    3: "PSP",
    4: "그룹감사 지침",
    5: "GAM 필수 Canvas 양식",
    6: "사용자가 생성한 Canvas 양식 (예: SCOT 양식)",
    7: "독립성",
    9: "프로필",
    10: "Canvas 맵"
};

export const contentTypeByName = {
    'PST': "PST",
    'PSPIndex': "PSP Index",
    'PSP': "PSP",
    'GAInstructions': "그룹감사 지침",
    'CanvasFormKnowledge': "Knowledge에서 불러온 Canvas 양식",
    'CanvasFormUserAdded': "사용자가 생성한 Canvas 양식 (예: SCOT 양식)",
    'IndependenceForm': "독립성",
    'Profile': "프로필",
    'Maps': "Canvas 맵"
};

export const reportTypes = {
    1: "적정 - 강조사항 있음",
    2: "적정 - 강조사항 없음",
    3: "한정 - 강조사항 있음",
    4: "한정 - 강조사항 없음",
    5: "부적정 - 강조사항 있음",
    6: "부적정 - 강조사항 없음",
    7: "의견거절 - 강조사항 있음",
    8: "의견거절 - 강조사항 없음",
    100: "아니오",
    101: "N/A",
    102: "미선택"
};

export const internalUserRoles = [{
        roleKey: 3,
        sectionId: 2,
        groupDisplayOrder: 150,
        groupName: "권한",
        roleNameUI: "Engagement Archive",
        displayName: "Engagement Archive",
        roleDisplayOrder: 2,
        tooltipText: "Engagement를 archive하는 기능"
    },
    {
        roleKey: 4,
        sectionId: 2,
        groupDisplayOrder: 150,
        groupName: "권한",
        roleNameUI: "Engagement 관리",
        displayName: "Engagement 관리",
        roleDisplayOrder: 1,
        tooltipText: "내외부 멤버를 초대하고 내부 멤버에게 권한을 배정하는 기능"
    },
    {
        roleKey: 5,
        sectionId: 2,
        groupDisplayOrder: 150,
        groupName: "권한",
        roleNameUI: "내용 업데이트",
        displayName: "내용 업데이트",
        roleDisplayOrder: 6,
        tooltipText: "프로필을 편집하고 내용 업데이트를 수락하는 기능"
    },
    {
        roleKey: 7,
        sectionId: 2,
        groupDisplayOrder: 150,
        groupName: "권한",
        roleNameUI: "서비스 요청 생성",
        displayName: "서비스 요청사항 관리",
        roleDisplayOrder: 4,
        tooltipText: "서비스 요청사항을 생성하고 서비스 요청사항에 완료 표시하는 기능"
    },
    {
        roleKey: 8,
        sectionId: 2,
        groupDisplayOrder: 150,
        groupName: "권한",
        roleNameUI: "그룹 관리",
        displayName: "그룹 관리",
        roleDisplayOrder: 5,
        tooltipText: "Primary 또는 지역 팀에서 수신한 그룹 지침을 수락하거나 거절하십시오"
    },
    {
        roleKey: 9,
        sectionId: 2,
        groupDisplayOrder: 150,
        groupName: "권한",
        roleNameUI: "Engagement 복사, Roll forward, 복원",
        displayName: "Engagement 복사, Roll forward, 복원",
        roleDisplayOrder: 3,
        tooltipText: "Engagement를 복사하거나, archive본을 roll forward 또는 복원하는 기능",
    },
    {
        roleKey: 0,
        sectionId: 1,
        groupDisplayOrder: 200,
        groupName: "기밀",
        roleNameUI: "기본",
        displayName: "없음 (기본)",
        roleDisplayOrder: 1,
        tooltipText: "기본 기밀 문서 역할"
    },
    {
        roleKey: 10,
        sectionId: 1,
        groupDisplayOrder: 200,
        groupName: "기밀",
        roleNameUI: "Low",
        displayName: "Low",
        roleDisplayOrder: 8,
        tooltipText: "낮은 기밀 문서 역할"
    },
    {
        roleKey: 11,
        sectionId: 1,
        groupDisplayOrder: 200,
        groupName: "기밀",
        roleNameUI: "High",
        displayName: "High",
        roleDisplayOrder: 10,
        tooltipText: "높은 기밀 문서 역할"
    },
    {
        roleKey: 12,
        sectionId: 1,
        groupDisplayOrder: 200,
        groupName: "기밀",
        roleNameUI: "Moderate",
        displayName: "Moderate",
        roleDisplayOrder: 9,
        tooltipText: "중간 기밀 문서 역할"
    },
    // {
    // roleKey: 13,
    // sectionId:1,
    // groupDisplayOrder: 200,
    // groupName: "기밀",
    // roleNameUI: "기밀",
    // displayName: "기밀",
    // roleDisplayOrder: 11,
    // tooltipText: "엄격한 기밀 문서 역할"
    // },
    {
        roleKey: 14,
        sectionId: 3,
        groupDisplayOrder: 100,
        groupName: "제한",
        roleNameUI: "읽기 전용",
        displayName: "읽기 전용",
        roleDisplayOrder: 12,
        tooltipText: "이 기능은 이 Canvas engagement에 제3자 검토자를 추가하는 데만 사용해야 합니다. 심리실에서 적합한 승인과 허가를 받아야 합니다."
    },
    {
        roleKey: 16,
        sectionId: 3,
        groupDisplayOrder: 100,
        groupName: "제한",
        roleNameUI: "검토 전용",
        displayName: "검토 전용",
        roleDisplayOrder: 13,
        tooltipText: "검토 전용은 이 사용자에게 EY Canvas engagement에 있는 정보를 보고, sign-off하고, 리뷰노트 기능을 사용할 수 있게 합니다. 다른 EY 사용자가 이 engagement를 검토해야 하지만 편집하면 안 될 때, 이를 사용합니다."
    },
  {
        roleKey: 37,
        sectionId: 3,
        groupDisplayOrder: 100,
        groupName: "제한",
        roleNameUI: "독립성 전용",
        displayName: "독립성 전용",
        roleDisplayOrder: 14,
        tooltipText: "독립성 전용은 이 사용자가 engagement에서 독립성 양식은 완료할 수 있지만 EY Canvas engagement에 완전하게 접근할 수는 없습니다. 사용자가 engagement를 위한 업무를 수행했지만 EY Canvas에 접근할 필요가 없는 경우 이를 사용해야 합니다.",
    },
    {
        roleKey: 6,
        sectionId: 2,
        groupDisplayOrder: 150,
        groupName: "권한",
        roleNameUI: "편집 실행 취소",
        displayName: "문서 rollback / 일괄 삭제",
        roleDisplayOrder: 7,
        tooltipText: "보고서 발행일 후 실수로 변경한 경우 문서를 roll-back하고 440 EY Canvas 양식에서 변경사항을 제거하는 기능"
    },
    {
        roleKey: 35,
        sectionId: 2,
        groupDisplayOrder: 150,
        groupName: "권한",
        roleNameUI: "EY Canvas FIT enablement 공유 관리",
        displayName: "가이드 업무흐름 관리",
        roleDisplayOrder: 14,
        tooltipText: "EY Canvas engagement 간 가이드 업무흐름을 공유하는 기능"
    },
    {
        roleKey: 36,
        sectionId: 2,
        groupDisplayOrder: 150,
        groupName: "권한",
        roleNameUI: "EY Helix 데이터 불러오기",
        displayName: "EY Helix 데이터 불러오기",
        roleDisplayOrder: 15,
        tooltipText: "EY Helix에서 데이터를 불러오는 기능"
    }
];

export const ValidationSubGroups = [{
        id: 9008,
        label: "독립성 준수"
    },
    {
        id: 9001,
        label: "계정 요약"
    },
    {
        id: 9002,
        label: "SCOT 요약"
    },
    {
        id: 9004,
        label: "IT 요약"
    },
    {
        id: 9003,
        label: "CRA 요약"
    },
    {
        id: 9005,
        label: "감사 계획"
    },
    {
        id: 9011,
        label: "실증절차평가표"
    },
    {
        id: 9012,
        label: "Canvas 양식별 유효성 검증"
    },
    {
        id: 9009,
        label: "IT evaluation"
    },
    {
        id: 49,
        label: "연결되지 않은 왜곡표시"
    },
    {
        id: 50,
        label: "연결되지 않은 미비점"
    },
    {
        id: 44,
        label: "중복된 파일 이름"
    },
    {
        id: 38,
        label: "미해결 충돌"
    },
    {
        id: 9013,
        label: "보고서 발행일 후 수정"
    },
    {
        id: 9014,
        label: "IT 흐름"
    },
    {
        id: 9015,
        label: "EY Canvas FIT enablement"
    },
    {
        id: 71,
        label: "내용 없는 양식"
    },
    {
        id: 9016,
        label: 'Incomplete canvas form response'
    },
    {
        id: 9017,
        label: 'Adjustment module'
    }
];

export const engagementIndustry = {
    116: "Not Sector Specific",
    61: "Aerospace and Defense – Aerospace Manufacturing",
    112: "Aerospace and Defense – Defense Contracts Manufacturing",
    59: "Airlines – Air Transportation",
    92: "Asset Management – Commodity Funds",
    57: "Asset Management – Other Funds",
    43: "Asset Management – Private Equity / Venture Capital",
    85: "Asset Management – Registered / Listed Funds",
    53: "Asset Management – Structured Products",
    60: "Asset Management – Unregulated Hedge Funds",
    10: "Asset Management – Unregulated Segregated Accounts",
    90: "Audit of Compliance Management Systems",
    51: "Automotive – Automotive Dealers and Repairs",
    101: "Automotive – Automotive Manufacturing",
    5: "Automotive – Automotive Suppliers",
    71: "Banking and Capital Markets – Banks",
    89: "Banking and Capital Markets – Broker Dealers",
    27: "Banking and Capital Markets – Credit Unions",
    54: "Banking and Capital Markets – Diversified and Other Financial Institutions",
    32: "Banking and Capital Markets – Investment Banking",
    4: "Biotechnology – Biotech – Emerging Growth Markets",
    109: "Biotechnology – Health Research and Testing",
    66: "Chemicals – Chemicals Manufacturing",
    41: "Cleantech",
    37: "Consolidations",
    130: "Construction – Engineering and Architectural Services",
    68: "Construction – Highway and Heavy Construction",
    65: "Construction – Specialty Contractors",
    82: "Consumer Products – Consumer Non– Durable Goods Manufacturing",
    17: "Consumer Products – Food and Beverages Manufacturing",
    35: "Consumer Products – Food Crops, Livestock, Fishing",
    33: "Consumer Products – Household Appliances and Electronics Manufacturing",
    75: "Consumer Products – Other Consumer Durable Goods Manufacturing",
    39: "Consumer Products – Textiles and Apparel Manufacturing",
    21: "Diversified Industrial Products – Fabricated Metals",
    31: "Diversified Industrial Products – Forestry, Pulp, and Paper",
    29: "Diversified Industrial Products – Industrial Instruments Manufacturing",
    40: "Diversified Industrial Products – Industrial Machines Manufacturing",
    26: "Diversified Industrial Products – Industrial Packaging",
    42: "Diversified Industrial Products – Lumber and Wood Manufacturing",
    105: "Diversified Industrial Products – Other Industrial Products",
    100: "Diversified Industrial Products – Primary Metals",
    45: "Diversified Industrial Products – Printing",
    1: "Diversified Industrial Products – Rubber and Plastics Manufacturing",
    118: "Diversified Industrial Products – Stone, Clay, and Glass Manufacturing",
    76: "General",
    79: "Government and Public Sector – Education",
    78: "Government and Public Sector – Federal, National, and International Governments",
    131: "Government and Public Sector – Health Commissioner",
    132: "Government and Public Sector – Health Provider",
    97: "Government and Public Sector – Local government, including State or other levels below National",
    2: "Health – Academic Medical Centers",
    72: "Health – Government Hospitals",
    74: "Health – Managed Health Care",
    8: "Health – Multi Hospital Systems",
    128: "Health – Non System Hospitals",
    94: "Health – Other Health Care Entities",
    73: "Health – Physician Groups",
    121: "Health – Post Acute Care",
    58: "Health – Specialty Hospitals",
    16: "Hospitality and Leisure – Gaming and Gambling",
    7: "Hospitality and Leisure – Hotels, Motels, and Lodging",
    126: "Hospitality – Restaurants / Eating and Drinking Establishments",
    84: "IFRS",
    55: "Insurance – Health Insurance",
    111: "Insurance – Insurance Agents and Brokers",
    69: "Insurance – Life Insurers",
    96: "Insurance – Other Insurance",
    11: "Insurance – Property and Casualty Insurers",
    117: "Insurance – Reinsurers",
    23: "Life Sciences – Medical Technology",
    48: "Media and Entertainment – Advertising",
    14: "Media and Entertainment – Broadcast, Cable Network, Online Video",
    18: "Media and Entertainment – Cable Provider, Satellite, MVPD",
    86: "Media and Entertainment – Film",
    46: "Media and Entertainment – Integrated Media and Entertainment",
    15: "Media and Entertainment – Music Industry",
    25: "Media and Entertainment – Other Media and Entertainment",
    20: "Media and Entertainment – Publishing",
    30: "Media and Entertainment – Sports",
    28: "Mining – Mining Operations",
    3: "Non-complex SMEs",
    120: "Not for Profit – Foundations and Charitable Trusts",
    107: "Not for Profit – Other Not For Profit Organizations",
    70: "Oil and Gas – Energy Trading",
    22: "Oil and Gas – Exploration and Production",
    67: "Oil and Gas – Refining",
    113: "Other Transportation – Local and Urban Transportation",
    38: "Other Transportation – Other Transportation",
    83: "Other Transportation – Rail Transportation",
    88: "Other Transportation – Road Transport and Warehousing",
    6: "Other Transportation – Water Transportation",
    87: "Pension Funds / Benefit Plans",
    95: "Pharmaceutical – Medical Devices Manufacturing",
    123: "Pharmaceutical – Pharmaceuticals Manufacturing and Wholesale",
    115: "Power and Utilities – Electricity",
    119: "Power and Utilities – Natural Gas",
    110: "Power and Utilities – Other Utilities",
    102: "Power and Utilities – Waste and Water",
    125: "Professional Firms and Services – Business Services",
    34: "Professional Firms and Services – Other Services",
    47: "Professional Firms and Services – Personal Services",
    124: "Professional Firms and Services – Professional Service Firms",
    127: "Professional Firms and Services – Rental and Leasing Services",
    108: "Professional Firms and Services – Travel Services",
    49: "Real Estate – Commercial Real Estate Owners/ Developers",
    56: "Real Estate – Other Real Estate Owners/ Developers",
    62: "Real Estate – Real Estate Investment Trusts",
    122: "Real Estate – Real Estate Investors",
    12: "Real Estate – Real Estate Service Companies",
    91: "Real Estate – Residential Real Estate Owners/ Developers",
    24: "Retail and Wholesale – Department Stores",
    93: "Retail and Wholesale – Internet Retail and Mail Order",
    80: "Retail and Wholesale – Mass Merchandisers / Discount Stores",
    9: "Retail and Wholesale – Other Specialty Retailers",
    77: "Retail and Wholesale – Retail Apparel and Accessory Stores",
    114: "Retail and Wholesale – Supermarkets, Grocery, and Convenience Stores",
    36: "Retail and Wholesale – Wholesale Durable Goods",
    64: "Retail and Wholesale – Wholesale Non– Durable Goods",
    104: "Sustainability",
    63: "Technology – Communication and Networking Equipment",
    52: "Technology – Computers and Electronics",
    138: "Technology – Internet and Social Commerce",
    103: "Technology – IT Services",
    19: "Technology – Other Technology",
    98: "Technology – Semiconductors",
    13: "Technology – Software / SaaS / Apps",
    81: "Telecommunications – Cable Communications Services",
    106: "Telecommunications – Integrated Communications Providers",
    129: "Telecommunications – Internet Service Providers",
    99: "Telecommunications – Mobile Wireless Communications Services",
    50: "Telecommunications – Other Communications",
    44: "Telecommunications – Satellite Communications Services"
};

export const rnhQuickFilterLabel = [{
        id: rnhQuickFilter.all,
        label: "모두 표시"
    },
    {
        id: rnhQuickFilter.assigned,
        filterType: rnhFilterTypeQuery.assignedTo,
        label: "내 담당"
    },
    {
        id: rnhQuickFilter.authored,
        filterType: rnhFilterTypeQuery.authoredBy,
        label: "내가 작성"
    }
];

export const relatedItemStatus = [{
        id: 1,
        label: "초안"
    },
    {
        id: 2,
        label: "고객 연락처 없음"
    },
    {
        id: 3,
        label: "전송됨"
    },
    {
        id: 4,
        label: "시스템 오류"
    },
    {
        id: 5,
        label: "유효하지 않은 고객 연락처"
    },
    {
        id: 6,
        label: "응답 보류 중"
    },
    {
        id: 7,
        label: "수신됨"
    },
    {
        id: 8,
        label: "수락됨"
    },
    {
        id: 9,
        label: "반송됨"
    },
    {
        id: 10,
        label: "철회됨"
    },
    {
        id: 11,
        label: "전송 진행 중"
    },
    {
        id: 12,
        label: "수락 진행 중"
    },
    {
        id: 13,
        label: "철회 진행 중"
    },
    {
        id: 14,
        label: "삭제 진행 중"
    },
    {
        id: 15,
        label: "반송 진행 중"
    },
    {
        id: 16,
        label: "응답 진행 중"
    },
    {
        id: 17,
        label: "삭제됨"
    },
    {
        id: 18,
        label: "유효하지 않은 고객 연락처 반송됨"
    },
    {
        id: 19,
        label: "회수 진행 중"
    },
    {
        id: 20,
        label: "회수됨"
    },
    {
        id: 21,
        label: "완료 진행 중"
    },
    {
        id: 22,
        label: "회수 진행 중"
    }
];

export const GroupDocuments = [{
        id: 33,
        label: "레이블: Primary team이 전송한 그룹 지침"
    },
    {
        id: 37,
        label: "레이블: Primary team이 반송한 문서"
    }
];

export const engagementUserStatus = {
    1: "활동",
    2: "보류 중",
    3: "거절됨",
    4: "비활성화됨",
    5: "Archive 접근권한 요청",
    6: "Archive 접근권한 거절",
    7: "Engagement 복사 - 비활동",
    8: "연결 해제됨 - 비활동",
    9: "템플릿 - 비활동",
    10: "Roll-forward - 비활동",
    11: "격리 Universal로 로컬라이즈됨",
    12: "초대 진행 중",
    13: "예정됨 - 비활동"
};
export const CGTTaskSendStatus = [{
        id: 1,
        label: "미전송"
    },
    {
        id: 2,
        label: "문서 전송 중"
    },
    {
        id: 3,
        label: "초안 버전 전송됨"
    },
    {
        id: 4,
        label: "반송됨"
    },
    {
        id: 5,
        label: "리뷰 중"
    },
    {
        id: 6,
        label: "완료"
    },
    {
        id: 7,
        label: "해제됨"
    },
    {
        id: 8,
        label: "거절 중"
    },
    {
        id: 9,
        label: "최종 버전 전송됨"
    },
    {
        id: 999,
        label: "보내기 실패"
    }
];

export const ServiceRequestStatus = [{
        id: 11,
        cssClass: 'accepted-text',
        statusLabel: "수락됨"
    },
    {
        id: 12,
        cssClass: 'pending-text',
        statusLabel: "전송됨"
    },
    {
        id: 13,
        cssClass: 'rejected-text',
        statusLabel: "취소됨"
    },
    {
        id: 14,
        statusLabel: "초안"
    },
    {
        id: 15,
        cssClass: 'completed-text',
        statusLabel: "완료됨"
    },
    {
        id: 16,
        statusLabel: "전기 완료"
    },
    {
        id: 17,
        statusLabel: "제출 오류"
    },
    {
        id: 22,
        statusLabel: "N/A"
    },
    {
        id: 24,
        statusLabel: "작업 필요"
    }
];

export const assignmentsSectionLabels = [{
        id: bulkAssignment.assign,
        label: "배정"
    },
    {
        id: bulkAssignment.timephase,
        label: "시기"
    },
    {
        id: bulkAssignment.tag,
        label: "태그"
    }
];

export const assignmentsSectionLabelsNew = [{
        id: bulkAssignment.assign,
        label: "배정"
    },
    {
        id: bulkAssignment.timephase,
        label: "시기"
    }
];

export const assignmentTypeLabels = [{
        id: assignmentTypes.preparer,
        label: "작성자"
    },
    {
        id: assignmentTypes.detailReviewer,
        label: "세부 검토자"
    },
    {
        id: assignmentTypes.generalReviewer,
        label: "일반 검토자"
    },
    {
        id: assignmentTypes.partner,
        label: "Partner"
    },
    {
        id: assignmentTypes.eqr,
        label: "EQR"
    },
    {
        id: assignmentTypes.other,
        label: "기타"
    }
];

export const assignmentActionsLabels = [{
        id: bulkAssignmentConstants.actionIds.add,
        label: "추가"
    },
    {
        id: bulkAssignmentConstants.actionIds.remove,
        label: "제거"
    },
    {
        id: bulkAssignmentConstants.actionIds.replace,
        label: "Replace"
    },
    {
        id: bulkAssignmentConstants.actionIds.updateDueDays,
        label: "만료 전 기간 업데이트"
    }
];

export const tagActionsLabels = [{
        id: bulkAssignmentConstants.actionIds.add,
        label: "추가"
    },
    {
        id: bulkAssignmentConstants.actionIds.remove,
        label: "제거"
    }
];

export const manageAssigmentsActionTypeLabel = [{
        id: actionTypes.edit,
        label: "편집"
    },
    {
        id: actionTypes.delete,
        label: "삭제"
    }
];

export const confidentialityLevels = {
    [confidentialityTypes.DEFAULT]: "기본",
    [confidentialityTypes.LOW]: "Low",
    [confidentialityTypes.MODERATE]: "Moderate",
    [confidentialityTypes.HIGH]: "High"
};

export const milestoneTaskLabels = [{
        id: milestoneBuildTaskIds.accounts,
        label: "계정 흐름 Task"
    },
    {
        id: milestoneBuildTaskIds.scots,
        label: "SCOT 흐름 Task"
    },
    {
        id: milestoneBuildTaskIds.itso,
        label: "IT/SO 흐름 Task"
    },
    {
        id: milestoneBuildTaskIds.cra,
        label: "CRA 흐름 Task"
    },
    {
        id: milestoneBuildTaskIds.auditPlan,
        label: "감사 계획 흐름 Task"
    },
    {
        id: milestoneBuildTaskIds.groupStructure,
        label: "그룹 구조 흐름 Task"
    },
    {
        id: milestoneBuildTaskIds.groupInstructions,
        label: "그룹 지침 흐름 Task"
    },
    {
        id: milestoneBuildTaskIds.review,
        label: "검토 흐름 task"
    }
];

//Filters for RegionComponentEvidence
export const gaDocFilters = {
    scope: "범위",
    teamName: "팀 이름",
    groupStructure: "그룹 구조",
    region: "지역",
    component: "부문"
};

export const filterSourceOfForm = [{
        value: '1',
        label: "사용자지정"
    },
    {
        value: '2',
        label: "Knowledge"
    },
    {
        value: '3',
        label: "독립성"
    }
];

export const independenceActions = [{
        id: independenceActionIds.createIndependenceForm,
        label: "독립성 양식 생성"
    },
    {
        id: independenceActionIds.removeTeamMember,
        label: "팀 멤버 제거"
    },
    {
        id: independenceActionIds.removeOverride,
        label: "무시 제거"
    }
];


export const reviewNoteModalLabels = {
    /*Review Notes*/
    commentThread: "노트 thread",
    singleNoteInstructionalText: "아래에서 선택된 comment를 보고 응답합니다",
    emptyNoteDetailsMessage: "세부정보를 보려면 노트를 선택하십시오. 한꺼번에 제어하려면, control 키나 shift 키를 이용하여 여러 리뷰 comment를 선택하십시오. 개별 comment에서 작업하려면,",
    documentReviewNotesLabel: "문서 노트",
    addNewReviewNoteButtonText: "신규 노트",
    noNotesAssociatedWithDocumentLabel: "아래에 입력하여 노트를 남기십시오. 노트를 사용자에게 배정하고 우선순위와 만료일을 지정하십시오.",
    noNotesFound: "노트를 찾을 수 없습니다",
    noNotesAssociatedWithTaskLabel: "Task에 연결된 {0} 노트가 없습니다",
    allNotesLabel: "모든 노트",
    charactersLabel: "characters",
    myNotesLabel: "내 노트",
    showClearedLabel: "처리된 항목 표시",
    showClosedLabel: "닫힌 항목 표시",
    assignedToLabel: "담당자",

    ofLabel: "of",
    enterNoteText: "노트 입력",
    addNewNoteModalClose: "닫기",
    addNewNoteModalTitleLabel: "신규 노트 추가",
    editNoteModalTitleLabel: "노트 편집",
    deleteIconHoverText: "삭제",
    deleteIconModalAcceptText: "삭제",
    deleteIconModalConfirmMessage: "이 comment에 대한 회신을 삭제하시겠습니까?",
    deleteIconModalConfirmMessageParent: "선택한 comment를 삭제하시겠습니까?",
    deleteIconModalTitleLabel: "노트 삭제",
    deleteReplyIconModalTitle: "회신 삭제",
    emptyRepliesMessage: "아직 회신이 없습니다",
    replyInputPlaceholder: "이 노트에 회신",
    replyInputPlaceholderEdit: "리뷰노트에 대한 회신 편집",
    noteInputPlaceholderEdit: "리뷰노트 편집",
    replyText: "회신 텍스트",
    editReplyModelTitle: "회신 편집",
    editReplyPlaceholder: "회신 입력",
    noteDueDateLabel: "만료",

    priorityLabel: "우선순위",
    dueDateLabel: "만료일",
    dueLabel: "만료",
    status: "상태",
    noteModifiedDateLabel: "수정됨",
    cancelLabel: "취소",
    saveLabel: "저장",
    clearedBy: "처리한 사람",
    closedBy: "닫은 사람",
    reopenedBy: "다시 연 사람",
    reply: "회신",
    editIconHoverTextLabel: "편집",
    required: "필수",
    closeTitle: "닫기",
    otherEngagementNotes: "다른 engagement 노트",
    closeLabel: "닫기",
    showMore: "더 표시",
    showLess: "덜 표시",
    showMoreEllipsis: "더 표시…",
    showLessEllipsis: "덜 표시…",
    noResultFound: "결과를 찾을 수 없습니다",
    engagementNameLabel: "Engagement 이름:",
    taskReviewNotesLabel: "Task 노트",
    fromUserLabel: labels.fromUserLabel,
    toUserLabel: labels.toUserLabel
};

//Copyhub create package
export const createPackageLabels = {
    packageType: "패키지 유형",
    categories: "범주",
    itemsToCopy: "복사할 항목",
    createPackage: "패키지 생성",
    selectPackageType: "패키지 유형 선택",
    selectPackageTypeTitle: "패키지 유형 선택",
    selectCategoriesTitle: "범주 선택",
    selectEntitiesTitle: "기업 선택",
    relateCanvasFormsTitle: "문서 연결",
    relateAnObjectTitle: "Object 연결",
    step1InstructionalText: "패키지 유형을 선택하고 이름을 입력한 후 수신자를 선택하십시오. 복사 패키지를 생성하거나 전송하기 전에 데이터 보호, 관할지 간 데이터 이전 및 기밀 정보 보호와 관련하여 해당 법률, 규정 및 EY 정책을 모두 준수하는지 확인하십시오.",
    packageTypes: [{
        value: 21,
        text: "Engagement"
    }, {
        value: 20,
        text: "증거"
    }, {
        value: 24,
        text: "기존에서 roll forward"
    }, {
        value: 22,
        text: "계정"
    }, {
        value: 23,
        text: "SCOT"
    }, {
        value: 26,
        text: "한꺼번에 내보내기"
    }, {
        value: 25,
        text: "템플릿"
    }, {
        value: 27,
        text: "외부 문서"
    }, {
        value: 28,
        text: "가이드 업무흐름"
    }, {
        value: 29,
        text: "기업별 engagement"
    }],

    packageName: "패키지 이름",
    packageDetailsText: "패키지 세부정보",
    required: "필수",
    sendTo: "수신자",
    nameOrEmail: "이름 또는 이메일",
    sendToName: "이름",
    sendToEmail: "이메일",
    clearAllValues: "모든 값 처리",
    engagementIdErrorMessage: "Engagement ID가 지정되지 않았습니다",
    emptyCategoriesStep2Text: '...',
    insufficientPermissionsMessage: "복사 패키지를 생성할 권한이 없습니다. Engagement 관리자에게 문의하여 복사 패키지 생성 권한을 요청하십시오.",
    CopyHubCanvasFormTooltip: "EY Canvas 양식 전용",
    CopyEngagementInProgress: "한 번에 Engagement 복사본 하나만 처리할 수 있습니다",

    //Step 3 labels
    step3Header: "복사할 {0} 선택",
    selectAllText: "모두 선택",
    delectAllText: "모두 선택 해제",
    documentsSelectedText: "문서 선택됨",
    scotsSelectedText: "SCOT 선택됨",
    accountsSelectedText: "계정 선택됨",
    entitiesSelectedText: "기업 선택됨",
    step3InstructionText: "데이터 패키지를 생성하거나 전송하기 전에 데이터 보호, 관할지 간 데이터 이전 및 기밀 정보 보호와 관련하여 해당 법률, 규정 및 EY 정책을 모두 준수하는지 확인하십시오.",
    step3InstructionTextEvidence: "Engagement 데이터를 전송하기 전에 데이터 보호, 관할지 간 데이터 이전 및 기밀 정보 보호와 관련하여 해당 법률, 규정 및 EY 정책을 모두 준수하는지 확인하십시오.",
    step3InstructionTextWarning: "EY Canvas 양식에는 관련 object(예, SCOT, 통제)가 포함되지 않습니다",
    step3InstructionTextWarningFIT: "가이드 업무흐름 복사본에는 식별된 관련 사건 및 상황과 그와 관련된 설명이 포함될 수 있습니다. 다른 관련 object(예: 계정, 위험)는 포함되지 않습니다.",
    availableCanvasFormsColumnName: "사용 가능한 문서",
    availableFITDocuments: "사용 가능한 가이드 업무흐름",
    availableAccountsColumnName: "사용 가능한 계정",
    availableSCOTsColumnName: "사용 가능한 SCOT",
    availableExternalDocumentsColumnName: "사용 가능한 외부 문서",
    step3NoItemeSelectedError: "계속하려면 항목을 하나 이상 선택하십시오",
    searchPackagePlaceholder: "검색",
    searchPackageClearHoverText: "처리",

    //step2:
    step2Header: "{0} 패키지 범주 선택",
    step2AccountsHdr: "복사 패키지에 포함할 범주를 선택하십시오. 핵심 패키지에는 관련 경영진주장, PSP, OSP가 모두 포함됩니다.",
    step2scotshdr: "복사 패키지에 포함할 범주를 선택하십시오. 핵심 패키지에는 관련 WCGW, 통제P, task가 모두 포함됩니다.",
    step2canformhdr: "복사 패키지에 포함할 범주를 선택하십시오",
    step2InstructionTextEngagementByEntity: "복사 패키지에 포함할 기업을 선택하십시오",
    availableEntitiesColumnName: "사용 가능한 기업",
    step2HeaderEntities: "Engagement 패키지용 {0}을(를) 선택하십시오",
    entitiesLabel: "기업",

    scots: "SCOT",
    itso: "IT application / SO 구조",
    evidence: "증거",
    realtedevidence: "연결된 증거",
    signoffs: "Sign-off",
    tempfiles: "임시 파일",
    priorperiodevidence: "전기 증거",
    recentlydeletedfiles: "최근 삭제 파일",
    historyfiles: "기록 파일",
    extgrp: "외부 그룹 및 외부 팀 멤버",
    eydocument: "EY 문서",
    extdoc: "외부 문서",
    totalfilesize: "모든 선택 항목의 총 파일 크기",
    requestandexernaltasks: "요청사항 및 외부 Task",
    rollForwardFromExisting: "기존에서 roll forward",
    template: "템플릿",
    bulkExport: "한꺼번에 내보내기",

    fileSizeWaring: "선택한 범주에는 {0}인 파일이 포함됩니다. EY Canvas는 이 한도를 초과하는 복사 패키지를 지원하지 않습니다.",
    fileSizeWarningline2: "전체 복사 패키지 파일 크기를 줄이려면 문서 범주 제거를 고려하십시오",
    coloredExceedLable: "{0} GB 초과",
    step2EngHdr: "복사 패키지에 포함할 범주를 선택하십시오 기본 패키지에는 engagement 프로필, knowledge 문서, 주요 표준 task, 기타 표준 task, 시기; 계정/공시, 경영진주장 및 연결된 task; SCOT, WCGW, 통제 및 연결된 task; IT application/서비스 조직, 위험, ITGC/ITSP 및 연결된 task가 모두 포함됩니다. 그룹 감사 engagement라면, 패키지에 그룹 감사 데이터도 포함됩니다.",
    step2EngByEntityHdr: "복사 패키지에 포함할 범주를 선택하십시오. 기본 패키지에는 engagement 프로필, knowledge 문서, 주요 표준 task, 기타 표준 task, 시기; 계정/공시, 경영진주장 및 연결된 task; SCOT, WCGW, 통제 및 연결된 task; IT application/서비스 조직, 위험, ITGC/ITSP 및 연결된 task; 맵이 모두 포함됩니다. 그룹 감사 engagement라면, 패키지에 그룹 감사 데이터도 포함됩니다.",
    step2BulkExpHdr: "내보낼 문서 범주 선택",
    gb: "GB",
    step2And: "AND",
    step2Files: "문서",
    lessThanMinGB: "0.01 GB 미만",
    CategoryFileSizeCount: "{0} GB 및 {0} 문서",

    cancelLabel: "취소",
    showSelected: "선택한 항목 표시",
    showSelectedDocuments: "선택된 {0} 문서 표시",
    showSelectedEntities: "선택된 {0} 기업 표시",
    showSelectedGuidedWorflows: "선택된 {0} 가이드 업무흐름 표시",
    showSelectedAccounts: "선택된 {0} 계정 표시",
    showSelectedSCOTs: "선택된 {0} SCOT 표시",
    noDataFoundLabel: "데이터를 찾을 수 없습니다",
    copyPackageSuccessMessage: "{0} 데이터 내보내기가 개시됐습니다",
    copyPackageWarningLabel: "경고 : 유효하지 않은 정보로 인해 아래 멤버에게 패키지를 전송하지 못했습니다 :- {0}",
    noResultFound: "결과를 찾을 수 없습니다",
    canvasForms: "EY Canvas 양식",
    canvasFormsInformationText: "EY Canvas 양식은 증거 및/또는 임시 파일로만 내보낼 수 있습니다.<br/>EY Canvas 양식 다운로드를 활성화하려면 이 옵션들 중 하나를 선택하십시오.",
    coEditSelectAllWarningMessage: "일부 문서가 현재 multi-user 편집 활성 모드이므로 복사 패키지에 포함할 수 없습니다",
    coEditDocumentTooltip: "문서가 multi-user 편집 활성 모드이므로 복사할 수 없습니다. 문서를 체크인하여 이 패키지의 일부로 문서로 복사하십시오.",
    coEditCopyWarningMessage: "{0} 문서가 {1} 범주에서 multi-user 편집 활성 모드입니다. 각 범주 내 모든 문서를 체크인하여 이 패키지의 일부로 포함하십시오."
};

export const documentTypes = [{
        id: 1,
        label: "증거"
    },
    {
        id: 2,
        label: "임시"
    },
    {
        id: 3,
        label: "전기 증거"
    },
    {
        id: 4,
        label: "고객 파일"
    },
    {
        id: 5,
        label: "스냅샷"
    },
    {
        id: 6,
        label: "스마트 양식"
    },
    {
        id: 29,
        label: "Paper Profile"
    },
    {
        id: 47,
        label: "대량 문서 내보내기"
    },
    {
        id: 48,
        label: "Canvas 양식"
    },
    {
        id: 51,
        label: "자동화 허브"
    },
    {
        id: 59,
        label: "패키지"
    },
    {
        id: 72,
        label: "스마트 조서"
    }
];

export const activityTypes = [{
        id: activityType.primaryLinkAccept,
        label: "{0}이(가) 수락한 링크 요청"
    },
    {
        id: activityType.primaryLinkReject,
        label: "{0}이(가) 거절한 링크 요청"
    },
    {
        id: activityType.primaryUnlink,
        label: "{0}이(가) 그룹에서 링크 해제한 Engagement"
    },
    {
        id: activityType.primaryComponentUnlink,
        label: "{0}이(가) 그룹에서 링크 해제한 Engagement"
    },
    {
        id: activityType.componentPrimaryUnlink,
        label: "{0}이(가) 그룹에서 링크 해제한 Engagement"
    },
    {
        id: activityType.primarySendLink,
        label: "{0}이(가) {1}에게 전송한 링크 요청"
    },
    {
        id: activityType.documentsReceived,
        label: "{0}이(가) 수신한 문서"
    },
    {
        id: activityType.primarySendInstruction,
        label: "{0}에서 {1}(으)로 전송된 지침"
    },
    {
        id: activityType.primaryRejectInstruction,
        label: "{0}이(가) 반송한 지침"
    },
    {
        id: activityType.primaryAcceptInstruction,
        label: "{0}이(가) 수락한 지침"
    },
    {
        id: activityType.componentReceivedInstruction,
        label: "수신된 지침"
    },
    {
        id: activityType.componentAcceptInstruction,
        label: "{0}이(가) 수락한 지침"
    },
    {
        id: activityType.componentRejectInstruction,
        label: "{0}이(가) 반송한 지침"
    },
    {
        id: activityType.componentAcceptUpdatetInstruction,
        label: "{0}이(가) 수락한 지침"
    },
    {
        id: activityType.componentRejectUpdateInstruction,
        label: "{0}이(가) 반송한 지침"
    },
    {
        id: activityType.primaryEvidenceReceived,
        label: "{0}이(가) 수신한 버전"
    },
    {
        id: activityType.documentVersionConflictResolved,
        label: "{0}이(가) 해결한 충돌"
    },
    {
        id: activityType.documentOverwrite,
        label: "{0}이(가) 덮어쓴 문서 내용"
    },

    {
        id: activityType.primaryAssignComponent,
        label: "{0}에게 배정된 문서"
    },
    {
        id: activityType.componentUnassigned,
        label: "{0}에게서 배정취소된 문서"
    },
    {
        id: activityType.clearDocumentReturnedtoComponent,
        label: "{0}이(가) 마무리한 버전"
    },
    {
        id: activityType.componentClearReturnedDocument,
        label: "{0}이(가) 해결한 버전"
    },
    {
        id: activityType.primaryReturnEvidence,
        label: "{0}이(가) 반송한 버전"
    },
    {
        id: activityType.componentEvidenceSent,
        label: "{0}이(가) 전송한 버전"
    },
    {
        id: activityType.componentReturnEvidence,
        label: "{0}이(가) 반송한 버전"
    },
    {
        id: activityType.createReviewNote,
        label: "{0}이(가) 연 노트"
    },
    {
        id: activityType.openReviewNote,
        label: "{0}이(가) 연 노트"
    },
    {
        id: activityType.clearReviewNote,
        label: "{0}이(가) 처리한 노트"
    },
    {
        id: activityType.closeReviewNote,
        label: "{0}이(가) 닫은 노트"
    },
    {
        id: activityType.reviewerSignOff,
        label: "{0}이(가) sign-off함"
    },
    {
        id: activityType.preparerSignOff,
        label: "{0}이(가) sign-off함"
    },
    {
        id: activityType.canvasSendClientRequest,
        label: labels.sent
    },
    {
        id: activityType.clientRespondToClientRequest,
        label: "응답됨"
    },
    {
        id: activityType.canvasRejectClientRequest,
        label: labels.rejected
    },
    {
        id: activityType.canvasWithdrawClientRequest,
        label: labels.WithdrawLabel
    },
    {
        id: activityType.canvasDeleteClientRequest,
        label: "삭제됨"
    },
    {
        id: activityType.canvasAcceptClientRequest,
        label: labels.accepted
    },
    {
        id: activityType.CEARecallClientRequest,
        label: "회수됨"
    },
    {
        id: activityType.canvasCompleteClientRequest,
        label: labels.completed
    }
];


export const gaLinkStatus = [{
        id: GALinkStatus.Undefined,
        label: "미확정"
    },
    {
        id: GALinkStatus.NoPointOfContact,
        label: "연락처 없음"
    },
    {
        id: GALinkStatus.Pending,
        label: "보류 중"
    },
    {
        id: GALinkStatus.Accepted,
        label: "수락됨"
    },
    {
        id: GALinkStatus.Rejected,
        label: "거절됨"
    },
    {
        id: GALinkStatus.Expired,
        label: "만료됨"
    },
    {
        id: GALinkStatus.Unlinked,
        label: "링크 해제됨"
    },
    {
        id: GALinkStatus.Delegated,
        label: "위임됨"
    },
    {
        id: GALinkStatus.SystemError,
        label: "시스템 오류"
    },
    {
        id: GALinkStatus.Sent,
        label: "전송됨"
    },
    {
        id: GALinkStatus.InvalidPointOfContact,
        label: "유효하지 않은 연락처"
    },
    {
        id: GALinkStatus.ComponentNotUsingCanvas,
        label: "Canvas를 사용하지 않는 부문"
    }
];

export const gaInstructionStatus = [{
        id: 0,
        label: labels.notApplicable
    },
    {
        id: instructionStatus.notSent,
        label: "미전송"
    },
    {
        id: instructionStatus.pending,
        label: "보류 중"
    },
    {
        id: instructionStatus.accepted,
        label: "수락됨"
    },
    {
        id: instructionStatus.rejected,
        label: "반송됨"
    },
    {
        id: instructionStatus.systemError,
        label: "시스템 오류"
    },
    {
        id: instructionStatus.expired,
        label: "만료됨"
    },
    {
        id: instructionStatus.sent,
        label: "전송됨"
    },
    {
        id: instructionStatus.unlinked,
        label: "링크 해제됨"
    },
    {
        id: instructionStatus.queued,
        label: "대기"
    }
];

export const gsSnapshotComparisonStatus = [{
        id: snapshotComparisonIds.noChange,
        value: "null"
    },
    {
        id: snapshotComparisonIds.new,
        value: "신규"
    },
    {
        id: snapshotComparisonIds.added,
        value: "추가됨"
    },
    {
        id: snapshotComparisonIds.modified,
        value: "수정됨"
    },
    {
        id: snapshotComparisonIds.updated,
        value: "업데이트됨"
    },
    {
        id: snapshotComparisonIds.removed,
        value: "제거됨"
    },
    {
        id: snapshotComparisonIds.itemsRemoved,
        value: "항목 제거됨"
    },
]

export const gaRoleType = [{
        id: GARoleTypeId.Primary,
        label: "Primary"
    },
    {
        id: GARoleTypeId.Region,
        label: "Region"
    },
    {
        id: GARoleTypeId.Component,
        label: "부문"
    }
];

export const linkRequestTypes = [{
        id: linkType.sent,
        label: "전송됨"
    },
    {
        id: linkType.unlinked,
        label: "링크 해제됨"
    },
    {
        id: linkType.accepted,
        label: "수락됨"
    }
];

export const instructionTypes = [{
        id: instructionType.sent,
        label: "전송됨"
    },
    {
        id: instructionType.rejected,
        label: "반송됨"
    },
    {
        id: instructionType.received,
        label: "수신됨"
    },
    {
        id: instructionType.accepted,
        label: "수락됨"
    }
];

export const syncStatusLabels = [{
        id: syncStatus.notSynchronized,
        label: "동기화되지 않음"
    },
    {
        id: syncStatus.syncInTransit,
        label: "동기화 중"
    },
    {
        id: syncStatus.syncInProcess,
        label: "동기화 진행 중"
    },
    {
        id: syncStatus.synchronized,
        label: "동기화됨"
    },
    {
        id: syncStatus.deleteInTransit,
        label: "삭제 중"
    },
    {
        id: syncStatus.deleteInProcess,
        label: "삭제 진행 중"
    },
    {
        id: syncStatus.deleted,
        label: "삭제됨"
    },
    {
        id: syncStatus.noHostEngagement,
        label: "호스트 engagement 없음"
    },
    {
        id: syncStatus.syncError,
        label: "동기화 오류"
    }
];

export const colorOptionsLabels = {
    Red: "빨간색",
    Orange: "귤색",
    Teal: "청록색",
    Blue: "파란색",
    Purple: "보라색",
    Green: "녹색",
    Yellow: "노란색",
    Gray: "회색"
};

export const todoListTimeFrameLabels = [{
        id: todoListTimeframeOptions.byDay,
        label: "일별"
    },
    {
        id: todoListTimeframeOptions.byWeek,
        label: "주별"
    },
    {
        id: todoListTimeframeOptions.byMonth,
        label: "월별"
    },
    {
        id: todoListTimeframeOptions.all,
        label: "모두"
    },
    {
        id: todoListTimeframeOptions.overdue,
        label: "지연"
    }
];

export const clientRequestsStatusFilter = [{
        value: 'Draft',
        label: "초안"
    },
    {
        value: 'Pending',
        label: "응답 보류 중"
    },
    {
        value: 'Received',
        label: "수신됨"
    },
    {
        value: 'Accepted',
        label: "수락됨"
    }
];

export const clientRequestsTypeFilter = [{
        value: 'Required',
        label: "Sign-off 필요"
    },
    {
        value: 'NotRequired',
        label: "Sign-off 필요하지 않음"
    }
];

export const clientRequestsPriorityFilter = [{
        value: 'Normal',
        label: "Normal"
    },
    {
        value: 'High',
        label: "High"
    },
    {
        value: 'Critical',
        label: "Critical"
    }
];

export const clientRequestsAttachmentsFilter = [{
        value: 'Analytics',
        label: "분석 "
    },
    {
        value: 'ExternalAttachments',
        label: "외부 첨부파일"
    },
    {
        value: 'EyAttachments',
        label: "EY 첨부파일"
    },
    {
        value: 'None',
        label: "없음"
    }
];

export const clientRequestsCreatedByFilter = [{
        value: 'Client',
        label: "고객"
    },
    {
        value: 'EY',
        label: "EY"
    }
];

export const filterTimePhase = [{
    value: -1,
    label: "시기 없음"
}];

export const clientRequestsBooleanFilters = [{
        value: 1,
        label: "예"
    },
    {
        value: 0,
        label: "아니오"
    }
]

export const bulkClientRequestsNoRelatedTaskFilter = [{
        value: false,
        label: "예"
    },
    {
        value: true,
        label: "아니오"
    }
]

export const controlsTestingFilters = [{
        value: 'true',
        label: "효과적"
    },
    {
        value: 'false',
        label: "비효과적"
    },
    {
        value: 'null',
        label: "미선택"
    }
];

export const controlsDesignEffectivenessFilters = [{
        value: '1',
        label: "효과적"
    },
    {
        value: '2',
        label: "비효과적"
    },
    {
        value: '0',
        label: "미선택"
    }
];

export const clientRequestAnnotationTabs = [{
        id: clientRequestNoteTab.comments,
        label: "Comment"
    },
    {
        id: clientRequestNoteTab.history,
        label: "기록"
    }
];

export const riskTypeOptions = [{
        id: 1,
        name: "유의적인 위험"
    },
    {
        id: 2,
        name: "부정 위험"
    },
    {
        id: 3,
        name: "중요왜곡표시위험"
    }
];

export const months = ['1월', '2월', '3월', '4월', '5월', '6월', '7월', '8월', '9월', '10월', '11월', '12월'];
export const longDays = ['일요일', '월요일', '화요일', '수요일', '목요일', '금요일', '토요일'];
export const shortDays = ['일', '월', '화', '수', '목', '금', '토'];

// GA Scopes
export const gaScopesResource = [{
        id: gaScopes.full,
        label: "Full"
    },
    {
        id: gaScopes.specific,
        label: "Specific"
    },
    {
        id: gaScopes.specificAuditProcedures,
        label: "Specified Audit Procedures"
    },
    {
        id: gaScopes.review,
        label: "Review"
    }
]

// GA Instructions
export const gaRecommendationTypeResource = [{
        id: gaRecommendationType.required,
        label: "필수"
    },
    {
        id: gaRecommendationType.optional,
        label: "선택 사항"
    },
    {
        id: gaRecommendationType.notApplicable,
        label: "해당 없음"
    }
]

// GS Group Summary
export const gsTabsResource = [{
        id: groupSummaryTabs.assignedTeams,
        label: "배정된 팀"
    },
    {
        id: groupSummaryTabs.instructions,
        label: "지침"
    },
    {
        id: groupSummaryTabs.tasks,
        label: "Task"
    }
]

export const receiveInstructionsTypeResource = {
    true: {
        title: "신규",
        instructional: "신규"
    },
    false: {
        title: "업데이트됨",
        instructional: "업데이트된"
    }
}

export const clientRequestSystemGeneratedMessages = {
    sent: "요청 전송 대상",
    accepted: "요청 수락됨",
    received: "요청 수신됨",
    returned: "요청이 반송됨",
    withdrawn: "요청 철회됨",
    complete: "EY가 요청을 완료했습니다",
    recalled: "요청 회수됨",
    notification_submit: "요청이 자동화에 제출됨",
    notification_success: "요청이 자동화에 제출됨",
    notification_error: "자동화에 제출하는 동안 오류가 발생했습니다. 자동화에 제출을 클릭하여 다시 시도하십시오.",
    restore_document: "문서 복원됨 -",
    delete_document: "문서 삭제됨 -",
    assignedto: "항목 재배정 대상",
    editrequest: "요청 편집됨",
    prioritychange: "요청 우선순위 업데이트 위치"
};

export const externalTaskSystemGeneratedMessages = {
    sent: "외부 Task 전송 대상",
    accepted: "외부 Task 수락됨",
    received: "응답 수신됨",
    returned: "외부 Task 반송됨",
    withdrawn: "외부 Task 철회됨",
    complete: "외부 Task가 EY Canvas에서 완료됐습니다",
    recalled: "외부 Task 회수됨",
    restore_document: "문서 복원됨 -",
    delete_document: "문서 삭제됨 -",
    assignedto: "항목 재배정 대상",
    editrequest: "외부 task 편집됨",
    prioritychange: "외부 task 우선순위 업데이트 위치"
};

export const ipInputLabels = [{
        id: ipInputType.ipAddress,
        label: "IP 주소"
    },
    {
        id: ipInputType.ipRange,
        label: "IP 범위"
    },
    {
        id: ipInputType.cidrBlock,
        label: "CIDR block"
    }
];

export const ipFilterTypeLabels = {
    [ipFilterType.ipAddress]: "IP 주소",
    [ipFilterType.ipRange]: "IP 범위",
    [ipFilterType.cidrBlock]: "CIDR Block"
};

export const gaLinkStatusObj = {
    [GALinkStatus.Undefined]: "미확정",
    [GALinkStatus.NoPointOfContact]: "연락처 없음",
    [GALinkStatus.NotSent]: "미전송",
    [GALinkStatus.Pending]: "링크 요청 보류 중",
    [GALinkStatus.Accepted]: "링크 요청 수락됨",
    [GALinkStatus.Rejected]: "거절됨",
    [GALinkStatus.Expired]: "만료됨",
    [GALinkStatus.Unlinked]: "링크 해제됨",
    [GALinkStatus.Delegated]: "위임됨",
    [GALinkStatus.SystemError]: "시스템 오류",
    [GALinkStatus.Sent]: "전송됨",
    [GALinkStatus.InvalidPointOfContact]: "유효하지 않은 연락처",
    [GALinkStatus.ComponentNotUsingCanvas]: "EY Canvas 미사용",
    [GALinkStatus.ComponentReferenceOnly]: "참조 전용"
};

export const epTasksObj = [{
        value: '3',
        label: "Sign-off된 문서 없음"
    },
    {
        value: '2',
        label: "일부 문서 sign-off됨"
    },
    {
        value: '1',
        label: "모든 문서 sign-off됨"
    }
];

export const eqrTasksObj = [{
        value: '6',
        label: "Sign-off된 문서 없음"
    },
    {
        value: '5',
        label: "일부 문서 sign-off됨"
    },
    {
        value: '4',
        label: "모든 문서 sign-off됨"
    }
];

export const groupsFilterEntity = [{
        id: 1,
        label: "Task"
    },
    {
        id: 2,
        label: "문서"
    }
];

export const scopesFilterEntity = [{
        id: 1,
        label: "Full"
    },
    {
        id: 2,
        label: "Specific"
    },
    {
        id: 3,
        label: "Specified Audit Procedures"
    },
    {
        id: 4,
        label: "Review"
    }
];

export const notesFilterLabels = [{
        id: notesFilter.allNotes,
        label: "모든 노트"
    },
    {
        id: notesFilter.myNotes,
        label: "내 노트"
    },
    {
        id: notesFilter.authoredByMeNotes,
        label: "내 담당"
    }
];

//Client Request Advanvce Search
export const advancedSearchValues = [{
        id: 1,
        value: labels.advancedSearchTitleCheck
    },
    {
        id: 2,
        value: labels.advancedSearchRefereceNumberCheck
    },
    {
        id: 3,
        value: labels.advancedSearchDocumentsCheck
    },
    {
        id: 4,
        value: labels.advancedSearchCommentsCheck
    }
];


export const TaskTypeLabels = [{
        id: TaskListTypes.ScopeAndStrategy,
        label: taskNavigation[TaskListTypes.ScopeAndStrategy]
    },
    {
        id: TaskListTypes.SCOTs,
        label: taskNavigation[TaskListTypes.SCOTs]
    },
    {
        id: TaskListTypes.ITSOs,
        label: taskNavigation[TaskListTypes.ITSOs]
    },
    {
        id: TaskListTypes.Accounts,
        label: taskNavigation[TaskListTypes.Accounts]
    },
    {
        id: TaskListTypes.GeneralExecution,
        label: taskNavigation[TaskListTypes.GeneralExecution]
    },
    {
        id: TaskListTypes.Conclusion,
        label: taskNavigation[TaskListTypes.Conclusion]
    }
];

export const TaskCategoryLabels = [{
        id: TaskListTypes.ScopeAndStrategy,
        label: taskNavigation[TaskListTypes.ScopeAndStrategy],
        displayOrder: 1
    },
    {
        id: TaskListTypes.Risks,
        label: taskNavigation[TaskListTypes.Risks],
        displayOrder: 2
    },
    {
        id: TaskListTypes.SCOTs,
        label: taskNavigation[TaskListTypes.SCOTs],
        displayOrder: 3
    },
    {
        id: TaskListTypes.ITSOs,
        label: taskNavigation[TaskListTypes.ITSOs],
        displayOrder: 4
    },
    {
        id: TaskListTypes.Accounts,
        label: taskNavigation[TaskListTypes.Accounts],
        displayOrder: 5
    },
    {
        id: TaskListTypes.GeneralExecution,
        label: taskNavigation[TaskListTypes.GeneralExecution],
        displayOrder: 6
    },
    {
        id: TaskListTypes.Conclusion,
        label: taskNavigation[TaskListTypes.Conclusion],
        displayOrder: 7
    },
];

export const kendoLabels = {
    alignLeft: "왼쪽 맞춤",
    alignRight: "오른쪽 맞춤",
    alignCenter: "가운데 맞춤",
    alignFull: "전체 맞춤",
    addComment: "Comment 추가",
    addColumnBefore: "왼쪽 열 추가",
    addColumnAfter: "오른쪽 열 추가",
    addRowAbove: "위쪽 행 추가",
    addRowBelow: "아래쪽 행 추가",
    bulletList: "순서 없는 목록 삽입",
    bold: "굵게",
    backColor: "하이라이트",
    createLink: "하이퍼링크 삽입",
    createTable: "표 생성",
    cleanFormatting: "서식 정리",
    deleteRow: "행 삭제",
    deleteColumn: "열 삭제",
    deleteTable: "표 삭제",
    fontSizeInherit: "글꼴 크기",
    foreColor: "색상",
    format: "형식",
    fontSize: "글꼴 크기",
    hyperlink: "웹 링크 삽입",
    italic: "기울임꼴",
    indent: "들여쓰기",
    insertTableHint: "{0} x {1} 표 생성",
    'hyperlink-dialog-content-address': "웹 주소",
    "hyperlink-dialog-title": "하이퍼링크 삽입",
    "hyperlink-dialog-content-title": "제목",
    "hyperlink-dialog-content-newwindow": "새 창에서 링크 열기",
    "hyperlink-dialog-cancel": "취소",
    "hyperlink-dialog-insert": "삽입",
    outdent: "내어쓰기",
    orderedList: "순서 있는 목록 삽입",
    print: "인쇄",
    pdf: "pdf로 내보내기",
    redo: "재실행",
    strikethrough: "취소선",
    subscript: "위첨자",
    superscript: "아래첨자",
    underline: "밑줄",
    undo: "실행 취소"
};

export const kendoFormatOptions = [{
        text: "문단",
        value: "p"
    },
    {
        text: "제목 1",
        value: "h1"
    },
    {
        text: "제목 2",
        value: "h2"
    },
    {
        text: "제목 3",
        value: "h3"
    },
    {
        text: "제목 4",
        value: "h4"
    },
    {
        text: "제목 5",
        value: "h5"
    },
    {
        text: "제목 6",
        value: "h6"
    }
];

export const kendoFontSize = [{
        text: '8',
        value: '8px'
    },
    {
        text: '9',
        value: '9px'
    },
    {
        text: '10',
        value: '10px'
    },
    {
        text: '11',
        value: '11px'
    },
    {
        text: '12',
        value: '12px'
    },
    {
        text: '14',
        value: '14px'
    },
    {
        text: '16',
        value: '16px'
    },
    {
        text: '18',
        value: '18px'
    },
    {
        text: '20',
        value: '20px'
    },
    {
        text: '22',
        value: '22px'
    },
    {
        text: '24',
        value: '24px'
    },
    {
        text: '26',
        value: '26px'
    },
    {
        text: '28',
        value: '28px'
    },
    {
        text: '36',
        value: '36px'
    },
    {
        text: '48',
        value: '48px'
    },
    {
        text: '72',
        value: '72px'
    }
];

export const monthsList = [
	"1월",
	"2월",
	"3월",
	"4월",
	"5월",
	"6월",
	"7월",
	"8월",
	"9월",
	"10월",
	"11월",
	"12월"
];

export const pspContentStatus = {
    1: "업데이트 필요",
    2: "업데이트 진행 중",
    3: "업데이트 완료",
    4: "업데이트 오류"
}

export const handOffLabels = {
    handoff: "Hand-off",
    handOffTitleTip: "리뷰를 위해 hand-off",
    markCompleteTitleTip: "완료 표시",
    handoffModalTitle: "다음 팀 멤버에게 hand-off",
    handoffConfirmButtonText: "Hand-off",
    return: "반송",
    handModalDescription: "증거 파일에 sign-off하려면, 아래 옵션에서 선택하십시오.",
    markCompleteTextLine1: "이 task를 다음 팀 멤버에게 hand-off",
    markCompleteTextLine2: "증거 파일에 sign-off하려면, 아래 옵션에서 선택하십시오. 귀하에게 이 task가 배정됐고 이를 완료했다면, <b>예</b>를 선택하여 닫으십시오. 이 task에 PIC 또는 EQR sign-off가 필요하다면 아래 옵션에서 선택하십시오.",
    closeLabel: "닫기",
    handoffto: "Hand-off 대상",
    missingToUserError: "필수",
    markCompleteConfirm: "완료 표시",
    markCompleteModalHeaderTextPart1: "이 task는 완료 표시됩니다",
    markCompleteModalHeaderTextPart2: "증거 파일에 sign-off하려면, 아래 옵션에서 선택하십시오. 귀하에게 이 task가 배정됐고 이를 완료했다면, <b>예</b>를 선택하여 닫으십시오. 이 task에 PIC 또는 EQR sign-off가 필요하다면 아래 옵션에서 선택하십시오.",
    signOffOnAllAs: "모두 Sign-off",
    preparer: "작성자",
    reviewer: "검토자",
    none: "없음",
    noSignOffsByMe: "내 sign-off 없음",
    myPreparerSignOffs: "내 작성자 sign-off",
    myReviewerSignOffs: "내 검토자 sign-off",
    myPreparerAndReviewerSignOffs: "내 작성자 및 검토자 sign-off",
    preparerTitle: "작성자 sign-off",
    reviewerTitle: "검토자 sign-off",
    autoAssignmentMessage: "이 팀 멤버에게 배정된 task가 없습니다. 만료일이 {1}인 {0} ​배정이 생성됩니다. 이 배정을 편집하려면 {2}",
    clickHere: "여기를 클릭하십시오",
    noTaskEvidencesHandoffModal: "이 task에 연결된 증거 파일이 없습니다.",
    // Create Assignment
    createAssignment: "배정 생성",
    create: "생성",
    cancelLabel: "취소",
    createassignmentheader1: "선택한 팀 멤버에게 이 task가 배정되지 않았습니다",
    createassignmentheader2: "여기에서 배정을 생성하십시오",
    dueDate: "만료일",
    teamMemberAssigmentLabel: "팀 멤버",
    daysPriorToEndDate: "종료일까지 남은 날짜",
    // Add Assignment
    addAssignmentTitle: "배정 이름 추가",
    confirmButtonLabel: "추가",
    cancelButtonLabel: "취소",
    assignmentTypeInstructionalText: "배정 유형을 선택하고 아래에 이름을 입력하십시오. 완료되면 <b>추가</b>를 클릭하십시오.",
    assignmentType: "배정 유형",
    required: "필수",
    clearHoverText: "처리",
    unmarkcomplete: "완료 표시 해제",
    markCompleteErrorMessage: "Task에 완료 표시할 수 없습니다. 페이지를 새로 고침하여 다시 시도하십시오. 문제가 지속되면 헬프 데스크에 문의하십시오.",
    // Assignment Dropdown
    noResultFound: "결과를 찾을 수 없습니다",
    addTaskGroupLabel: "Task 그룹 추가",
    addAssignmentName: "배정 이름 추가",
    assignmentName: "배정 이름",
    additionalSignOff: "추가적인 필수 sign-off",
    signoffRequirementsModalPICLabel: "PIC",
    signoffRequirementsModalEQRLabel: "EQR",
    closeMyAssignment: "내 배정 닫기",
    filterYes: "예",
    filterNo: "아니오",
    assignmentTypeLabels: [{
            id: assignmentTypes.preparer,
            label: "작성자"
        },
        {
            id: assignmentTypes.detailReviewer,
            label: "세부 검토자"
        },
        {
            id: assignmentTypes.generalReviewer,
            label: "일반 검토자"
        },
        {
            id: assignmentTypes.partner,
            label: "Partner"
        },
        {
            id: assignmentTypes.eqr,
            label: "EQR"
        },
        {
            id: assignmentTypes.other,
            label: "기타"
        }
    ]
};

export const displayedOn = {
    "Account": "계정",
    "SCOT": "SCOT",
    "IT/SO": "IT/SO",
    "Scope & Strategy": "범위 및 전략",
    "Execution": "실행",
    "Conclusion": "결론"
}

export const auditPlanReportLabels = {
    adc: "연결된 object",
    secondaryObject: "연결된 보조 object",
    taskTypeColumn: "Task 유형",
    taskNamePrefix: "Task prefix",
    taskName: "Task 제목",
    taskNameSuffix: "Task suffix",
    taskDescription: "Task 설명",
    auditTaskStatus: "Task 상태",
    rationaleForRejection: "거절 근거",
    knowledgeTaskTitle: "Knowledge task 제목",
    knowledgeTaskDescription: "Knowledge task 설명",
    assignedTo: "담당자",
    engagementTagGroupName: "태그 그룹",
    engagementTagName: "태그",
    prioritized: "우선순위 지정됨",
    viewDisplayedOn: "표시 보기",
    engagementPhase: "Engagement 단계",
    milestone: "Milestone",
    periodName: "시기",
    riskTypeAbbr: "연결된 위험 유형",
    riskName: "연결된 위험 이름",
    relatedMESTEntityName: "연결된 MEST 기업",
    scheduledNextWaveservices: "중앙집중식 서비스",
    taskID: "Task ID",
    timephaseID: "시기 ID",
    taskTypeID: "Task 유형 ID",
    timephaseTypeID: "시기 유형 ID"
}

export const reportingTaskAll = {
    taskType: labels.taskType,
    taskStatus: labels.taskStatusLabel,
    taskAssignedTo: labels.taskassignedto,
    taskNamePrefix: labels.taskPrefix,
    task_Name: labels.repTaskTitle,
    taskNameSuffix: labels.taskSuffix,
    taskDescription: labels.repTaskDescription,
    knowledge_Task_Title: "Knowledge task 제목",
    knowledge_Task_Description: "Knowledge task 설명",
    rejected: labels.rejected,
    rationale_for_Rejection: "거절 근거",
    audit_Phase: labels.auditPhasesLabel,
    milestonename: labels.filterMilestoneLabel,
    periodName: labels.timephase,
    timephasestartdateinutc: "(UTC 기준) 시기 시작일",
    timephaseduedateinutc: "(UTC 기준) 시기 만료일",
    taskSourceType: labels.repTaskSource,
    taskNatureType: labels.repTaskNature,
    lastTaskChangeDateInUTC: "(UTC 기준) 최근 task 상태 변경일",
    engagementTagGroupName: labels.manageTagGroupName,
    engagementTagName: labels.tagsLabel,
    mesT_Entity_Name: "연결된 MEST 기업",
    multiEntityType: "Multi-entity 유형",
    taskID: "Task ID",
    taskTypeID: "Task 유형 ID",
    taskStatusID: "Task 상태 ID",
    auditPhaseID: "감사 단계 ID",
    timephaseTypeID: "Milestone ID",
    taskSourceTypeID: "Task 원천 ID",
    taskNatureTypeID: "Task 성격 ID",
    cgTaskID: "Knowledge task ID",
    knowledgeContentID: "Knowledge 내용 ID"
}

export const reportTaskAssignments = {
    taskNamePrefix: labels.taskPrefix,
    taskName: labels.repTaskTitle,
    taskNameSuffix: labels.taskSuffix,
    taskDescription: labels.repTaskDescription,
    taskTypeName: labels.taskType,
    taskSourceType: labels.repTaskSource,
    taskNatureType: labels.repTaskNature,
    auditPhaseName: labels.engagementPhase,
    milestones: labels.filterMilestoneLabel,
    periodName: labels.timephase,
    PICSignoffRequired: "PIC sign-off 필수",
    EQRSignoffRequired: "EQR sign-off 필수",
    taskStatusName: labels.taskStatusLabel,
    taskDueDateInUTC: "(UTC 기준) Task 만료일",
    engagementTagGroupName: labels.manageTagGroupName,
    engagementTagName: labels.tagsLabel,
    completedAssignment: labels.completedAssignments,
    totalAssignment: "총 배정",
    closedTaskAssignmentPercent: "닫힌 task 배정 %",
    assignmentOrder: "배정 순서",
    firstNameVal: "Task 배정 팀 멤버 이름",
    lastNameVal: "Task 배정 팀 멤버 성",
    assignmentName: labels.assignmentName,
    assignmentTypeName: labels.filterAssignmentTypeLabel,
    roleName: "Engagement 사용자 역할",
    assignmentStatusVal: "Task 배정 상태",
    dueDays: "만료 전 기간",
    completedDateInUTC: "(UTC 기준) 완료일",
    assignmentDueDateInUTC: "(UTC 기준) 배정 만료일",
    daysCompleteBeforeDueDate: "Task 배정 만료일 전 잔여 기간",
    daysCompleteAfterDueDate: "Task 배정 만료일 후 지연 기간",
    closedEarlyOrLate: "일찍/늦게 닫힘",
    closedDaysEarly: "일찍 닫힌 기간",
    closedDaysLate: "늦게 닫힌 기간",
    oldTaskName: "레거시 task 제목",
    oldTaskDetail: "레거시 task 설명",
    taskID: "Task ID",
    assignmentID: "배정 ID",
    roleID: "역할 ID",
    userID: "사용자 ID"
}

export const reportingMultiEntityTask = {
	engagementID: 'EngagementId',
	taskID: 'TaskId',
    taskNamePrefix: labels.taskPrefix,
    task_Name: labels.repTaskTitle,
    taskNameSuffix: labels.taskSuffix,
    taskDescription: labels.repTaskDescription,
    mesT_Entity_Name: "연결된 기업",
    multiEntityType: "Multi-Entity 유형",
    taskTypeID: "Task 유형 ID",
    taskStatusID: "Task 상태 ID"
}

export const reportingManageteamInternal = {
        firstName: labels.firstnameLabel,
        lastName: labels.lastnameLabel,
        userInitials: labels.initialsLabel,
        emailAddress: labels.editExternalEmailLabel,
        gui: "GUI",
        engagementRole: labels.engagementrole,
        hasOverallResponsability: "전반적인 책임이 있습니까",
        userStatus: "상태",
        independenceStatus: "독립성 상태",
        grantedAccess: "Archive 후 접근 부여됨",
        primaryOffice: "Primary office",
        preferredContactPhone: "전화번호",
        engagementUserStatusID: "Engagement 사용자 상태 ID",
        engagementRoleID: "Engagement 역할 ID",
        independenceStatusID: "독립성 상태 ID"
    }

export const reportingManageteamExternal = {
    clientGroupName: "그룹 이름",
    firstName: labels.firstnameLabel,
    lastName: labels.lastnameLabel,
    userInitials: labels.initialsLabel,
    emailAddress: labels.editExternalEmailLabel,
    domain: "사용자 도메인",
    validDomainWithinGroup: "그룹 내 유효한 도메인",
    userStatus: "사용자 상태",
    preferredContactPhone: "기본 전화번호"
};

export const controlDesignEffectivenessType = {
    1: "효과적",
    2: "비효과적"
};

export const itAppSOSummaryReportLabels = {
    itApplicationName: "IT Application/서비스조직",
    strategyTypeName: "IT 전략",
    typeName: "유형",
    itProcessName: "IT 프로세스",
    itRiskName: "IT 위험",
    itControlName: "ITGC/ITSP",
    natureOfTest: "테스트 성격",
    controlFrequencyTypeNameColumn: "빈도",
    testing: "테스트",
    designEffectiveness: "설계 효과성",
    evaluation: "IT 프로세스 평가"
};

export const ArchiveReportLabels = {
    engagementDescription: "Engagement 설명",
    archiveReportQualifiedNameSection: "보고서 한정",
    archiveReportQualifiedTypeNameSection: "보고서 한정 유형",
    archiveFolderDescription: "Archive 폴더 설명",
    archiveFolderTypeNameSection: "폴더 유형",
    location: "위치",
    archiveComments: "Archive comment",
    engagementID: "Engagement ID",
    archiveCountryOfficeRegionID: "Country office region ID archive",
    archiveReportQualifiedID: "보고서 한정 ID archive",
    archiveReportQualifiedTypeID: "보고서 한정 유형 ID archive"
};

export const canvasFormRelatedCommentsLabels = {
    canvasFormName: "Canvas 양식 이름",
    order1: "머리글 순서",
    formHeaderName: "머리글",
    order2: "섹션 순서",
    order3: "본문 순서",
    formBodyResponseValue: "응답",
    commentNumber: "Comment 번호",
    author: "작성자",
    assignedTo: "담당자",
    createDateSection: "생성일",
    commentStatusSection: "상태",
    commentText: "Comment",
    commentVoiceNote: "음성 노트 있음",
    reply: "회신",
    replyVoiceNote: "음성 노트 있음"
};

export const canvasFormRelatedObjectsLabels = {
    canvasFormName: "Canvas 양식 이름",
    order1: "머리글 순서",
    formHeaderName: "머리글",
    formHeaderID: "양식 머리글 ID",
    order2: "섹션 순서",
    formSectionID: "양식 섹션 ID",
    formSectionName: "섹션",
    firstLevelEntityColumn: "수준 1 기업",
    firstLevelRelatedObject: "수준 1 관련 object",
    secondLevelEntityColumn: "수준 2 기업",
    secondLevelRelatedObject: "수준 2 관련 object"
};

export const canvasFormResponseLabels = {
    canvasFormName: "Canvas 양식 이름",
    order1: "머리글 순서",
    formHeaderName: "머리글",
    knowledgeFormHeaderID: "머리글 Knowledge ID",
    headerKnowledgeContentID: "머리글 Knowledge 내용 ID",
    order2: "섹션 순서",
    formSectionName: "섹션",
    knowledgeFormSectionID: "섹션 Knowledge ID",
    sectionKnowledgeContentID: "섹션 Knowledge 내용 ID",
    order3: "본문 순서",
    formBody: "본문",
    knowledgeFormBodyID: "본문 Knowledge ID",
    bodyKnowledgeContentID: "본문 Knowledge 내용 ID",
    formBodyResponse_Value: "응답"
};

export const CanvasFormsIncompleteLabels = {
    canvasFormName: "Canvas 양식 이름",
    header: "머리글",
    headerOrder: "머리글 순서",
    sectionOrder: "섹션 순서",
    bodyOrder: "본문 순서",
    body: "본문",
    formHeaderID: "양식 머리글 ID",
    formSectionID: "양식 섹션 ID",
    formBodyID: "양식 본문 ID"
};

export const controlFormResponseLabels = {
    controlName: "통제",
    documentName: "문서",
    engagementDescription: "Engagement 설명",
    formHeader: "머리글",
    headerKnowledgeDisplayOrder: "머리글 Knowledge 표시 순서",
    formSection: "섹션",
    sectionKnowledgeDisplayOrder: "섹션 Knowledge 표시 순서",
    formBodyVal: "본문",
    bodyKnowledgeDisplayOrder: "본문 Knowledge 표시 순서",
    ControlTesting: "통제 테스트 있음",
    controlFrequencyType: "통제 빈도",
    Effective: "효과적임",
    formBodyOptionVal: "양식 옵션 본문 값",
    controlType: "통제 유형",
    controlDesignEffectivenessType: "통제 설계 효과성 유형"
};

export const itProcessSummaryLabels = {
    itProcessName: "IT 프로세스",
    itProcessEvaluation: "IT 프로세스 평가",
    itProcesSupportingRationale: "근거",
    itRiskName: "IT 위험",
    itControlName: "ITGC/ITSP",
    natureOfTest: "테스트 성격",
    controlFrequencyTypeId: "빈도",
    testing: "테스트",
    designEffectiveness: "설계 효과성",
    operatingEffectiveness: "운영 효과성"
}

export const itProcessScotControlsLabels = {
    itProcessName: "IT 프로세스",
    scotName: "SCOT",
    controlName: "통제",
    controlDesignEffectivenessTypeName: "설계 효과성",
    testing: "테스트",
    operatingEffectiveness: "운영 효과성",
    controlTypeName: "통제 유형",
    isIPEManuallyTestedName: "IPE를 수동으로 테스트했습니까",
    itApplicationName: "IT Application",
    aggregateITEvaluationTypeName: "Aggregate IT Evaluation"
};

export const scotsControlsReportLabels = {
    scotName: "SCOT",
    controlName: "통제",
    operatingEffectiveness: "운영 효과성",
    itApplicationName: "IT Application",
    aggregateITEvaluation: "Aggregate IT Evaluation",
    supportingRationaleControlLabel: "근거"
}

export const sCOTSummaryReportHeaderLabels = {
    scotName: "SCOT",
    scotTypeName: "거래 유형",
    strategyTypeName: "SCOT 전략",
    itApplicationName: "SCOT IT App / SO",
    wcgwName: labels.wcgw,
    controlName: labels.control,
    controlFrequencyTypeName: labels.frequencyLabel,
    controlTypeName: "통제 유형",
    testing: "테스트",
    operatingEffectiveness: "운영 효과성",
    controlITApplication: "통제 IT App/SO",
    aggregateITEvaluationTypeName: "Aggregate IT Evaluation",
    supportingRationale: "근거",
    scotId: "SCOT ID",
    strategyTypeID: "전략 유형 ID",
    scotTypeID: "SCOT 유형 ID",
    wcgwid: "WCGW ID",
    controlID: "통제 ID",
    controlFrequencyTypeID: "통제 빈도 유형 ID",
    controlTypeID: "통제 유형 ID",
    aggregateITEvaluationTypeID: "Aggregate IT Evaluation 유형 ID"
};

export const findingsDeficiencyHeaderLabels = {
    description: "미비점 설명",
    controls: "통제",
    controlsIsEffective: "통제의 운영 효과성",
    type: "미비점 유형",
    magnitude: "규모",
    responseText: "응답 텍스트",
    remediatedAtYearEnd: "기말에 개선됨",
    mitigatingControls: "보완 통제",
    mitigatingControlsIsEffective: "보완 통제의 운영 효과성",
    mitigatingTasks: "완화 Task",
    foundIn: "발견 문서",
    accountsAndAssertions: "계정 및 경영진주장",
    scoTs: "SCOT",
    deficiencyID: "미비점 ID",
    controlID: "통제 ID",
    mitigatedControlID: "완화된 통제 ID",
    mitigatedTaskID: "완화된 task ID",
    documentID: "문서 ID",
    accountID: "계정 ID",
    scotID: "SCOT ID"
};

export const findingsMisstatementHeaderLabels = {
    description: "왜곡표시 설명",
    type: "왜곡표시 유형",
    trialBalance: "시산표",
    period: "기간",
    accountNumber: "계정 번호",
    accountName: "계정 이름",
    accountType: "계정 유형",
    debit: "차변",
    credit: "대변",
    responseText: "응답 텍스트",
    correctedUncorrected: "수정/미수정",
    mitigatingTasks: "완화 task",
    foundInDocument: "발견 문서",
    accountsAndAssertions: "계정 및 경영진주장",
    misstatementID: "왜곡표시 ID",
    trialBalanceID: "시산표 ID",
    misstatementAdjustmentID: "왜곡표시 조정 ID"
};

export const findingsDeficiencyITHeaderLabels = {
    itApplicationName: "IT Application 이름",
    itProcessName: "IT 프로세스 이름",
    itControlName: "IT 통제 이름",
    itApproachTypeName: "IT 접근법 유형",
    isEffective: "통제 효과성",
    referenceNumber: "참조 번호",
    description: "미비점 설명",
    deficiencyMagnitudeName: "미비점 규모",
    deficiencyTypeName: "미비점 유형"
};

export const auditPlanRelatedEvidenceReportHeaderLabels = {
    adc: "연결된 object",
    secondaryObject: "연결된 통제 / 실증절차",
    taskName: "Task 제목",
    taskDescription: "Task 설명",
    taskTypeColumn: "Task 유형",
    taskStatusValue: "Task 상태",
    rationaleForRejection: "거절 근거",
    engagementPhase: "Engagement 단계",
    milestone: "Milestone",
    periodName: "시기",
    assignedTo: "담당자",
    engagementTagGroupName: "태그 그룹",
    engagementTagName: "태그",
    displayedOn: "표시 보기",
    documentName: "문서 이름",
    preparersValue: "작성자 (UTC 기준 날짜)",
    reviewersValue: "검토자 (UTC 기준 날짜)",
    openReviewNotes: "처리 전 리뷰노트",
    closedReviewNotes: "처리된 리뷰노트",
    trackChangesValue: "변경사항 추적",
    lastModifiedBy: "최근 수정한 사람",
    lastModifiedDateValue: "(UTC 기준) 최근 수정일",
    taskID: "Task ID",
    timephaseID: "시기 ID",
    taskTypeID: "Task 유형 ID",
    documentTypeID: "문서 유형 ID",
    parentDocumentTypeID: "Parent 문서 유형 ID",
    timePhaseTypeID: "시기 유형 ID"
};

// group instruction summary
export const groupInstructionSummaryReportHeaderLabels = {
    sectionName: "섹션",
    gaInstructionName: "지침 제목",
    gaInstructionDescription: "지침 설명",
    documents: "문서 이름",
    knowledgeInstructionName: "Knowledge 지침 제목",
    knowledgeInstructionDescription: "Knowledge 지침 설명",
    gaScopeName: "연결된 범위 / 하위 범위",
    componentOnly: "범위 / 개별 지침",
    shortName: "지역/부문 이름",
    cSection: "사용자지정 섹션",
    customInstruction: "사용자지정 지침",
    gAinstructionID: "GA 지침 ID"
};

// GIS last publish and send
export const gIsLastPublishAndSendReportHeaderLabels = {
    primaryEngagementID: "Engagement ID",
    gaScopeID: "GA 범위 ID",
    gaScopeName: "범위",
    gaComponentID: "GA 부문 ID",
    shortName: "부문 이름",
    lastPublishedDateInUTC: "최근 발간일",
    lastSentDateInUTC: "최근 전송일",
    gaLinkStatusId: "링크 상태",
    gaInstructionStatusId: "지침 상태"
};

// Group Activity
export const groupActivityReportHeaderLabels = {
    engagementID: "Engagement ID",
    gaScopeID: "GA 범위 ID",
    gaScopeName: "범위",
    gaComponentID: "GA 부문 ID",
    shortName: "부문 이름",
    gaLinkStatusId: "링크 상태",
    accountID: "계정 ID",
    accountName: "계정 이름",
    accountType: "계정 지정",
    activityTypeID: "활동 유형 ID",
    activityTypeText: "활동 유형",
    modifyDateInUTC: "날짜 수정",
    modifyUser: "사용자 수정",
};

export const AccountDisclosuresReportHeadeLabels = {
    engagementID: "Engagement ID",
    accountID: "계정 ID",
    accountName: "계정 이름",
    accountTypeID: "계정 유형 ID",
    accountTypeId: "계정 지정",
    knowledgeAssertionId: "경영진주장 약어",
    inherentRiskTypeId: "고유위험 평가",
    controlRiskTypeId: "통제위험 평가",
    craValue: "CRA",
    riskID: "위험 ID",
    riskTypeID: "위험 유형 ID",
    riskType: "위험 유형",
    riskName: "위험 이름",
    isHigherRiskValue: 'Is higher risk',
};

// CRA summary
export const craSummaryReportHeaderLabels = {
    accountName: "계정",
    accountTypeName: "계정 유형",
    rationale: "근거",
    pspIndex: "PSP index",
    conclusionStatement: "계정 결론",
    scotName: "SCOT",
    transactionType: "거래 유형",
    strategyTypeName: "SCOT 전략",
    wcgwName: "WCGW",
    controlName: "통제",
    controlFrequencyTypeName: "빈도",
    controlTypeName: "통제 유형",
    testing: "테스트",
    operatingEffectiveness: "운영 효과성",
    itApplicationName: "SCOT IT App/ SO",
    controlITApplication: "Control IT App/SO"
};

export const craSummaryAssertionReportHeaderLabels = {
    accountName: "계정",
    accountTypeName: "계정 유형",
    rationale: "근거",
    pspIndex: "PSP Index",
    assertionAbbreviation: "경영진주장",
    riskName: "위험",
    inherentRiskTypeName: "고유위험 평가",
    controlRiskTypeName: "통제위험 평가",
    craValue: "CRA",
    wcgwName: "WCGW",
    controlName: "통제",
    controLFrequencyTypeName: "빈도",
    controlTypeName: "통제 유형",
    testing: "테스트 선택",
    isLowerR: "위험이 lower입니까",
    operatingEffectiveness: "운영 효과성",
    itApplicationName: "IT App/ SO"
};

export const craSummaryDataReportHeaderLabels = {
    wcgwName: "WCGW",
    controlName: "통제",
    controLFrequencyTypeName: "통제 빈도",
    controlTypeName: "통제 유형",
    itApplicationName: "IT Application",
    assertionName: "경영진주장",
    statementTypeName: "재무제표 유형",
    accountTypeName: "계정 유형",
    assertionAbbreviation: "경영진주장 약어",
    inherentRiskTypeName: "고유 위험",
    controlRiskTypeName: "통제 위험",
    craValue: "CRA",
    riskTypeAbbreviation: "위험 약어",
    frequency: "빈도",
    accountName: "계정",
    riskName: "위험",
    pspIndex: "PSP index",
    testing: "테스트",
    operatingEffectiveness: "운영 효과성",
    isLowerRiskColumn: "낮은 위험",
    scotName: "SCOT",
    controlitApplicationName: "통제 > IT Application",
    rationale: "근거",
    accountID: "계정 ID",
    riskID: "위험 ID",
    scotid: "SCOT ID",
    wcgwid: "WCGW ID",
    controlID: "통제 ID",
    itApplicationID: "IT Application ID",
    knowledgeAssertionID: "Knowledge 경영진주장 ID",
    controlTypeID: "통제 유형 ID",
    controlFrequencyTypeID: "통제 빈도 유형 ID",
    accountTypeID: "계정 유형 ID",
    riskTypeID: "위험 유형 ID",
    inherentRiskTypeID: "고유 위험 유형 ID",
    controlRiskTypeID: "통제 위험 유형 ID",
    statementTypeID: "재무제표 유형 ID",
    conclusionStatement: "계정 결론"
};

export const reportingRequestsAndTasks = {
    requestTitle: "요청/Task 제목",
    request_Description: "요청/Task 설명",
    type: "유형",
    tasks: "Task 제목",
    engagementTagName: "태그",
    eyAssigned: "배정된 EY 사용자",
    clientGroupName: "외부 그룹",
    externalAssignedUser: "배정된 외부 사용자",
    periodName: "시기",
    dueDateInUTC: "(UTC 기준) 만료일",
    requestStatus: "요청/Task 상태",
    documentType: "문서 유형",
    documentName: "당기 문서 이름",
    priorYearDocumentName: "전기 문서 이름",
    externalDocumentSignOffInUTC: "(UTC 기준) 외부 문서 sign-off",
    clientRequestReferenceNumber: "고객 요청 참조 번호"
};

export const reportingRequestComment = {
    requestTitle: "요청/Task 제목",
    request_Description: "요청/Task 설명",
    type: "유형",
    tasks: "Task 제목",
    engagementTagName: "태그",
    eyAssigned: "배정된 EY 사용자",
    clientGroupName: "외부 그룹",
    externalAssignedUser: "배정된 외부 사용자",
    periodName: "시기",
    dueDateInUTC: "(UTC 기준) 만료일",
    requestStatus: "요청/Task 상태",
    externalDocumentSignOffInUTC: "(UTC 기준) 외부 문서 sign-off",
    annotationTextData: "Comment",
    createDateInUTC: "(UTC 기준) Comment 날짜",
    annotationUserInitials: "Comment한 사람"
};

export const reportingAllDocuments = {
    documentName: "문서 이름",
    fileExt: "파일 확장자",
    canvasFormType: "Canvas 양식 유형",
    docType: "문서 유형",
    confidentiality: "기밀",
    docFileSize: "파일 크기 (KB)",
    preparers: "작성자 (UTC 기준)",
    reviewers: "검토자 (UTC 기준)",
    relatedTask: "연결된 task",
    openReviewNote: "처리 전 리뷰노트",
    clearedReviewNote: "처리된 리뷰노트",
    trackChanges: "변경사항 추적",
    hiddenSheets: "숨긴 시트",
    comments: "Comment",
    highlighted: "하이라이트",
    conflicted: "충돌",
    docModifyUser: "최근 수정한 사람",
    docModifyDateInUTC: "(UTC 기준) 최근 수정일",
    documentID: "문서 ID"
};

export const signOffDocuments = {
    documentName: "문서 이름",
    fileExt: "파일 확장자",
    canvasFormType: "Canvas 양식 유형",
    docType: "문서 유형",
    confidentiality: "기밀",
    docFileSize: "파일 크기 (KB)",
    docModifyUser: "최근 수정한 사람",
    docModifyDateInUTC: "(UTC 기준) 최근 수정일",
    signOffDate: "(UTC 기준) Sign-off 날짜",
    signedOffBy: "Sign-off한 사람",
    role: "역할",
    preparerReviewer: "작성자/검토자"
};

export const reportingDocumentsModified = {
    documentName: "문서 이름",
    lastModifiedDateInUTC: "(UTC 기준) 최근 수정일",
    lastModifiedUser: "최근 수정한 사용자",
    reason: "이유",
    documentChangeComment: "근거",
    preparersInUTC: "작성자 (UTC 기준)",
    reviewersInUTC: "검토자 (UTC 기준)",
    approver: "승인 (UTC 기준)"
};

export const reportingDeletedTaskReport = {
    taskNamePrefix: labels.taskPrefix,
    taskName: "Task 제목",
    taskNameSuffix: labels.taskSuffix,
    taskDescription: "Task 설명",
    taskTypeAbbreviation: "Task 유형",
    taskSourceType: "Task 원천",
    taskNatureType: "Task 성격",
    last_Modified_By: "최근 수정한 사람",
    modifyDateInUTC: "(UTC 기준) 최근 수정일",
    oldTaskName: "레거시 task 제목",
    oldTaskDetail: "레거시 task 설명"
};

export const SEMReportHeaderLabel = {
    accountAssertion: "계정/경영진주장",
    craValue: "CRA",
    riskOfMaterialMisstatements: labels.riskOfMaterialMisstatement,
    relatedRisks: "연결된 위험",
    taskType: "Task 유형",
    taskTitle: "Task 제목",
    taskSource: labels.source,
    taskNature: labels.nature,
    taskTypeID: "Task 유형 ID",
    taskSourceTypeID: "Task 원천 유형 ID",
    taskNatureTypeID: "Task 성격 유형 ID"
}

export const MilestonesReportHeaderLabels = {
    taskName: labels.repTaskTitle,
    taskType: labels.taskType,
    taskStatus: labels.taskStatusLabel,
    auditPhase: labels.auditPhasesLabel,
    periodName: labels.timephase,
    timephase: "현재 milestone",
    correctTimephase: "올바른 milestone"
}

export const MilestonesReportHeader = {
    milestone: "Milestone",
    status: "Milestone 상태",
    taskStatus: "Task 상태",
    taskTitle: "Task 제목",
    taskTypeAbbreviationColumn: "Task 유형 약어",
    taskType: "Task 유형",
    timePhase: "시기",
    assignedTo: "담당자",
    taskName: "Task 이름",
    task_Detail: "Task 세부정보",
    due_Date: "만료일",
    documentName: "문서 이름",
    preparers: "작성자",
    reviewers: "검토자",
    tagGroup: "태그 그룹",
    tags: "태그",
    engagementID: "Engagement ID",
    taskID: "Task ID",
    taskTypeID: "Task 유형 ID",
    taskStatusID: "Task 상태 ID",
    timephaseID: "시기 ID",
    timephaseTypeID: "시기 유형 ID",
    documentID: "문서 ID"
}

export const groupStructureSummaryReportHeaderLabels = {
    gaScopeName: "범위 설명",
    gaScopeDescription: "범위 / 하위 범위 이름",
    shortName: "지역 / 부문 이름",
    legalName: "법적 이름",
    gaRoleTypeName: "그룹 역할",
    relatedRegion: "연결된 지역",
    pocText: "연락처",
    gaLinkStatusName: "링크 상태",
    gaInstructionStatusName: "지침 상태",
    engagementID: "Engagement ID",
    gaRoleTypeID: "GA 역할 유형 ID",
    gaLinkStatusID: "GA 링크 상태 ID",
    gaInstructionStatusID: "GA 지침 상태 ID"
}

export const collaborationSummary = {
    clientRequestID: "요청 번호",
    requestTitle: "제목",
    requestType: "유형",
    engagementTagName: "태그",
    clientUser: "담당자",
    clientEmail: "고객 이메일",
    clientStatusName: "상태",
    isOverDue: "지연",
    dueDateInUTC: "(UTC 기준) 만료일",
    eySentDateInUTC: "(UTC 기준) EY 전송일",
    eyReceivedDateInUTC: "(UTC 기준) 수신일",
    deliveredLate: "전달 지연",
    daysLate: "지연 기간",
    timesReturned: "반송 횟수"
}

export const collaborationActivity = {
    clientRequestID: "요청 번호",
    requestTitle: "제목",
    requestType: "유형",
    engagementTagName: "태그",
    clientUser: "담당자",
    clientEmail: "고객 이메일",
    clientStatusName: "상태",
    isOverDue: "지연",
    dueDateInUTC: "(UTC 기준) 만료일",
    eySentDateInUTC: "(UTC 기준) EY 전송일",
    eyReceivedDateInUTC: "(UTC 기준) 수신일",
    deliveredLate: "전달 지연",
    daysLate: "지연 기간",
    timesReturned: "반송 횟수",
    activity: "활동",
    activityDateInUTC: "(UTC 기준) 활동일",
    historicalDueDateInUTC: "(UTC 기준) 기록된 만료일"
}

export const groupReportHeaderLabels = {
    gaInstructionName: "지침 이름",
    gascopeTypeIDName: labels.scope,
    componentName: "부문 이름",
    pointOfContact: labels.pointOfContact,
    dueDateValue: "(UTC 기준) 만료일",
    overdueValue: labels.overdueLabel,
    gaStatusIdName: labels.status,
    documentName: labels.documents,
    createDateValue: "(UTC 기준) Sign-off 날짜",
    signoffBy: labels.signedOffBy,
    engagementRoleIDName: labels.role,
    isPreparerText: "작성자/검토자",
    documentID: "문서 ID",
    gaStatusID: "GA 상태 ID",
    engagementRoleID: "Engagement 역할 ID"
}

export const wcgwSummaryHeaders = {
    wcgwName: "WCGW",
    scotName: "SCOT",
    controlName: "연결된 통제",
    itApplications: "연결된 IT App/SO",
    testing: "테스트 선택",
    isLowerR: "위험이 lower입니까",
    controlFrequencyTypeName: "통제 빈도",
    controlTypeName: "통제 유형",
    wcgwCount: "연결된 다른 WCGW 수"
}

export const allControlsHeaders = {
    engagementID: "Engagement ID",
    scotid: "SCOT ID",
    controlID: "통제 ID",
    scotName: "SCOT 이름",
    controlName: "통제 설명",
    hasControlTesting: "테스트 선택",
    isLowerRisk: "낮은 위험입니까",
    controlTypeID: "통제 유형",
    relatedITApplicationNames: "연결된 ID App/SO",
    responsiveToSR: "유의적인 위험에 대응",
    IPE: "IPE"
}


export const qualityChecksHeaders = {
    itemID: "항목 ID",
    itemName: "항목 이름",
    qualityChecks: "품질 검증",
    validationDescription: "검증 설명",
    buildGroup: "작성 그룹",
    impactedItem: "영향받은 항목",
    type: "유형"
}

export const statisticsHeaders = {
    scotname: "SCOT",
    strategyTypeId: "SCOT 전략",
    wcgwName: "WCGW",
    controlName: "통제",
    operatingEvaluation: "운영 평가",
    itApplicationName: "연결된 IT App/SO",
    assertions: "경영진주장",
    controlTypeId: "통제 유형",
    testingSelection: "테스트 선택",
    controlFrequencyTypeId: "빈도",
    itApplications: "IT Application",
    scotTypeId: "SCOT 유형",
    itType: "IT App 유형",
    isLowerR: "낮은 위험",
    engagementID: "Engagement ID",
    workspaceID: "Workspace ID",
    scotID: "SCOT ID",
    scotTypeID: "SCOT 유형 ID",
    wcgwid: "WCGW ID",
    controlID: "통제 ID"
}

export const CRTAssertionCountSummaryHeaders = {
    accountName: "계정",
    assertion: "경영진주장",
    controlName: "통제",
    ControlTypeName: "통제 유형",
    ControlFrequencyTypeName: "빈도",
    Testing: "테스트",
    OperatingEvaluation: "운영 평가",
    assertionControlCount: "경영진주장 통제 수",
    assertionAbbreviation: "경영진주장 약어",
    wcgwName: "WCGW",
    engagementID: "Engagement ID",
    workspaceID: "Workspace ID",
    assertionID: "경영진주장 ID",
    wcgwid: "WCGW ID",
    controlID: "통제 ID"
}

export const crtlistcontrolTypeName = {
    'IT Application Control': "IT Application 통제",
    'IT Dependent Manual Control': "IT 의존 수동 통제",
    'Manual Prevent': "수동 예방",
    'Manual Detect': "수동 적발"
}

export const controlFrequencyNameTypes = {
    'Many times per day': "하루에 여러 번",
    'Daily': "매일",
    'Weekly': "매주",
    'Monthly': "매월",
    'Quarterly': "매분기",
    'Annually': "매년",
    'IT Application Control': "IT Application 통제",
    'Other': "기타"
};

// Folder types
export const archiveFolderTypeNameTypes = {
    'Working Papers': "조서",
    'Perm File Active': "활성 영구 조서",
    'Perm File Superseded': "대체된 영구 조서",
    'Working Papers - CD/DVD': "조서 - CD/DVD",
    'Perm File Active - CD/DVD': "활성 영구 조서 - CD/DVD",
    'Perm File Superseded - CD/DVD': "대체된 영구 조서 - CD/DVD",
    'Data Storage Devices': "데이터 저장 도구"
};

export const operatingEvaluationType = {
    'Effective': "효과적",
    'Ineffective': "비효과적",
    'Not Selected': "미선택"
};

export const CRTSCOTCountSummaryHeaders = {
    scotname: "SCOT",
    strategyTypeName: "SCOT 전략",
    wcgwName: "연결된 WCGW",
    controlName: "연결된 통제",
    operatingEvaluation: "운영 평가",
    itApplicationName: "연결된 IT App/SO",
    assertions: "경영진주장",
    controlTypeName: "통제 유형",
    testing: "테스트 선택",
    controlFrequencyTypeName: "빈도",
    itApplications: "IT Application",
    itAppType: "IT Application 유형",
    scotTypeName: "SCOT 유형",
    soctisLowerRisk: "위험이 lower인 통제",
    engagementID: "Engagement ID",
    workspaceID: "Workspace ID",
    scotID: "SCOT ID",
    scottypeid: "SCOT 유형 ID",
    wcgwid: "WCGW ID",
    controlID: "통제 ID"
};

export const projectInsightCanvasFormExportHeaders = {
    EngagementID: "Engagement ID",
    DocumentID: "문서 ID",
    ControlID: "통제 ID "
};

export const projectInsightSCOTToWCGWToControlHeaders = {
    engagementID: "Engagement ID",
    scotName: "SCOT 이름",
    strategyTypeName: "전략 유형 이름",
    wcgwName: "WCGW 이름",
    controlID: "통제 ID",
    controlName: "통제 이름",
    controlFrequencyTypeName: "통제 빈도 유형 이름",
    controlTypeName: "통제 유형 이름",
    isLowerRiskHeader: "위험이 lower입니까",
    hasControlTestingHeader: "통제테스트 있음",
    operativeEffectiveness: "운영 효과성"
};

export const ComponentTeamGroupAccountInfoControlHeaders = {
    engagementId: "Engagement ID",
    accountId: "계정 ID",
    accountName: "계정 이름",
    accountTypeId: "계정 유형 ID",
    accountDesignation: "계정 지정",
    pspIndexTitle: "PSP index",
    knowledgeAssertion: "경영진주장 약어",
    inherentRiskType: "고유위험 평가",
    controlRiskType: "통제위험 평가",
    craValue: "CRA",
    riskId: "위험 ID",
    riskTypeId: "위험 유형 ID",
    riskTypeEnum: "위험 유형",
    riskName: "위험 이름",
    isHigherRiskText: "Is higher risk",
    rejectedTaskId: "Task ID",
    rejectedTaskName: "거절된 PSP",
    rejectedTaskRationale: "거절된 PSP 근거"
};

export const projectInsightControlToITApplicationHeaders = {
    engagementID: "Engagement ID",
    controlID: "통제 ID",
    itApplicationID: "IT Application ID",
    controlITApplication: "통제 IT Application"
};

export const projectInsightControlToAssertionHeaders = {
    engagementID: "Engagement ID",
    controlID: "통제 ID",
    Accountname: "계정 이름",
    AssertionAbbreviation: "경영진주장 약어"
};

export const projectInsightRisksToWCGWsHeaders = {
    engagementId: "Engagement ID",
    accountName: "계정 이름",
    accountId: "계정 ID",
    knowledgeAssertion: "경영진주장",
    CRA: "CRA",
    RelatedRisk: "연결된 위험",
    riskId: "위험 ID",
    riskType: "위험 유형",
    WCGW: "WCGW",
    wcgwId: "WCGW ID",
    RelatedSCOT: "연결된 SCOT",
    scotId: "SCOT ID"
};

export const ipeControlsHeaders = {
    EngagementID: "Engagement ID",
    DocumentID: "문서 ID"
};

export const ipeSubstantiveHeaders = {
    EngagementID: "Engagement ID",
    DocumentID: "문서 ID"
};

export const ipeITGCHeaders = {
    EngagementID: "Engagement ID",
    DocumentID: "문서 ID"
};

export const iTAppSOReport = {
    relatedITSO: "연결된 IT App/SO",
    iTAppType: "IT App 유형",
    iTAppControl: "IT App 통제",
    testingSelection: "테스트 선택",
    relatedSCOTs: "연결된 SCOT",
    relatedSCOTStrategy: "연결된 SCOT 전략",
    itdm: "ITDM",
    manualPrevent: "수동 예방",
    manualDetect: "수동 적발",
    noRelatedControls: "연결된 통제 없음",
    controlsStatistics: "유형별 통제",
    relatedSCOTType: "연결된 SCOT 유형",
    controlType: "통제 유형",
    grandTotal: "합계",
    yes: "예",
    no: "아니오",
    notSelected: "미선택",
    controls: "통제",
    substantive: "실증",
    routine: "일상적",
    nonRoutine: "비일상적",
    estimation: "추정"
};

export const IndependenceSummaryReport = {
    id: "ID",
    userName: "사용자 이름",
    order: "주문",
    questionFormatted: "질문",
    answer: "답변",
    actionTypeID: "작업 유형 ID",
    independenceStatusID: "독립성 상태 ID",
    EngagementUserStatusName: "Engagement 사용자 상태",
    engagementUserStatusID: "Engagement 사용자 상태 ID",
    IndependenceStatusName: "독립성 상태",
    requiresExecutiveClearance: "Executive clearance 필요"
};

export const additionalInfoBasedOnValidationTypeId = {
    1: "유효성 검증을 해결하려면 How to clear validation checks in EY Canvas enabler에 있는 단계별 guidance를 활용하십시오",
    2: "팀은 현재 최신 109 - 팀 멤버 독립성 양식 버전을 사용하고 있지 않습니다",
    3: "독립성 문제가 있는 다른 팀 멤버에게 접근권한을 부여한 후, 팀 멤버의 역할이 PPEDD 역할에서 변경됐습니다",
    4: "독립성 문제가 있는 다른 팀 멤버를 재지정한 후, 팀 멤버의 역할이 PPEDD 역할에서 변경되었습니다",
    5: "유효성 검증 링크를 클릭하여, 옆에 숫자 배지가 없는 SCOT을 식별하십시오. SCOT을 계정에 연결하십시오.",
    6: "유효성 검증을 해결하려면 How to clear validation checks in EY Canvas enabler에 있는 단계별 guidance를 활용하십시오",
    7: "연결된 WCGW 수가 비어있는 SCOT을 식별하십시오. 각 build task로 이동하십시오. SCOT을 확장하고 적합한 WCGW를 추가하십시오.",
    8: "연결된 통제 수가 비어있는 SCOT을 식별하십시오. 각 build task로 이동하십시오. SCOT을 확장하고 WCGW에 통제를 추가하십시오.",
    9: "유효성 검증이 있는 SCOT을 식별하여 SCOT 세부정보를 확장하고 WCGW별로 하나 이상의 통제가 테스트에 '예'로 선택됐는지 확인하십시오",
    10: "유효성 검증이 있는 SCOT을 식별하여 SCOT 세부정보를 확장하십시오. WCGW별로 하나 이상의 통제가 테스트에 '예'로 선택됐는지 확인하십시오",
    11: "유효성 검증 링크를 클릭하여, 옆에 숫자 배지가 없는 위험을 식별하십시오. 위험에 적합한 경영진주장을 연결하십시오.",
    12: "고유 및/또는 통제위험이 누락된 경영진주장을 식별하십시오. 누락된 필드를 완료하십시오.",
    13: "유효성 검증 링크를 클릭하여 'WCGW 드로어 추가'를 여십시오. 한 번에 하나의 SCOT을 선택하여 옆에 숫자 배지가 없는 WCGW를 식별하십시오. WCGW에 적합한 경영진주장을 연결하십시오",
    14: "옆에 숫자 배지가 없는 계정을 식별하십시오. SCOT build 흐름으로 이동하여 계정에 SCOT을 연결하십시오.",
    15: "유효성 검증이 있는 계정/경영진주장을 식별하여, 'WCGW 버튼 추가'를 클릭하고 경영진주장에 WCGW를 연결하십시오",
    16: "유효성 검증은 통제 전략이 있는 경영진주장과 연결된 모든 WCGW가 테스트 할 통제에서 다뤄지는지 확인합니다. 유효성 검증이 있는 경영진주장을 식별하고, 'WCGW 버튼 추가'를 클릭하여 경영진주장에 WCGW를 연결하십시오.",
    17: "경영진주장과 연결된 각 WCGW를 검토하여, 테스트 전략에 '예'로 표시된 하나 이상의 통제로 대응되는지 확인하십시오",
    18: "의존 전략이 있는 경영진주장에 대한 모든 WCGW는 테스트 값이 ‘예’로 설정된 통제로 대응해야 합니다",
    19: "삭제되지 않았으며 IT/SO 프로세스와 연결되어 있지 않은 의존 전략이 있는 IT/SO",
    20: "IT/SO 위험과 연결되어 있지 않은 IT/SO 통제/IT 실증절차",
    21: "IT/SO 프로세스 생성 후 의존 전략에서 의존하지 않는 전략으로 변경",
    22: "위험이 경영진주장과 연결되어 있지 않습니다",
    23: "IT/SO 위험과 연결되어 있지 않은 IT/SO 통제/IT 실증절차",
    24: "IT/SO 위험과 연결되어 있는 IT/SO 통제/실증절차가 테스트를 위해 선택되지 않았습니다",
    25: "IT/SO 위험과 연결되어 있지 않은 IT/SO 통제/IT 실증절차",
    26: "Task가 없는 limited risk 계정을 식별하십시오. 하나 이상의 OSP를 추가하십시오.",
    27: "PSP를 불러왔는지 확인하십시오. PSP를 불러오지 않았다면, 'PSP 불러오기'를 클릭하십시오. 경영진주장에 PSP가 없다면, OSP를 생성하십시오.",
    28: "SCOT build 흐름으로 이동하여 '통제테스트 드로어 추가'를 열고 옆에 숫자 배지가 없는 TOC task를 식별하십시오. TOC task에 통제를 연결하십시오.",
    29: "Engagement에 SCOT과 연결되지 않은 walkthrough task가 하나 이상 있습니다",
    30: "SCOT과 연결된 walkthrough task가 하나 이상 없습니다",
    31: "SCOT build flow로 이동하여 '통제테스트 드로어 추가'를 열어, 옆에 숫자 badge가 없는 TOC task를 식별하십시오. 통제에 TOC task를 연결하십시오.",
    32: "IT/SO walkthrough가 IT/SO process와 하나 이상 연결되어 있지 않습니다",
    33: "IT/SO 통제테스트가 테스트 값이 ‘예’로 설정된 IT/SO 통제/실증절차 하나 이상과 연결되어 있지 않습니다",
    34: "IT/SO 기타실증절차가 테스트 값이 ‘예’로 설정된 IT/SO 통제/실증절차와 하나 이상 연결되어 있지 않습니다",
    35: "IT/SO 프로세스와 연결된 walkthrough task가 하나 이상 없습니다",
    36: "테스트 값이 ‘예’로 설정된 통제와 연결된 통제 테스트 task가 없습니다",
    37: "IT/SO 기타실증절차는 테스트 값이 ‘예’로 설정된 IT/SO 통제/실증절차와 하나 이상 연결되어 있지 않습니다",
    38: "유효성 검증 링크를 클릭한 후 증거 목록에서 충돌 아이콘을 클릭하여 충돌을 해결하십시오",
    39: "유효성 검증을 해결하려면 How to clear validation checks in EY Canvas enabler에 있는 단계별 guidance를 활용하십시오",
    40: "유효성 검증 링크를 클릭하여 증거 목록에서 작성자 또는 검토자 sign-off가 누락된 문서에 sign-off 하십시오. 귀하가 작성하거나 검토한 파일에만 sign-off 하십시오.",
    41: "유효성 검증 링크를 클릭하여 필터링된 task 목록에서 각 task를 검토하고 적합한 증거 파일을 연결하십시오",
    42: "유효성 검증을 해결하려면 How to clear validation checks in EY Canvas enabler에 있는 단계별 guidance를 활용하십시오",
    43: "유효성 검증을 해결하려면 How to clear validation checks in EY Canvas enabler에 있는 단계별 guidance를 활용하십시오",
    44: "유효성 검증 링크를 클릭하여 증거 목록에서 이름이 중복된 문서 이름을 바꾸십시오",
    45: "IT 프로세스 평가가 선택되지 않았거나 ITCG/ITSP 운영 효과성 평가와 모순됩니다",
    46: "유효성 검증을 해결하려면 How to clear validation checks in EY Canvas enabler에 있는 단계별 guidance를 활용하십시오",
    47: "하나 이상의 application/ITDM 통제에 aggregate IT evaluation이 선택되지 않았습니다",
    48: "Canvas 양식에 미완료 필드가 하나 이상 있습니다 ",
    49: "경영진주장 또는 limited risk 계정을 연결하려면 유효성 검증을 클릭하고 '경영진주장 추가'를 클릭하십시오",
    50: "경영진주장 또는 limited risk 계정이 연결되지 않은 task. 경영진주장이나 limited risk 계정을 연결하려면 경영진주장 추가를 클릭하십시오.",
    51: "WCGW이 실증 task와 연결되지 않았습니다",
    52: "Engagement에 하나 이상의 WCGW에 연결되지 않은 고유 위험, 유의적인 위험 또는 부정 위험이 하나 이상 있습니다",
    53: "EST 회계 추정치 index가 누락된 추정치 계정. PSP index 목록에서 이를 추가하십시오.",
    54: "추정치가 있는 계정을 식별하고 여기에 연결된 추정 SCOT이 있는지 확인하기 위해 계정을 여십시오. 추정 SCOT이 누락된 계정을 식별하면 추정 SCOT을 연결해야 합니다.",
    55: "추정치 계정에 연결되지 않은 추정 SCOT을 식별하십시오. 추정치 계정이 누락된 추정 SCOT을 식별하면 추정 SCOT을 추정치 계정에 연결해야 합니다.",
    56: "유의적인 위험 또는 부정 위험은 실증절차, 통제, (해당하는 경우) 통제테스트 task를 각각 하나 이상 포함해야 합니다",
    57: "유의적인 위험 또는 부정 위험은 실증절차, 통제, (해당하는 경우) 통제테스트 task를 각각 하나 이상 포함해야 합니다",
    58: "유효성 검증이 있는 위험을 클릭하여 경영진주장을 확장하십시오. '예'가 선택된 task를 하나 이상 확인하십시오.",
    59: "유효성 검증이 있는 위험을 클릭하여 경영진주장을 확장하십시오. '예'가 선택된 task를 하나 이상 확인하십시오. 통제에 대한 설계 효과성 또한 완료해야 합니다.",
    60: "Canvas 양식 comment 해결' 유효성 검증 링크를 클릭하십시오. 각 Canvas 양식을 열어 '미해결 comment 표시'를 선택하십시오. 모든 comment는 처리되거나 닫혀야 합니다.",
    61: "미완료 Canvas 양식 응답 마무리' 유효성 검증 링크를 클릭하십시오. 각 Canvas 양식을 열어 '미해결 comment 표시'를 선택하십시오. 모든 comment는 처리되거나 닫혀야 합니다.",
    62: "유효성 검증 링크를 클릭하여 미해결 comment를 검토하고 미해결 comment를 모두 처리하거나 닫으십시오",
    63: "유효성 검증을 해결하려면 How to clear validation checks in EY Canvas enabler에 있는 단계별 guidance를 활용하십시오",
    64: "유효성 검증 링크를 클릭하여, 필터링된 task 목록에서 각 task를 검토하고 처리 전 task에 완료 표시하십시오",
    65: "공유 증거 링크를 모두 해제하려면 '모두 링크 해제' 버튼을 클릭하십시오",
    66: "440 양식에 변경 사유를 선택하지 않은 문서가 하나 이상 있습니다",
    67: "440 양식에 비관리적 변경 사유를 선택했으나 그 근거를 작성하지 않은 문서가 하나 이상 있습니다.",
    68: "440 양식에 비관리적 변경 사유를 선택했으나 manager 이상이 승인하지 않은 문서가 하나 이상 있습니다.",
    69: "440 양식에 engagement partner 또는 partner in charge가 sign-off 하지 않았습니다",
    70: "Archive 체크리스트에 있는 그룹 버튼에서 '링크 해제'를 클릭하십시오",
    71: "Canvas 양식에 머리글 또는 표준 내용이 없습니다",
    72: "유효성 검증을 해결하려면 How to clear validation checks in EY Canvas enabler에 있는 단계별 guidance를 활용하십시오",
    73: "미완료 응답의 수를 보려면 Canvas 양식에 있는 유효성 검증 아이콘을 클릭하십시오 ",
    74: "링크를 클릭하여 업데이트된 engagement 프로필.smt 버전을 제출하십시오",
    75: "유효성 검증을 해결하려면 How to clear validation checks in EY Canvas enabler에 있는 단계별 guidance를 활용하십시오",
    76: "유효성 검증을 해결하려면 How to clear validation checks in EY Canvas enabler에 있는 단계별 guidance를 활용하십시오",
    77: "유효성 검증을 해결하려면 How to clear validation checks in EY Canvas enabler에 있는 단계별 guidance를 활용하십시오",
    78: "유효성 검증을 해결하려면 How to clear validation checks in EY Canvas enabler에 있는 단계별 guidance를 활용하십시오",
    79: "유효성 검증을 해결하려면 How to clear validation checks in EY Canvas enabler에 있는 단계별 guidance를 활용하십시오",
    80: "유효성 검증을 해결하려면 How to clear validation checks in EY Canvas enabler에 있는 단계별 guidance를 활용하십시오",
    81: "IT 프로세스를 식별하여 IT application에 연결하십시오",
    82: "유효성 검증을 해결하려면 How to clear validation checks in EY Canvas enabler에 있는 단계별 guidance를 활용하십시오",
    83: "유효성 검증을 해결하려면 How to clear validation checks in EY Canvas enabler에 있는 단계별 guidance를 활용하십시오",
    84: "유효성 검증을 해결하려면 How to clear validation checks in EY Canvas enabler에 있는 단계별 guidance를 활용하십시오",
    85: "유효성 검증을 해결하려면 How to clear validation checks in EY Canvas enabler에 있는 단계별 guidance를 활용하십시오",
    86: "유효성 검증을 해결하려면 How to clear validation checks in EY Canvas enabler에 있는 단계별 guidance를 활용하십시오",
    87: "유효성 검증을 해결하려면 How to clear validation checks in EY Canvas enabler에 있는 단계별 guidance를 활용하십시오",
    88: "유효성 검증을 해결하려면 How to clear validation checks in EY Canvas enabler에 있는 단계별 guidance를 활용하십시오",
    89: "IT 프로세스 평가가 선택되지 않았거나 ITCG/ITSP 운영 효과성 평가와 모순됩니다",
    90: "통제에 설계 효과성 선택이 없습니다",
    91: "감사 관련 SCOT과 연결된 IT application 보기",
    92: "유효성 검증을 해결하려면 How to clear validation checks in EY Canvas enabler에 있는 단계별 guidance를 활용하십시오",
    93: "유효성 검증을 해결하려면 How to document the IT flow in EY Canvas enabler에 있는 단계별 guidance를 활용하십시오",
    94: "유효성 검증을 해결하려면 How to document the IT flow in EY Canvas enabler에 있는 단계별 guidance를 활용하십시오",
    95: "팀 관리에서 engagement 담당자로 식별된 특정 팀 멤버가 없습니다",
    96: "위험요소가 위험과 연결되지 않았거나 “ROMM 아님”으로 표시되지 않았습니다",
    97: "위험이 경영진주장과 연결되어 있지 않습니다",
    98: "예측 기준에 금액이 입력되어야 합니다",
    99: "예측 기준 근거가 입력되어야 합니다",
    100: "조정 기준에 금액이 입력되어야 합니다",
    101: "Planning materiality 백분율이 선택되지 않았습니다",
    102: "Planning materiality 백분율이 허용 가능한 범위를 벗어났습니다",
    103: "Planning Materiality 백분율을 선택한 근거가 입력되어야 합니다",
    104: "Tolerable error가 입력되지 않았습니다",
    105: "Tolerable error가 허용 가능한 범위를 벗어났습니다",
    106: "Tolerable error를 선택한 근거가 입력되어야 합니다",
    107: "SAD 백분율이 선택되지 않았습니다",
    108: "SAD 백분율이 허용 가능한 범위를 벗어났습니다",
    109: "SAD 백분율을 선택한 근거가 입력되어야 합니다",
    110: "유효성 검증을 해결하려면 How to clear validation checks in EY Canvas enabler에 있는 단계별 guidance를 활용하십시오",
    111: "유효성 검증을 해결하려면 How to clear validation checks in EY Canvas enabler에 있는 단계별 guidance를 활용하십시오",
    112: "유효성 검증을 해결하려면 How to clear validation checks in EY Canvas enabler에 있는 단계별 guidance를 활용하십시오",
    113: "유효성 검증을 해결하려면 How to clear validation checks in EY Canvas enabler에 있는 단계별 guidance를 활용하십시오",
    114: "유효성 검증을 해결하려면 How to clear validation checks in EY Canvas enabler에 있는 단계별 guidance를 활용하십시오",
    115: "유효성 검증을 해결하려면 How to clear validation checks in EY Canvas enabler에 있는 단계별 guidance를 활용하십시오",
    116: "유효성 검증을 해결하려면 How to clear validation checks in EY Canvas enabler에 있는 단계별 guidance를 활용하십시오",
    117: "유효성 검증을 해결하려면 How to clear validation checks in EY Canvas enabler에 있는 단계별 guidance를 활용하십시오",
    118: "유효성 검증을 해결하려면 How to clear validation checks in EY Canvas enabler에 있는 단계별 guidance를 활용하십시오",
    119: "유효성 검증을 해결하려면 How to clear validation checks in EY Canvas enabler에 있는 단계별 guidance를 활용하십시오",
    120: "유효성 검증을 해결하려면 How to clear validation checks in EY Canvas enabler에 있는 단계별 guidance를 활용하십시오",
    121: "유효성 검증을 해결하려면 How to clear validation checks in EY Canvas enabler에 있는 단계별 guidance를 활용하십시오",
    122: "유효성 검증을 해결하려면 How to clear validation checks in EY Canvas enabler에 있는 단계별 guidance를 활용하십시오",
    123: "유효성 검증을 해결하려면 How to clear validation checks in EY Canvas enabler에 있는 단계별 guidance를 활용하십시오",
    124: "유효성 검증을 해결하려면 How to clear validation checks in EY Canvas enabler에 있는 단계별 guidance를 활용하십시오",
    125: "보호 문서는 필요하지 않는 한 engagement 파일에 보관하면 안 됩니다",
    126: "문서를 삭제하고 재업로드하십시오",
    127: "유효성 검증을 해결하려면 How to clear validation checks in EY Canvas enabler에 있는 단계별 guidance를 활용하십시오",
    128: "유효성 검증을 해결하려면 How to clear validation checks in EY Canvas enabler에 있는 단계별 guidance를 활용하십시오",
    129: "유효성 검증을 해결하려면 How to clear validation checks in EY Canvas enabler에 있는 단계별 guidance를 활용하십시오",
    130: "유효성 검증을 해결하려면 How to clear validation checks in EY Canvas enabler에 있는 단계별 guidance를 활용하십시오",
    131: "추정치 목록 양식으로 이동하여 ‘문서 생성’ 옵션을 사용하십시오",
    132: "유효성 검증을 해결하려면 How to clear validation checks in EY Canvas enabler에 있는 단계별 guidance를 활용하십시오",
    133: "유효성 검증을 해결하려면 How to clear validation checks in EY Canvas enabler에 있는 단계별 guidance를 활용하십시오",
    134: "유효성 검증을 해결하려면 How to clear validation checks in EY Canvas enabler에 있는 단계별 guidance를 활용하십시오",
    135: "유효성 검증을 해결하려면 How to clear validation checks in EY Canvas enabler에 있는 단계별 guidance를 활용하십시오",
    136: "유효성 검증을 해결하려면 How to clear validation checks in EY Canvas enabler에 있는 단계별 guidance를 활용하십시오",
    137: "유효성 검증을 해결하려면 How to clear validation checks in EY Canvas enabler에 있는 단계별 guidance를 활용하십시오",
    138: "유효성 검증을 해결하려면 How to clear validation checks in EY Canvas enabler에 있는 단계별 guidance를 활용하십시오",
    139: "유효성 검증을 해결하려면 How to clear validation checks in EY Canvas enabler에 있는 단계별 guidance를 활용하십시오",
    140: "유효성 검증을 해결하려면 How to clear validation checks in EY Canvas enabler에 있는 단계별 guidance를 활용하십시오",
    141: "유효성 검증을 해결하려면 “How to clear validation checks in EY Canvas” enabler에 있는 단계별 guidance를 활용하십시오",
    142: "유효성 검증을 해결하려면 “How to clear validation checks in EY Canvas” enabler에 있는 단계별 guidance를 활용하십시오",
    143: "유효성 검증을 해결하려면 “How to clear validation checks in EY Canvas” enabler에 있는 단계별 guidance를 활용하십시오",
    144: "유효성 검증을 해결하려면 “How to clear validation checks in EY Canvas” enabler에 있는 단계별 guidance를 활용하십시오",
    145: "유효성 검증을 해결하려면 “How to clear validation checks in EY Canvas” enabler에 있는 단계별 guidance를 활용하십시오",
    146: "유효성 검증을 해결하려면 “How to clear validation checks in EY Canvas” enabler에 있는 단계별 guidance를 활용하십시오",
    147: "유효성 검증을 해결하려면 “How to clear validation checks in EY Canvas” enabler에 있는 단계별 guidance를 활용하십시오",
    148: "유효성 검증을 해결하려면 “How to clear validation checks in EY Canvas” enabler에 있는 단계별 guidance를 활용하십시오",
    149: "미완료 Canvas 양식 응답 마무리 유효성 검증 링크를 클릭하십시오. 각 Canvas 양식을 열어 요건에 연결된 모든 필수 문서에 관련 PIC/EQR sign-off가 있는지 확인하십시오. 귀하가 작성하거나 검토한 파일에만 sign-off 하십시오.",
    150: "미완료 Canvas 양식 응답 마무리 유효성 검증 링크를 클릭하십시오. 각 Canvas 양식을 열어 요건에 연결된 모든 필수 문서에 PIC/EQR sign-off 요건이 연결되었는지 확인하십시오.",
    151: "모든 유의적인 계정 및 공시에 경영진주장이 하나 이상 있는지 확인하십시오",
    152: "각 Canvas 양식을 열어 요건에 연결된 모든 필수 문서에 작성자 및 검토자 sign-off가 있는지 확인하십시오. 귀하가 작성하거나 검토한 파일에만 sign-off 하십시오.",
    153: "조정사항으로 이동하여 “증거 추가” 옵션으로 적합한 증거를 연결하십시오",
    154: "추정치 문서로 이동하여 높은/낮은 위험 추정치에 연결된 추정치 계정이 있는지 확인하십시오. 매우 낮은 위험 추정치에는 계정이 하나 이상 연결되어 있어야 합니다.",
    155: "추정치 문서로 이동하여 연결된 계정을 확인하십시오. 감사 문서화에 따라 비추정치 계정을 연결 해제하거나 추정치 계정으로 수정하십시오.",
    156: "추정치 문서로 이동하여 응답을 확인하십시오",
    157: "추정치 문서로 이동하여 높은/낮은 위험 추정치에 연결된 추정 SCOT이 있는지 확인하십시오. 매우 낮은 위험 추정치에는 SCOT이 하나 이상 연결되어 있어야 합니다.",
    158: "계정 문서로 이동하여 높은 또는 낮은 위험 추정치가 하나 이상 연결되어 있는지 확인하십시오",
    159: "계정 문서로 이동하여 높은 또는 낮은 위험 추정치가 하나 이상 연결되어 있는지 확인하십시오",
    160: "추정치 리드 시트로 이동하여 추정치가 연결되지 않은 추정 SCOT을 식별하십시오. 감사 문서화에 따라 그러한 SCOT을 비추정으로 수정하거나 추정치를 연결하십시오.",
    161: "조정사항으로 이동하여 차변 분개 합계가 대변 분개 합계와 같은지 확인하십시오",
    162: "추정치 문서로 이동하여 유의적인 위험 또는 부정 위험이 하나 이상 연결되어 있는지 확인하십시오",
    163: '이 유효성 검증을 해결하려면 "How to clear validation checks in EY Canvas" enabler에 있는 단계별 guidance를 활용하십시오',
    164: '이 유효성 검증을 해결하려면 "How to clear validation checks in EY Canvas" enabler에 있는 단계별 guidance를 활용하십시오',
    165: '이 유효성 검증을 해결하려면 "How to clear validation checks in EY Canvas" enabler에 있는 단계별 guidance를 활용하십시오',
    166: "추정치 문서로 이동하여 연결된 위험을 확인하십시오. 감사 문서화에 따라 유의적인/부정 위험을 연결 해제하거나 추정치 범주를 Higher risk로 업데이트하십시오."
};

export const validationChecksReportHeaderLabels = {
    validationType: "검증 유형",
    validationDescription: "검증 설명",
    itemName: "항목 이름",
    auditPhase: "감사 단계",
    additionalInformation: "추가 정보",
    localization: "로컬본",
    itemType: "항목 유형",
    location: labels.location,
    count: "수",
    validationCount: "검증 수",
    itemID: "항목 ID",
    validationTypeID: "검증 유형 ID",
    category: "범주",
    auditPhaseID: "감사 단계 ID",
    entity: labels.filterEntitiesLabel
};


export const ReviewNotesReportHeaderLabel = {
    annotationID: "주석 ID",
    assignToUserID: "담당 사용자 ID",
    assignedtoUser: labels.assignedTo,
    createUserID: "작성자 ID",
    createdBy: "작성자",
    createdDate: "생성일",
    dueDateLabel: "만료일",
    relatedEvidence: "연결된 증거",
    reviewNote: labels.reviewNotesLabel,
    lastModifiedBy: "최근에 수정한 사람",
    modifyUserID: "수정한 사용자 ID",
    lastModifiedOnLabel: "최근 수정된 날짜",
    priorityType: labels.priorityLabel,
    annotationParentID: "Parent 주석 ID",
    referenceNumber: "참조",
    relatedTasks: "연결된 task",
    replies: labels.reply,
    reviewNoteStatus: labels.status,
    statusChangedByUserID: "상태 변경한 사용자 ID",
    statusChangedBy: "상태를 변경한 사람",
    statusChangedDateLabel: "상태 변경한 사람",
    startDateLabel: "(UTC 기준) 처음 생성됨",
    clearedDateLabel: "(UTC 기준) 최근 처리됨",
    closedDateLabel: "(UTC 기준) 최근 닫힘",
    documentTypeID: "상태 변경 날짜",
    childAnnotationID: "문서 유형 ID"
};

export const taskDueDateCategoryIdLabels = {
    0: "과거 주간",
    1: "이번 주",
    2: "다음 주",
    3: "미래 주간"
};

export const taskSummaryReportHeaderLabels = {
    engagementID: "Engagement ID",
    taskID: "Task ID",
    displayedTaskName: labels.TaskName,
    taskNamePrefix: "Task Prefix",
    taskNameSuffix: "Task Suffix",
    dueDateColumn: labels.taskDueDateHeader,
    dueDateWeek: labels.dueLabel,
    assignmentType: labels.assignmentType,
    assignmentTypeID: "배정 유형 ID",
    assignmentName: labels.assignmentName,
    assignmentStatus: labels.taskAssigmentStatusHeader,
    reviewNoteAssignedOpen: "배정된 처리 전 리뷰노트",
    reviewNoteAssignedCleared: "배정된 처리된 리뷰노트",
    reviewNoteAuthoredOpen: "작성된 처리 전 리뷰노트",
    reviewNoteAuthoredCleared: "작성된 처리된 리뷰노트",
    taskStatus: labels.taskStatusLabel,
    taskStatusID: "Task 상태 ID",
    taskType: labels.taskType,
    taskTypeID: "Task 유형 ID",
    milestone: labels.filterMilestoneLabel,
    milestoneID: "Milestone ID",
    isOverdueColumn: labels.Overdue,
    timephaseName: labels.timephase,
    relatedObjectName: "연결된 object",
    relatedEntityID: "연결된 object ID",
    openAssignmentsOverdue: "처리 전 배정-지연됨",
    openAssignmentsThisWeek: "처리 전 배정-이번 주",
    openAssignmentsNextWeek: "처리 전 배정-다음 주",
    openAssignmentsTotal: "처리 전 배정-합계",
    inProgressAssignmentsOverdue: "진행 중 배정-지연됨",
    inProgressAssignmentsThisWeek: "진행 중 배정-이번 주",
    inProgressAssignmentsNextWeek: "진행 중 배정-다음 주",
    inProgressAssignmentsTotal: "진행 중 배정-합계"
};

export const crtControlSummaryReportHeaderLabels = {
    scotID: "SCOT ID",
    scotName: "SCOT",
    strategyTypeName: "전략 유형",
    wcgwID: "WCGW ID",
    wcgwName: "WCGW",
    controlID: "통제 ID",
    controlName: "통제",
    operatingEvaluation: "운영 평가",
    assertions: "경영진주장",
    controlTypeName: "통제 유형",
    testingFormatted: "테스트 선택",
    scotStrategy: "SCOT 전략",
    itApplicationName: "연결된 IT App/SO",
    controlFrequencyTypeName: "빈도",
    scotTypeID: "SCOT 유형 ID",
    scotTypeName: "SCOT 유형",
    itAppType: "IT/SO Application",
    lowerRiskControl: "위험이 lower인 통제"
};

export const trialBalanceReportHeaderLabels = {
    engagementID: "Engagement ID",
    trialBalanceID: "시산표 ID",
    trialBalanceTypeID: "시산표 유형 ID",
    trialBalanceTypeName: "시산표 유형 이름",
    financialStatementID: "재무제표 ID",
    financialStatementName: "재무제표 이름",
    financialStatementTypeID: "재무제표 유형 ID",
    financialStatementTypeName: "재무제표 유형 이름",
    financialStatementSubTypeID: "재무제표 하위유형 ID",
    financialStatementSubTypeName: "재무제표 하위유형 이름",
    analysisPeriodBalance: "분석일 잔액",
    comparativePeriodBalance: "비교일 잔액",
    analysisComparativeBalanceChange: "분석 비교 잔액 변동",
    analysisComparativeBalanceChangePercent: "분석 비교 잔액 변동 퍼센트",
    secondComparativePeriodBalance: "이차 비교일 잔액",
    analysisSecondComparativeBalanceChange: "분석 두 번째 비교 잔액 변동",
    analysisSecondComparativeBalanceChangePercent: "분석 두 번째 비교 잔액 변동 퍼센트",
    parentFinancialStatementID: "지배기업 재무제표 ID",
    displayOrder: "표시 순서",
    eyCanvasAccountName: "EY Canvas 계정 이름",
    relatedEntities: "연결된 기업"
};

export const taskSourceTypes = {
    1: labels.internal,
    2: labels.external
};

export const taskNatureTypes = {
    1: labels.testOfDetail,
    2: labels.substantiveAnalyticalProcedure,
    3: labels.testOfControl
};

export const priorityTypesCollaboration = [{
        value: 1,
        label: "Normal"
    },
    {
        value: 3,
        label: "High"
    },
    {
        value: 4,
        label: "Critical"
    }
];

export const StatementType = [{
    id: 1,
    value: "손익계산서"
}, {
    id: 2,
    value: "재무상태표"
}, {
    id: 3,
    value: "둘 다"
}];

export const AccountTypes = [{
        id: 1,
        accountTypeName: "유의적"
    },
    {
        id: 2,
        accountTypeName: "Limited risk"
    },
    {
        id: 3,
        accountTypeName: "비유의적"
    },
    {
        id: 4,
        accountTypeName: "기타"
    },
    {
        id: 5,
        accountTypeName: "유의적인 공시"
    }
];

export const ITAppSOAttributes = [{
    id: 1,
    value: "테스트 선택"
}, {
    id: 2,
    value: "연결된 IT App/SO"
}, {
    id: 3,
    value: "연결된 SCOT"
}, {
    id: 4,
    value: "연결된 SCOT 전략"
}, {
    id: 5,
    value: "연결된 SCOT 유형"
}];

export const notesEditorLabels = {
    addNoteButtonLabel: reviewNoteModalLabels?.addNewReviewNoteButtonText,
    saveNoteButtonLabel: labels.saveLabel,
    messagePlaceholder: labels.addNewNoteModalTitle,
    messagePlaceholderReply: reviewNoteModalLabels?.replyInputPlaceholder,
    messagePlaceholderEdit: reviewNoteModalLabels?.noteInputPlaceholderEdit,
    messagePlaceholderReplyEdit: reviewNoteModalLabels?.replyInputPlaceholderEdit,
    addReplyButtonLabel: reviewNoteModalLabels?.reply,
    characters: labels.characters,
    of: labels.of,
    formRequired: labels.required,
    formMaxLength: labels.formMaxLength,
    toFieldLabel: labels.assignedTo,
    priorityFieldLabel: labels.rnhPriority,
    dueDateFieldLabel: labels.dueDate,
    voiceNoteButtonLabel: labels.voiceNoteButtonLabel,
    stopRecordingButtonLabel: labels.stopRecordingButtonLabel,
    cancelButtonLabel: labels.cancelButtonLabel,
    noResultsFound: labels.noResultsFound,
    microphoneBlockedMessage: labels.microphoneBlockedMessage,
    microphoneBlockedOnVideoMessage: labels.microphoneBlockedOnVideoMessage,
    notInMainWindowVoice: labels.notInMainWindowVoice,
    notInMainWindowScreen: labels.notInMainWindowScreen,
    voiceNoteNotAvailable: "드로어 보기에서 음성 노트와 화면 기록을 사용할 수 없습니다. 이러한 기능을 사용하려면 전체 화면 보기로 바꾸십시오.",
    deleteButtonTitle: labels.voiceNoteCommentDeleteLabel,
    playButtonTitle: labels.voiceNoteCommentPlayLabel,
    pauseButtonTitle: labels.voiceNoteCommentStopLabel,
    screenRecord: labels.screenRecord,
    playbackReview: labels.playbackReview,
    close: labels.reviewNotesModalClose
};


export const noteModalLabels = {
    ...notesEditorLabels,
    closeButton: labels.reviewNotesModalClose,
    closed: labels.closed,
    open: labels.open,
    cleared: labels.cleared,
    allNotes: labels.allNotes,
    myNotes: labels.myNotes,
    assignedToMe: labels.assignedToMe,
    noNotesFound: reviewNoteModalLabels?.noNotesFound,
    noNotesFoundInstructional: reviewNoteModalLabels?.noNotesAssociatedWithDocumentLabel,
    assignedTo: labels.assignedTo,
    dueDate: labels.dueDate,
    edit: labels.edit,
    delete: labels.delete,
    clear: labels.clear,
    reopen: labels.reopen,
    close: labels.closeTitle,
    reply: labels.reply,
    confirm: labels.confirm,
    cancel: labels.cancelButtonLabel,
    deleteModalHeaderNote: reviewNoteModalLabels?.deleteIconModalTitleLabel,
    deleteModalHeaderReply: reviewNoteModalLabels?.deleteReplyIconModalTitle,
    deleteModalTextNote: reviewNoteModalLabels?.deleteIconModalConfirmMessageParent,
    deleteModalTextReply: reviewNoteModalLabels?.deleteIconModalConfirmMessage,
    showMore: reviewNoteModalLabels?.showMore,
    showLess: reviewNoteModalLabels?.showLess,
    view: labels.view,
    notSelected: labels.notSelectedText,
    deleteButtonTitle: labels.voiceNoteCommentDeleteLabel,
    playButtonTitle: labels.voiceNoteCommentPlayLabel,
    pauseButtonTitle: labels.voiceNoteCommentStopLabel
};

export const EntitiesLabels = {
    close: "닫기",
    cancel: "취소",
    repNoRecordMessage: "결과를 찾을 수 없습니다",
    edit: "편집",
    delete: "삭제",
    actions: "작업",
    show: "표시",
    first: "첫 페이지",
    last: "마지막 페이지",
    prev: "이전 페이지",
    next: "다음 페이지",

    [Entity.Account]: {
        manageEntity: "계정 및 공시 관리",
        searchEntity: "계정 검색",
        createEntity: "신규 계정",
        entityName: "계정",
        entityNameCaps: "계정",
        entityNamePlural: "계정",
        placeholderText: "신규 계정 및 공시를 생성하거나, 아니면 아래 기존 계정 및 공시를 편집하거나 삭제하십시오",
        deleteConfirmLabel: "이 계정을 삭제하시겠습니까? 기존 연결은 모두 제거됩니다. 이 작업은 실행 취소할 수 없습니다."
    },
    [Entity.Estimate]: {
        manageEntity: "추정치 관리",
        searchEntity: "추정치 검색",
        createEntity: "신규 추정치",
        entityName: "추정치",
        entityNameCaps: "추정치",
        entityNamePlural: "추정치",
        placeholderText: "신규 추정치를 생성하거나 아래 기존 추정치를 편집하거나 삭제하십시오",
        deleteConfirmLabel: "이 추정치를 삭제하시겠습니까? 기존 연결은 모두 제거됩니다. 이 작업은 실행 취소할 수 없습니다."
    },
    [Entity.Risk]: {
        manageEntity: "위험 관리",
        searchEntity: "위험 검색",
        createEntity: "신규 위험",
        entityName: "위험",
        entityNameCaps: "위험",
        entityNamePlural: "위험",
        placeholderText: "신규 위험을 생성하거나 아래 기존 위험을 편집하거나 삭제하십시오",
        deleteConfirmLabel: "이 위험을 삭제하시겠습니까? 기존 연결은 모두 제거됩니다. 이 작업은 실행 취소할 수 없습니다."
    },
    [Entity.STEntity]: {
        manageEntity: "기업 관리",
        searchEntity: "기업 검색",
        createEntity: "신규 기업",
        entityName: "기업",
        entityNameCaps: "기업",
        entityNamePlural: "기업",
        placeholderText: "신규 기업을 생성하거나, 아래 기존 기업을 편집하거나 삭제하십시오",
        deleteEntity: "기업 삭제",
        deleteConfirmLabel: "이 기업을 삭제하시겠습니까? 기존 연결은 모두 제거됩니다. 이 작업은 실행 취소할 수 없습니다."
    },
    [Entity.Control]: {
        manageEntity: "통제 관리",
        searchEntity: "통제 검색",
        createEntity: "신규 통제",
        entityName: "통제",
        entityNameCaps: "통제",
        entityNamePlural: "통제",
        placeholderText: "신규 통제를 생성하거나, 아래 기존 통제를 편집하거나 삭제하십시오",
        deleteEntity: "통제 삭제",
        deleteConfirmLabel: "이 통제를 삭제하시겠습니까? 기존 연결은 모두 제거됩니다. 이 작업은 실행 취소할 수 없습니다."
    },
    [Entity.SCOT]: {
        manageEntity: "SCOT 관리",
        searchEntity: "SCOT 검색",
        createEntity: "신규 SCOT",
        entityName: "SCOT",
        entityNameCaps: "SCOT",
        entityNamePlural: "SCOT",
        placeholderText: "신규 SCOT을 생성하거나, 아래 기존 SCOT을 편집하거나 삭제하십시오",
        deleteEntity: "SCOT 삭제",
        deleteConfirmLabel: "이 SCOT을 삭제하시겠습니까? 기존 연결은 모두 제거됩니다. 이 작업은 실행 취소할 수 없습니다."
    },
    [Entity.ITApplication]: {
        manageEntity: "IT application 관리",
        searchEntity: "검색",
        createEntity: "신규 IT application",
        entityName: "IT application",
        entityNameCaps: "IT application",
        entityNamePlural: "IT application",
        placeholderText: "신규 IT application을 생성하거나 아래 기존 IT application을 편집하거나 삭제하십시오",
        deleteEntity: "IT application 삭제",
        deleteConfirmLabel: "이 IT application을 삭제하시겠습니까? 기존 연결은 모두 제거됩니다. 이 작업은 실행 취소할 수 없습니다."
    },
    [Entity.TaskSection]: {
        manageEntity: "Task 그룹 관리",
        searchEntity: "Task 그룹 검색",
        createEntity: "신규 task 그룹",
        entityName: "Task 그룹",
        entityNameCaps: "Task 그룹",
        entityNamePlural: "Task 그룹",
        placeholderText: "신규 task 그룹을 생성하거나, 아래 기존 task 그룹을 편집하거나 삭제하십시오",
        deleteEntity: "Task 그룹 삭제",
        deleteConfirmLabel: "선택한 조정을 삭제하시겠습니까? 이 작업은 실행 취소할 수 없습니다."
    },
    [Entity.WCGW]: {
        manageEntity: "WCGW 관리",
        searchEntity: "WCGW 검색",
        createEntity: "신규 WCGW",
        entityName: "WCGW",
        entityNameCaps: "WCGW",
        entityNamePlural: "WCGW",
        placeholderText: "신규 WCGW을 생성하거나 아래 기존 WCGW을 편집하거나 삭제하십시오",
        deleteEntity: "WCGW 삭제",
        deleteConfirmLabel: "이 WCGW을 삭제하시겠습니까? 기존 연결은 모두 제거됩니다. 이 작업은 실행 취소할 수 없습니다."
    },
    [Entity.Misstatement]: {
        manageEntity: "조정사항 관리",
        searchEntity: "조정사항 검색",
        createEntity: "신규 조정사항",
        entityName: "조정",
        entityNameCaps: "조정",
        entityNamePlural: "조정사항",
        placeholderText: "신규 조정사항을 생성하거나, 아래 기존 조정사항을 편집하거나 삭제하십시오",
        deleteConfirmLabel: "선택한 조정을 삭제하시겠습니까? 이 작업은 실행 취소할 수 없습니다."
    },
    [Entity.AdjustmentValidation]: {
        manageEntity: "유효성 검증이 있는 조정사항 관리",
        searchEntity: "검색",
        entityName: "조정사항",
        entityNameCaps: "조정사항",
        entityNamePlural: "조정사항",
		placeholderText: '각 조정사항은 증거가 하나 이상 연결되어야 하며 각 조정사항 차변 합계가 대변 합계와 같아야 합니다. 다음 조정사항에는 유효성 검증 문제가 하나 이상 있습니다. <b>"편집"</b>을 클릭하여 해결하십시오.',
        deleteConfirmLabel: "선택한 조정을 삭제하시겠습니까? 이 작업은 실행 취소할 수 없습니다.",
        adjustmentHeader: "조정",
        validationTyeHeader: "검증 유형",
        validationTypeAmtMissmatch: "차변 합계가 대변 합계와 같지 않습니다",
        validationTypeNoEvidence: "연결된 증거 없음"
    },
    [Entity.SampleItem]: {
        manageEntity: "표본 태그 관리",
        searchEntity: "태그 검색",
        createEntity: "신규 태그",
        createManageTagEntity: "태그 그룹 관리",
        entityName: "태그",
        entityNamePlural: "태그",
        entityNameForTagGroupPlural: "태그 그룹",
        placeholderText: "신규 태그를 생성하거나 아래 기존 태그를 편집하거나 삭제하십시오"
    },
    [Entity.SampleTagGroups]: {
        manageEntity: "표본 태그 그룹 관리",
        searchEntity: "검색",
        createEntity: "신규 태그 그룹",
        entityName: "태그 그룹",
        entityNameCaps: "태그 그룹",
        entityNamePlural: "태그 그룹",
        placeholderText: "신규 표본 태그 그룹을 생성하거나 아래 기존 표본 태그 그룹을 편집하거나 삭제하십시오",
    }
};

export const executionType = [{
        id: 1,
        label: '',
        toolTip: '',
        value: "이 engagement"
    },
    {
        id: 2,
        label: 'CT',
        toolTip: "다른 engagement에 있는 절차 [PT-only]",
        value: "다른 engagement [PT-only]"
    },
    {
        id: 3,
        label: 'PT/CT',
        toolTip: "이 engagement 및 다른 engagement에 있는 절차 [PT-only]",
        value: "이 enagement 및 다른 engagement [PT-only]"
    }
];

export const AccountType = [{
        id: 1,
        accounttypename: "유의적인 계정"
    },
    {
        id: 2,
        accounttypename: "Limited risk 계정"
    },
    {
        id: 3,
        accounttypename: "비유의적인 계정"
    },
    {
        id: 4,
        accounttypename: "기타 계정"
    },
    {
        id: 5,
        accounttypename: "유의적인 공시"
    }
];

export const statementTypes = [{
        id: 1,
        name: "손익계산서"
    },
    {
        id: 2,
        name: "재무상태표"
    },
    {
        id: 3,
        name: "둘 다 "
    }
];

export const CreateEditAccountLabels = {
    createModalDescription: "아래에 신규 계정 세부정보를 입력하고 '<b>{0}</b>'을(를) 선택하여 마칩니다. 다른 계정을 생성하려면, '<b>{1}</b>'을(를) 선택하십시오.",
    editModalDescription: "아래에서 계정 세부정보를 편집하고 '<b>{0}</b>'을(를) 선택하여 마칩니다.",
    close: "닫기",
    cancel: "취소",
    yes: "예",
    no: "아니오",
    createAccount: "신규 계정",
    editAccount: "계정 편집",
    delete: "삭제",
    save: "저장",
    saveAndCloseLabel: "저장 및 닫기",
    saveAndCreateLabel: "저장 및 추가 생성",
    accountNameLabel: "계정 이름 (필수)",
    accountDesignationLabel: "지정",
    accountExecutionTypeLabel: "이 계정에 대한 절차는 어느 Canvas engagement에서 수행되고 문서화됩니까?",
    accountEstimateLabel: "추정치가 이 계정에 영향을 미칩니까?",
    accountStatementTypeLabel: "재무제표 유형",
    pspIndexDropdownLabel: "PSP index (필수, 5개까지 선택)",
    removePSPIndexLabel: "PSP index 제거",
    assertionsLabel: "관련 경영진주장을 선택하십시오",
    assertionOptions: assertions,
    executionTypeOptions: executionType,
    accountTypeOptions: AccountType,
    statementTypeOptions: statementTypes,
    confirm: "확인",
    pspIndexErrorMsg: "필수",
    assertionWarningMessage: "유의적인 위험, 부정위험, 중요왜곡표시위험 또는 추정치가 연결된 경영진주장은 변경할 수 없습니다. 이러한 연결을 먼저 제거해야 합니다.",
    confirmChanges: "변경사항 확인",
    executionTypeWarningMessage: "이 계정에 저장하려는 변경사항은 기존 경영진주장 및 PSP에 영향을 미쳐 링크가 끊어질 것입니다. 계속 진행하시겠습니까? 이 작업은 실행 취소할 수 없습니다.",
    contentUpdateToastMessage: "{0}에 대해 내용을 업데이트할 수 있습니다. 내용 업데이트 페이지에서 내용 업데이트를 개시하십시오.",
    assertionsRequired: "경영진주장을 하나 이상 선택해야 합니다",
    pspIndexDisabledLabel: "PSP index를 다섯개까지 선택합니다. 계속하려면 옵션을 하나 이상 선택 해제합니다.",
    newSignificantDisclosure: "신규 유의적인 공시",
    noOptionsMessage: "결과를 찾을 수 없습니다",
    accountNameErrorMsg: "필수 "
};

export const CreateMestLabels = {
    createModalTitle: "신규 기업",
    createModalDescription: "아래에 기업을 입력하고 '<b>{0}</b>'을(를) 선택하여 마칩니다. 다른 기업을 생성하려면 '<b>{1}</b>'을(를) 선택하십시오. 기업은 감사 접근법을 어떻게 계획하는지에 따라, 법인이 아닌 사업부나 다른 조합일 수 있습니다.",
    close: "닫기",
    cancel: "취소",
    save: "저장",
    saveAndCloseLabel: "저장 및 닫기",
    saveAndCreateLabel: "저장 및 추가 생성",
    entityNameLabel: "기업 이름",
    entityStandardIndexLabel: "기업 표준 Index",
    entityDescriptionLabel: "기업 설명 (선택사항)",
    entityNameErrorMsg: "필수",
    entityStandardIndexErrorMsg: "필수 "
}

export const CreateEditSCOTLabels = {
    createModalTitle: "신규 SCOT",
    editModalTitle: "SCOT 편집",
    createModalDescription: "아래에 신규 SCOT 세부정보를 입력하고 '<b>{0}</b>'을(를) 선택하여 마칩니다. 다른 SCOT을 생성하려면, '<b>{1}</b>'을(를) 선택하십시오.",
    editModalDescription: "아래에서 SCOT 세부정보를 편집하고 ‘<b>{0}</b>’을(를) 선택하여 마칩니다",
    close: "닫기",
    cancel: "취소",
    save: "저장",
    saveAndCloseLabel: "저장 및 닫기",
    saveAndCreateLabel: "저장 및 추가 생성",
    scotNameLabel: "SCOT 이름 (필수)",
    scotStrategyLabel: "SCOT 전략",
    scotTypeLabel: "SCOT 유형",
    scotTypeOptions: scotTypes,
    hasEstimateLabel: "추정치가 이 SCOT에 영향을 미칩니까?",
    itAPPUsedLabel: "사용된 IT application 없음",
    routine: "일상적",
    nonRoutine: "비일상적",
    controls: "통제",
    substantive: "실증",
    yes: "예",
    scotNameErrorMsg: "필수",
    remove: "제거",
    noOptionsMessage: "결과를 찾을 수 없습니다",
    wtDetailPrefix: "<p>매 기간마다 walkthrough 절차를 수행하여 모든 일상적 및 비일상적 SCOT과 유의적인 공시 프로세스에 대한 이해를 확인합니다. 또한, PCAOB 감사인 경우, 추정 SCOT에 대해 walkthrough 절차를 수행합니다.<br/>통제 의존 전략을 취하는 경우 모든 SCOT과, 유의적인 위험에 대응하는 통제에 대해, 관련 통제가 적합하게 설계되고 구축되었는지 확인합니다. 통제 의존 전략이 여전히 적합한 결정인지 확인합니다.<br/><br/>SCOT의 운영이 조서에 정확하게 설명되어 있고, IT 사용으로 발생하는 위험 등 적합한 WCGW 및 (해당하는 경우) 관련 통제를 모두 식별했는지 결론 내립니다.<br/><br/> 실증 단독 전략을 사용하는 추정 SCOT인 경우 실증절차에 기초하여 추정 SCOT에 대한 이해가 적합한지 확인합니다.</p>",
    disabledTabTooltipMessage: "IT application을 연결하려면 “사용된 IT application 없음” 선택을 해제하십시오",
    itAppLabels: {
        tabLabel: "IT App",
        dropdownLabel: "IT application 연결",
        noRelatedItems: "연결된 IT Application 없음",
        itApplications: "IT Application"
    },
    soLabels: {
        tabLabel: "SO",
        dropdownLabel: "서비스조직 연결",
        noRelatedItems: "연결된 서비스조직 없음",
        serviceOrganizations: "서비스조직"
    }
};

export const CreateEditWCGWLabels = {
    wcgwName: "WCGW 이름 (필수)",
    editWCGW: "WCGW 편집",
    editTheWCGW: "아래에서 WCGW 세부정보를 편집하고 ‘<b>{0}</b>’을(를) 선택하여 마칩니다",
    createNewWCGW: "아래에 신규 WCGW 세부정보를 입력하고 ‘<b>{0}</b>’을(를) 선택하여 마칩니다. 다른 WCGW을 생성하려면, '<b>{1}</b>'을(를) 선택하십시오.",
    createEditWCGWModelScot: "SCOT",
    newWCGWTitel: "New WCGW",
    editWCGWSave: "저장",
    editWCGWClose: "취소",
    closeTitle: "닫기",
    wcgwNameIsRequired: "필수",
    saveAndCloseLabel: "저장 및 닫기",
    saveAndCreateLabel: "저장 및 추가 생성"
};

export const controlFrequencyTypes = [{
        value: 1,
        label: "하루에 여러 번"
    },
    {
        value: 2,
        label: "매일"
    },
    {
        value: 3,
        label: "매주"
    },
    {
        value: 4,
        label: "매월"
    },
    {
        value: 5,
        label: "매분기"
    },
    {
        value: 6,
        label: "매년"
    },
    {
        value: 8,
        label: "기타"
    }
];

export const controlTypes = [{
        value: 1,
        label: "IT Application 통제"
    },
    {
        value: 2,
        label: "IT 의존 수동 통제"
    },
    {
        value: 3,
        label: "수동 예방"
    },
    {
        value: 4,
        label: "수동 적발"
    }
];

export const CreateEditControlLabels = {
    createModalTitle: "신규 통제",
    editModalTitle: "통제 편집",
    close: "닫기",
    cancel: "취소",
    save: "저장",
    saveAndCloseLabel: "저장 및 닫기",
    saveAndCreateLabel: "저장 및 추가 생성",
    controlNameLabel: "통제 이름 (필수)",
    frequency: "빈도",
    controlType: "통제 유형",
    frequencyTypeOptions: controlFrequencyTypes,
    controlTypeOptions: controlTypes,
    designEffectiveness: "설계 효과성",
    operatingEffectiveness: "운영 효과성",
    testingLabel: "테스트",
    lowerRiskLabel: "통제가 낮은 위험입니까?",
    ITDMControlSubstantiveTestingOptionLabel: "이 ITDM 통제의 자동화 부분은 시스템 생성 보고서의 사용 뿐이며 실증 테스트됩니다",
    effective: "효과적",
    ineffective: "비효과적",
    yes: "예",
    no: "아니오",
    required: "필수",
    remove: "제거",
    noOptionsMessage: "결과를 찾을 수 없습니다",
    disabledTabTooltipMessage: "“통제 유형”을 “IT Application 통제” 혹은 “IT 의존 수동 통제”로 선택하여 IT Application을 연결하십시오",
    itAppLabels: {
        tabLabel: "IT App",
        dropdownLabel: "IT application 연결",
        noRelatedItems: "연결된 IT Application 없음",
        itApplications: "IT Application"
    },
    soLabels: {
        tabLabel: "SO",
        dropdownLabel: "서비스조직 연결",
        noRelatedItems: "연결된 서비스조직 없음",
        serviceOrganizations: "서비스조직"
    },
    controlNameErrorMsg: "필수",
    createModalDescriptionLabel: "아래에 신규 통제 세부정보를 입력하고 ‘<b>{0}</b>’을(를) 선택하여 마칩니다. 다른 통제를 생성하려면, '<b>{1}</b>'을(를) 선택하십시오.",
    editModalDescriptionLabel: "아래에서 통제 세부정보를 편집하고 ‘<b>{0}</b>’을(를) 선택하여 마칩니다",
    wcgwLabel: "WCGW"
};

export const CreateEditITApplicationLabels = {
    close: "닫기",
    cancel: "취소",
    yes: "예",
    no: "아니오",
    delete: "삭제",
    save: "저장",
    closeTitle: "닫기",
    saveAndCloseLabel: "저장 및 닫기",
    saveAndCreateLabel: "저장 및 추가 생성",
    iTApplicationNameLabel: "IT application 이름 (필수)",
    iTSOApplicationNameLabel: "서비스 조직 이름",
    newITApplicationLabel: "신규 IT application",
    newITSOApplicationLabel: "신규 서비스 조직",
    editITApplicationLabel: "IT application 편집",
    confirm: "확인",
    confirmChanges: "변경사항 확인",
    noOptionsMessage: "결과를 찾을 수 없습니다",
    iTAppNameErrorMsg: "필수",
    iTSOAppNameErrorMsg: "필수",
    controls: "통제",
    substantive: "실증",
    remove: "제거",
    iTApplicationStrategyLabel: "IT application 전략",
    SCOTsLabel: "SCOT 이름",
    StrategyLabel: "전략",
    ControlsLabel: "통제 이름",
    ControlTypeLabel: "유형",
    addDescriptionLabel: "아래에 신규 IT application 세부정보를 입력하고 '<b>{0}</b>'을(를) 선택하여 마칩니다. 다른 IT application을 생성하려면, '<b>{1}</b>'을(를) 선택하여 마칩니다.",

    editDescriptionLabel: "아래에서 IT application 세부정보를 편집하고 ‘<b>{0}</b>’을(를) 선택하여 마칩니다",

    addSODescriptionLabel: "아래에 신규 서비스조직 세부정보를 입력하고 '<b>저장 및 닫기</b>’를 선택하여 마칩니다. 다른 서비스조직을 생성하려면, ‘<b>저장 및 추가 생성</b>'을 선택하십시오.",

    scotErrorMessage: "통제가 연결되어 있기 때문에 IT application에서 SCOT 연결을 해제할 수 없습니다",
    SCOTsLabels: {
        tabLabel: "SCOT",
        dropdownLabel: "SCOT 연결",
        noRelatedItems: "연결된 SCOT 없음"
    },
    ControlsLabels: {
        tabLabel: "통제",
        dropdownLabel: "통제 연결",
        noRelatedItems: "연결된 통제 없음"
    },
    strategyType: {
        1: "통제",
        2: "실증",
        3: "Rely",
        4: "Not Rely"
    },
    controlType: {
        1: "IT Application",
        2: "IT 의존 수동",
        3: "수동 예방",
        4: "수동 적발"
    }
};

export const groupComponentAccountReportHeaderLabels = {
    primaryEngagementId: "Engagement ID",
    gaScopeName: "범위",
    gaComponentId: "GA 부문 ID",
    shortName: "부문 이름",
    pocText: "연락처",
    accountId: "계정 ID",
    accountName: "계정 이름",
    accountType: "계정 지정",
    knowledgeAssertion: "경영진주장",
    inherentRiskType: "고유 위험",
    riskId: "위험 ID",
    riskType: "위험 유형",
    riskName: "위험 이름",
    isHigherRiskText: "높은 위험입니까?"
};

export const AccountTypeIDs = {
    1: "유의적인 계정",
    2: "Limited Risk 계정",
    3: "비유의적인 계정",
    4: "계정 - 기타",
    5: "유의적인 공시 "
};

export const InherentRiskTypeIDs = {
    1: "Higher",
    2: "Lower",
    3: "Very Low"
};

export const riskTypeIDs = {
    1: "유의적인 위험",
    2: "부정 위험",
    3: "중요왜곡표시위험"
};

export const riskTypeIDsShortForm = {
    1: "SR",
    2: "FR",
    3: "ROMM"
};

export const ControlRiskTypeIDs = {
    1: "Rely",
    2: "Not Rely",
    3: "MP 테스트"
};

export const knowledgeAssertions = {
    1: "완전성",
    2: "실재성",
    3: "평가",
    4: "권리와 의무",
    5: "표시와 공시",
    6: "완전성",
    7: "발생사실",
    8: "측정",
    9: "표시와 공시",
    10: "완전성",
    11: "실재성/발생사실",
    12: "측정/평가",
    13: "권리와 의무",
    14: "표시와 공시"
};

export const gaInstructionStatuslabels = {
    0: "미확정",
    [instructionStatus.notSent]: "미전송",
    [instructionStatus.pending]: "보류 중",
    [instructionStatus.accepted]: "수락됨",
    [instructionStatus.rejected]: "반송됨",
    [instructionStatus.systemError]: "시스템 오류",
    [instructionStatus.expired]: "만료됨",
    [instructionStatus.sent]: "전송됨",
    [instructionStatus.unlinked]: "링크 해제됨",
    [instructionStatus.queued]: "대기"
};

export const financialStatementTypeLabels = {
    [financialStatementType.Asset]: "자산",
    [financialStatementType.CurrentAsset]: "유동자산",
    [financialStatementType.NonCurrentAsset]: "비유동자산",
    [financialStatementType.Liability]: "부채",
    [financialStatementType.CurrentLiability]: "유동부채",
    [financialStatementType.NonCurrentLiability]: "비유동부채",
    [financialStatementType.Equity]: "자본",
    [financialStatementType.Revenue]: "수익",
    [financialStatementType.Expense]: "비용",
    [financialStatementType.NonOperatingIncome]: "영업외수익/(비용)",
    [financialStatementType.OtherComprehensiveIncome]: "기타포괄손익",
    [financialStatementType.Other]: "기타",
    [financialStatementType.AccountType]: "계정 유형",
    [financialStatementType.AccountSubType]: "계정 하위 유형",
    [financialStatementType.AccountClass]: "계정 분류",
    [financialStatementType.AccountSubClass]: "계정 하위 분류",
    [financialStatementType.NetIncomeExpense]: "순(이익)/비용",
    18: "GL 계정"
};

export const trialBalanceTypeLabels = {
    [trialBalanceType.Planning]: "계획"
};

export const createEditRiskModalLabels = {
    createModalDescription: "아래에 신규 위험 세부정보를 입력하고 ‘<b>{0}</b>’을(를) 선택하여 마칩니다. 다른 위험을 생성하려면, '<b>{1}</b>'을(를) 선택하십시오.",
    editModalDescription: "아래에서 위험 세부정보를 편집하고 <b>{0}</b>을(를) 선택하여 마칩니다",
    close: "닫기",
    cancel: "취소",
    createRisk: "신규 위험",
    editRisk: "위험 편집",
    riskType: "위험 유형 (필수)",

    riskTypeOptions: [{
            value: 1,
            label: "유의적인 위험"
        },
        {
            value: 2,
            label: "부정 위험"
        },
        {
            value: 3,
            label: "중요왜곡표시위험"
        }
    ],
    save: "저장",
    saveAndCloseLabel: "저장 및 닫기",
    saveAndCreateLabel: "저장 및 추가 생성",
    riskNameLabel: "위험 이름 (필수)",
    relatedAccountsAssertionsLabel: "연결된 계정 및 경영진주장 (선택사항)",
    relateAccounts: "계정 및 경영진주장 연결 (선택사항)",
    assertionsLabel: "관련 경영진주장 선택",
    riskNameErrorMsg: "필수",
    riskTypeErrorMsg: "필수",
    assertionOptions: assertions,
    removeAccountLabel: "계정 제거",
    required: "필수",
    assertionsRequired: "경영진주장을 하나 이상 선택해야 합니다"
};

export const activityTypeLabels = {
    104: "추가됨",
    105: "제거됨"
};

export const superModalNavigationLabels = {
    identifyAccountsAndDisclosures: "계정 및 공시 식별",
    identifySCOTs: "SCOT 식별 및 계정에 연결",
    determineSCOTStrategy: "SCOT 전략 결정",
    identifyWCGWAndControls: "WCGW 및 통제 식별",
    selectControlToTest: "테스트할 통제 선택",
    identifyRisks: "위험 식별",
    relateWCGWsToAssertions: "WCGW를 경영진주장에 연결",
    relateRisksToWCGWs: "위험을 WCGW에 연결",
    determineCRA: "CRA 결정",
    timephase: "시기",
    SCOTWT: "WT 생성",
    controlTOC: "TOC 생성",
    ITProcessUDP: "UDP 생성",
    ITGC_ITSP_TOC_OSP: "IT TOC/OSP 생성",
    accountPSP: "PSP 생성",
    accountOSP: "OSP 생성",
    relateWCGWTo: "WCGW 연결 대상",
    relatedWCGWToTask: "WCGW을 task에 연결",
    respondToSignificant_fraudRisks: "유의적인/부정 위험에 대응",
    OST: "OST",
    accountSummary: "계정 요약",
    SCOTSummary: "SCOT 요약",
    ITSummary: "IT 요약",
    understandITProcesses: "IT 프로세스 이해",
    evaluateIT: "IT 평가",
    CRASummary: "CRA 요약",
    auditPlan: "감사 계획",
    workplanSummary: "작업 계획 요약",
    buildSteps: "작성 단계",
    ITApplicationsAndITProcesses: "IT application 및 IT 프로세스",
    workPlan: "작업 계획",
    accounts: "계정",
    scots: "SCOT",
    cra: "CRA",
    openInNewTab: "신규 탭에서 열기"
}

export const auditPlanITProcessLabels = {
    itProcess: "IT 프로세스",
    itProcesses: "IT 프로세스",
    tasks: "Task",
    sectionHeading: "IT 프로세스 및 관련 프로세스 (UDP) 이해 task",
    subHeader: "IT 프로세스 이해",
    visualDistinctMessage: "각 IT 프로세스에 UDP를 하나 이상 연결해야 합니다. {0} 또는 {1}을(를) 생성하십시오.",
    addUdp: "신규 UDP",
    relatedUdp: "UDP 연결",
    toggleFilter: "UDP가 연결되지 않은 IT 프로세스만 표시",
    noResultsFound: "결과를 찾을 수 없습니다",
    taskTitle: "IT 프로세스 이해 및 문서화: {0}",
    taskDescription: "IT 프로세스에 대한 이해를 문서화합니다. 관련 양식을 IT 프로세스에 대한 이해를 뒷받침하는 증거로 첨부합니다. ITGC가 Task 정보 섹션에 나타날 때, walkthrough 절차를 수행하여 ITGC에 대한 이해를 확인하고 그 설계와 구축을 평가합니다. 절차의 증거를 첨부합니다.",
    noRecordsAvailable: "사용 가능한 IT 프로세스 없음",
    unrelatedLabel: "연결되지 않은 UDP 보기",
    unrelatedModalHeader: "연결되지 않은 UDP task",
    noUnrelatedTaskPlaceholder: "연결되지 않아 사용 가능한 UDP task 없음",
    noTaskselectedLabel: "삭제할 task를 하나 이상 선택해야 합니다.",
    relateITProcessTaskTitle: "UDP를 IT 프로세스에 연결",
    understandITProcesses: "IT 프로세스 이해",
    unrelatedTasksMustBeAssociated: "연결이 해제된 task는 IT 프로세스에 연결하거나 삭제해야 합니다"
}

export const noEvidenceReferencedReasonsLabels = {
    immaterialReason: "Immaterial: 잔액/활동이 테스트 범위를 충족하지 않습니다 - 추가 조사 면제됨",
    strikethroughMText: "m",
    waivedReason: "Waived: SAD 미달 금액 - 추가 조사 면제됨    ",
    strikethroughWText: "w"
}

export const auditPlanScotListLabels = {
    scot: "SCOT",
    scots: "SCOT",
    tasks: "Task",
    sectionHeading: "SCOT 및 관련 walkthrough task",
    subHeader: "Walkthrough task",
    visualDistinctMessage: "각 SCOT에 walkthrough를 하나 이상 연결해야 합니다. {0} 또는 {1}을(를) 생성하십시오.",
    newWT: "신규 WT",
    relatedWT: "WT 연결",
    toggleFilter: "WT가 연결되지 않은 SCOT만 표시",
    noResultsFound: "결과를 찾을 수 없습니다",
    noRecordsAvailable: "사용 가능한 SCOT 없음",
    relateScotTaskTitle: "WT를 SCOT에 연결",
    taskTitle: "Walkthrough: {0}",
    taskDescription: "<p>매 기간마다 walkthrough 절차를 수행하여 모든 일상적 및 비일상적 SCOT과 유의적인 공시 프로세스에 대한 이해를 확인합니다. 또한, PCAOB 감사인 경우, 추정 SCOT에 대해 walkthrough 절차를 수행합니다.<br/>통제 의존 전략을 취하는 경우 모든 SCOT과, 유의적인 위험에 대응하는 통제에 대해, 관련 통제가 적합하게 설계되고 구축되었는지 확인합니다. 통제 의존 전략이 여전히 적합한 결정인지 확인합니다.<br/><br/>SCOT의 운영이 조서에 정확하게 설명되어 있고, IT 사용으로 발생하는 위험 등 적합한 WCGW 및 (해당하는 경우) 관련 통제를 모두 식별했는지 결론 내립니다.<br/><br/> 실증 단독 전략을 사용하는 추정 SCOT인 경우 실증절차에 기초하여 추정 SCOT에 대한 이해가 적합한지 확인합니다.</p>",
    unrelatedLabel: "연결되지 않은 WT 보기",
    unrelatedModalHeader: "연결되지 않은 WT task",
    noUnrelatedTaskPlaceholder: "연결되지 않아 사용 가능한 WT task 없음",
    noTaskselectedLabel: "삭제할 task를 하나 이상 선택해야 합니다.",
    manageScots: "SCOT 관리",
    unrelatedTasksMustBeAssociated: "연결이 해제된 task는 SCOT에 연결하거나 삭제해야 합니다"
}

export const auditPlanControlsLabels = {
    control: "통제",
    controls: "테스트를 위해 선택된 통제",
    tasks: "Task",
    sectionHeading: "통제 및 관련 통제테스트",
    subHeader: "통제테스트 task",
    visualDistinctMessage: "각 통제에 통제테스트를 하나 이상 연결해야 합니다. {0} 또는 {1}을(를) 생성하십시오.",
    addToc: "신규 TOC",
    relatedToc: "TOC 연결",
    toggleFilter: "TOC가 연결되지 않은 통제만 표시",
    noResultsFound: "결과를 찾을 수 없습니다",
    noRecordsAvailable: "테스트를 위해 선택된 통제 없음",
    unrelatedLabel: "연결되지 않은 TOC 보기",
    unrelatedModalHeader: "연결되지 않은 TOC task",
    noUnrelatedTaskPlaceholder: "연결되지 않아 사용 가능한 TOC task 없음",
    noTaskselectedLabel: "삭제할 task를 하나 이상 선택해야 합니다.",
    relateControlTaskTitle: "통제에 TOC 연결",
    manageControl: "통제 관리",
    taskTitleTOC: "통제테스트: {0}",
    taskDescriptionTOC: "통제테스트의 성격, 시기, 범위를 설계하여, 경영진주장 수준에서 중요왜곡표시를 예방하거나 적발하여 수정하기 위해 통제가 의존 기간에 걸쳐 설계된 대로 효과적으로 운영된다는 충분하고 적합한 감사증거를 입수합니다. <br> 표본 규모를 확대하거나 보완 통제를 테스트한 경우를 포함하여 통제테스트의 결과를 평가함으로써, 통제의 운영 효과성에 대해 결론을 내립니다.",
    manageControls: "통제 관리",
    unrelatedTasksMustBeAssociated: "연결이 해제된 task는 통제에 연결하거나 삭제해야 합니다"
}

export const industrySelectionGroupLabels = {
    1: "선택한 산업",
    2: "기타 산업"
}

export const knowledgeDataLabels = {
    industry: "산업",
    showSelected: "선택 항목만 보기",
    noContent: "선택한 산업에 대해 Knowledge에 사용 가능한 내용이 없습니다",
    importFromKnowledge: "Knowledge에서 불러오기",
    importAccounts: "계정 불러오기",
    importAccountsAndDisclosures: "계정 및 공시 불러오기",
    accountBuild1: "계정 작성 단계 1",
    import: "불러오기",
    close: "닫기",
    cancel: "취소",
    selected: "선택됨",
    scotTitle: "SCOT build 1",
    importScots: "SCOT 불러오기",
    noKnowledgeDataResult: "선택 가능한 내용이 없습니다",
    showOnlySelectedLabel: "선택 항목만 보기",
    scot: "SCOT",
    scotDropdownLabel: "선택한 산업에 대한 SCOT",
    importWcgw: "WCGW 불러오기",
    importFailedLabel: "불러오기 실패. 불러오기를 다시 시도하십시오.",
    wtDetailPrefix: "<p>매 기간마다 walkthrough 절차를 수행하여 모든 일상적 및 비일상적 SCOT과 유의적인 공시 프로세스에 대한 이해를 확인합니다. 또한, PCAOB 감사인 경우, 추정 SCOT에 대해 walkthrough 절차를 수행합니다.<br/>통제 의존 전략을 취하는 경우 모든 SCOT과, 유의적인 위험에 대응하는 통제에 대해, 관련 통제가 적합하게 설계되고 구축되었는지 확인합니다. 통제 의존 전략이 여전히 적합한 결정인지 확인합니다.<br/><br/>SCOT의 운영이 조서에 정확하게 설명되어 있고, IT 사용으로 발생하는 위험 등 적합한 WCGW 및 (해당하는 경우) 관련 통제를 모두 식별했는지 결론 내립니다.<br/><br/> 실증 단독 전략을 사용하는 추정 SCOT인 경우 실증절차에 기초하여 추정 SCOT에 대한 이해가 적합한지 확인합니다.</p>",
    importOSP: "OSP 불러오기",
    auditPlanBuild7: "감사 계획 Build 7",
    account: "계정",
    accountName: "PSP Index",
    wcgwName: "WCGW",
    selectScot: "SCOT 유형 선택",
    wcgwTitle: "SCOT build 3",
    noResultFound: "결과를 찾을 수 없습니다",
    importValidationMessage: "선택은 필수입니다",
    searchIconHoverLabel: "검색",
    scotsHeader: "SCOT",
    controlsHeader: "통제",
    ospsHeader: "OSP",
    wcgw: "WCGW",
    importControls: "통제 불러오기",
    accountAssertionsValidationMessage: "Task 경영진주장이 없습니다",
    accountsAndDisclosures: "계정 및 공시",
}

export const auditPlanITControlsLabels = {
    itcontrol: "IT 통제",
    itcontrols: "테스트를 위해 선택된 IT 통제",
    tasks: "Task",
    type: "유형",
    sectionHeading: "ITGC, ITSP, 및 관련 통제테스트와 실증 task",
    subHeader: "TOC/OSP task",
    visualTOCDistinctMessage: "각 ITGC에 통제테스트를 하나 이상 연결해야 합니다. {0} 또는 {2}을(를) 생성하십시오.",
    visualOSPDistinctMessage: "각 ITSP에 실증절차를 하나 이상 연결해야 합니다. {1} 또는 {3}을(를) 생성하십시오.",
    addTOC: "신규 TOC",
    addOSP: "신규 OSP",
    relatedTOCOSP: "TOC/OSP 연결",
    relatedTOC: "TOC 연결",
    relatedOSP: "OSP 연결",
    toggleFilter: "TOC/OSP가 연결되지 않은 IT 통제만 표시",
    noResultsFound: "결과를 찾을 수 없습니다",
    noRecordsAvailable: "테스트를 위해 선택된 ITGC 없음",
    taskTitleTOC: "통제테스트: {0}",
    taskDescriptionTOC: "의존대상기간 동안의 운영 효과성에 대한 충분하고 적합한 감사증거를 입수하기 위해 설계된 ITGC 테스트를 수행합니다",
    taskTitleOSP: "기타실증절차: {0}",
    taskDescriptionOSP: "이 task 설명을 상황에 맞게 수정하여, IT 위험이 의존 기간에 걸쳐 효과적으로 대응되었다는 충분하고 적합한 감사증거를 입수하도록 IT 실증절차의 성격, 시기, 범위를 설계합니다.<br>중간일에 IT 실증절차를 수행하는 경우, 기말까지 중간절차가 적용되는 기간 동안 IT 위험이 대응된다는 추가 증거를 입수하기 위해 절차를 설계하고 수행합니다.<br>IT 실증절차의 결과에 대해 결론을 내립니다.",
    relateITControlTaskTitle: "IT 통제에 TOC/OSP 연결",
    relateITControlTOCTaskTitle: "ITGC에 TOC 연결",
    relateITControlOSPTaskTitle: "OSP에 ITSP 연결",
    unrelatedModalHeader: "연결되지 않은 TOC/OSP task",
    noUnrelatedTaskPlaceholder: "연결되지 않아 사용 가능한 TOC/OSP task 없음",
    noTaskselectedLabel: "삭제할 task를 하나 이상 선택해야 합니다.",
    unrelatedLabel: "연결되지 않은 TOC/OSP 보기",
    understandITProcesses: "IT 프로세스 이해",
    unrelatedTasksMustBeAssociated: "연결이 해제된 task는 IT 통제에 연결하거나 삭제해야 합니다"
}

export const generalLabelsForMobile = {
    noRecordsFound: "이 task 범주에서 결과를 찾을 수 없습니다",
    taskListTitle: "내 task",
    taskEvidenceTitle: "증거",
    cameraPagesTitle: "페이지",
    cameraTitle: "카메라",
    taskDetailsTitle: "Task 세부정보",
    invalidPage: "페이지를 찾을 수 없습니다",
    combinedTaskLabel: "PIC/EQR",
    picTaskLabel: "PIC",
    eqrTaskLabel: "EQR",
    pageLabel: "페이지",
    ofLabel: "of",
    noTasksAvailable: "사용 가능한 task 없음",
    searchLabel: "검색…",
    noDescriptionAvailable: 'No description available.',
    knowledge: 'Knowledge',
    description: 'Description',
    knowledgeDescription: 'Knowledge description',
    customized: 'Customized',
    taskDetailsTitle: "Task 세부정보",
    unassigned: "배정되지 않음",
    assignTo: "담당자",
    signOffLabel: "Sign-off",
    evidenceNoteLabel: "증거 노트",
    attributeLabel: "정보",
    addNoteLabel: "신규 노트",
    addCommentLabel: "Comment 추가",
    editCommentLabel: "Comment 업데이트",
    addReplyNoteLabel: "이 노트에 회신",
    replyNoteLabel: "회신",
    replyEditNoteLabel: "회신 편집",
    enterReplyPlaceholder: "회신 입력",
    editNoteLabel: "편집",
    deleteNoteLabel: "삭제",
    reopenNoteLabel: "다시 열기",
    closeNoteLabel: "닫기",
    clearNoteLabel: "처리",
    preparerAbbrv: "P",
    reviewerAbbrv: "R",
    uploadPhoto: "사진 업로드",
    noEvidenceFound: "Task에 증거가 연결되지 않았습니다",
    noRegionComponentFound: "지역 또는 부문 팀에서 수신한 문서 없음",
    noEvidenceMessage: "증거를 업로드하려면 사진 업로드를 클릭하십시오",
    noNotesFound: "노트를 찾을 수 없습니다",
    noNotesStatement: "아래에 입력하여 노트를 남기십시오. 노트를 사용자에게 배정하고 우선순위와 만료일을 지정하십시오.",
    regionComponentEvidence: "지역 및 부문 증거",
    documentWarning: "다운로드된 문서는 읽기 전용입니다. 사용 후 해당 파일을 폐기하십시오.",
    preparerTitle: "작성자 sign-off",
    reviewerTitle: "검토자 sign-off",
    teamLabel: "팀",
    saveEvidenceTitle: "증거 저장",
    saveButton: "저장",
    cancelButton: "취소",
    confirmButtonLabel: "확인",
    previewButton: "미리보기",
    evidenceLable: "증거 이름",
    mergingTitleLable: "PDF에 병합된 이미지",
    showErrFileExistMsg: "파일 이름이 이미 존재합니다. 파일 이름을 바꾸십시오.",
    showErrForNoImgExist: "PDF 생성을 위한 이미지 없음",
    showErrBlankFileNameMsg: "파일 이름은 비워둘 수 없습니다",
    showIsCompletedMessage: "파일이 업로드됐습니다",
    uploadingTitle: "처리 중",
    showErrImgContext: "useImages는 반드시 ImagesProvider 내에서 사용해야 합니다",
    PagePreviewTitle: "페이지",
    regionComponentEvidenceLabel: "지역 및 부문 증거",
    downloadProcessLabel: "다운로드 중",
    downloadCompleteLabel: "다운로드 완료",
    taskNotes: "Task 노트",
    documentNotes: "문서 노트",
    dueDateLabel: "만료일",
    view: "보기:",
    documentNotes: "문서 노트",
    newNote: "노트 추가",
    editNote: "노트 편집",
    assignedTo: "담당자",
    priority: "우선순위",
    select: "선택",
    dueDate: "만료일",
    addNewNote: "신규 노트 추가",
    addNote: "노트 추가",
    updateNote: "노트 업데이트",
    enterDescription: "설명 입력...",
    allnotes: "모든 노트",
    mynotes: "내 노트",
    assignedToMe: "내 담당",
    hashValue: "#",
    showLessToggle: "덜 표시",
    showMoreToggle: "더 표시",
    delete: "삭제",
    deleteNoteModalTitle: "메시지 삭제",
    deleteReplyModalTitle: "회신 삭제",
    confirmDeleteNoteLabel: "선택한 노트를 삭제하시겠습니까?",
    confirmDeleteReplyLabel: "이 노트에 대한 회신을 삭제하시겠습니까?",
    downloadInfo: "문자 #을 포함한 파일은 다운로드할 수 없습니다",
	evidenceFileValidationInfo: '파일 이름에 */:<>\\?|" 문자를 포함할 수 없습니다',
    previewPageTitle: "미리보기",
    redirecting: "몇 초 후 랜딩 페이지로 이동…",
    redirectingToTask: "몇 초 후 \내 Tasks\ 페이지로 이동…",
    errorApplyingConstraints: "제약조건 적용 중 오류 발생:",
    zoomIsNotSupported: "이 기기에서는 Zoom을 지원하지 않습니다",
    errorCheckingCameraCapability: "카메라 기능 확인 중 오류 발생:",
    previous: "이전",
    next: "다음",
    after: "후",
    redirectingToTaskDetails: "몇 초 후 task 세부정보로 이동",
    mobileURL: '/mobile'
};

export const RNHNoteMobileStatusOptions = [{
        value: 1,
        label: "처리 전 "
    },
    {
        value: 2,
        label: "처리됨 "
    },
    {
        value: 3,
        label: "닫힘"
    }
];

export const auditPhaseTypes = [{
        value: 1,
        label: "범위 및 전략"
    },
    {
        value: 2,
        label: "실행"
    },
    {
        value: 3,
        label: "결론"
    },
];

export const CreateEditTaskSectionLabels = {
    createModalTitle: "신규 task 그룹",
    editModalTitle: "Task 그룹 편집",
    createModalDescription: "아래에서 task 그룹 세부정보를 입력하고 ‘<b>{0}</b>’을(를) 선택하여 마칩니다. 추가 task 그룹을 생성하려면,  '<b>{1}</b>'을(를) 선택합니다.",
    editModalDescription: "아래에 task 그룹 세부정보를 편집하고 ‘<b>{0}</b>’을(를) 선택하여 마칩니다",
    close: "닫기",
    cancel: "취소",
    save: "저장",
    saveAndCloseLabel: "저장 및 닫기",
    saveAndCreateLabel: "저장 및 추가 생성",
    taskSectionNameLabel: "Task 그룹 이름 (필수)",
    taskSectionNameErrorMsg: "필수",
    engagementPhaseOptions: auditPhaseTypes,
    engagementPhaseLabel: "Engagement 단계 (필수)",
    engagementPhaseErrorMsg: "필수",
};

export const auditPhaseLabels = {
    1: "범위 및 전략",
    2: "실행",
    3: "결론",
    4: "예비적인 engagement 활동 수행",
    5: "위험 식별 및 평가",
    6: "위험에 대응",
    7: "결론 및 보고"
};

export const ITApproachType = {
    1: "ITGC",
    2: "ITSP"
};

// taskbuildmilestoneid labels
export const taskBuildMilestoneId = [{
        id: 1,
        label: superModalNavigationLabels.identifyAccountsAndDisclosures
    },
    {
        id: 31,
        label: superModalNavigationLabels.identifyAccountsAndDisclosures
    },
    {
        id: 5,
        label: superModalNavigationLabels.identifySCOTs
    },
    {
        id: 32,
        label: superModalNavigationLabels.identifySCOTs
    },
    {
        id: 6,
        label: superModalNavigationLabels.determineSCOTStrategy
    },
    {
        id: 7,
        label: superModalNavigationLabels.identifyWCGWAndControls
    },
    {
        id: 38,
        label: superModalNavigationLabels.identifyWCGWAndControls
    },
    {
        id: 8,
        label: superModalNavigationLabels.selectControlToTest
    },
    {
        id: 2,
        label: superModalNavigationLabels.identifyRisks
    },
    {
        id: 15,
        label: superModalNavigationLabels.relateWCGWsToAssertions
    },
    {
        id: 30,
        label: superModalNavigationLabels.relateRisksToWCGWs
    },
    {
        id: 3,
        label: superModalNavigationLabels.determineCRA
    },
    {
        id: 18,
        label: superModalNavigationLabels.SCOTWT
    },
    {
        id: 19,
        label: superModalNavigationLabels.controlTOC
    },
    {
        id: 20,
        label: superModalNavigationLabels.ITProcessUDP
    },
    {
        id: 21,
        label: superModalNavigationLabels.ITGC_ITSP_TOC_OSP
    },
    {
        id: 25,
        label: superModalNavigationLabels.accountPSP
    },
    {
        id: 26,
        label: superModalNavigationLabels.accountOSP,
    },
    {
        id: 27,
        label: superModalNavigationLabels.respondToSignificant_fraudRisks
    },
    {
        id: 56,
        label: superModalNavigationLabels.respondToSignificant_fraudRisks
    },
    {
        id: 29,
        label: superModalNavigationLabels.relatedWCGWToTask
    },
    {
        id: 39,
        label: superModalNavigationLabels.respondToSignificant_fraudRisks
    },
    {
        id: 50,
        label: superModalNavigationLabels.OST
    }
];

export const noEvidenceReferencedReasons = [{
        id: 1,
        reason: noEvidenceReferencedReasonsLabels.immaterialReason,
        glAccountTypeId: 12,
        strikethroughText: noEvidenceReferencedReasonsLabels.strikethroughMText
    },
    {
        id: 2,
        reason: noEvidenceReferencedReasonsLabels.waivedReason,
        glAccountTypeId: 13,
        strikethroughText: noEvidenceReferencedReasonsLabels.strikethroughWText
    }
];


export const createEditAdjustmentLabels = {
    createModalTitle: "신규 조정사항",
    editModalTitle: "조정사항 편집",
    createModalDescription: "아래에서 조정사항 세부정보를 입력하고 ‘<b>{0}</b>’을(를) 선택하여 마칩니다. 다른 조정사항을 생성하려면, '<b>{1}</b>'을(를) 선택하십시오.",
    editModalDescription: "아래에서 조정사항 세부정보를 편집하고 ‘<b>{0}</b>’을(를) 선택하여 마칩니다. 해당 조정사항을 삭제하려면 '<b>{1}</b>'을(를) 클릭하십시오.",
    close: "닫기",
    cancel: "취소",
    save: "저장",
    saveAndCloseLabel: "저장 및 닫기",
    saveAndCreateLabel: "저장 및 추가 생성",
    delete: "삭제",
    adjustmentNameLabel: "조정사항 index (필수)",
    adjustmentDescriptionLabel: "조정사항 설명 (필수)",
    adjustmentDescriptionPlaceholder: "조정사항 설명 (필수)",
    required: "필수",
    editDescriptionModal: "조정사항 설명 편집",
    descriptionRequired: "조정사항 설명은 필수입니다",
    uploadDocumentPlaceholder: "조정사항을 저장해야 증거에 연결할 수 있습니다",
    generalLedgerAccount: "GL 계정 (필수)",
    documentHeader: "문서 (필수)",
    addDocumentButton: "증거 추가",
    glAccountPlaceholder: 'GL account is not available. To add the account click {0}.',
    adjustmentIndex: "조정사항 index",
    addglaccountbutton: "GL 계정 추가",
    descriptionMaxLengthError: "응답이 허용된 최대 수를 초과합니다",
    glaccountTotalError: "차변 항목 합계는 대변 항목 합계와 같아야 합니다",
    glaccountIdDuplicate: "각 GL 계정은 조정사항에서 한 번만 사용돼야 합니다",
    placeholderText: 'No related documents. To relate a document click <a>Add evidence<a>',
    editAdjustmentDescriptionHeader: "조정사항 설명 편집",
    editAdjustmentDescriptionSubHead: "아래에서 조정사항 설명 세부정보를 편집하고 \<b>저장</b>\을 선택하여 마칩니다"
};

export const addUpdateGlAccountLabels = {
    addGLaccountTitle: "GL 계정 추가",
    glaccountDescription: "아래에서 GL 계정 세부정보를 입력하고 <b>{0}</b>을(를) 선택하여 마칩니다. 다른 GL 계정을 더 추가하려면, <b>{1}</b>을(를) 선택하십시오.",
    addAndClose: "저장 및 닫기",
    addAnother: "더 추가",
    accountSubClassPlaceholder: "계정 하위 분류",
    glAccountsPlaceholder: "사용 가능한 GL 계정을 보려면 계정 하위 분류를 선택하십시오",
    glAccountListHeaderColumn: "GL 계정",
    amountLabel: "금액 (필수)",
    debitCreditOptions: [{
            id: 1,
            label: "차변"
        },
        {
            id: 2,
            label: "대변 "
        }
    ],
    searchPlaceholder: "검색",
    newGlAccount: "신규 조정 계정",
    noResultsFound: "결과를 찾을 수 없습니다",
    noRecordsPlaceholder: "선택한 계정 하위 분류에 대한 조정 계정을 찾을 수 없습니다. 다른 하위 분류를 선택하거나 {0}을(를) 클릭하여 선택된 계정 하위 분류에 대한 조정 계정을 추가하십시오.",
    editTitleTip: "조정 계정 편집",
    removeTitleTip: "조정 계정 삭제",
    custom: "사용자지정",
    duplicateGLAccount: "각 GL 계정은 조정사항에서 한 번만 사용돼야 합니다",
    updateModalTitle: "조정 계정 업데이트",
    updateModalDescription: `Update GL account amount and debit/credit details below and select '<b>{0}</b>' to finish.`,
    accountClassLabel: "Account class",
    glAccountLabel: "GL account",
    updateLabel: "업데이트",
    updateGlAccountModalTitle: "GL 계정 업데이트",
}

export const deleteGLAccountLabels = {
    deleteConfirmationModallHeader: "조정 계정 삭제",
    deleteConfirmationModalBodyHeader: "선택한 조정 계정을 삭제하시겠습니까? 이 작업은 실행 취소할 수 없습니다.",
    deleteConfirmationModalAccountSubClass: "계정 하위 분류:",
    deleteConfirmationModalAccountName: "계정 이름:",
    deleteConfirmationModalGLAccountName: "조정 계정 이름:",
    closeButtonTitle: "취소",
    confirmBtnTitle: "삭제"
}

export const glAccountListLabel = {
    accountClass: "계정 분류",
    accountSubClass: "계정 하위 분류",
    glAccount: "GL 계정",
    debit: "차변",
    credit: "대변",
    actions: "작업",
    editTitleTip: "GL 계정 편집",
    removeTitleTip: "GL 계정 제거"
}

export const EngagementMapLabels = {
    objectivePreviewMessage: 'Hover over a map item to preview',
    noMapAvailableMessage: "사용 가능한 맵이 없습니다",
    takeContentUpdateMessage: "내용을 업데이트하여 최신 맵을 가져오십시오",
    noRecordsLabel: "기록을 찾을 수 없습니다",
    auditTopic: "감사 주제",
    auditTopicPlaceholder: "주제를 선택하여 보기",
    numberSelected: "{0} 주제 선택됨",
    refreshMapTitletip: "Engagement 맵 업데이트를 시작하려면 여기를 클릭하십시오",
    mapUpdateInProgress: "업데이트 진행 중. 업데이트가 완료되는 데 10분까지 소요될 수 있습니다.",
    refreshMapsLabel: "Refresh maps"
}

export const createEditGLAccountLabels = {
    createModalTitle: "신규 조정 계정",
    editModalTitle: "조정 계정 편집",
    createModalDescription: "아래에서 조정 계정 세부정보를 편집하고 ‘<b>{0}</b>’을(를) 선택하여 마칩니다. 다른 조정 계정을 추가하려면, '<b>{1}</b>'을(를) 선택하십시오.",
    editModalDescription: "아래에서 조정 계정 세부정보를 편집하고 ‘<b>{0}</b>’을(를) 선택하여 마칩니다",
    accountSubClass: "계정 하위 분류",
    accountName: "계정 이름 (필수)",
    glAccountName: "조정 계정 이름 (필수)",
    cancelbtn: "취소",
    saveAndAddbtn: "저장 및 더 추가",
    saveAndClosebtn: "저장 및 닫기",
    save: "저장",
    required: "필수",
}

//Receive instructions switcher
export const receiveInstructionSwitcherLabels = {

    [receiveInstructionSwitcherIds.groupInstructions]: "그룹 지침",
    [receiveInstructionSwitcherIds.groupRiskAssessment]: "그룹 위험평가",
    [receiveInstructionSwitcherIds.documents]: "문서"
};

export const misstatementEvidenceLabels = {
    placeholderText: "연결된 증거 없음. 증거를 하나 이상 연결해야 합니다. 증거를 연결하려면 {0}을(를) 클릭하십시오.",
    addEvidenceBtn: "증거 추가",
};

export const misstatementTempLabels = {
    placeholderText: "연결된 임시 문서 없음. 임시 문서를 연결하려면 {0}을(를) 클릭하십시오.",
    addEvidenceBtn: "임시 파일 추가",
};

export const inherentRiskFactorTypes = [{
        id: 1,
        label: "복잡성",
        displayOrder: 1
    },
    {
        id: 2,
        label: "주관성 불확실성",
        displayOrder: 2
    },
    {
        id: 3,
        label: "부정 또는 오류",
        displayOrder: 3
    },
    {
        id: 4,
        label: "변경",
        displayOrder: 4
    },
    {
        id: 5,
        label: "계정 성격",
        displayOrder: 5
    },
    {
        id: 6,
        label: "특수관계자",
        displayOrder: 6
    }
];

export const helixSettingsStepLabels = {
    title: "연결 설정 정의",
    subTitle: "귀하의 analyzer 연결 설정을 선택하십시오",
    connectionNameLabel: "연결 이름",
    connectionNamePlaceholder: "연결 이름 (필수)",
    connetionTypesLabel: "연결 유형",
    connectionTypeScopeAndStrategy: "범위 및 전략",
    connectionTypeFinancionStatement: "재무제표",
    includeAllBusinessUnitsField: "모든 사업부를 포함하시겠습니까?",
    yes: "예",
    no: "아니오",
    businessUnitsLabel: "사업부",
    businessUnitsPlaceholder: "사업부",
    analysisPeriodLabel: "분석일",
    analysisPeriodPlaceholder: "분석일",
    comparativePeriod1Label: "비교일 1",
    comparativePeriod1Placeholder: "비교일 1 (선택사항)",
    comparativePeriod2Label: "비교일 2",
    comparativePeriod2Placeholder: "비교일 2 (선택사항)",
    currencyTypeField: "통화 유형",
    reporting: "보고",
    functional: "기능",
    currencyCodeField: "통화 코드",
    currencyCodePlaceholder: "통화 코드 (필수)",
    scopeAndStrategyLabel: "범위 및 전략",
    financialStatementLabel: "재무제표",

    required: "필수",
    comparativePeriodError: "유효하지 않은 날짜. 분석일 이전 날짜를 선택하십시오.",

    dataConnectionLink: 'How to manage data connections',
    helixfiscalDropDownLabel: "날짜 {0} - {1}",

    helixError: 'Could not connect to the selected analyzer. Refresh the page and try again. If the issue persists, contact the Help Desk.',
    businessUnitsSelectedCount: "{0} 선택됨",
    allBusinessUnitsLabel: "모든 사업부"
};

export const importDataModalLabels = ({
    title,
    description,
    buttonLabel
}) => {
    return {
        title: title,
        description: description,
        entity: "기업",
        trialBalanceName: "시산표 이름",
        reporting: "보고",
        functional: "기능",
        analysisPeriod: "분석일",
        comparativePeriod: "비교일",
        secondComparativePeriod: "이차 비교일 (선택사항)",
        includeFinancialStatements: "재무제표 포함",
        carryForwardReferencesAndAdjustments: "참조 및 조정사항을 신규 불러오기로 이연합니까?",
        import: buttonLabel,
        businessUnitSelectedCount: "{0} 사업부",
        businessUnitsSelectedCount: "{0} 사업부",
        allBusinessUnitsLabel: "모든 사업부",
        businessUnitsPlaceholder: "사업부",
        required: "필수",
        comparativePeriodError: "유효하지 않은 날짜. 분석일 이전 날짜를 선택하십시오.",
        secondComparativePeriodError: "비교일보다 늦거나 같은 이차 비교일",
        equalComparativePeriodError: "날짜는 동일할 수 없습니다",
        analysisDateMustBeLaterError: 'Analysis date must be later than both comparative dates.'
    };
};

export const AnalyzerHelixErrors = {
    400: "선택한 연결에 EY Helix 프로젝트를 더 이상 사용할 수 없습니다. 추가 세부정보를 보려면 EY Helix 관리자에게 문의하십시오. 연결을 영구히 제거하려면거, 먼저 연결에 연결된 불러오기를 모두 제거하십시오. 그러고 나서, 기타 메뉴에서 ‘analyzer 연결 해제’를 클릭하십시오. 다른 analyzer를 연결해야 할지 고려하십시오.",
    403: "연결된 analyzer에 권한이 있는 팀 멤버가 아닙니다. 접근 권한을 얻으려면 EY Helix 프로젝트 관리자에게 문의하십시오.",
    405: "분석을 링크된 연결에서 사용할 수 없습니다. 계속하려면 EY Helix로 이동하여 데이터 & 분석 처리 단계를 완료하십시오.",
    406: "선택한 연결에 EY Helix analyzer를 더 이상 사용할 수 없습니다. 추가 세부정보를 보려면 EY Helix 관리자에게 문의하십시오. 연결을 영구히 제거하려면거, 먼저 연결에 연결된 불러오기를 모두 제거하십시오. 그러고 나서, 기타 메뉴에서 ‘analyzer 연결 해제’를 클릭하십시오. 다른 analyzer를 연결해야 할지 고려하십시오.",
    408: "선택한 연결에 EY Helix 프로젝트를 더 이상 사용할 수 없습니다. 추가 세부정보를 보려면 EY Helix 관리자에게 문의하십시오. 연결을 영구히 제거하려면거, 먼저 연결에 연결된 불러오기를 모두 제거하십시오. 그러고 나서, 기타 메뉴에서 ‘analyzer 연결 해제’를 클릭하십시오. 다른 analyzer를 연결해야 할지 고려하십시오.",
    411: "선택한 analyzer에 필요한 모든 파라미터가 없습니다. 추가 세부정보를 보려면 EY Helix 관리자에게 문의하십시오.",
    430: "선택한 analyzer에 필요한 모든 파라미터가 없습니다. 추가 세부정보를 보려면 EY Helix 관리자에게 문의하십시오. 페이지를 새로 고침하여 다시 시도하십시오. 문제가 지속되면, 헬프 데스크에 문의하십시오.",
    800: "귀하는 전에 EY Helix에 접속한 적이 없는 것 같습니다. EY Helix로 이동하여, 로그인 후 지침에 따라 계정을 설정하십시오.",
    801: "링크된 프로젝트에 권한이 있는 팀 멤버가 아닙니다. 접근 권한을 얻으려면 EY Helix 프로젝트 관리자에게 문의하십시오.",
    901: "선택한 연결에 EY Helix 프로젝트를 더 이상 사용할 수 없습니다. 추가 세부정보를 보려면 EY Helix 관리자에게 문의하십시오. 연결을 영구 삭제하려면 아래 추가 메뉴에서 ‘삭제’를 클릭십시오. 다른 analyzer가 연결되어야 하는지 고려하십시오.",
    902: "선택한 연결에 EY Helix 프로젝트가 삭제 표시됐습니다. 추가 세부정보를 보려면 EY Helix 관리자에게 문의하십시오. 연결을 영구 삭제하려면 아래 추가 메뉴에서 ‘삭제’를 클릭십시오. 다른 analyzer가 연결되어야 하는지 고려하십시오.",
    903: "선택한 연결에 EY Helix 프로젝트가 저장 표시됐습니다. 추가 세부정보를 보려면 EY Helix 관리자에게 문의하십시오. 연결을 영구 삭제하려면 아래 추가 메뉴에서 ‘삭제’를 클릭십시오. 다른 analyzer가 연결되어야 하는지 고려하십시오.",
    926: "선택한 analyzer를 EY Helix에서 사용할 수 없습니다. 페이지를 새로 고침하여 다시 시도하십시오. 문제가 지속되면, 헬프 데스크에 문의하십시오.",
    927: "분석을 링크된 프로젝트에서 사용할 수 없습니다. 계속하려면 EY Helix로 이동하여 데이터 & 분석 처리 단계를 완료하십시오.",
    928: "EY Helix에서 유효하지 않거나 누락된 analyzer. 페이지를 새로 고침하여 다시 시도하십시오. 문제가 지속되면, 헬프 데스크에 문의하십시오.",
    929: "링크된 EY Helix 프로젝트에 관련된 오류가 발생했습니다. 데이터를 불러올 수 없습니다."
};

export const validationLabels = {
    viewAdjustmentWithValidations: "유효성 검증 {0} 있는 조정사항 보기",
    validationTypeAmtMissmatch: "차변 합계가 대변 합계와 같지 않습니다",
    validationTypeNoEvidence: "연결된 증거 없음"
};

export const canavsImportErrors = {
    400: "불러오기 실패. 선택한 연결에 EY Helix 프로젝트를 더 이상 사용할 수 없습니다. 추가 세부정보를 보려면 EY Helix 관리자에게 문의하십시오. 연결을 영구히 제거하려면거, 먼저 연결에 연결된 불러오기를 모두 제거하십시오. 그러고 나서, 기타 메뉴에서 ‘analyzer 연결 해제’를 클릭하십시오. 다른 analyzer를 연결해야 할지 고려하십시오.",
    403: "불러오기 실패. 연결된 analyzer에 권한이 있는 팀 멤버가 아닙니다. 접근 권한을 얻으려면 EY Helix 프로젝트 관리자에게 문의하고 나서 페이지를 새로 고침하여 다시 시도하십시오. 문제가 지속되면, 헬프 데스크에 문의하십시오.",
    405: "불러오기 실패. 분석을 링크된 연결에서 사용할 수 없습니다. 계속하려면 EY Helix로 이동하여 데이터 & 분석 처리 단계를 완료하십시오. 그러고 나서 페이지를 새로 고침하여 다시 시도하십시오. 문제가 지속되면, 헬프 데스크에 문의하십시오.",
    406: "불러오기 실패. 선택한 연결에 EY Helix analyzer를 더 이상 사용할 수 없습니다. 추가 세부정보를 보려면 EY Helix 관리자에게 문의하십시오. 연결을 영구히 제거하려면거, 먼저 연결에 연결된 불러오기를 모두 제거하십시오. 그러고 나서, 기타 메뉴에서 ‘analyzer 연결 해제’를 클릭하십시오. 다른 analyzer를 연결해야 할지 고려하십시오.",
    408: "불러오기 실패. 선택한 연결에 EY Helix 프로젝트를 더 이상 사용할 수 없습니다. 추가 세부정보를 보려면 EY Helix 관리자에게 문의하십시오. 연결을 영구히 제거하려면거, 먼저 연결에 연결된 불러오기를 모두 제거하십시오. 그러고 나서, 기타 메뉴에서 ‘analyzer 연결 해제’를 클릭하십시오. 다른 analyzer를 연결해야 할지 고려하십시오.",
    411: "불러오기 실패. 선택한 analyzer에 필요한 모든 파라미터가 없습니다. 추가 세부정보를 보려면 EY Helix 관리자에게 문의하고 나서 페이지를 새로 고침하여 다시 시도하십시오. 문제가 지속되면, 헬프 데스크에 문의하십시오.",
    430: "불러오기 실패. 선택한 analyzer에 필요한 모든 파라미터가 없습니다. 추가 세부정보를 보려면 EY Helix 관리자에게 문의하십시오. 페이지를 새로 고침하여 다시 시도하십시오. 문제가 지속되면, 헬프 데스크에 문의하십시오.",
    113082: "분석 기간은 비워둘 수 없습니다"
};
